webpackJsonp([1],{

/***/ 1000:
/***/ (function(module, exports) {

module.exports = {"version":"2018e","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|012|-2le00 4i6N0","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le80 1XO3u 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BAu|29e5","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rb0 1ld0 14n0 1zd0 On0 1zd0 On0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Etc/GMT-0|GMT|0|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Pacific/Pohnpei|+11|-b0|0||34e3","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4","Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2","Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Etc/GMT-11","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ }),

/***/ 1001:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Job Listing")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Displaying Analytics In Job Applications")])]), _c('div', {
    staticClass: "col-sm-7"
  }, [(_vm.graphOutdatedStatus) ? _c('b-btn', {
    staticClass: "pull-right ml-1",
    attrs: {
      "id": "refreshButton",
      "type": "button",
      "variant": "success"
    },
    on: {
      "click": _vm.refreshGraph
    }
  }, [_vm._v("Data updated, please refresh")]) : _vm._e()], 1)]), _c('br'), _c('job-chart', {
    attrs: {
      "id": "lineGraph",
      "daysOfGraph": _vm.daysOfGraph,
      "graphData": _vm.graphDataUpdate
    }
  }), _c('br'), _c('app-table', {
    attrs: {
      "data": _vm.jobTableItems,
      "label": _vm.jobTableFields,
      "sortBy": "timestamp",
      "sortDesc": true
    }
  }), _c('br'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('ul', {
    attrs: {
      "id": "example-1"
    }
  }, _vm._l((_vm.textToChanges), function(textToChange) {
    return _c('li', [_vm._v(_vm._s(textToChange))])
  }))])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1002:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitorTimeline_vue__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d9a7eea_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_VisitorTimeline_vue__ = __webpack_require__(1312);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitorTimeline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d9a7eea_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_VisitorTimeline_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1003:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);





var moment = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      initialise: true,
      userAccessLevel: this.$store.state.profile.accessLevel,

      options: {
        startDate: moment().subtract(29, 'days'),
        endDate: moment(),
        locale: {
          format: 'DD/MM/YYYY'
        },
        ranges: {
          'Last 7 Days': [moment().subtract(6, 'days'), moment()],
          'Last 30 Days': [moment().subtract(29, 'days'), moment()],
          'This Month': [moment().startOf('month'), moment().endOf('month')],
          'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        }
      },
      yAxisLabels: [],
      sliderEndPoint: '',
      sliderStartPoint: '',
      option: null
    };
  },

  mounted: function mounted() {
    var _this = this;

    var el = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.ref.$el);
    el.on('apply.daterangepicker', function (event, picker) {
      var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      _this.sliderEndPoint = picker.endDate.format('L').substring(3, 5) + ' ' + monthNames[parseInt(picker.endDate.format('L').substring(0, 2)) - 1];
      _this.sliderStartPoint = picker.startDate.format('L').substring(3, 5) + ' ' + monthNames[parseInt(picker.startDate.format('L').substring(0, 2)) - 1];
      var sliderStartTime = new Date(picker.startDate.format('L'));
      var sliderEndTime = new Date(picker.endDate.format('L'));
      var dataStartTime = new Date(_this.yAxisLabels[0] + ' 2019');
      var dataEndTime = new Date(_this.yAxisLabels[_this.yAxisLabels.length - 1] + ' 2019');
      if (sliderStartTime < dataStartTime) {
        _this.sliderStartPoint = _this.yAxisLabels[0];
      }
      if (sliderEndTime > dataEndTime) {
        _this.sliderEndPoint = _this.yAxisLabels[_this.yAxisLabels.length - 1];
      }
      _this.setOption(_this.sliderEndPoint, _this.sliderStartPoint, _this.yAxisLabels, _this.numberOfUsers, _this.numberOfInteractions);
      var dom = document.getElementById('graphContainer');
      var myChart = __WEBPACK_IMPORTED_MODULE_1_echarts___default.a.init(dom);
      myChart.setOption(_this.option, true);
    });
    this.getGraph();
  },
  methods: {
    getGraph: function getGraph() {
      var dom = document.getElementById('graphContainer');
      var myChart = __WEBPACK_IMPORTED_MODULE_1_echarts___default.a.init(dom);
      var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var yAxisLabels = [];
      var numberOfUsers = [];
      var numberOfInteractions = [];
      var lastDay = '';

      var year = 2019;

      var todayDate = new Date();
      var date = +__WEBPACK_IMPORTED_MODULE_1_echarts___default.a.number.parseDate(year + '-01-01');
      var end = +__WEBPACK_IMPORTED_MODULE_1_echarts___default.a.number.parseDate(year + '-' + (todayDate.getMonth() + 1) + '-' + todayDate.getDate());
      var dayTime = 3600 * 24 * 1000;

      for (var time = date; time <= end; time += dayTime) {
        var dateString = __WEBPACK_IMPORTED_MODULE_1_echarts___default.a.format.formatTime('yyyy-MM-dd', time);
        lastDay = dateString.substring(8) + ' ' + monthNames[parseInt(dateString.substring(5, 7)) - 1];
        yAxisLabels.push(lastDay);
        var userNumber = Math.floor(Math.random() * 500);
        var botNumber = userNumber + Math.floor(Math.random() * 500);
        numberOfInteractions.push(botNumber);
        numberOfUsers.push(userNumber);
      }

      if (this.initialise) {
        this.sliderEndPoint = lastDay;
        this.sliderStartPoint = yAxisLabels[yAxisLabels.length - 30];
        this.yAxisLabels = yAxisLabels;
        this.numberOfUsers = numberOfUsers;
        this.numberOfInteractions = numberOfInteractions;
        this.initialise = false;
      }
      this.setOption(this.sliderEndPoint, this.sliderStartPoint, this.yAxisLabels, this.numberOfUsers, this.numberOfInteractions);
      if (this.option && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.option) === 'object') {
        myChart.setOption(this.option, true);
      }
    },
    setOption: function setOption(sliderEndPoint, sliderStartPoint, yAxisLabels, numberOfUsers, numberOfInteractions) {
      this.option = {
        backgroundColor: '#fff',
        animation: false,
        title: {
          top: 5,
          left: 5,
          text: 'Visitors Timeline' },
        legend: {
          top: 10,
          right: 100,
          data: ['Visitors Interaction', 'Visitors']
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            animation: false,
            shadowStyle: { color: 'rgba(50,181,217,0.1)' }
          },
          backgroundColor: 'rgba(255, 255, 255, 1)',
          borderWidth: 1,
          transitionDuration: 0.1,
          borderColor: '#ccc',
          padding: 10,
          textStyle: {
            color: '#000'
          }
        },
        axisPointer: {
          link: { xAxisIndex: 'all' },
          label: {
            backgroundColor: '#777'
          }
        },
        toolbox: {
          orient: 'vertical',
          top: 5,
          right: 20,
          showTitle: false,
          feature: {
            dataZoom: {
              yAxisIndex: false,
              show: false
            },
            restore: {},
            saveAsImage: {}
          }
        },
        grid: [{
          left: '10%',
          right: '8%',
          height: '50%'
        }, {
          left: '10%',
          right: '8%',
          top: '63%',
          height: '16%'
        }],
        xAxis: [{
          type: 'category',
          data: yAxisLabels,
          scale: true,
          boundaryGap: true,
          axisLine: { onZero: false },
          splitLine: { show: false },
          splitNumber: 20,
          min: 'dataMin',
          max: 'dataMax',
          axisPointer: {
            z: 100
          }
        }, {
          type: 'category',
          gridIndex: 1,
          data: yAxisLabels,
          scale: true,
          boundaryGap: true,
          axisLine: { onZero: false },
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: { show: false },
          splitNumber: 20,
          min: 'dataMin',
          max: 'dataMax'
        }],
        yAxis: [{
          scale: true,
          splitArea: {
            show: true
          }
        }, {
          scale: true,
          gridIndex: 1,
          splitNumber: 2,
          axisLabel: { show: false },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false }
        }],
        dataZoom: [{
          type: 'inside',
          xAxisIndex: [0, 1],
          startValue: sliderStartPoint,
          endValue: sliderEndPoint
        }, {
          show: true,
          smooth: true,
          xAxisIndex: [0, 1],
          type: 'slider',
          top: '85%',
          startValue: sliderStartPoint,
          endValue: sliderEndPoint
        }],
        series: [{
          name: 'Visitors',
          type: 'line',
          symbol: 'emptyCircle',
          symbolSize: 8,
          color: '#32b5d9',
          data: numberOfUsers,
          smooth: false,
          lineStyle: {
            color: '#32b5d9'
          }
        }, {
          name: 'Visitors Interaction',
          type: 'line',
          symbol: 'circle',
          symbolSize: 8,
          color: '#6fdebd',
          label: {
            normal: {
              show: true,
              color: '#fff',
              position: 'top',
              padding: 2,
              borderRadius: 4,
              backgroundColor: '#6fdebd'
            }
          },
          data: numberOfInteractions,
          smooth: false,
          markLine: {
            silent: true,
            type: 'solid',
            label: { show: false },
            lineStyle: {
              color: '#ccc',
              type: 'solid'
            },
            symbol: 'none',
            data: [{
              xAxis: '01 Jan'
            }, {
              xAxis: '01 Feb'
            }, {
              xAxis: '01 Mar'
            }, {
              xAxis: '01 Apr'
            }, {
              xAxis: '01 May'
            }, {
              xAxis: '01 Jun'
            }, {
              xAxis: '01 Jul'
            }, {
              xAxis: '01 Aug'
            }, {
              xAxis: '01 Sep'
            }, {
              xAxis: '01 Oct'
            }, {
              xAxis: '01 Nov'
            }, {
              xAxis: '01 Dec'
            }]
          },
          lineStyle: {
            color: '#6fdebd'
          }
        }, {
          name: 'Visitors',
          type: 'bar',
          color: '#32b5d9',
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          },
          xAxisIndex: 1,
          yAxisIndex: 1,
          data: numberOfUsers
        }]
      };
    }
  }
});

/***/ }),

/***/ 1312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "dateRangePickerContainer"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _c('date-range-picker', {
    ref: "ref",
    staticClass: "ml-2 dateRangePicker",
    attrs: {
      "options": _vm.options
    }
  }), _c('i', {
    staticClass: "fa fa-caret-down"
  })], 1)])]), _c('br'), _c('div', {
    staticStyle: {
      "height": "800px"
    },
    attrs: {
      "id": "graphContainer"
    }
  })])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DailyVisitor_vue__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_529f37ee_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_DailyVisitor_vue__ = __webpack_require__(1318);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DailyVisitor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_529f37ee_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_DailyVisitor_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);







var moment = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    var _ranges;

    var thisYear = moment().startOf('year').format('YYYY');
    return {
      initialise: true,
      userAccessLevel: this.$store.state.profile.accessLevel,

      options: {
        startDate: moment().startOf('year'),
        locale: {
          format: 'YYYY'
        },
        singleDatePicker: true,
        showCustomRangeLabel: false,
        showDropdowns: false,
        ranges: (_ranges = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ranges, '' + thisYear, [moment().startOf('year')]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ranges, '' + (thisYear - 1), [moment().subtract(1, 'year').startOf('year')]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ranges, '' + (thisYear - 2), [moment().subtract(2, 'year').startOf('year')]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ranges, '' + (thisYear - 3), [moment().subtract(3, 'year').startOf('year')]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ranges, '' + (thisYear - 4), [moment().subtract(4, 'year').startOf('year')]), _ranges)
      },
      range: moment().startOf('year').format('YYYY'),
      yAxisLabels: [],
      option: null
    };
  },

  mounted: function mounted() {
    var _this = this;

    var el = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$refs.ref.$el);
    var that = this;
    el.on('apply.daterangepicker', function (event, picker) {
      that.range = '' + picker.startDate.format('YYYY');
      var userMaximum = 0;
      var interactionMaximum = 0;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(_this.fullData).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];

        var year = key.substring(0, 4);
        if (year == that.range) {
          userMaximum = Math.max(userMaximum, val.totals.users ? val.totals.users.total : 0);
          interactionMaximum = Math.max(interactionMaximum, val.totals.interactions ? val.totals.interactions.total : 0);
        }
      });
      _this.setOption(_this.range, _this.yAxisLabels, _this.numberOfUsers, _this.numberOfInteractions, userMaximum, interactionMaximum);
      var userContainerDom = document.getElementById('userContainer');
      var interactionContainerDom = document.getElementById('interactionContainer');
      var userChart = __WEBPACK_IMPORTED_MODULE_4_echarts___default.a.init(userContainerDom);
      var interactionChart = __WEBPACK_IMPORTED_MODULE_4_echarts___default.a.init(interactionContainerDom);
      userChart.setOption(_this.userOption, true);
      interactionChart.setOption(_this.interactionOption, true);
    });
    this.getGraph();
  },
  methods: {
    getGraph: function getGraph() {
      var userContainerDom = document.getElementById('userContainer');
      var interactionContainerDom = document.getElementById('interactionContainer');
      var userChart = __WEBPACK_IMPORTED_MODULE_4_echarts___default.a.init(userContainerDom);
      var interactionChart = __WEBPACK_IMPORTED_MODULE_4_echarts___default.a.init(interactionContainerDom);
      var userMaximum = 1000;
      var interactionMaximum = 1000;

      var numberOfUsers = [];
      var numberOfInteractions = [];

      function getVirtulData(year) {
        year = year || '2017';
        var date = +__WEBPACK_IMPORTED_MODULE_4_echarts___default.a.number.parseDate(year + '-01-01');
        var end = +__WEBPACK_IMPORTED_MODULE_4_echarts___default.a.number.parseDate(+year + 1 + '-01-01');
        var dayTime = 3600 * 24 * 1000;
        var data = [];
        for (var time = date; time < end; time += dayTime) {
          data.push([__WEBPACK_IMPORTED_MODULE_4_echarts___default.a.format.formatTime('yyyy-MM-dd', time), Math.floor(Math.random() * 1000)]);
        }
        return data;
      }
      numberOfUsers = getVirtulData(2019);
      numberOfInteractions = getVirtulData(2019);

      if (this.initialise) {
        this.numberOfUsers = numberOfUsers;
        this.numberOfInteractions = numberOfInteractions;
        this.userMaximum = userMaximum;
        this.interactionMaximum = interactionMaximum;
        this.initialise = false;
      }
      this.setOption(this.range, this.yAxisLabels, this.numberOfUsers, this.numberOfInteractions, this.userMaximum, this.interactionMaximum);
      if (this.userOption && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.userOption) === 'object') {
        userChart.setOption(this.userOption, true);
        interactionChart.setOption(this.interactionOption, true);
      }
    },
    setOption: function setOption(range, yAxisLabels, numberOfUsers, numberOfInteractions, userMaximum, interactionMaximum) {
      this.userOption = {
        backgroundColor: '#fff',
        animation: false,
        title: {
          top: 5,
          left: 5,
          text: 'Daily Number of Visitors Heatmap'
        },
        tooltip: {
          formatter: function formatter(c0) {
            var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            var lastDay = c0.data[0].substring(8, 10) + ' ' + monthNames[parseInt(c0.data[0].substring(5, 7)) - 1];
            return lastDay + ' - ' + c0.data[1];
          },
          backgroundColor: 'rgba(255, 255, 255, 1)',
          borderWidth: 1,
          transitionDuration: 0.1,
          borderColor: '#ccc',
          padding: 10,
          textStyle: {
            color: '#000'
          },
          position: 'top'
        },
        visualMap: {
          type: 'continuous',
          min: 0,
          max: userMaximum,
          itemWidth: 20,
          calculable: true,
          text: ['Busy', 'Quiet'],
          textStyle: { fontWeight: 'bold', fontSize: 10 },
          orient: 'horizontal',
          color: ['#6fdebd', '#fafffd'],
          right: 80,
          top: 10
        },
        toolbox: {
          orient: 'vertical',
          top: 5,
          right: 20,
          showTitle: false,
          feature: {
            dataZoom: {
              yAxisIndex: false,
              show: false
            },
            restore: {},
            saveAsImage: {}
          }
        },
        calendar: [{
          yearLabel: {
            formatter: 'Visitors',
            textStyle: {
              fontSize: 14,
              color: '#666'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#666',
              width: 2,
              type: 'solid'
            }
          },
          dayLabel: { firstDay: 1 },
          top: '80',
          left: '80',
          right: '50',
          range: range,
          cellSize: ['auto', 20]
        }],
        series: [{
          type: 'heatmap',
          coordinateSystem: 'calendar',
          calendarIndex: 0,
          data: numberOfUsers
        }]
      };

      this.interactionOption = {
        backgroundColor: '#fff',
        animation: false,
        title: {
          top: 5,
          left: 5,
          text: 'Daily Visitor Interactions Heatmap'
        },
        tooltip: {
          formatter: function formatter(c0) {
            var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            var lastDay = c0.data[0].substring(8, 10) + ' ' + monthNames[parseInt(c0.data[0].substring(5, 7)) - 1];
            return lastDay + ' - ' + c0.data[1];
          },
          backgroundColor: 'rgba(255, 255, 255, 1)',
          borderWidth: 1,
          transitionDuration: 0.1,
          borderColor: '#ccc',
          padding: 10,
          textStyle: {
            color: '#000'
          },
          position: 'top'
        },
        toolbox: {
          orient: 'vertical',
          top: 5,
          right: 20,
          showTitle: false,
          feature: {
            dataZoom: {
              yAxisIndex: false,
              show: false
            },
            restore: {},
            saveAsImage: {}
          }
        },
        visualMap: {
          type: 'continuous',
          min: 0,
          max: interactionMaximum,
          itemWidth: 20,
          calculable: true,
          text: ['Busy', 'Quiet'],
          textStyle: { fontWeight: 'bold', fontSize: 10 },
          orient: 'horizontal',
          color: ['#32b5d9', '#fafeff'],
          right: 80,
          top: 10
        },
        calendar: [{
          yearLabel: {
            formatter: 'Visitor Interactions',
            textStyle: {
              fontSize: 14,
              color: '#666'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#666',
              width: 2,
              type: 'solid'
            }
          },
          dayLabel: { firstDay: 1 },
          top: 100,
          left: '80',
          right: '50',
          range: range,
          cellSize: ['auto', 20]
        }],
        series: [{
          type: 'heatmap',
          coordinateSystem: 'calendar',
          calendarIndex: 0,
          data: numberOfInteractions
        }]
      };
    }
  }
});

/***/ }),

/***/ 1318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "dateRangePickerContainer"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _c('date-range-picker', {
    ref: "ref",
    staticClass: "ml-2 dateRangePicker",
    attrs: {
      "options": _vm.options
    }
  }), _c('i', {
    staticClass: "fa fa-caret-down"
  })], 1)])]), _c('br'), _c('div', {
    staticStyle: {
      "height": "300px"
    },
    attrs: {
      "id": "interactionContainer"
    }
  }), _c('div', {
    staticStyle: {
      "height": "300px"
    },
    attrs: {
      "id": "userContainer"
    }
  })])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InteractionsTimeline_vue__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19611514_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_InteractionsTimeline_vue__ = __webpack_require__(1321);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InteractionsTimeline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19611514_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_InteractionsTimeline_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);




var moment = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      initialise: true,
      userAccessLevel: this.$store.state.profile.accessLevel,

      options: {
        startDate: moment().subtract(29, 'days'),
        endDate: moment(),
        locale: {
          format: 'DD/MM/YYYY'
        },
        ranges: {
          'Last 7 Days': [moment().subtract(6, 'days'), moment()],
          'Last 30 Days': [moment().subtract(29, 'days'), moment()],
          'This Month': [moment().startOf('month'), moment().endOf('month')],
          'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        }
      },
      yAxisLabels: [],
      sliderEndPoint: '',
      sliderStartPoint: '',
      option: null
    };
  },

  mounted: function mounted() {
    var _this = this;

    var el = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$refs.ref.$el);
    el.on('apply.daterangepicker', function (event, picker) {
      var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      _this.sliderEndPoint = picker.endDate.format('L').substring(3, 5) + ' ' + monthNames[parseInt(picker.endDate.format('L').substring(0, 2)) - 1];
      _this.sliderStartPoint = picker.startDate.format('L').substring(3, 5) + ' ' + monthNames[parseInt(picker.startDate.format('L').substring(0, 2)) - 1];
      _this.setOption(_this.sliderEndPoint, _this.sliderStartPoint, _this.yAxisLabels, _this.numberOfTotal, _this.numberOfAgent, _this.numberOfBot, _this.numberOfUser);
      var sliderStartTime = new Date(picker.startDate.format('L'));
      var sliderEndTime = new Date(picker.endDate.format('L'));
      var dataStartTime = new Date(_this.yAxisLabels[0] + ' 2019');
      var dataEndTime = new Date(_this.yAxisLabels[_this.yAxisLabels.length - 1] + ' 2019');
      if (sliderStartTime < dataStartTime) {
        _this.sliderStartPoint = _this.yAxisLabels[0];
      }
      if (sliderEndTime > dataEndTime) {
        _this.sliderEndPoint = _this.yAxisLabels[_this.yAxisLabels.length - 1];
      }
      _this.setOption(_this.sliderEndPoint, _this.sliderStartPoint, _this.yAxisLabels, _this.numberOfTotal, _this.numberOfAgent, _this.numberOfBot, _this.numberOfUser);
      var dom = document.getElementById('graphContainer');
      var myChart = __WEBPACK_IMPORTED_MODULE_1_echarts___default.a.init(dom);
      myChart.setOption(_this.option, true);
    });
    this.getGraph();
  },
  methods: {
    getGraph: function getGraph() {
      this.loadRealData = true;
      var dom = document.getElementById('graphContainer');
      var myChart = __WEBPACK_IMPORTED_MODULE_1_echarts___default.a.init(dom);
      var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var yAxisLabels = [];
      var numberOfTotal = [];
      var numberOfAgent = [];
      var numberOfBot = [];
      var numberOfUser = [];
      var lastDay = '';
      var year = 2019;

      var todayDate = new Date();
      var date = +__WEBPACK_IMPORTED_MODULE_1_echarts___default.a.number.parseDate(year + '-01-01');
      var end = +__WEBPACK_IMPORTED_MODULE_1_echarts___default.a.number.parseDate(year + '-' + (todayDate.getMonth() + 1) + '-' + todayDate.getDate());
      var dayTime = 3600 * 24 * 1000;

      for (var time = date; time < end; time += dayTime) {
        var dateString = __WEBPACK_IMPORTED_MODULE_1_echarts___default.a.format.formatTime('yyyy-MM-dd', time);
        lastDay = dateString.substring(8) + ' ' + monthNames[parseInt(dateString.substring(5, 7)) - 1];
        yAxisLabels.push(lastDay);
        var agentNumber = Math.floor(Math.random() * 100);
        var botNumber = Math.floor(Math.random() * 1000);
        var userNumber = Math.floor(Math.random() * 1000);
        numberOfTotal.push(agentNumber + botNumber + userNumber);
        numberOfAgent.push(agentNumber);
        numberOfBot.push(botNumber);
        numberOfUser.push(userNumber);
      }
      this.sliderEndPoint = lastDay;
      this.sliderStartPoint = yAxisLabels[yAxisLabels.length - 30];
      this.yAxisLabels = yAxisLabels;
      this.numberOfTotal = numberOfTotal;
      this.numberOfAgent = numberOfAgent;
      this.numberOfBot = numberOfBot;
      this.numberOfUser = numberOfUser;
      this.initialise = false;
      this.setOption(this.sliderEndPoint, this.sliderStartPoint, this.yAxisLabels, this.numberOfTotal, this.numberOfAgent, this.numberOfBot, this.numberOfUser);
      if (this.option && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.option) === 'object') {
        myChart.setOption(this.option, true);
      }
    },
    setOption: function setOption(sliderEndPoint, sliderStartPoint, yAxisLabels, numberOfTotal, numberOfAgent, numberOfBot, numberOfUser) {
      this.option = {
        backgroundColor: '#fff',
        animation: false,
        title: {
          top: 5,
          left: 5,
          text: 'Interactions Timeline'
        },
        legend: {
          top: 10,
          right: 100,
          data: ['Total', 'Visitors', 'Bot', 'Agent']
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            animation: false,
            shadowStyle: { color: 'rgba(50,181,217,0.1)' }
          },
          backgroundColor: 'rgba(255, 255, 255, 1)',
          borderWidth: 1,
          transitionDuration: 0.1,
          borderColor: '#ccc',
          padding: 10,
          textStyle: {
            color: '#000'
          }
        },
        axisPointer: {
          link: {
            xAxisIndex: 'all'
          },
          label: {
            backgroundColor: '#777'
          }
        },
        toolbox: {
          orient: 'vertical',
          top: 5,
          right: 20,
          showTitle: false,
          feature: {
            dataZoom: {
              yAxisIndex: false,
              show: false
            },
            restore: {},
            saveAsImage: {}
          }
        },
        grid: [{
          left: '10%',
          right: '8%',
          height: '50%'
        }, {
          left: '10%',
          right: '8%',
          top: '66%',
          height: '16%'
        }],
        xAxis: [{
          type: 'category',
          data: yAxisLabels,
          scale: true,
          boundaryGap: true,
          axisLine: {
            onZero: false
          },
          splitLine: { show: true },
          splitNumber: 20,
          min: 'dataMin',
          max: 'dataMax',
          axisPointer: {
            z: 100
          }
        }, {
          type: 'category',
          gridIndex: 1,
          data: yAxisLabels,
          scale: true,
          boundaryGap: true,
          axisLine: { onZero: false },
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: { show: false },
          splitNumber: 20,
          min: 'dataMin',
          max: 'dataMax'
        }],
        yAxis: [{
          scale: true,
          splitArea: {
            show: true
          }
        }, {
          scale: true,
          gridIndex: 1,
          splitNumber: 2,
          axisLabel: { show: false },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false }
        }],
        dataZoom: [{
          type: 'inside',
          xAxisIndex: [0, 1],
          startValue: sliderStartPoint,
          endValue: sliderEndPoint
        }, {
          show: true,
          smooth: true,
          xAxisIndex: [0, 1],
          type: 'slider',
          top: '85%',
          startValue: sliderStartPoint,
          endValue: sliderEndPoint
        }],
        series: [{
          name: 'Total',
          type: 'line',
          symbol: 'circle',
          barGap: 0,
          symbolSize: 8,
          step: 'middle',
          smooth: false,
          color: '#32b5d9',
          data: numberOfTotal,
          label: {
            normal: {
              show: true,
              color: '#fff',
              position: 'top',
              padding: 2,
              borderRadius: 4,
              backgroundColor: '#32b5d9'
            }
          },
          lineStyle: {
            type: 'dotted',
            color: '#999'
          }
        }, {
          name: 'Visitors',
          type: 'bar',
          barGap: 0,
          symbol: 'circle',
          symbolSize: 8,
          color: '#6fdebd',
          data: numberOfUser,
          smooth: false,
          lineStyle: {
            color: '#6fdebd'
          },
          label: {
            normal: {
              show: true,
              color: '#6fdebd',
              position: 'top'
            }
          }
        }, {
          name: 'Bot',
          barGap: 0,
          type: 'bar',
          symbol: 'circle',
          symbolSize: 8,
          color: '#ffb994',
          data: numberOfBot,
          smooth: false,
          lineStyle: {
            color: '#ffb994'
          },
          label: {
            normal: {
              show: true,
              color: '#ffb994',
              position: 'top'
            }
          }
        }, {
          name: 'Agent',
          type: 'bar',
          symbol: 'circle',
          symbolSize: 8,
          color: '#afb2e3',
          data: numberOfAgent,
          smooth: false,
          lineStyle: {
            color: '#afb2e3'
          },
          label: {
            normal: {
              show: true,
              color: '#afb2e3',
              position: 'top'
            }
          }
        }, {
          name: 'Visitors',
          type: 'bar',
          color: '#6fdebd',
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          },
          xAxisIndex: 1,
          yAxisIndex: 1,
          data: numberOfUser
        }]
      };
    }
  }
});

/***/ }),

/***/ 1321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "dateRangePickerContainer"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _c('date-range-picker', {
    ref: "ref",
    staticClass: "ml-2 dateRangePicker",
    attrs: {
      "options": _vm.options
    }
  }), _c('i', {
    staticClass: "fa fa-caret-down"
  })], 1)])]), _c('br'), _c('div', {
    staticStyle: {
      "height": "800px"
    },
    attrs: {
      "id": "graphContainer"
    }
  })])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DailyInteractions_vue__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf1bd6d4_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_DailyInteractions_vue__ = __webpack_require__(1324);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DailyInteractions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf1bd6d4_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_DailyInteractions_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);







var moment = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    var _ranges;

    var quarter = moment().quarter();
    var year = moment().startOf('year').format('YYYY');
    var startDateString = '';
    var endDateString = '';
    if (quarter == 1) {
      startDateString = year + '-01-01';
      endDateString = year + '-03-31';
    } else if (quarter == 2) {
      startDateString = year + '-04-01';
      endDateString = year + '-06-30';
    } else if (quarter == 3) {
      startDateString = year + '-07-01';
      endDateString = year + '-09-30';
    } else if (quarter == 4) {
      startDateString = year + '-10-01';
      endDateString = year + '-12-31';
    }
    return {
      initialise: true,
      userAccessLevel: this.$store.state.profile.accessLevel,

      options: {
        startDate: moment(startDateString),
        endDate: moment(endDateString),
        locale: {
          format: 'DD/MM/YYYY'
        },
        showCustomRangeLabel: false,
        ranges: (_ranges = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ranges, year + ' - Q4', [moment(year + '-10-01'), moment(year + '-12-31')]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ranges, year + ' - Q3', [moment(year + '-07-01'), moment(year + '-09-30')]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ranges, year + ' - Q2', [moment(year + '-04-01'), moment(year + '-06-30')]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ranges, year + ' - Q1', [moment(year + '-01-01'), moment(year + '-03-31')]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ranges, year - 1 + ' - Q4', [moment(year - 1 + '-10-01'), moment(year - 1 + '-12-31')]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ranges, year - 1 + ' - Q3', [moment(year - 1 + '-07-01'), moment(year - 1 + '-09-30')]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ranges, year - 1 + ' - Q2', [moment(year - 1 + '-04-01'), moment(year - 1 + '-06-30')]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ranges, year - 1 + ' - Q1', [moment(year - 1 + '-01-01'), moment(year - 1 + '-03-31')]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ranges, year - 2 + ' - Q4', [moment(year - 2 + '-10-01'), moment(year - 2 + '-12-31')]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ranges, year - 2 + ' - Q3', [moment(year - 2 + '-07-01'), moment(year - 2 + '-09-30')]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ranges, year - 2 + ' - Q2', [moment(year - 2 + '-04-01'), moment(year - 2 + '-06-30')]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ranges, year - 2 + ' - Q1', [moment(year - 2 + '-01-01'), moment(year - 2 + '-03-31')]), _ranges)
      },
      startDateString: startDateString,
      endDateString: endDateString,
      yAxisLabels: [],
      sliderEndPoint: '',
      sliderStartPoint: '',
      option: null,
      cellSize: [60, 50],
      pieRadius: 18,
      pieInitialized: false,
      app: {}
    };
  },

  mounted: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _this = this;

      var that, dom, myChart, el, year, date, end, dayTime, data, time, agentNumber, botNumber, userNumber;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              that = this;
              dom = document.getElementById('graphContainer');
              myChart = __WEBPACK_IMPORTED_MODULE_4_echarts___default.a.init(dom);
              el = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$refs.ref.$el);
              year = 2019;
              date = +__WEBPACK_IMPORTED_MODULE_4_echarts___default.a.number.parseDate(year + '-01-01');
              end = +__WEBPACK_IMPORTED_MODULE_4_echarts___default.a.number.parseDate(+year + 1 + '-01-01');
              dayTime = 3600 * 24 * 1000;
              data = [];

              for (time = date; time <= end; time += dayTime) {
                agentNumber = Math.floor(Math.random() * 100);
                botNumber = Math.floor(Math.random() * 1000);
                userNumber = Math.floor(Math.random() * 1000);

                data.push([__WEBPACK_IMPORTED_MODULE_4_echarts___default.a.format.formatTime('yyyy-MM-dd', time), userNumber, botNumber, agentNumber]);
              }
              this.fullData = data;
              this.setOption(data);
              if (this.option && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.option) === 'object') {
                myChart.setOption(this.option, true);
              }
              if (!this.app.inNode) {
                setTimeout(function () {
                  this.pieInitialized = true;
                  myChart.setOption({ series: that.getPieSeries(data, myChart) });
                }, 10);
              }

              el.on('apply.daterangepicker', function (event, picker) {
                _this.endDateString = '' + picker.endDate.format('YYYY-MM-DD');
                _this.startDateString = '' + picker.startDate.format('YYYY-MM-DD');
                var date = +__WEBPACK_IMPORTED_MODULE_4_echarts___default.a.number.parseDate(_this.startDateString);
                var end = +__WEBPACK_IMPORTED_MODULE_4_echarts___default.a.number.parseDate(_this.endDateString);
                var data = [];
                var that = _this;
                for (var time = date; time <= end; time += dayTime) {
                  var _agentNumber = Math.floor(Math.random() * 100);
                  var _botNumber = Math.floor(Math.random() * 1000);
                  var _userNumber = Math.floor(Math.random() * 1000);
                  data.push([__WEBPACK_IMPORTED_MODULE_4_echarts___default.a.format.formatTime('yyyy-MM-dd', time), _userNumber, _botNumber, _agentNumber]);
                }
                _this.setOption(_this.fullData);
                myChart.clear();
                myChart.setOption(_this.option, false);
                myChart.setOption({ series: that.getPieSeries(data, myChart) });
              });

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    getPieSeries: function getPieSeries(scatterData, chart) {
      var that = this;
      return __WEBPACK_IMPORTED_MODULE_4_echarts___default.a.util.map(scatterData, function (item, index) {
        var center = chart.convertToPixel('calendar', item);
        return {
          id: index + 'pie',
          type: 'pie',
          color: ['#6fdebd', '#ffb994', '#afb2e3'],
          center: center,
          label: {
            normal: {
              formatter: '{c}',
              position: 'inside'
            }
          },
          radius: that.pieRadius,
          data: [{ name: 'Visitor', value: item[1] }, { name: 'Bot', value: item[2] }, { name: 'Agent', value: item[3] }]
        };
      });
    },
    setOption: function setOption(scatterData) {
      this.option = {
        backgroundColor: '#fff',
        animation: false,
        title: {
          top: 5,
          left: 5,
          text: 'Daily Interactions'
        },
        tooltip: {
          backgroundColor: 'rgba(255, 255, 255, 1)',
          borderWidth: 1,
          transitionDuration: 0.1,
          borderColor: '#ccc',
          padding: 10,
          textStyle: { color: '#000' },
          position: 'top'
        },
        toolbox: {
          orient: 'vertical',
          top: 5,
          right: 20,
          showTitle: false,
          feature: {
            dataZoom: {
              yAxisIndex: false,
              show: false
            },
            restore: {},
            saveAsImage: {}
          }
        },
        legend: {
          data: ['Visitor', 'Bot', 'Agent'],
          orient: 'horizontal',
          align: 'right',
          right: 100,
          top: 10
        },
        calendar: {
          top: 'middle',
          width: '85%',
          orient: 'horizontal',
          cellSize: this.cellSize,
          splitLine: {
            show: true,
            lineStyle: {
              color: '#666',
              width: 2,
              type: 'solid'
            }
          },
          yearLabel: {
            margin: 50,
            show: true,
            textStyle: { margin: '1px', fontSize: 30 }
          },
          dayLabel: {
            margin: 15,
            firstDay: 1,
            nameMap: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            textStyle: {
              fontSize: 15,
              fontWeight: 'bold'
            }
          },
          monthLabel: {
            position: 'end',
            show: true,
            textStyle: {
              fontSize: 24
            }
          },
          range: [this.startDateString, this.endDateString]
        },
        series: [{
          id: 'label',
          type: 'scatter',
          coordinateSystem: 'calendar',
          symbolSize: 1,
          label: {
            normal: {
              show: true,
              formatter: function formatter(params) {
                return __WEBPACK_IMPORTED_MODULE_4_echarts___default.a.format.formatTime('dd', params.value[0]);
              },
              offset: [-this.cellSize[0] / 2 + 10, -this.cellSize[1] / 2 + 10],
              textStyle: {
                color: '#333',
                fontSize: 14,
                fontWeight: 'bold'
              }
            }
          },
          data: scatterData
        }]
      };
    }
  }
});

/***/ }),

/***/ 1324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "dateRangePickerContainer"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _c('date-range-picker', {
    ref: "ref",
    staticClass: "ml-2 dateRangePicker",
    attrs: {
      "options": _vm.options
    }
  }), _c('i', {
    staticClass: "fa fa-caret-down"
  })], 1)])]), _c('br'), _c('div', {
    staticStyle: {
      "height": "500px"
    },
    attrs: {
      "id": "graphContainer"
    }
  })])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntentsPie_vue__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f24d3a9_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_IntentsPie_vue__ = __webpack_require__(1327);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntentsPie_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f24d3a9_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_IntentsPie_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sample_data_json__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sample_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__sample_data_json__);









var moment = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      initialise: true,
      userAccessLevel: this.$store.state.profile.accessLevel,

      options: {
        startDate: moment('20190826').subtract(29, 'days'),
        endDate: moment('20190826'),
        locale: {
          format: 'DD/MM/YYYY'
        },
        ranges: {
          'Last 7 Days': [moment('20190826').subtract(6, 'days'), moment('20190826')],
          'Last 30 Days': [moment('20190826').subtract(29, 'days'), moment('20190826')],
          'This Month': [moment('20190826').startOf('month'), moment('20190826').endOf('month')],
          'Last Month': [moment('20190826').subtract(1, 'month').startOf('month'), moment('20190826').subtract(1, 'month').endOf('month')]
        }
      },
      sliderEndPoint: '',
      sliderStartPoint: '',
      option: null,
      fullData: null
    };
  },

  mounted: function mounted() {
    var _this = this;

    var el = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this.$refs.ref.$el);
    el.on('apply.daterangepicker', function (event, picker) {
      var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(_this.fullData));
      var sliderStartTime = new Date(picker.startDate.format('L'));
      var sliderEndTime = new Date(picker.endDate.format('L'));
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];

        var day = key.substring(6);
        var month = key.substring(4, 6);
        var year = key.substring(0, 4);
        var keyTime = new Date(month + '-' + day + '-' + year);
        if (keyTime < sliderStartTime) {
          delete data[key];
        } else if (keyTime > sliderEndTime) {
          delete data[key];
        }
      });
      _this.loadData(data);
    });
    this.getGraph();
  },
  methods: {
    getGraph: function getGraph() {
      this.fullData = __WEBPACK_IMPORTED_MODULE_7__sample_data_json___default.a.daily;
      var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_7__sample_data_json___default.a.daily));
      var sliderEndTime = new Date('08-26-2019');
      var sliderStartTime = new Date(sliderEndTime - 30 * 24 * 60 * 60 * 1000);
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref3) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
            key = _ref4[0],
            val = _ref4[1];

        var day = key.substring(6);
        var month = key.substring(4, 6);
        var year = key.substring(0, 4);
        var keyTime = new Date(month + '-' + day + '-' + year);
        if (keyTime < sliderStartTime) {
          delete data[key];
        } else if (keyTime > sliderEndTime) {
          delete data[key];
        }
      });
      this.loadData(data);
    },
    loadData: function loadData(data) {
      var dom = document.getElementById('graphContainer');
      var myChart = __WEBPACK_IMPORTED_MODULE_5_echarts___default.a.init(dom);
      var intentNameArray = [];
      var intentNumberArray = [];
      var initialise = true;
      var summedTopics = {};
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref5) {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
            key = _ref6[0],
            val = _ref6[1];

        var dailyDatas = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(val);
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(dailyDatas[0]).forEach(function (_ref7) {
          var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
              intentName = _ref8[0],
              intentData = _ref8[1];

          if (initialise == true) {
            summedTopics = {
              'SmallTalks': { interactions: 0 },
              'General Info': { interactions: 0 },
              'Cust Service': { interactions: 0 },
              'Getting There': { interactions: 0 },
              'Products': { interactions: 0 },
              'Stock Price': { interactions: 0 },
              'Booking': { interactions: 0 },
              'Membership': { interactions: 0 },
              'CDN': { interactions: 0 },
              'Broker': { interactions: 0 },
              'Sector': { interactions: 0 },
              'Latest News': { interactions: 0 }
            };
            initialise = false;
          }
          if (!summedTopics[intentName] && !intentName.includes('ST0') && !intentName.includes('ST7') && !intentName.includes('i10') && !intentName.includes('i11') && !intentName.includes('i12') && !intentName.includes('i20') && !intentName.includes('i21') && !intentName.includes('i22') && !intentName.includes('i23') && !intentName.includes('i31') && !intentName.includes('i32') && !intentName.includes('i33') && !intentName.includes('i34') && !intentName.includes('tt ') && !intentName.includes('TT ') && !intentName.includes('Room-FreeRoom') && !intentName.includes('Get Started - ')) {
            summedTopics[intentName] = {
              interactions: 0
            };
          }
          if (intentName.includes('ST0') || intentName.includes('ST7')) {
            summedTopics['SmallTalks'].interactions += intentData.interactions || 0;
          } else if (intentName.includes('i10')) {
            summedTopics['General Info'].interactions += intentData.interactions || 0;
          } else if (intentName.includes('i11')) {
            summedTopics['Cust Service'].interactions += intentData.interactions || 0;
          } else if (intentName.includes('i12')) {
            summedTopics['Getting There'].interactions += intentData.interactions || 0;
          } else if (intentName.includes('i20')) {
            summedTopics['Products'].interactions += intentData.interactions || 0;
          } else if (intentName.includes('i21')) {
            summedTopics['Stock Price'].interactions += intentData.interactions || 0;
          } else if (intentName.includes('i22')) {
            summedTopics['Booking'].interactions += intentData.interactions || 0;
          } else if (intentName.includes('i23')) {
            summedTopics['Membership'].interactions += intentData.interactions || 0;
          } else if (intentName.includes('i31')) {
            summedTopics['CDN'].interactions += intentData.interactions || 0;
          } else if (intentName.includes('i32')) {
            summedTopics['Broker'].interactions += intentData.interactions || 0;
          } else if (intentName.includes('i33')) {
            summedTopics['Sector'].interactions += intentData.interactions || 0;
          } else if (intentName.includes('i34')) {
            summedTopics['Latest News'].interactions += intentData.interactions || 0;
          } else if (intentName.includes('tt ') || intentName.includes('TT ') || intentName.includes('Room-FreeRoom') || intentName.includes('Get Started - ')) {} else {
            summedTopics[intentName].interactions += intentData.interactions || 0;
          }
        });
      });

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(summedTopics).forEach(function (_ref9) {
        var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref9, 2),
            intentName = _ref10[0],
            intentData = _ref10[1];

        intentNameArray.push(intentName);
        intentNumberArray.push(intentData.interactions || 0);
      });

      var keysSorted = [];
      for (var i = 0; i < intentNumberArray.length; i++) {
        keysSorted.push(i);
      }
      keysSorted.sort(function (a, b) {
        return intentNumberArray[b] - intentNumberArray[a];
      });
      var topIntentNumberArrayTop = [];
      var topIntentNameArray = [];
      for (var _i = 0; _i < intentNumberArray.length; _i += 1) {
        topIntentNumberArrayTop.push(intentNumberArray[keysSorted[_i]]);
        topIntentNameArray.push(intentNameArray[keysSorted[_i]]);
      }

      var legendData = [];
      var seriesData = [];
      var selected = {};
      for (var _i2 = 0; _i2 < topIntentNumberArrayTop.length; _i2++) {
        legendData.push('' + topIntentNameArray[_i2]);
        seriesData.push({
          name: '' + topIntentNameArray[_i2],
          value: topIntentNumberArrayTop[_i2]
        });
        selected['' + topIntentNameArray[_i2]] = true;
      }

      this.setOption(legendData, seriesData, selected);
      if (this.option && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.option) === 'object') {
        myChart.setOption(this.option, true);
      }
    },
    setOption: function setOption(legendData, seriesData, selected) {
      this.option = {
        backgroundColor: '#fff',
        animation: false,
        title: {
          top: 5,
          left: 5,
          text: 'Intents Summary Pie Chart'
        },
        toolbox: {
          orient: 'vertical',
          top: 5,
          right: 20,
          showTitle: false,
          feature: {
            dataZoom: {
              yAxisIndex: false,
              show: false
            },
            restore: {},
            saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'shadow',
            animation: false,
            shadowStyle: { color: 'rgba(50,181,217,0.1)' }
          },
          backgroundColor: 'rgba(255, 255, 255, 1)',
          borderWidth: 1,
          transitionDuration: 0.1,
          borderColor: '#ccc',
          padding: 10,
          textStyle: {
            color: '#000'
          },
          formatter: '{b} : {c} ({d}%)'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          align: 'right',
          right: 20,
          top: 70,
          data: legendData,
          selected: selected
        },
        series: [{
          name: 'Interactions',
          type: 'pie',
          radius: ['30%', '50%'],
          center: ['40%', '50%'],
          color: ['#6fdebd', '#93daa3', '#b3d48f', '#d0cd85', '#e8c485', '#f6bb8d', '#feb39c', '#ffaead', '#f6abc1', '#e4abd2', '#cbaede', '#afb2e3', '#7cbff3', '#24cbed', '#00d4cd', '#54d699', '#8cd179', '#b8c964', '#ddbf5e', '#eeb671', '#f3af88', '#efad9e', '#e3afaf'],
          data: seriesData,
          label: {
            normal: {
              formatter: '{b|{b}:}{c|{c}} {per|{d}%}',
              backgroundColor: '#fff',
              borderColor: '#666',
              borderWidth: 1,
              borderRadius: 4,
              rich: {
                b: {
                  align: 'center',
                  fontSize: 12,
                  padding: [5, 5]
                },
                c: {
                  align: 'center',
                  fontSize: 12,
                  padding: [5, 5],
                  fontWeight: 'bold'
                },
                hr: {
                  borderColor: '#aaa',
                  width: '100%',
                  borderWidth: 0.5,
                  height: 20
                },
                per: {
                  align: 'center',
                  color: '#eee',
                  fontSize: 12,
                  backgroundColor: '#666',
                  padding: [5, 5],
                  borderRadius: 3
                }
              }
            }
          },

          itemStyle: {
            emphasis: {
              shadowBlur: 20,
              shadowOffsetX: 5,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      };
    }
  }
});

/***/ }),

/***/ 1327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "dateRangePickerContainer"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _c('date-range-picker', {
    ref: "ref",
    staticClass: "ml-2 dateRangePicker",
    attrs: {
      "options": _vm.options
    }
  }), _c('i', {
    staticClass: "fa fa-caret-down"
  })], 1)])]), _c('br'), _c('div', {
    staticStyle: {
      "height": "500px"
    },
    attrs: {
      "id": "graphContainer"
    }
  })])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntentsTreemap_vue__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c5c18ca_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_IntentsTreemap_vue__ = __webpack_require__(1330);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntentsTreemap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c5c18ca_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_IntentsTreemap_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sample_data_json__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sample_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__sample_data_json__);









var moment = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      initialise: true,
      userAccessLevel: this.$store.state.profile.accessLevel,

      options: {
        startDate: moment('20190826').subtract(29, 'days'),
        endDate: moment('20190826'),
        locale: {
          format: 'DD/MM/YYYY'
        },
        ranges: {
          'Last 7 Days': [moment('20190826').subtract(6, 'days'), moment('20190826')],
          'Last 30 Days': [moment('20190826').subtract(29, 'days'), moment('20190826')],
          'This Month': [moment('20190826').startOf('month'), moment('20190826').endOf('month')],
          'Last Month': [moment('20190826').subtract(1, 'month').startOf('month'), moment('20190826').subtract(1, 'month').endOf('month')]
        }
      },
      yAxisLabels: [],
      sliderEndPoint: '',
      sliderStartPoint: '',
      option: null,
      visualMin: -100,
      visualMax: 100,
      visualMinBound: -40,
      visualMaxBound: 40,
      fullData: null
    };
  },

  mounted: function mounted() {
    var _this = this;

    var el = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this.$refs.ref.$el);
    el.on('apply.daterangepicker', function (event, picker) {
      var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(_this.fullData));
      var sliderStartTime = new Date(picker.startDate.format('L'));
      var sliderEndTime = new Date(picker.endDate.format('L'));
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];

        var day = key.substring(6);
        var month = key.substring(4, 6);
        var year = key.substring(0, 4);
        var keyTime = new Date(month + '-' + day + '-' + year);
        if (keyTime < sliderStartTime) {
          delete data[key];
        } else if (keyTime > sliderEndTime) {
          delete data[key];
        }
      });
      _this.loadData(data);
    });
    this.getGraph();
  },
  methods: {
    getGraph: function getGraph() {
      this.fullData = __WEBPACK_IMPORTED_MODULE_7__sample_data_json___default.a.daily;
      var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_7__sample_data_json___default.a.daily));
      var sliderEndTime = new Date('26-08-2019');
      var sliderStartTime = new Date(sliderEndTime - 30 * 24 * 60 * 60 * 1000);
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref3) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
            key = _ref4[0],
            val = _ref4[1];

        var day = key.substring(6);
        var month = key.substring(4, 6);
        var year = key.substring(0, 4);
        var keyTime = new Date(month + '-' + day + '-' + year);
        if (keyTime < sliderStartTime) {
          delete data[key];
        } else if (keyTime > sliderEndTime) {
          delete data[key];
        }
      });
      this.loadData(data);
    },
    loadData: function loadData(data) {
      var dom = document.getElementById('graphContainer');
      var myChart = __WEBPACK_IMPORTED_MODULE_5_echarts___default.a.init(dom);

      var treemapData = [{
        value: 0,
        name: 'SmallTalks',
        id: 'SmallTalks-branch',
        discretion: null,
        children: []
      }, {
        value: 0,
        name: 'Default',
        id: 'Default-branch',
        discretion: null,
        children: []
      }, {
        value: 0,
        name: 'General Info',
        id: 'General-Info-branch',
        discretion: null,
        children: []
      }, {
        value: 0,
        name: 'Cust Service',
        id: 'Cust-Service-branch',
        discretion: null,
        children: []
      }, {
        value: 0,
        name: 'Getting There',
        id: 'Getting-There-branch',
        discretion: null,
        children: []
      }, {
        value: 0,
        name: 'Room',
        id: 'Room-branch',
        discretion: null,
        children: []
      }, {
        value: 0,
        name: 'Stock Price',
        id: 'Stock-Price-branch',
        discretion: null,
        children: []
      }, {
        value: 0,
        name: 'Booking',
        id: 'Booking-branch',
        discretion: null,
        children: []
      }, {
        value: 0,
        name: 'Membership',
        id: 'Membership-branch',
        discretion: null,
        children: []
      }, {
        value: 0,
        name: 'CDN',
        id: 'CDN-branch',
        discretion: null,
        children: []
      }, {
        value: 0,
        name: 'Broker',
        id: 'Broker-branch',
        discretion: null,
        children: []
      }, {
        value: 0,
        name: 'Sector',
        id: 'Sector-branch',
        discretion: null,
        children: []
      }, {
        value: 0,
        name: 'Dining',
        id: 'Dining-branch',
        discretion: null,
        children: []
      }, {
        value: 0,
        name: 'Latest News Intent',
        id: 'Latest-News-branch',
        discretion: null,
        children: []
      }, {
        value: 0,
        name: 'Default Fallback Intent',
        id: 'Fallback-branch',
        discretion: null,
        children: []
      }];

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref5) {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
            key = _ref6[0],
            val = _ref6[1];

        var dailyDatas = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(val);
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(dailyDatas[0]).forEach(function (_ref7) {
          var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
              intentName = _ref8[0],
              intentData = _ref8[1];

          var index = 0;
          if (intentName.includes('ST0') || intentName.includes('ST7')) {
            index = 0;
          } else if (intentName.includes('i00')) {
            index = 1;
          } else if (intentName.includes('i10')) {
            index = 2;
          } else if (intentName.includes('i11')) {
            index = 3;
          } else if (intentName.includes('i12')) {
            index = 4;
          } else if (intentName.includes('i20')) {
            index = 5;
          } else if (intentName.includes('i21')) {
            index = 6;
          } else if (intentName.includes('i22')) {
            index = 7;
          } else if (intentName.includes('i23')) {
            index = 8;
          } else if (intentName.includes('i31')) {
            index = 9;
          } else if (intentName.includes('i32')) {
            index = 10;
          } else if (intentName.includes('i33')) {
            index = 11;
          } else if (intentName.includes('i34')) {
            index = 12;
          } else if (intentName.includes('Default Welcome')) {
            index = 13;
          } else if (intentName.includes('Default Fallback')) {
            index = 14;
          } else if (intentName.includes('tt ') || intentName.includes('TT ') || intentName.includes('Room-FreeRoom') || intentName.includes('Get Started - ')) {
            index = 15;
          }
          if (index != 15) {
            treemapData[index].value += intentData.interactions || 0;
            var foundMatch = false;
            treemapData[index].children.forEach(function (element, key) {
              if (element.name == intentName) {
                treemapData[index].children[key].value += intentData.interactions || 0;
                foundMatch = true;
              }
            });

            if (foundMatch == false) {
              treemapData[index].children.push({
                value: intentData.interactions || 0,
                name: intentName,
                id: intentName,
                discretion: 'mandatory'
              });
            }
          }
        });
      });
      this.convertData(treemapData);
      this.treemapData = treemapData;
      this.setOption(this.treemapData);
      if (this.option && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.option) === 'object') {
        myChart.setOption(this.option, true);
      }
    },
    convertData: function convertData(originList) {
      var min = Infinity;
      var max = -Infinity;

      for (var i = 0; i < originList.length; i++) {
        var node = originList[i];
        if (node) {
          var value = node.value;
          value != null && value < min && (min = value);
          value != null && value > max && (max = value);
        }
      }

      for (var _i = 0; _i < originList.length; _i++) {
        var _node = originList[_i];
        if (_node) {
          if (_node.children) {
            this.convertData(_node.children);
          }
        }
      }
    },
    setOption: function setOption(treemapData) {
      this.option = {
        backgroundColor: '#fff',
        animation: false,
        title: {
          top: 5,
          left: 5,
          text: 'Intents Treemap'
        },
        toolbox: {
          orient: 'vertical',
          top: 5,
          right: 20,
          showTitle: false,
          feature: {
            dataZoom: {
              yAxisIndex: false,
              show: false
            },
            restore: {},
            saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'shadow',
            animation: false,
            shadowStyle: { color: 'rgba(50, 181, 217, 0.1)' }
          },
          backgroundColor: 'rgba(255, 255, 255, 1)',
          borderWidth: 1,
          transitionDuration: 0.1,
          borderColor: '#ccc',
          padding: 10,
          textStyle: {
            color: '#000'
          },
          formatter: function formatter(info) {
            var value = info.value;
            var amount = value;
            return ['<div class="tooltip-title">' + __WEBPACK_IMPORTED_MODULE_5_echarts___default.a.format.encodeHTML(info.name) + ' (' + amount + ')</div>', ''].join('');
          }
        },
        series: [{
          name: 'ALL',
          top: 80,
          type: 'treemap',
          selectedMode: 'single',
          upperLabel: {
            normal: {
              show: true,
              padding: 5,
              fontSize: 12,
              fontWeight: 'bold',
              height: 30
            }
          },
          label: {
            position: 'insideTopLeft',
            show: true,
            formatter: function formatter(params) {
              var arr = ['{name|' + params.name + '} {label|Name}', '{hr|}', '{intentNum|' + __WEBPACK_IMPORTED_MODULE_5_echarts___default.a.format.addCommas(params.value) + '} {label|interactions}'];
              return arr.join('\n');
            },
            rich: {
              intentNum: {
                fontSize: 20,
                color: '#32b5d9'
              },
              label: {
                fontSize: 9,
                backgroundColor: 'rgba(0,0,0,0.3)',
                color: '#fff',
                borderRadius: 2,
                padding: [2, 2],
                lineHeight: 25,
                align: 'left'
              },
              name: {
                fontSize: 10,
                fontWeight: 'bold',
                color: '#50666D'
              },
              hr: {
                width: '100%',
                borderColor: '#99e0da',
                borderWidth: 0.5,
                height: 0,
                lineHeight: 10
              }
            }
          },
          itemStyle: {
            normal: {
              borderColor: '#32b5d9'
            }
          },
          visualMin: this.visualMin,
          visualMax: this.visualMax,
          visualDimension: 0,
          levels: [{
            itemStyle: {
              normal: {
                borderWidth: 3,
                borderColor: '#50666D',
                gapWidth: 3
              }
            }
          }, {
            color: ['#fff9cf', '#d5e6ff', '#b4f6ff', '#beffed', '#effcd1', '#d0edf7', '#ffe0e2', '#eddfed', '#f4f7d0', '#f2ecc7'],
            itemStyle: {
              normal: {
                gapWidth: 0
              }
            }
          }],
          data: treemapData
        }]
      };
    }
  }
});

/***/ }),

/***/ 1330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "dateRangePickerContainer"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _c('date-range-picker', {
    ref: "ref",
    staticClass: "ml-2 dateRangePicker",
    attrs: {
      "options": _vm.options
    }
  }), _c('i', {
    staticClass: "fa fa-caret-down"
  })], 1)])]), _c('br'), _c('div', {
    staticStyle: {
      "height": "800px"
    },
    attrs: {
      "id": "graphContainer"
    }
  })])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntentsList_vue__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_518e7f51_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_IntentsList_vue__ = __webpack_require__(1333);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntentsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_518e7f51_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_IntentsList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jsonToXlsx__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sample_data_json__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sample_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__sample_data_json__);









var moment = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  components: {},
  data: function data() {
    return {
      options: {
        startDate: moment('20190826').subtract(30, 'days'),
        endDate: moment('20190826'),
        locale: {
          format: 'DD/MM/YYYY'
        },
        ranges: {
          'Last 7 Days': [moment('20190826').subtract(6, 'days'), moment('20190826')],
          'Last 30 Days': [moment('20190826').subtract(30, 'days'), moment('20190826')],
          'This Month': [moment('20190826').startOf('month'), moment('20190826').endOf('month')],
          'Last Month': [moment('20190826').subtract(1, 'month').startOf('month'), moment('20190826').subtract(1, 'month').endOf('month')]
        }
      },
      initialise: true,
      userAccessLevel: this.$store.state.profile.accessLevel,
      tableItems: [],
      tableFields: {
        name: {
          label: 'Name of Intent',
          sortable: true,
          tdClass: 'titleWidthInTable'
        },
        category: {
          label: 'Category',
          sortable: true,
          tdClass: 'categoryWidthInTable'
        },
        number: {
          label: 'Number',
          sortable: true,
          sortDesc: 'Descending',
          tdClass: 'categoryWidthInTable'
        },
        percent: {
          label: 'Percent',
          sortable: true,
          tdClass: 'categoryWidthInTable'
        }
      },
      totalTableItems: [],
      totalTableFields: {
        name: {
          label: 'Total',
          tdClass: 'titleWidthInTable'
        },
        category: {
          label: '',
          tdClass: 'categoryWidthInTable'
        },
        number: {
          label: 'Number',
          tdClass: 'categoryWidthInTable'
        },
        percent: {
          label: 'Percent',
          tdClass: 'categoryWidthInTable'
        }
      }
    };
  },

  mounted: function mounted() {
    var _this = this;

    var el = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$refs.ref.$el);
    var that = this;
    el.on('apply.daterangepicker', function (event, picker) {
      var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this.fullData));
      _this.sliderStartTime = new Date(picker.startDate.format('L'));
      _this.sliderEndTime = new Date(picker.endDate.format('L'));
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];

        var day = key.substring(6);
        var month = key.substring(4, 6);
        var year = key.substring(0, 4);
        var keyTime = new Date(month + '-' + day + '-' + year);
        if (keyTime < that.sliderStartTime) {
          delete data[key];
        } else if (keyTime > that.sliderEndTime) {
          delete data[key];
        }
      });
      _this.loadData(data);
    });
    this.getTable();
  },
  methods: {
    getTable: function getTable() {
      var that = this;
      this.fullData = __WEBPACK_IMPORTED_MODULE_6__sample_data_json___default.a.daily;
      var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.fullData));
      this.sliderEndTime = new Date('26-08-2019');
      this.sliderStartTime = new Date(this.sliderEndTime - 30 * 24 * 60 * 60 * 1000);
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref3) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
            key = _ref4[0],
            val = _ref4[1];

        var day = key.substring(6);
        var month = key.substring(4, 6);
        var year = key.substring(0, 4);
        var keyTime = new Date(month + '-' + day + '-' + year);
        if (keyTime < that.sliderStartTime) {
          delete data[key];
        } else if (keyTime > that.sliderEndTime) {
          delete data[key];
        }
      });
      this.loadData(data);
    },
    loadData: function loadData(data) {
      var self = this;
      var listOfIntentName = [];
      var listOfTotalIntent = [];
      var msgs = [];
      var totalMsgs = [];
      var totalNumber = 0;
      var numberUnmatch = 0;
      var totalTopics = {};
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref5) {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
            key = _ref6[0],
            val = _ref6[1];

        var dailyDatas = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(val);
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(dailyDatas[0]).forEach(function (_ref7) {
          var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
              intentName = _ref8[0],
              intentData = _ref8[1];

          if (!totalTopics[intentName]) {
            totalTopics[intentName] = {
              interactions: 0
            };
          }
          totalTopics[intentName].interactions += intentData.interactions || 0;
          if (intentName == 'Default Fallback Intent') {
            numberUnmatch += intentData.interactions;
          }
          totalNumber += intentData.interactions || 0;
        });
      });
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(totalTopics).forEach(function (_ref9) {
        var _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref9, 2),
            intentName = _ref10[0],
            intentData = _ref10[1];

        if (intentData.interactions != 0) {
          listOfIntentName.push(intentName);
          intentData.interactions = intentData.interactions || 0;
          listOfTotalIntent.push(intentData.interactions);
        }
      });
      var keysSorted = [];
      for (var i = 0; i < listOfTotalIntent.length; i++) {
        keysSorted.push(i);
      }
      keysSorted.sort(function (a, b) {
        return listOfTotalIntent[b] - listOfTotalIntent[a];
      });
      var topListOfTotalIntent = [];
      var topListOfIntentName = [];
      var category = '';
      for (var _i = 0; _i < listOfTotalIntent.length; _i += 1) {
        topListOfTotalIntent.push(listOfTotalIntent[keysSorted[_i]]);
        topListOfIntentName.push(listOfIntentName[keysSorted[_i]]);
        if (listOfIntentName[keysSorted[_i]].includes('Small') || listOfIntentName[keysSorted[_i]].includes('ST0')) {
          category = 'Small Talks';
        } else if (listOfIntentName[keysSorted[_i]].includes('i10')) {
          category = 'General Info';
        } else if (listOfIntentName[keysSorted[_i]].includes('i11')) {
          category = 'Cust Service';
        } else if (listOfIntentName[keysSorted[_i]].includes('i12')) {
          category = 'Getting There';
        } else if (listOfIntentName[keysSorted[_i]].includes('i20')) {
          category = 'Room';
        } else if (listOfIntentName[keysSorted[_i]].includes('i21')) {
          category = 'Reservations';
        } else if (listOfIntentName[keysSorted[_i]].includes('i22')) {
          category = 'Booking';
        } else if (listOfIntentName[keysSorted[_i]].includes('i23')) {
          category = 'Membership';
        } else if (listOfIntentName[keysSorted[_i]].includes('i31')) {
          category = 'Casino';
        } else if (listOfIntentName[keysSorted[_i]].includes('i32')) {
          category = 'Concert';
        } else if (listOfIntentName[keysSorted[_i]].includes('i33')) {
          category = 'Attractions';
        } else if (listOfIntentName[keysSorted[_i]].includes('i34')) {
          category = 'Dining';
        } else {
          category = 'Others';
        }
        msgs.push({
          name: listOfIntentName[keysSorted[_i]],
          number: listOfTotalIntent[keysSorted[_i]],
          category: category,
          percent: (listOfTotalIntent[keysSorted[_i]] / totalNumber * 100).toFixed(1) + '%'
        });
      }
      totalMsgs.push({
        name: 'Total Intents',
        number: totalNumber,
        percent: '100%',
        _rowVariant: 'success'
      });
      totalMsgs.push({
        name: 'Total Matched',
        number: totalNumber - numberUnmatch,
        percent: ((totalNumber - numberUnmatch) / totalNumber * 100).toFixed(1) + '%',
        _rowVariant: 'warning'
      });
      totalMsgs.push({
        name: 'Total Unmatched',
        number: numberUnmatch,
        percent: (numberUnmatch / totalNumber * 100).toFixed(1) + '%',
        _rowVariant: 'danger'
      });
      self.tableItems = msgs;
      self.totalTableItems = totalMsgs;
    },
    clickDownloadxlsx: function clickDownloadxlsx() {
      var that = this;
      var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.fullData));
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref11) {
        var _ref12 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref11, 2),
            key = _ref12[0],
            val = _ref12[1];

        var day = key.substring(6);
        var month = key.substring(4, 6);
        var year = key.substring(0, 4);
        var keyTime = new Date(month + '-' + day + '-' + year);
        if (keyTime < that.sliderStartTime) {
          delete data[key];
        } else if (keyTime > that.sliderEndTime) {
          delete data[key];
        }
      });
      var startDate = this.formatDate(that.sliderStartTime);
      var endDate = this.formatDate(that.sliderEndTime);
      Object(__WEBPACK_IMPORTED_MODULE_4__jsonToXlsx__["g" /* exportIntentListExcel */])(data, startDate, endDate);
    },
    clickDownloadpdf: function clickDownloadpdf() {
      var that = this;
      var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.fullData));
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref13) {
        var _ref14 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref13, 2),
            key = _ref14[0],
            val = _ref14[1];

        var day = key.substring(6);
        var month = key.substring(4, 6);
        var year = key.substring(0, 4);
        var keyTime = new Date(month + '-' + day + '-' + year);
        if (keyTime < that.sliderStartTime) {
          delete data[key];
        } else if (keyTime > that.sliderEndTime) {
          delete data[key];
        }
      });
      var startDate = this.formatDate(that.sliderStartTime);
      var endDate = this.formatDate(that.sliderEndTime);
      Object(__WEBPACK_IMPORTED_MODULE_4__jsonToXlsx__["h" /* exportIntentListPdf */])(data, startDate, endDate);
    },

    formatDate: function formatDate(date) {
      var month = '' + (date.getMonth() + 1);
      var day = '' + date.getDate();
      var year = date.getFullYear();
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      return [day, month, year].join('/');
    }
  }
});

/***/ }),

/***/ 1333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Intents List")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Displaying Analytics Of Top Intents In Table")])]), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "dateRangePickerContainerTable"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _c('date-range-picker', {
    ref: "ref",
    staticClass: "ml-2 dateRangePicker",
    attrs: {
      "options": _vm.options
    }
  }), _c('i', {
    staticClass: "fa fa-caret-down"
  })], 1), _c('div', {
    staticClass: "pull-right ml-1 hidden-sm-down"
  }, [_c('b-dropdown', {
    staticClass: "float-right",
    attrs: {
      "variant": "transparent p-0"
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('img', {
    staticStyle: {
      "width": "14px",
      "height": "14px"
    },
    attrs: {
      "src": "static/img/download.png",
      "alt": ""
    }
  })]), _c('b-dropdown-item-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.clickDownloadxlsx
    }
  }, [_vm._v("Download as xlsx")]), _c('b-dropdown-item-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.clickDownloadpdf
    }
  }, [_vm._v("Download as pdf")])], 2)], 1)])]), _c('br'), _c('app-conversationtopictable', {
    attrs: {
      "data": _vm.totalTableItems,
      "label": _vm.totalTableFields
    }
  }), _c('br'), _c('app-conversationtopictable', {
    attrs: {
      "data": _vm.tableItems,
      "label": _vm.tableFields
    }
  })], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fallback_vue__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_418ce20d_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Fallback_vue__ = __webpack_require__(1336);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fallback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_418ce20d_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Fallback_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Fallback',
  data: function data() {
    return {};
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ 1336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Fallback String")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Displaying string that triggered fallback intent")])])]), _c('br'), _c('fallback-table')], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2515ce7d_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__ = __webpack_require__(1339);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2515ce7d_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard'
});

/***/ }),

/***/ 1339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('h1', {
    staticClass: "float-left display-3 mr-4"
  }, [_vm._v("404")]), _c('h4', {
    staticClass: "pt-3"
  }, [_vm._v("Oops! You're lost.")]), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("The page you are looking for was not found.")])]), _c('div', {
    staticClass: "input-prepend input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "prependedInput",
      "size": "16",
      "type": "text",
      "placeholder": "What are you looking for?"
    }
  }), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Search")])])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8a8c664_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(1342);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8a8c664_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(14);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      login: {
        email: '',
        password: ''
      },
      fp: false
    };
  },

  methods: {
    logIn: function logIn() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* auth */].signInWithEmailAndPassword(this.login.email, this.login.password).then(function (user) {
        _this.$router.replace('/');
        _this.$snotify.success('You have successfully logged in');
      }, function (err) {
        _this.$snotify.error('Oops. ' + err.message);
      });
    },
    forgetPassword: function forgetPassword() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* auth */].sendPasswordResetEmail(this.login.email).then(function (user) {
        _this2.$snotify.success('Reset email has been sent!');
      }, function () {
        _this2.$snotify.success('Reset email has been sent!');
      });
    }
  }
});

/***/ }),

/***/ 1342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center",
    staticStyle: {
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-12"
  }, [_c('b-form', [_c('div', {
    staticClass: "mb-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": "static/img/logo.png",
      "alt": ""
    }
  })]), _c('b-input-group', {
    staticClass: "mb-3",
    attrs: {
      "left": "<i class=\"icon-user\"></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "email",
      "autocomplete": "username",
      "placeholder": "Email"
    },
    model: {
      value: (_vm.login.email),
      callback: function($$v) {
        _vm.login.email = $$v
      },
      expression: "login.email"
    }
  })], 1), (!_vm.fp) ? _c('b-input-group', {
    staticClass: "mb-3",
    attrs: {
      "left": "<i class=\"icon-lock\"></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password",
      "autocomplete": "current-password",
      "placeholder": "Password"
    },
    model: {
      value: (_vm.login.password),
      callback: function($$v) {
        _vm.login.password = $$v
      },
      expression: "login.password"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [(!_vm.fp) ? _c('b-button', {
    staticClass: "px-4 mx-auto",
    attrs: {
      "variant": "primary",
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logIn($event)
      }
    }
  }, [_vm._v("Login")]) : _c('b-button', {
    staticClass: "px-4 mx-auto",
    attrs: {
      "variant": "primary",
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.forgetPassword($event)
      }
    }
  }, [_vm._v("Forgot password")])], 1), _c('div', {
    staticClass: "row"
  }, [_c('a', {
    staticClass: "mx-auto text-muted mt-1",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.fp = !_vm.fp
      }
    }
  }, [(!_vm.fp) ? _c('span', [_vm._v("Forgot password?")]) : _c('span', [_vm._v("Login")])])])], 1)], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26d90575_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__ = __webpack_require__(1345);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26d90575_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(14);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Logout',
  data: function data() {
    return {};
  },

  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* auth */].signOut().then(function () {
      _this.$router.replace('login');
      _this.$snotify.info('You have successfully logged out');
    });
  }
});

/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center",
    staticStyle: {
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_vm._v("Logging Out")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside_vue__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout_vue__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header_vue__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch_vue__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Statsbox_vue__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Table_vue__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Chat_vue__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Charts_vue__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DateSelection_vue__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DateSelectionPie_vue__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__InteractionsTable_vue__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__IntentTable_vue__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ConversationTopicTable_vue__ = __webpack_require__(1548);

















/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.component(__WEBPACK_IMPORTED_MODULE_0__Aside_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__Aside_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_2__Callout_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__Callout_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_3__Footer_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__Footer_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_4__Header_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__Header_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_6__Switch_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_6__Switch_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_7__Statsbox_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_7__Statsbox_vue__["a" /* default */]);
    Vue.component('line-chart', __WEBPACK_IMPORTED_MODULE_10__Charts_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_8__Table_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_8__Table_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_9__Chat_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_9__Chat_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_11__DateSelection_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_11__DateSelection_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_12__DateSelectionPie_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_12__DateSelectionPie_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_14__IntentTable_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_14__IntentTable_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_13__InteractionsTable_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_13__InteractionsTable_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_15__ConversationTopicTable_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_15__ConversationTopicTable_vue__["a" /* default */]);
  }
});

/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bf786e9_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(1354);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bf786e9_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BlankDiv__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url_pattern__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url_pattern___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_url_pattern__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-aside',
  components: {
    'blank-div': __WEBPACK_IMPORTED_MODULE_1__BlankDiv__["a" /* default */]
  },
  data: function data() {
    return {
      route: null,

      correspondingRightbarComponent: __WEBPACK_IMPORTED_MODULE_1__BlankDiv__["a" /* default */],

      rightbarComponentsByRoute: [{
        pattern: '/studio',
        component: 'nl-studio-rightbar',
        shownAsDefault: false
      }, {
        pattern: '/interactions/live',
        shownAsDefault: false
      }, {
        pattern: '/interactions/historical',
        shownAsDefault: false
      }, {
        pattern: /\/interactions\/(?:.+)/,
        component: 'interaction-rightbar',
        shownAsDefault: true
      }]
    };
  },

  methods: {
    getMatchingRouteObject: function getMatchingRouteObject(route) {
      var routeObject = void 0;
      var routeObjects = this.rightbarComponentsByRoute;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(routeObjects), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var r = _step.value;

          if (new __WEBPACK_IMPORTED_MODULE_2_url_pattern___default.a(r.pattern).match(route)) {
            routeObject = r;
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      routeObject = routeObject || null;

      return routeObject || null;
    },
    changeRightbarComponent: function changeRightbarComponent(matchedRouteObject, component) {
      var componentOfPattern = matchedRouteObject ? matchedRouteObject.component : null;
      this.correspondingRightbarComponent = component || componentOfPattern || __WEBPACK_IMPORTED_MODULE_1__BlankDiv__["a" /* default */];
    },
    displayRightbar: function displayRightbar(matchedRouteObject) {
      var rightbarShown = document.getElementsByClassName('aside-menu-hidden').length === 0;

      var showRightbar = matchedRouteObject ? matchedRouteObject.shownAsDefault : false;

      if (!rightbarShown && showRightbar) {
        this.$store.dispatch('setAsideStatus');
      } else if (rightbarShown && !showRightbar) {
        this.$store.dispatch('setAsideStatus');
      }
    }
  },
  mounted: function mounted() {
    this.route = this.$route.path;
    var matchedRouteObject = this.getMatchingRouteObject(this.route);
    this.changeRightbarComponent(matchedRouteObject);
    this.displayRightbar(matchedRouteObject);
  },

  watch: {
    $route: function $route(to, from) {
      this.route = to.path;
      var matchedRouteObject = this.getMatchingRouteObject(this.route);
      this.changeRightbarComponent(matchedRouteObject);
      this.displayRightbar(matchedRouteObject);
    }
  }
});

/***/ }),

/***/ 1349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlankDiv_vue__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ca638fc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_BlankDiv_vue__ = __webpack_require__(1351);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlankDiv_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ca638fc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_BlankDiv_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blank-div'
});

/***/ }),

/***/ 1351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "aside-menu",
    staticStyle: {
      "overflow-y": "scroll"
    }
  }, [_c(_vm.correspondingRightbarComponent, {
    tag: "component"
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1355:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24cac5a2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(1357);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24cac5a2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-breadcrumb',
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
        return item;
      }
      if (item.name) {
        item = item.name;
        return item;
      }
    }
  }
});

/***/ }),

/***/ 1357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      staticClass: "breadcrumb-item"
    }, [(_vm.isLast(index)) ? _c('span', {
      staticClass: "active"
    }, [_vm._v(_vm._s(_vm.showName(item)))]) : _c('router-link', {
      attrs: {
        "to": _vm.showName(item) == 'Home' ? '/' : item.path
      }
    }, [_vm._v(_vm._s(_vm.showName(item)))])], 1)
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2dc58be_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(1360);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2dc58be_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-callout',
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),

/***/ 1360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classList
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_789f1aba_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(1363);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_789f1aba_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-footer',
  data: function data() {
    return {
      currentYear: ''
    };
  },

  mounted: function mounted() {
    this.currentYear = new Date().getFullYear();
  }
});

/***/ }),

/***/ 1363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer"
  }, [_c('a', {
    attrs: {
      "href": "http://enchatment.com"
    }
  }, [_vm._v("Enchatment")]), _vm._v(" © 2017 - " + _vm._s(_vm.currentYear) + "\n  "), _vm._m(0)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "float-right"
  }, [_vm._v("Powered by "), _c('a', {
    attrs: {
      "href": "http://chatinfinite.com"
    }
  }, [_vm._v("Chat Infinite")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc5d02a8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(1366);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc5d02a8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(300);






var bots = __WEBPACK_IMPORTED_MODULE_1__firebase__["c" /* metadb */].ref('bots');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-header',
  data: function data() {
    return {
      bots: [],
      currentBot: null
    };
  },

  mounted: function mounted() {
    var _this = this;

    bots.once('value').then(function (snapshot) {
      _this.bots = snapshot.val();
      _this.changeBotInfo();
    });
    this.$store.dispatch('setRef');
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['users'])),
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    },

    changeBot: function changeBot(botName) {
      this.$store.dispatch('changeFBRef', botName);
      this.changeBotInfo();
    },
    changeBotInfo: function changeBotInfo() {
      this.currentBot = this.$store.state.bot;
      var logoURL = this.bots[this.currentBot].logoURL;
      this.$refs.logo.$el.style.backgroundImage = 'url(' + logoURL + ')';
    }
  }
});

/***/ }),

/***/ 1366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-header navbar"
  }, [_c('button', {
    staticClass: "navbar-toggler mobile-sidebar-toggler d-lg-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileSidebarToggle
    }
  }, [_vm._v("☰")]), _vm._v(" "), _c('b-link', {
    ref: "logo",
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggler sidebar-toggler d-md-down-none mr-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sidebarMinimize
    }
  }, [_vm._v("☰")])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1367:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43eeb8cd_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(1379);
function injectStyle (ssrContext) {
  __webpack_require__(1368)
}
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43eeb8cd_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1368:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarNavDropdown__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarNavLink__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarNavTitle__ = __webpack_require__(1376);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_0__SidebarNavDropdown__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_1__SidebarNavLink__["a" /* default */],
    SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_2__SidebarNavTitle__["a" /* default */]
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ec; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ecp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ecrm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ecrmp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ei; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return eip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return exportIntentListExcel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return exportIntentListPdf; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_xlsx__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_xlsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__firebase__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);







var exportIntentListXlsx = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(data, startDate, endDate) {
    var listOfIntentName, listOfTotalIntent, msgs, totalMsgs, totalNumber, numberUnmatch, totalTopics, keysSorted, i, topListOfTotalIntent, topListOfIntentName, category, _i, ws, _i2, _i3, wb, d;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            listOfIntentName = [];
            listOfTotalIntent = [];
            msgs = [];
            totalMsgs = [];
            totalNumber = 0;
            numberUnmatch = 0;
            totalTopics = {};

            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref2) {
              var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
                  key = _ref3[0],
                  val = _ref3[1];

              var dailyDatas = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(val);
              __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(dailyDatas[0]).forEach(function (_ref4) {
                var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
                    intentName = _ref5[0],
                    intentData = _ref5[1];

                if (!totalTopics[intentName]) {
                  totalTopics[intentName] = {
                    interactions: 0
                  };
                }
                totalTopics[intentName].interactions += intentData.interactions || 0;
                if (intentName == 'Default Fallback Intent') {
                  numberUnmatch += intentData.interactions;
                }
                totalNumber += intentData.interactions || 0;
              });
            });
            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(totalTopics).forEach(function (_ref6) {
              var _ref7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref6, 2),
                  intentName = _ref7[0],
                  intentData = _ref7[1];

              if (intentData.interactions != 0) {
                listOfIntentName.push(intentName);
                intentData.interactions = intentData.interactions || 0;
                listOfTotalIntent.push(intentData.interactions);
              }
            });
            keysSorted = [];

            for (i = 0; i < listOfTotalIntent.length; i++) {
              keysSorted.push(i);
            }
            keysSorted.sort(function (a, b) {
              return listOfTotalIntent[b] - listOfTotalIntent[a];
            });
            topListOfTotalIntent = [];
            topListOfIntentName = [];
            category = '';

            for (_i = 0; _i < listOfTotalIntent.length; _i += 1) {
              topListOfTotalIntent.push(listOfTotalIntent[keysSorted[_i]]);
              topListOfIntentName.push(listOfIntentName[keysSorted[_i]]);
              if (listOfIntentName[keysSorted[_i]].includes('Small') || listOfIntentName[keysSorted[_i]].includes('ST0')) {
                category = 'Small Talks';
              } else if (listOfIntentName[keysSorted[_i]].includes('i10')) {
                category = 'General Info';
              } else if (listOfIntentName[keysSorted[_i]].includes('i11')) {
                category = 'Cust Service';
              } else if (listOfIntentName[keysSorted[_i]].includes('i12')) {
                category = 'Getting There';
              } else if (listOfIntentName[keysSorted[_i]].includes('i20')) {
                category = 'Room';
              } else if (listOfIntentName[keysSorted[_i]].includes('i21')) {
                category = 'Reservations';
              } else if (listOfIntentName[keysSorted[_i]].includes('i22')) {
                category = 'Booking';
              } else if (listOfIntentName[keysSorted[_i]].includes('i23')) {
                category = 'Membership';
              } else if (listOfIntentName[keysSorted[_i]].includes('i31')) {
                category = 'Casino';
              } else if (listOfIntentName[keysSorted[_i]].includes('i32')) {
                category = 'Concert';
              } else if (listOfIntentName[keysSorted[_i]].includes('i33')) {
                category = 'Attractions';
              } else if (listOfIntentName[keysSorted[_i]].includes('i34')) {
                category = 'Dining';
              } else {
                category = 'Others';
              }
              msgs.push({
                name: listOfIntentName[keysSorted[_i]],
                number: listOfTotalIntent[keysSorted[_i]],
                category: category,
                percent: (listOfTotalIntent[keysSorted[_i]] / totalNumber * 100).toFixed(1) + '%'
              });
            }
            totalMsgs.push({
              name: 'Total Intents',
              number: totalNumber,
              percent: '100%',
              _rowVariant: 'success'
            });
            totalMsgs.push({
              name: 'Total Matched',
              number: totalNumber - numberUnmatch,
              percent: ((totalNumber - numberUnmatch) / totalNumber * 100).toFixed(1) + '%',
              _rowVariant: 'warning'
            });
            totalMsgs.push({
              name: 'Total Unmatched',
              number: numberUnmatch,
              percent: (numberUnmatch / totalNumber * 100).toFixed(1) + '%',
              _rowVariant: 'danger'
            });
            self.totalTableItems = totalMsgs;

            ws = __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.utils.json_to_sheet([{ A: 'Date Range', B: startDate, C: endDate, D: '' }], { header: ['A', 'B', 'C', 'D'], skipHeader: true });

            __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.utils.sheet_add_json(ws, [{ A: '', B: '', C: '', D: '' }], { header: ['A', 'B', 'C', 'D'], skipHeader: true, origin: -1 });
            __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.utils.sheet_add_json(ws, [{ A: 'Total', B: 'Category', C: 'Number', D: 'Percent' }], { header: ['A', 'B', 'C', 'D'], skipHeader: true, origin: -1 });
            for (_i2 = 0; _i2 < totalMsgs.length; _i2 += 1) {
              __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.utils.sheet_add_json(ws, [{ A: totalMsgs[_i2].name, B: totalMsgs[_i2].category, C: totalMsgs[_i2].number, D: totalMsgs[_i2].percent }], { header: ['A', 'B', 'C', 'D'], skipHeader: true, origin: -1 });
            }
            __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.utils.sheet_add_json(ws, [{ A: '', B: '', C: '', D: '' }], { header: ['A', 'B', 'C', 'D'], skipHeader: true, origin: -1 });
            __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.utils.sheet_add_json(ws, [{ A: 'Name of Intent', B: 'Category', C: 'Number', D: 'Percent' }], { header: ['A', 'B', 'C', 'D'], skipHeader: true, origin: -1 });
            for (_i3 = 0; _i3 < msgs.length; _i3 += 1) {
              __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.utils.sheet_add_json(ws, [{ A: msgs[_i3].name, B: msgs[_i3].category, C: msgs[_i3].number, D: msgs[_i3].percent }], { header: ['A', 'B', 'C', 'D'], skipHeader: true, origin: -1 });
            }
            wb = { SheetNames: [], Sheets: {} };

            wb.SheetNames.push('Intents List');
            wb.Sheets['Intents List'] = ws;
            d = getTimestamp();

            __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.writeFile(wb, 'IntentList_' + d + '.xlsx');

          case 32:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function exportIntentListXlsx(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();





function getTimestamp() {
  var d = new Date();
  var t = String(d.getFullYear()) + String(d.getMonth() + 1) + String(d.getDate()) + String(d.getHours()) + String(d.getMinutes()) + String(d.getSeconds());
  return t;
}

function exportIntentListPDF(data, startDate, endDate) {
  var listOfIntentName = [];
  var listOfTotalIntent = [];
  var msgs = [];
  var totalMsgs = [];
  var totalNumber = 0;
  var numberUnmatch = 0;
  var totalTopics = {};
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref8) {
    var _ref9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref8, 2),
        key = _ref9[0],
        val = _ref9[1];

    var dailyDatas = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(val);
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(dailyDatas[0]).forEach(function (_ref10) {
      var _ref11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref10, 2),
          intentName = _ref11[0],
          intentData = _ref11[1];

      if (!totalTopics[intentName]) {
        totalTopics[intentName] = {
          interactions: 0
        };
      }
      totalTopics[intentName].interactions += intentData.interactions || 0;
      if (intentName == 'Default Fallback Intent') {
        numberUnmatch += intentData.interactions;
      }
      totalNumber += intentData.interactions || 0;
    });
  });
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(totalTopics).forEach(function (_ref12) {
    var _ref13 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref12, 2),
        intentName = _ref13[0],
        intentData = _ref13[1];

    if (intentData.interactions != 0) {
      listOfIntentName.push(intentName);
      intentData.interactions = intentData.interactions || 0;
      listOfTotalIntent.push(intentData.interactions);
    }
  });
  var keysSorted = [];
  for (var i = 0; i < listOfTotalIntent.length; i++) {
    keysSorted.push(i);
  }
  keysSorted.sort(function (a, b) {
    return listOfTotalIntent[b] - listOfTotalIntent[a];
  });
  var topListOfTotalIntent = [];
  var topListOfIntentName = [];
  var category = '';
  for (var _i4 = 0; _i4 < listOfTotalIntent.length; _i4 += 1) {
    topListOfTotalIntent.push(listOfTotalIntent[keysSorted[_i4]]);
    topListOfIntentName.push(listOfIntentName[keysSorted[_i4]]);
    if (listOfIntentName[keysSorted[_i4]].includes('Small') || listOfIntentName[keysSorted[_i4]].includes('ST0')) {
      category = 'Small Talks';
    } else if (listOfIntentName[keysSorted[_i4]].includes('i10')) {
      category = 'General Info';
    } else if (listOfIntentName[keysSorted[_i4]].includes('i11')) {
      category = 'Cust Service';
    } else if (listOfIntentName[keysSorted[_i4]].includes('i12')) {
      category = 'Getting There';
    } else if (listOfIntentName[keysSorted[_i4]].includes('i20')) {
      category = 'Room';
    } else if (listOfIntentName[keysSorted[_i4]].includes('i21')) {
      category = 'Reservations';
    } else if (listOfIntentName[keysSorted[_i4]].includes('i22')) {
      category = 'Booking';
    } else if (listOfIntentName[keysSorted[_i4]].includes('i23')) {
      category = 'Membership';
    } else if (listOfIntentName[keysSorted[_i4]].includes('i31')) {
      category = 'Casino';
    } else if (listOfIntentName[keysSorted[_i4]].includes('i32')) {
      category = 'Concert';
    } else if (listOfIntentName[keysSorted[_i4]].includes('i33')) {
      category = 'Attractions';
    } else if (listOfIntentName[keysSorted[_i4]].includes('i34')) {
      category = 'Dining';
    } else {
      category = 'Others';
    }
    msgs.push({
      name: listOfIntentName[keysSorted[_i4]],
      number: listOfTotalIntent[keysSorted[_i4]],
      category: category,
      percent: (listOfTotalIntent[keysSorted[_i4]] / totalNumber * 100).toFixed(1) + '%'
    });
  }
  totalMsgs.push({
    name: 'Total Intents',
    number: totalNumber,
    percent: '100%',
    _rowVariant: 'success'
  });
  totalMsgs.push({
    name: 'Total Matched',
    number: totalNumber - numberUnmatch,
    percent: ((totalNumber - numberUnmatch) / totalNumber * 100).toFixed(1) + '%',
    _rowVariant: 'warning'
  });
  totalMsgs.push({
    name: 'Total Unmatched',
    number: numberUnmatch,
    percent: (numberUnmatch / totalNumber * 100).toFixed(1) + '%',
    _rowVariant: 'danger'
  });

  var pdf = new Jspdf('p', 'pt');
  var totalColumns = [{ title: 'Total', dataKey: 'total' }, { title: 'Category', dataKey: 'category' }, { title: 'Number', dataKey: 'number' }, { title: 'Percent', dataKey: 'percent' }];
  var intentColumns = [{ title: 'Name of Intent', dataKey: 'name' }, { title: 'Category', dataKey: 'category' }, { title: 'Number', dataKey: 'number' }, { title: 'Percent', dataKey: 'percent' }];
  var titleRows = [];
  var intentRows = [];
  pdf.text('Intents List', 260, 40);
  pdf.setFontSize(12);
  pdf.text(startDate + ' - ' + endDate, 230, 60);

  for (var _i5 = 0; _i5 < totalMsgs.length; _i5 += 1) {
    titleRows.push({ total: totalMsgs[_i5].name, category: totalMsgs[_i5].category, number: totalMsgs[_i5].number, percent: totalMsgs[_i5].percent });
  }
  for (var _i6 = 0; _i6 < msgs.length; _i6 += 1) {
    intentRows.push({ name: msgs[_i6].name, category: msgs[_i6].category, number: msgs[_i6].number, percent: msgs[_i6].percent });
  }
  var d = getTimestamp();
  pdf.autoTable(totalColumns, titleRows, {
    margin: { top: 75 },
    styles: { overflow: 'linebreak' },
    columnStyles: {
      total: {
        overflow: 'linebreak',
        cellWidth: 250
      },
      category: {
        cellWidth: 70
      },
      number: {
        cellWidth: 70
      },
      percent: {
        cellWidth: 70
      }
    }
  });
  pdf.autoTable(intentColumns, intentRows, {
    columnStyles: {
      name: {
        overflow: 'linebreak',
        cellWidth: 250
      },
      category: {
        cellWidth: 70
      },
      number: {
        cellWidth: 70
      },
      percent: {
        cellWidth: 70
      }
    }
  });
  pdf.save('IntentList_' + d + '.pdf');
}

function exportCustomer() {
  __WEBPACK_IMPORTED_MODULE_7__firebase__["b" /* db */].ref('users').once('value').then(function (datasnapshot) {
    var ws = __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.utils.json_to_sheet([{ A: 'Customer Name/ ID', B: 'Email', C: 'Phone Number', D: 'Last Interaction' }], { header: ['A', 'B', 'C', 'D'], skipHeader: true });
    var k = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(datasnapshot.val());
    for (var i = k.length - 1; i >= 0; i--) {
      var key = k[i];
      var name = void 0;
      if (datasnapshot.val()[key].hasOwnProperty('firstName')) {
        name = datasnapshot.val()[key].firstName + ' ' + datasnapshot.val()[key].lastName;
      } else {
        name = key;
      }
      var email = datasnapshot.val()[key].email || 'Not Applicable';
      var ph = datasnapshot.val()[key].telNo || 'Not Applicable';
      var ts = datasnapshot.val()[key].timestamp ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(parseInt(datasnapshot.val()[key].timestamp)).format("Do MMM 'YY, hh:mmA") : __WEBPACK_IMPORTED_MODULE_8_moment___default()().format("Do MMM 'YY, hh:mmA");
      __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.utils.sheet_add_json(ws, [{ A: name, B: email, C: ph, D: ts }], { header: ['A', 'B', 'C', 'D'], skipHeader: true, origin: -1 });
    }

    var wb = { SheetNames: [], Sheets: {} };
    wb.SheetNames.push('Customer');
    wb.Sheets['Customer'] = ws;
    var d = getTimestamp();
    __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.writeFile(wb, 'imSME_ChatBot_CustomerData_' + d + '.xlsx');
  });
}

function exportCustomerPDF() {
  __WEBPACK_IMPORTED_MODULE_7__firebase__["b" /* db */].ref('users').once('value').then(function (datasnapshot) {
    var pdf = new jspdf('p', 'pt');
    var columns = [{ title: 'Customer Name/ ID', dataKey: 'Name' }, { title: 'Email', dataKey: 'Email' }, { title: 'Phone Number', dataKey: 'PhoneNumber' }, { title: 'Last Interaction', dataKey: 'Timezone' }];
    var rows = [];
    pdf.text('Customer Data', 250, 40);
    var k = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(datasnapshot.val());
    for (var i = k.length - 1; i >= 0; i--) {
      var key = k[i];
      var name = void 0;
      if (datasnapshot.val()[key].hasOwnProperty('firstName')) {
        name = datasnapshot.val()[key].firstName + ' ' + datasnapshot.val()[key].lastName;
      } else {
        name = key;
      }
      var email = datasnapshot.val()[key].email || 'Not Applicable';
      var ph = datasnapshot.val()[key].telNo || 'Not Applicable';
      var ts = datasnapshot.val()[key].timestamp ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(parseInt(datasnapshot.val()[key].timestamp)).format("Do MMM 'YY, hh:mmA") : __WEBPACK_IMPORTED_MODULE_8_moment___default()().format("Do MMM 'YY, hh:mmA");
      rows.push({ Name: name, Email: email, PhoneNumber: ph, Timezone: ts });
    }

    var d = getTimestamp();
    pdf.autoTable(columns, rows, { margin: { top: 70 } });
    pdf.save('imSME_ChatBot_CustomerData_' + d + '.pdf');
  });
}

function exportCRM() {
  __WEBPACK_IMPORTED_MODULE_7__firebase__["b" /* db */].ref('custom/appt').once('value').then(function (datasnapshot) {
    var ws = __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.utils.json_to_sheet([{ A: 'Customer Name', B: 'E-mail', C: 'Phone Number', D: 'Submitted On', E: 'Resolved', F: 'Remark' }], { header: ['A', 'B', 'C', 'D', 'E', 'F'], skipHeader: true });
    var k = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(datasnapshot.val());
    for (var i = k.length - 1; i >= 0; i--) {
      var key = k[i];
      var name = datasnapshot.val()[key].fullName || 'Not Applicable';
      var email = datasnapshot.val()[key].email || 'Not Applicable';
      var ph = datasnapshot.val()[key].telNo || 'Not Applicable';
      var ts = __WEBPACK_IMPORTED_MODULE_8_moment___default()(parseInt(datasnapshot.val()[key].timestamp)).format("Do MMM 'YY, hh:mmA");
      var resolved = datasnapshot.val()[key].resolved ? 'Done' : 'Undone';
      var remark = datasnapshot.val()[key].remark || 'Not Applicable';
      __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.utils.sheet_add_json(ws, [{ A: name, B: email, C: ph, D: ts, E: resolved, F: remark }], { header: ['A', 'B', 'C', 'D', 'E', 'F'], skipHeader: true, origin: -1 });
    }

    var wb = { SheetNames: [], Sheets: {} };
    wb.SheetNames.push('CRM');
    wb.Sheets['CRM'] = ws;
    var d = getTimestamp();
    __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.writeFile(wb, 'imSME_ChatBot_CRM_' + d + '.xlsx');
  });
}

function exportCRMPDF() {
  __WEBPACK_IMPORTED_MODULE_7__firebase__["b" /* db */].ref('custom/appt').once('value').then(function (datasnapshot) {
    var pdf = new jspdf('l', 'pt');
    var columns = [{ title: 'Customer Name', dataKey: 'CustomerName' }, { title: 'E-mail', dataKey: 'email' }, { title: 'Phone Number', dataKey: 'PhoneNumber' }, { title: 'Submitted On', dataKey: 'Timestamp' }, { title: 'Resolved', dataKey: 'Resolved' }, { title: 'Remark', dataKey: 'Remark' }];
    var rows = [];
    pdf.text('Customer Relationship Management', 300, 40);
    var k = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(datasnapshot.val());
    for (var i = k.length - 1; i >= 0; i--) {
      var key = k[i];
      var name = datasnapshot.val()[key].fullName || 'Not Applicable';
      var email = datasnapshot.val()[key].email || 'Not Applicable';
      var ph = datasnapshot.val()[key].telNo || 'Not Applicable';
      var ts = __WEBPACK_IMPORTED_MODULE_8_moment___default()(parseInt(datasnapshot.val()[key].timestamp)).format("Do MMM 'YY, hh:mmA");
      var resolved = datasnapshot.val()[key].resolved ? 'Done' : 'Undone';
      var remark = datasnapshot.val()[key].remark || 'Not Applicable';
      rows.push({ CustomerName: name, email: email, PhoneNumber: ph, Timestamp: ts, Resolved: resolved, Remark: remark });
    }

    var d = getTimestamp();
    pdf.autoTable(columns, rows, { margin: { top: 70 } });
    pdf.save('imSME_ChatBot_CRM_' + d + '.pdf');
  });
}

function exportIntent() {
  __WEBPACK_IMPORTED_MODULE_7__firebase__["b" /* db */].ref('analytics/topics').once('value').then(function (datasnapshot) {
    var ws = __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.utils.json_to_sheet([{ A: 'Topics', B: 'Users Count', C: 'Interactions Count' }], { header: ['A', 'B', 'C'], skipHeader: true });
    datasnapshot.forEach(function (child) {
      __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.utils.sheet_add_json(ws, [{ A: child.val().intent, B: child.val().interactions, C: child.val().users }], { header: ['A', 'B', 'C'], skipHeader: true, origin: -1 });
    });
    var wb = { SheetNames: [], Sheets: {} };
    wb.SheetNames.push('Intent');
    wb.Sheets['Intent'] = ws;
    var d = getTimestamp();
    __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.writeFile(wb, 'imSME_ChatBot_Intent_' + d + '.xlsx');
  });
}

function exportIntentPDF() {
  __WEBPACK_IMPORTED_MODULE_7__firebase__["b" /* db */].ref('analytics/topics').once('value').then(function (datasnapshot) {
    var pdf = new jspdf('p', 'pt');
    var columns = [{ title: 'Topics', dataKey: 'Intent' }, { title: 'Users Count', dataKey: 'Interaction' }, { title: 'Interactions Count', dataKey: 'Users' }];
    var rows = [];
    pdf.text('Intent List', 275, 40);
    datasnapshot.forEach(function (child) {
      rows.push({ Intent: child.val().intent, Interaction: child.val().interactions, Users: child.val().users });
    });
    var d = getTimestamp();
    pdf.autoTable(columns, rows, { margin: { top: 70 } });
    pdf.save('imSME_ChatBot_Intent_' + d + '.pdf');
  });
}

var ec = exportCustomer;
var ecp = exportCustomerPDF;
var ecrm = exportCRM;
var ecrmp = exportCRMPDF;
var ei = exportIntent;
var eip = exportIntentPDF;
var exportIntentListExcel = exportIntentListXlsx;
var exportIntentListPdf = exportIntentListPDF;

/***/ }),

/***/ 1370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f631d512_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(1372);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f631d512_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1371:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),

/***/ 1372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": _vm.url,
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" " + _vm._s(_vm.name))]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_vm._t("default")], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1373:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc4f8840_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(1375);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc4f8840_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1374:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      default: ''
    }
  }
});

/***/ }),

/***/ 1375:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": _vm.url
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" " + _vm._s(_vm.name) + "\n  "), _c('b-badge', {
    attrs: {
      "variant": _vm.badge.variant
    }
  }, [_vm._v(_vm._s(_vm.badge.text))])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1376:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e559673c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(1378);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e559673c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1377:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ 1378:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-title"
  }, [_vm._v("\n  " + _vm._s(_vm.name) + "\n")])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1379:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('div', {
    slot: "header"
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_vm._l((_vm.navItems), function(item, index) {
    return _c('li', {
      staticClass: "nav-item"
    }, [(item.title) ? [_c('SidebarNavTitle', {
      attrs: {
        "name": item.name
      }
    })] : (item.divider) ? [_c('li', {
      staticClass: "divider"
    })] : [(item.children) ? [_c('SidebarNavDropdown', {
      attrs: {
        "name": item.name,
        "url": item.url,
        "icon": item.icon
      }
    }, [_vm._l((item.children), function(child, index) {
      return [(child.children) ? [_c('SidebarNavDropdown', {
        attrs: {
          "name": child.name,
          "url": child.url,
          "icon": child.icon
        }
      }, _vm._l((item.children), function(child, index) {
        return _c('li', {
          staticClass: "nav-item"
        }, [_c('SidebarNavLink', {
          attrs: {
            "name": child.name,
            "url": child.url,
            "icon": child.icon,
            "badge": child.badge
          }
        })], 1)
      }))] : [_c('li', {
        staticClass: "nav-item"
      }, [_c('SidebarNavLink', {
        attrs: {
          "name": child.name,
          "url": child.url,
          "icon": child.icon,
          "badge": child.badge
        }
      })], 1)]]
    })], 2)] : [_c('SidebarNavLink', {
      attrs: {
        "name": item.name,
        "url": item.url,
        "icon": item.icon,
        "badge": item.badge
      }
    })]]], 2)
  }), _vm._v(" "), _c('li', {
    staticClass: "nav-item mt-auto"
  }, [_c('SidebarNavLink', {
    attrs: {
      "name": "User Manual",
      "url": "/manual",
      "icon": "icon-notebook"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('SidebarNavLink', {
    attrs: {
      "name": "Profile",
      "url": "/profile",
      "icon": "icon-user"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('SidebarNavLink', {
    attrs: {
      "name": "Logout",
      "url": "/logout",
      "icon": "icon-power"
    }
  })], 1)], 2), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "fixed-bottom",
    slot: "footer"
  })], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f3fa7d3_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(1382);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f3fa7d3_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-switch',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),

/***/ 1382:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: _vm.classList
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.isChecked
    },
    on: {
      "change": _vm.handleChange
    }
  }), _vm._v(" "), (_vm.isOn) ? [_c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": _vm.on,
      "data-off": _vm.off
    }
  })] : [_c('span', {
    staticClass: "switch-label"
  })], _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statsbox_vue__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6e000aa_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Statsbox_vue__ = __webpack_require__(1385);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statsbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6e000aa_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Statsbox_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'statsbox',
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    category: {
      type: String,
      default: 'Uncategorised'
    },
    actions: Array,
    data: Array,
    label: Array
  },
  computed: {
    colorClass: function colorClass() {
      return 'bg-' + this.color;
    }
  },
  methods: {}
});

/***/ }),

/***/ 1385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    class: _vm.colorClass,
    attrs: {
      "no-block": true,
      "no-body": "no-body"
    }
  }, [_c('b-card-body', {
    staticClass: "pb-0"
  }, [(_vm.actions) ? _c('b-dropdown', {
    staticClass: "float-right",
    attrs: {
      "variant": "transparent p-0",
      "right": "right"
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('i', {
    staticClass: "icon-settings"
  })]), _vm._l((_vm.actions), function(action) {
    return _c('b-dropdown-item', {
      key: action.name
    }, [_vm._v(_vm._s(action.name))])
  })], 2) : _vm._e(), _c('h4', {
    staticClass: "mb-0"
  }, [_vm._t("default", [_vm._v("N/A")])], 2), _c('p', [_vm._v(_vm._s(_vm.category))]), _c('div', {
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "height": "70"
    }
  })], 1), _c('small', {
    staticClass: "py-1 px-3"
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Synced")])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eadc7b02_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__(1388);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eadc7b02_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase__ = __webpack_require__(14);







var usersRef = __WEBPACK_IMPORTED_MODULE_3__firebase__["b" /* db */].ref('users');
var msgsRef = __WEBPACK_IMPORTED_MODULE_3__firebase__["b" /* db */].ref('newestChats');
var flagRef = __WEBPACK_IMPORTED_MODULE_3__firebase__["b" /* db */].ref('flags');
var customRef = __WEBPACK_IMPORTED_MODULE_3__firebase__["b" /* db */].ref('custom');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-table',
  data: function data() {
    return {
      messageModel: {},
      modalAppear: {},
      remark: null
    };
  },
  props: {
    sortBy: null,
    sortDesc: true,
    loading: true,
    small: false,
    rowClick: false,
    rowBroadcastClick: false,
    sending: false,
    msg: null,
    data: {
      type: Array,
      default: function _default() {
        return [{
          avatar: { url: 'static/img/avatars/1.jpg', status: 'success' },
          user: { name: 'Yiorgos Avraamu', new: true, registered: 'Jan 1, 2017' },
          country: { name: 'USA', flag: 'static/img/flags/USA.png' },
          usage: { value: 50, period: 'Jun 11, 2017 - Jul 10, 2017' },
          payment: { name: 'Mastercard', icon: 'fa fa-cc-mastercard' },
          activity: '10 sec ago',
          actions: { name: 'Yiorgos Avraamu' }
        }, {
          avatar: { url: 'static/img/avatars/2.jpg', status: 'danger' },
          user: { name: 'Avram Tarasios', new: false, registered: 'Jan 1, 2017' },
          country: { name: 'Brazil', flag: 'static/img/flags/Brazil.png' },
          usage: { value: 22, period: 'Jun 11, 2017 - Jul 10, 2017' },
          payment: { name: 'Visa', icon: 'fa fa-cc-visa' },
          activity: '5 minutes ago',
          actions: { name: 'Yiorgos Avraamu' }
        }, {
          avatar: { url: 'static/img/avatars/3.jpg', status: 'warning' },
          user: { name: 'Quintin Ed', new: true, registered: 'Jan 1, 2017' },
          country: { name: 'India', flag: 'static/img/flags/India.png' },
          usage: { value: 74, period: 'Jun 11, 2017 - Jul 10, 2017' },
          payment: { name: 'Stripe', icon: 'fa fa-cc-stripe' },
          activity: '1 hour ago',
          actions: { name: 'Yiorgos Avraamu' }
        }, {
          avatar: { url: 'static/img/avatars/4.jpg', status: '' },
          user: { name: 'Enéas Kwadwo', new: true, registered: 'Jan 1, 2017' },
          country: { name: 'France', flag: 'static/img/flags/France.png' },
          usage: { value: 98, period: 'Jun 11, 2017 - Jul 10, 2017' },
          payment: { name: 'PayPal', icon: 'fa fa-paypal' },
          activity: 'Last month',
          actions: { name: 'Yiorgos Avraamu' }
        }, {
          avatar: { url: 'static/img/avatars/5.jpg', status: 'success' },
          user: { name: 'Agapetus Tadeáš', new: true, registered: 'Jan 1, 2017' },
          country: { name: 'Spain', flag: 'static/img/flags/Spain.png' },
          usage: { value: 22, period: 'Jun 11, 2017 - Jul 10, 2017' },
          payment: { name: 'Google Wallet', icon: 'fa fa-google-wallet' },
          activity: 'Last week',
          actions: { name: 'Yiorgos Avraamu' }
        }, {
          avatar: { url: 'static/img/avatars/6.jpg', status: 'danger' },
          user: { name: 'Friderik Dávid', new: true, registered: 'Jan 1, 2017' },
          country: { name: 'Poland', flag: 'static/img/flags/Poland.png' },
          usage: { value: 43, period: 'Jun 11, 2017 - Jul 10, 2017' },
          payment: { name: 'Amex', icon: 'fa fa-cc-amex' },
          activity: 'Last week',
          actions: { name: 'Yiorgos Avraamu' }
        }];
      }
    },
    label: {
      type: Object,
      default: function _default() {
        return {
          avatar: {
            label: '<i class="icon-people"></i>',
            class: 'text-center'
          },
          user: {
            label: 'User'
          },
          country: {
            label: 'Country',
            class: 'text-center'
          },
          usage: {
            label: 'Usage'
          },
          payment: {
            label: 'Payment method',
            class: 'text-center'
          },
          activity: {
            label: 'Activity'
          },
          actions: {
            label: '',
            thStyle: {
              minWidth: '14em'
            }
          }
        };
      }
    }
  },
  computed: {},
  updated: function updated() {
    var that = this;
    if (typeof that.data[0] != 'undefined') {
      var checkboxArray = document.getElementsByClassName('checkbox');
      for (var i = 0; i < that.data.length; i++) {
        var id = 'checkbox' + that.data[i].manualRate.key;
        checkboxArray[i].id = id;
        checkboxArray[i].checked = that.data[i].manualRate.value;
      }
    }
  },
  methods: {
    checkboxToggle: function checkboxToggle(value) {
      var id = 'checkbox' + value;
      var bool = {
        manualRate: document.getElementById(id).checked
      };
      customRef.child('jobRequirement').child(value).update(bool);
    },
    letModalAppear: function letModalAppear(id) {
      this.modalAppear[id] = true;
      console.log(this.modalAppear);
    },
    ping: function ping(e) {
      this.rowClick && this.$router.push({ name: 'Interaction', params: { userId: e.userId } });
      this.rowBroadcastClick && this.$router.push({ name: 'Broadcast', params: { Id: e.broadcastActions } });
    },
    sendMessage: function sendMessage(userId, flagged) {
      this.sending = true;
      var content = {
        platform: 'webPopup',
        userID: userId,
        message: this.messageModel[userId]
      };
      console.log(content);
      Object(__WEBPACK_IMPORTED_MODULE_2__api__["i" /* send */])(content).then(function (res) {
        res.error && this.$snotify.error(res.error);
        this.sending = false;
        this.messageModel[userId] = '';

        flagged && Object(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* cancelCountdown */])(userId).then(function (res) {
          console.log(res);
        });
      }.bind(this));

      this.$root.$emit('bv::hide::popover');
    },
    sendRemark: function sendRemark(id, crm, remark) {
      customRef.child(crm).child(id).update({
        remark: remark
      });
      this.$root.$emit('bv::hide::popover');
    },
    onClose: function onClose() {
      this.$refs.popover.$emit('close');
    },
    chatLink: function chatLink(value) {
      return { name: 'Interaction', params: { userId: value } };
    },
    broadcastLink: function broadcastLink(value) {
      return { path: '/broadcast/' + value };
    },
    variant: function variant(value) {
      var $variant = void 0;
      if (value <= 25) {
        $variant = 'info';
      } else if (value > 25 && value <= 50) {
        $variant = 'success';
      } else if (value > 50 && value <= 75) {
        $variant = 'warning';
      } else if (value > 75 && value <= 100) {
        $variant = 'danger';
      }
      return $variant;
    },
    influence: function influence(value) {
      var $influence = void 0;
      if (value < 300) {
        $influence = 'danger';
      } else if (value >= 300 && value < 1000) {
        $influence = 'warning';
      } else if (value >= 1000 && value < 10000) {
        $influence = 'success';
      } else if (value >= 10000) {
        $influence = 'info';
      }
      return $influence;
    },
    heat: function heat(value) {
      var $heat = void 0;
      if (value < 300) {
        $heat = 1;
      } else if (value >= 300 && value < 1000) {
        $heat = 2;
      } else if (value >= 1000 && value < 10000) {
        $heat = 3;
      } else if (value >= 10000) {
        $heat = 4;
      }
      return $heat;
    },
    userIdString: function userIdString(value) {
      return value ? value.toString() : '';
    },
    mailTo: function mailTo(email) {
      return 'mailto:' + email;
    },
    pause: function pause(userId, msgId, timestamp) {
      usersRef.child(userId).update({
        takeover: true
      });

      msgsRef.child(msgId).update({
        timestamp: timestamp + 1
      });
      console.log(userId, msgId, 'paused');
    },
    unpause: function unpause(userId, msgId, timestamp) {
      usersRef.child(userId).update({
        takeover: false
      });

      msgsRef.child(msgId).update({
        timestamp: timestamp - 1
      });
      console.log(userId, msgId, 'unpaused');
    },
    unpauseResolve: function unpauseResolve(userId, msgId, timestamp, flagged) {
      usersRef.child(userId).update({
        takeover: false
      });
      flagRef.orderByChild('userID').equalTo(userId).on('value', function (snapshot) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(snapshot.val()).forEach(function (_ref) {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
              key = _ref2[0],
              val = _ref2[1];

          flagRef.child(key).remove();
        });
      });

      flagged && Object(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* cancelCountdown */])(userId).then(function (res) {
        console.log(res);
      });
      msgsRef.child(msgId).update({
        timestamp: timestamp - 1
      });
      console.log(userId, msgId, 'unpaused');
    },
    spam: function spam(userId, msgId, timestamp, flagged) {
      flagRef.orderByChild('userID').equalTo(userId).on('value', function (snapshot) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(snapshot.val()).forEach(function (_ref3) {
          var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
              key = _ref4[0],
              val = _ref4[1];

          flagRef.child(key).remove();
        });
      });
      usersRef.child(userId).update({
        takeover: false
      });

      flagged && Object(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* cancelCountdown */])(userId).then(function (res) {
        console.log(res);
      });
      msgsRef.child(msgId).update({
        timestamp: timestamp - 1
      });
    },
    resolved: function resolved(key, crm, _resolved) {
      customRef.child(crm).child(key).update({ resolved: !_resolved });
    }
  },
  filters: {
    cleanTime: function cleanTime(val) {
      return val.slice(0, -3);
    },
    nric: function nric(val) {
      try {
        val = val.toString();
        if (val.length == 12) {
          var arr = val.split('');
          arr.splice(6, 0, '-');
          arr.splice(9, 0, '-');
          val = arr.join('');
        }
        return val;
      } catch (res) {
        console.log('nric', res);
        return 'Not Available';
      }
    },
    upperCase: function upperCase(val) {
      if (val) {
        var str = '';
        for (var i in val) {
          if (!parseInt(val[i])) {
            str += val[i].toUpperCase();
          } else {
            str += val[i];
          }
        }
        return str;
      } else {
        return val;
      }
    },
    camelCase: function camelCase(val) {
      return val.split(' ').map(function (word, index) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }).join(' ');
    }
  }
});

/***/ }),

/***/ 1388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-table', {
    staticClass: "table-outline mb-0",
    attrs: {
      "hover": "hover",
      "responsive": "responsive",
      "outline": "outline",
      "head-variant": "default",
      "items": _vm.data,
      "fields": _vm.label,
      "small": _vm.small,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc
    },
    on: {
      "row-clicked": _vm.ping,
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "avatar",
      fn: function(item) {
        return [_c('div', {
          staticClass: "avatar"
        }, [(item.value.tooltip) ? _c('img', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: (_vm.userIdString(item.value.tooltip)),
            expression: "userIdString(item.value.tooltip)",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "img-avatar",
          attrs: {
            "src": item.value.url || "static/img/avatars/0.png",
            "alt": ""
          }
        }) : _vm._e(), (item.value.status) ? _c('span', {
          staticClass: "avatar-status",
          class: {
            'bg-success': item.value.status == 'success', 'bg-warning': item.value.status == 'warning', 'bg-danger': item.value.status == 'danger', 'bg-secondary': item.value.status == ''
          }
        }) : _vm._e()])]
      }
    }, {
      key: "avatarPlain",
      fn: function(item) {
        return [_c('div', {
          staticClass: "avatar"
        }, [_c('img', {
          staticClass: "img-avatar",
          attrs: {
            "src": item.value.url,
            "alt": ""
          }
        })])]
      }
    }, {
      key: "user",
      fn: function(item) {
        return [_c('div', [_vm._v(_vm._s(item.value.name) + " "), (item.value.gender) ? _c('span', [(item.value.gender == "male") ? _c('i', {
          staticClass: "fa fa-mars text-primary"
        }) : _c('i', {
          staticClass: "fa fa-venus text-danger"
        })]) : _vm._e()]), _c('div', {
          staticClass: "small text-muted"
        }, [_c('span', [(item.value.new) ? [_vm._v("New")] : [_vm._v("Recurring")]], 2), _vm._v(" | Registered: "), (typeof item.value.registered == "number") ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(item.value.registered, "from", "now")))]) : _c('span', [_vm._v(_vm._s(item.value.registered))])])]
      }
    }, {
      key: "name",
      fn: function(item) {
        return [_c('span', {
          staticClass: "text-capitalize"
        }, [_vm._v(_vm._s(item.value))])]
      }
    }, {
      key: "company",
      fn: function(item) {
        return [_c('div', [_vm._v(_vm._s(item.value.name) + " ")]), _c('div', {
          staticClass: "small text-muted"
        }, [_vm._v(_vm._s(item.value.Id))])]
      }
    }, {
      key: "country",
      fn: function(item) {
        return [_c('img', {
          staticStyle: {
            "height": "24px"
          },
          attrs: {
            "src": item.value.flag,
            "alt": item.value.name
          }
        })]
      }
    }, {
      key: "usage",
      fn: function(item) {
        return [_c('div', {
          staticClass: "clearfix"
        }, [_c('div', {
          staticClass: "float-left"
        }, [_c('strong', [_vm._v(_vm._s(item.value.value) + "%")])]), _c('div', {
          staticClass: "float-right"
        }, [_c('small', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(item.value.period))])])]), _c('b-progress', {
          staticClass: "progress-xs",
          attrs: {
            "variant": _vm.variant(item.value.value)
          },
          model: {
            value: (item.value.value),
            callback: function($$v) {
              item.value.value = $$v
            },
            expression: "item.value.value"
          }
        })]
      }
    }, {
      key: "payment",
      fn: function(item) {
        return [_c('i', {
          class: item.value.icon,
          staticStyle: {
            "font-size": "24px"
          }
        })]
      }
    }, {
      key: "activity",
      fn: function(item) {
        return [_c('div', {
          staticClass: "small text-muted"
        }, [_vm._v("Last login")]), _c('strong', [_vm._v(_vm._s(item.value))])]
      }
    }, {
      key: "actions",
      fn: function(item) {
        return [_c('b-btn-group', [_c('b-btn', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: ("Reply"),
            expression: "\"Reply\"",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "pill-left",
          attrs: {
            "type": "button",
            "variant": "outline-primary",
            "id": "send" + item.value.id
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-paper-plane-o"
        })]), _c('b-btn', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: ("History"),
            expression: "\"History\"",
            modifiers: {
              "hover": true
            }
          }],
          attrs: {
            "type": "button",
            "variant": "outline-secondary",
            "to": _vm.chatLink(item.value.id),
            "router-tag": "button"
          }
        }, [_c('i', {
          staticClass: "fa fa-history"
        })]), (!item.value.paused) ? _c('b-btn', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: ("Pause Chatbot"),
            expression: "\"Pause Chatbot\"",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "pill-right",
          attrs: {
            "type": "button",
            "variant": "danger"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.pause(item.value.id, item.value.msgID, item.value.timestamp)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pause"
        })]) : _vm._e(), (item.value.paused) ? _c('b-btn', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: ("Unpause Chatbot"),
            expression: "\"Unpause Chatbot\"",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "pill-right",
          attrs: {
            "type": "button",
            "variant": "success"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.unpause(item.value.id, item.value.msgID, item.value.timestamp)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-play"
        })]) : _vm._e()], 1), _c('b-popover', {
          ref: "popover",
          attrs: {
            "target": "send" + item.value.id,
            "placement": "left",
            "triggers": "click"
          }
        }, [_c('b-form', {
          attrs: {
            "inline": "inline"
          },
          on: {
            "submit": function($event) {
              $event.preventDefault();
              _vm.sendMessage(item.value.id)
            },
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_c('b-form-input', {
          staticClass: "pill-left",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.messageModel[item.value.id]),
            callback: function($$v) {
              _vm.$set(_vm.messageModel, item.value.id, $$v)
            },
            expression: "messageModel[item.value.id]"
          }
        }), _c('b-btn', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: (_vm.sending ? "Sending Message" : "Send Message"),
            expression: "sending ? \"Sending Message\" : \"Send Message\"",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "btn pill-right",
          attrs: {
            "type": "button",
            "variant": "outline-primary",
            "disabled": !_vm.messageModel[item.value.id]
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.sendMessage(item.value.id)
            }
          }
        }, [(_vm.sending) ? _c('i', {
          staticClass: "fa fa-refresh fa-spin"
        }) : _c('i', {
          staticClass: "icon-paper-plane"
        })])], 1)], 1)]
      }
    }, {
      key: "quicksend",
      fn: function(item) {
        return [_c('b-form', {
          attrs: {
            "inline": "inline"
          },
          on: {
            "submit": function($event) {
              $event.preventDefault();
              _vm.sendMessage(item.value.id, true)
            },
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_c('b-input-group', {
          staticClass: "ml-auto"
        }, [_c('b-form-input', {
          model: {
            value: (_vm.messageModel[item.value.id]),
            callback: function($$v) {
              _vm.$set(_vm.messageModel, item.value.id, $$v)
            },
            expression: "messageModel[item.value.id]"
          }
        }), _c('b-input-group-button', {
          slot: "right"
        }, [(!item.value.paused) ? _c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: ("Pause Chatbot"),
            expression: "\"Pause Chatbot\"",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "btn",
          attrs: {
            "type": "button",
            "variant": "danger"
          },
          on: {
            "click": function($event) {
              _vm.pause(item.value.id, item.value.msgID, item.value.timestamp)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pause"
        })]) : _vm._e(), (item.value.paused) ? _c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: ("Unpause Chatbot"),
            expression: "\"Unpause Chatbot\"",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "btn",
          attrs: {
            "type": "button",
            "variant": "success"
          },
          on: {
            "click": function($event) {
              _vm.unpauseResolve(item.value.id, item.value.msgID, item.value.timestamp, true)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-play"
        })]) : _vm._e(), _c('b-btn', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: ("Spam"),
            expression: "\"Spam\"",
            modifiers: {
              "hover": true
            }
          }],
          attrs: {
            "type": "button",
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              _vm.spam(item.value.id, item.value.msgID, item.value.timestamp, true)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-shield"
        })]), _c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: (_vm.sending ? "Sending Message" : "Send Message"),
            expression: "sending ? \"Sending Message\" : \"Send Message\"",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "btn text-white",
          attrs: {
            "type": "submit",
            "variant": "secondary",
            "disabled": !_vm.messageModel[item.value.id]
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.sendMessage(item.value.id, true)
            }
          }
        }, [(_vm.sending) ? _c('i', {
          staticClass: "fa fa-refresh fa-spin"
        }) : _c('i', {
          staticClass: "icon-paper-plane"
        })])], 1)], 1)], 1)]
      }
    }, {
      key: "timestamp",
      fn: function(item) {
        return [_vm._v(_vm._s(_vm._f("moment")(item.value, "from", "now")))]
      }
    }, {
      key: "momentDate",
      fn: function(item) {
        return [_vm._v(_vm._s(_vm._f("moment")(item.value, "from", "now")))]
      }
    }, {
      key: "numTimestamp",
      fn: function(item) {
        return [_vm._v(_vm._s(_vm._f("moment")(item.value, "Do MMM 'YY, hh:mmA")))]
      }
    }, {
      key: "timezone",
      fn: function(item) {
        return [_vm._v("+" + _vm._s(item.value))]
      }
    }, {
      key: "message",
      fn: function(item) {
        return [_c('div', [_vm._v(_vm._s(item.value))])]
      }
    }, {
      key: "messagePair",
      fn: function(item) {
        return [_c('div', {
          staticClass: "text-secondary"
        }, [_vm._v(_vm._s(item.value.messagePrev))]), _c('div', [_vm._v(_vm._s(item.value.message))])]
      }
    }, {
      key: "upperCase",
      fn: function(item) {
        return [_vm._v(_vm._s(_vm._f("upperCase")(item.value)))]
      }
    }, {
      key: "nric",
      fn: function(item) {
        return [_vm._v(_vm._s(_vm._f("nric")(item.value)))]
      }
    }, {
      key: "messageId",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "fbId",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "phoneId",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "topic",
      fn: function(item) {
        return [_vm._v(_vm._s(_vm._f("cleanTime")(item.value)))]
      }
    }, {
      key: "intent",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "users",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "interactions",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "exits",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value)), _c('small', [_vm._v("%")])]
      }
    }, {
      key: "respondTime",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value)), _c('small', [_vm._v("s")])]
      }
    }, {
      key: "agent",
      fn: function(item) {
        return [_c('div', {
          staticClass: "avatar"
        }, [_c('img', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            value: (_vm.userIdString(item.value.tooltip)),
            expression: "userIdString(item.value.tooltip)",
            modifiers: {
              "hover": true,
              "right": true
            }
          }],
          staticClass: "img-avatar",
          attrs: {
            "src": item.value.url,
            "alt": ""
          }
        })])]
      }
    }, {
      key: "campaign",
      fn: function(item) {
        return [(item.value.campaignTitle) ? _c('div', [_vm._v(_vm._s(item.value.campaignTitle))]) : _c('div', [_vm._v("Untitled Campaign")]), _c('div', {
          staticClass: "small text-muted"
        }, [_vm._v(_vm._s(item.value.campaign))])]
      }
    }, {
      key: "startDate",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "endDate",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "audience",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "sent",
      fn: function(item) {
        return [(item.value) ? _c('i', {
          staticClass: "fa fa-check text-success"
        }) : _c('i', {
          staticClass: "fa fa-spinner"
        })]
      }
    }, {
      key: "statusString",
      fn: function(item) {
        return [(item.value.mapUrl != "null") ? _c('b-btn', {
          staticClass: "mr-1 text-white",
          attrs: {
            "type": "button",
            "variant": "secondary",
            "href": item.value.mapUrl,
            "target": "_blank",
            "disabled": !item.value.mapUrl
          }
        }, [_c('i', {
          staticClass: "fa fa-map-marker"
        })]) : _vm._e(), (item.value.formUrl != "null") ? _c('b-btn', {
          staticClass: "mr-1",
          attrs: {
            "type": "button",
            "variant": "primary",
            "href": item.value.formUrl,
            "target": "_blank",
            "disabled": !item.value.formUrl
          }
        }, [_c('i', {
          staticClass: "fa fa-file-o"
        })]) : _vm._e(), (item.value.imageUrl != "null") ? _c('b-btn', {
          staticClass: "mr-1",
          attrs: {
            "type": "button",
            "variant": "primary",
            "href": item.value.imageUrl,
            "target": "_blank",
            "disabled": !item.value.imageUrl
          }
        }, [_c('i', {
          staticClass: "fa fa-file-image-o"
        })]) : _vm._e(), (item.value.carUrl != "null") ? _c('b-btn', {
          staticClass: "mr-1 text-white",
          attrs: {
            "type": "button",
            "variant": "secondary",
            "href": item.value.carUrl,
            "target": "_blank",
            "disabled": !item.value.carUrl
          }
        }, [_c('i', {
          staticClass: "fa fa-car"
        })]) : _vm._e(), (item.value.btn1 == "Followed Up" && !item.value.resolved) ? _c('b-btn', {
          staticClass: "mr-1",
          attrs: {
            "type": "button",
            "variant": "success"
          },
          on: {
            "click": function($event) {
              _vm.resolved(item.value.id, item.value.crm, item.value.resolved)
            }
          }
        }, [_vm._v("Mark as Done")]) : (item.value.btn1 == "Followed Up" && item.value.resolved && item.value.userAccessLevel == "agent") ? _c('b-btn', {
          staticClass: "mr-1",
          attrs: {
            "type": "button",
            "variant": "outline-success",
            "disabled": "disabled"
          },
          on: {
            "click": function($event) {
              _vm.resolved(item.value.id, item.value.crm, item.value.resolved)
            }
          }
        }, [_vm._v("Done")]) : (item.value.btn1 == "Followed Up" && item.value.resolved) ? _c('b-btn', {
          staticClass: "mr-1",
          attrs: {
            "type": "button",
            "variant": "outline-success"
          },
          on: {
            "click": function($event) {
              _vm.resolved(item.value.id, item.value.crm, item.value.resolved)
            }
          }
        }, [_vm._v("Mark as Undone")]) : (item.value.btn1) ? _c('b-btn', {
          staticClass: "mr-1",
          attrs: {
            "type": "button",
            "variant": "success"
          }
        }, [_vm._v(_vm._s(item.value.btn1))]) : (item.value.btn1) ? _c('b-btn', {
          staticClass: "mr-1",
          attrs: {
            "type": "button",
            "variant": "success"
          }
        }, [_vm._v("Qualify")]) : _vm._e(), (item.value.remark == null || item.value.remark == "") ? _c('b-btn', {
          staticClass: "mr-1",
          attrs: {
            "type": "button",
            "variant": "success",
            "id": "remark" + item.value.id
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_vm._v("Make Remark")]) : _c('b-btn', {
          staticClass: "mr-1",
          attrs: {
            "type": "button",
            "variant": "outline-success",
            "id": "viewRemark" + item.value.id
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_vm._v("View Remark")]), (item.value.remark == null || item.value.remark == "") ? _c('b-popover', {
          ref: "popover",
          attrs: {
            "target": "remark" + item.value.id,
            "placement": "left",
            "triggers": "click"
          }
        }, [_c('b-form', {
          attrs: {
            "inline": "inline"
          },
          on: {
            "submit": _vm.sendRemark
          }
        }, [_c('b-form-input', {
          staticClass: "pill-left",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.messageModel[item.value.id]),
            callback: function($$v) {
              _vm.$set(_vm.messageModel, item.value.id, $$v)
            },
            expression: "messageModel[item.value.id]"
          }
        }), _c('b-btn', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: (_vm.sending ? "Sending Remark" : "Send Remark"),
            expression: "sending ? \"Sending Remark\" : \"Send Remark\"",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "btn pill-right",
          attrs: {
            "type": "button",
            "variant": "success"
          },
          on: {
            "click": function($event) {
              _vm.sendRemark(item.value.id, item.value.crm, _vm.messageModel[item.value.id])
            }
          }
        }, [(_vm.sending) ? _c('i', {
          staticClass: "fa fa-refresh fa-spin"
        }) : _c('i', {
          staticClass: "fa fa-chevron-right"
        })])], 1)], 1) : _c('b-popover', {
          ref: "popover",
          attrs: {
            "target": "viewRemark" + item.value.id,
            "placement": "left",
            "triggers": "click"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "text",
            "readonly": "readonly"
          },
          model: {
            value: (item.value.remark),
            callback: function($$v) {
              item.value.remark = $$v
            },
            expression: "item.value.remark"
          }
        })], 1)]
      }
    }, {
      key: "approval",
      fn: function(item) {
        return [(item.value == "approved") ? _c('i', {
          staticClass: "fa fa-check text-success"
        }) : (item.value == "pending") ? _c('i', {
          staticClass: "fa fa-spinner"
        }) : _c('i', {
          staticClass: "fa fa-times text-danger"
        })]
      }
    }, {
      key: "platform",
      fn: function(item) {
        return [_c('b-row', [_c('b-col', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: ("Email"),
            expression: "\"Email\"",
            modifiers: {
              "hover": true
            }
          }]
        }, [_c('i', {
          staticClass: "fa fa-envelope-o",
          class: {
            "text-success": item.value.email
          }
        })]), _c('b-col', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: ("SMS"),
            expression: "\"SMS\"",
            modifiers: {
              "hover": true
            }
          }]
        }, [_c('i', {
          staticClass: "fa fa-mobile",
          class: {
            "text-success": item.value.sms
          }
        })]), _c('b-col', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: ("Facebook Messenger"),
            expression: "\"Facebook Messenger\"",
            modifiers: {
              "hover": true
            }
          }]
        }, [_c('i', {
          staticClass: "fa fa-facebook",
          class: {
            "text-success": item.value.messenger
          }
        })])], 1)]
      }
    }, {
      key: "broadcastActions",
      fn: function(item) {
        return [_c('router-link', {
          attrs: {
            "to": _vm.broadcastLink(item.value)
          }
        }, [_c('b-btn', {
          staticClass: "mr-1",
          attrs: {
            "type": "button",
            "variant": "outline-secondary"
          }
        }, [_c('i', {
          staticClass: "fa fa-chevron-right"
        })])], 1)]
      }
    }, {
      key: "loanAmount",
      fn: function(item) {
        return [_c('div', [_vm._v("RM " + _vm._s(item.value))])]
      }
    }, {
      key: "turnOverAmount",
      fn: function(item) {
        return [_c('div', [_vm._v("RM " + _vm._s(item.value))])]
      }
    }, {
      key: "influence",
      fn: function(item) {
        return [_c('i', {
          staticClass: "fa",
          class: ["fa-users", "text-" + _vm.influence(item.value)]
        }), _vm._v(" " + _vm._s(item.value))]
      }
    }, {
      key: "manualRate",
      fn: function(item) {
        return [_c('input', {
          staticClass: "checkbox",
          attrs: {
            "type": "checkbox"
          },
          on: {
            "click": function($event) {
              _vm.checkboxToggle(item.value.key)
            }
          }
        })]
      }
    }, {
      key: "reason",
      fn: function(item) {
        return [_c('div', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: (item.value),
            expression: "item.value",
            modifiers: {
              "hover": true
            }
          }]
        }, [_vm._v(_vm._s(item.value))])]
      }
    }])
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chat_vue__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f07b092_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Chat_vue__ = __webpack_require__(1391);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f07b092_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Chat_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 139:
/***/ (function(module, exports) {

function parseMessage(message, cutoff) {
  var cutOff = cutoff || 9999;
  var outputMessage = void 0;
  try {
    if (typeof message === 'string') {
      outputMessage = message;
    } else if (message == '' || message == null) {
      outputMessage = '';
    } else if (message[0].speech) {
      outputMessage = message[0].speech.slice(0, cutOff) + (message[0].speech.length > cutOff ? '...' : '');
    } else if (message[0].text) {
      outputMessage = message[0].text.text[0].slice(0, cutOff) + (message[0].text.text[0].length > cutOff ? '...' : '');
    } else if (message[0].quickReplies) {
      outputMessage = message[0].quickReplies.title ? message[0].quickReplies.title.slice(0, cutOff) + (message[0].quickReplies.title.length > cutOff ? '...' : '') : '[FACEBOOK_QUICKREPLY]';
    } else if (message[0].payload.facebook.attachment.type === 'template') {
      outputMessage = 'CAROUSEL';
    } else {
      outputMessage = '...';
    }
  } catch (err) {
    console.log('parse error', err);
    outputMessage = '...';
  }
  return outputMessage;
}

exports.parseMessage = parseMessage;

/***/ }),

/***/ 1390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_carousel__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_carousel__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-chat',
  components: {
    Carousel: __WEBPACK_IMPORTED_MODULE_1_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_1_vue_carousel__["Slide"]
  },
  props: {
    loading: true,
    profPic: {
      type: String,
      default: 'static/img/avatars/0.png'
    },
    takeover: false,
    duplicateAgent: false,
    botPic: {
      type: String,
      default: 'static/img/favicon.png'
    },
    msgs: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  mounted: function mounted() {},
  methods: {
    sendMessage: function sendMessage() {
      var content;
      Object(__WEBPACK_IMPORTED_MODULE_0__api__["i" /* send */])(content).then(function (res) {
        res.error && alert(res.error);
      });
      this.$refs.popover.$emit('close');
    },
    translate: function translate(query, messageIndex) {
      var content = {
        query: query,
        target: 'en'
      };
      var that = this;
      Object(__WEBPACK_IMPORTED_MODULE_0__api__["j" /* translateServer */])(content).then(function (res) {
        that.msgs[messageIndex].translatedText = res.answer;
        res.error && alert(res.error);
      });
    },
    onClose: function onClose() {
      this.$refs.popover.$emit('close');
    },
    userIDString: function userIDString(value) {
      return value ? value.toString() : '';
    }
  },
  filters: {
    parsePlatform: function parsePlatform(platform) {
      var platforms = {
        'sms': 'SMS',
        'fb': 'Facebook',
        'whatsapp': 'WhatsApp',
        'default': 'Website'
      };

      return platforms[platform] || platforms['default'];
    },
    parseBot: function parseBot(bot) {
      var bots = {
        'insurbot': 'LiveLife',
        'cibank': 'CI Bank',
        'default': 'Chat Infinite'
      };

      return bots[bot] || bots['default'];
    }
  }
});

/***/ }),

/***/ 1391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      "chat-paused-flag": _vm.takeover, "chat-duplicate-agent": _vm.duplicateAgent
    }
  }, [(_vm.takeover) ? _c('h6', {
    staticStyle: {
      "margin-top": "-2px",
      "margin-left": "-1px"
    }
  }, [_c('b-badge', {
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v("Agent Takeover Active")])], 1) : _vm._e(), _vm._l((_vm.msgs), function(msg, index) {
    return _c('div', {
      key: index,
      staticClass: "row",
      attrs: {
        "id": msg.chatID
      }
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [(msg.fromUser) ? _c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-2"
    }, [_c('img', {
      staticClass: "img-avatar",
      staticStyle: {
        "height": "50px",
        "width": "50px"
      },
      attrs: {
        "src": _vm.profPic
      }
    })]), _c('div', {
      staticClass: "col-md-10"
    }, [_c('p', {
      staticClass: "chat-left text-left"
    }, [(msg.message.imageUrl) ? _c('span', [_c('img', {
      staticStyle: {
        "max-width": "100%"
      },
      attrs: {
        "src": msg.message.imageUrl,
        "alt": msg.message.message
      }
    })]) : _c('span', [_vm._v(_vm._s(msg.message))]), _c('br'), (msg.translatedText) ? _c('span', [_c('i', {
      staticClass: "translatedText"
    }, [_vm._v(_vm._s(msg.translatedText))]), _c('br')]) : _vm._e(), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v("sent " + _vm._s(_vm._f("moment")(msg.timestamp, 'from', 'now')) + " from"), (msg.fromUser) ? _c('span', [(msg.platform.bot) ? _c('span', [_vm._v(" " + _vm._s(_vm._f("parseBot")(msg.platform.bot)))]) : _vm._e(), _vm._v(" " + _vm._s(_vm._f("parsePlatform")(msg.platform.source)))]) : _vm._e(), _c('div', {
      staticClass: "text-muted float-right"
    }, [(msg.sentimentValue >= 0) ? _c('span', {
      staticClass: "individualSuccessSentiment text-light"
    }, [_vm._v(_vm._s(msg.sentiment) + "  "), _c('span', {
      staticClass: "fa fa-thumbs-o-up"
    })]) : (msg.sentimentValue < 0) ? _c('span', {
      staticClass: "individualDangerSentiment text-light"
    }, [_vm._v(_vm._s(msg.sentiment) + "  "), _c('span', {
      staticClass: "fa fa-thumbs-o-down"
    })]) : _vm._e(), _c('b-button', {
      staticClass: "btn-translate",
      attrs: {
        "variant": "link",
        "no-caret": "no-caret"
      },
      on: {
        "click": function($event) {
          _vm.translate(msg.message, index)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-globe text-muted"
    })])], 1)])])])])]) : (!msg.fromUser) ? _c('div', [_c('div', {
      staticClass: "col-md-6"
    }), (msg.message) ? _c('div', {
      staticClass: "col-md-6 pull-right"
    }, [((msg.message[0].speech && msg.message[0].speech != "") || (msg.message[0].text && msg.message[0].text.text[0]) || (msg.message[0].payload) || typeof msg.message === "string" || (msg.message[0].title) || (msg.message[0].address) || (msg.message[0].elements)) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-10"
    }, [_c('p', {
      staticClass: "chat-right text-right"
    }, [(typeof msg.message != "string" && msg.message[0].speech) ? _c('span', [_vm._v(_vm._s(msg.message[0].speech))]) : (typeof msg.message != "string" && msg.message[0].text) ? _c('span', [_vm._v(_vm._s(msg.message[0].text.text[0]))]) : (typeof msg.message != "string" && msg.message[0].quickReplies) ? _c('span', [_vm._v(_vm._s(msg.message[0].title))]) : (typeof msg.message != "string" && msg.message[0].address) ? _c('section', {
      staticClass: "VueCarousel",
      staticStyle: {
        "position": "static"
      }
    }, [_c('div', {
      staticClass: "VueCarousel-wrapper"
    }, [_c('Carousel', {
      attrs: {
        "per-page": 1,
        "paginationPadding": 5,
        "mouseDrag": true
      }
    }, _vm._l((msg.message), function(message) {
      return (message.address) ? _c('slide', {
        key: message.id,
        staticStyle: {
          "margin-bottom": "0px"
        },
        attrs: {
          "tabindex": "-1"
        }
      }, [_c('div', {
        staticClass: "carousel-generic-content"
      }, [_c('img', {
        staticClass: "carousel-generic-image",
        staticStyle: {
          "max-width": "100%",
          "border-bottom": "thin solid rgb(204, 204, 204)"
        },
        attrs: {
          "src": message.picUrl
        }
      }), _c('div', {
        staticClass: "carousel-cart",
        staticStyle: {
          "border-bottom": "thin solid rgb(204, 204, 204)"
        }
      }, [_c('span', {
        staticClass: "carousel-title"
      }, [_vm._v(_vm._s(message.name) + " "), _c('br')]), _c('span', {
        staticClass: "carousel-subtitle"
      }, [_vm._v("Tel: " + _vm._s(message.tel)), _c('br'), _vm._v("Fax: " + _vm._s(message.fax)), _c('br'), _vm._v("Contact Person: " + _vm._s(message.contactPerson)), _c('br'), _vm._v("E-mail: " + _vm._s(message.email))])])])]) : _vm._e()
    }))], 1)]) : (typeof msg.message != "string" && msg.message[0].title) ? _c('section', {
      staticClass: "VueCarousel",
      staticStyle: {
        "position": "static"
      }
    }, [_c('div', {
      staticClass: "VueCarousel-wrapper"
    }, [_c('Carousel', {
      attrs: {
        "per-page": 1,
        "paginationPadding": 5,
        "mouseDrag": true
      }
    }, _vm._l((msg.message), function(message) {
      return _c('slide', {
        key: message.id,
        staticStyle: {
          "margin-bottom": "0px"
        },
        attrs: {
          "tabindex": "-1"
        }
      }, [_c('div', {
        staticClass: "carousel-generic-content"
      }, [_c('img', {
        staticClass: "carousel-generic-image",
        attrs: {
          "src": message.image_url
        }
      }), _c('div', {
        staticClass: "carousel-cart",
        staticStyle: {
          "border-bottom": "thin solid rgb(204, 204, 204)"
        }
      }, [_c('span', {
        staticClass: "carousel-title"
      }, [_vm._v(_vm._s(message.title) + " "), _c('br')]), _c('span', {
        staticClass: "carousel-subtitle"
      }, [_vm._v(_vm._s(message.subtitle) + " "), _c('br')])]), _vm._l((message.buttons), function(button) {
        return _c('div', {
          staticClass: "carousel-generic-button",
          staticStyle: {
            "border-bottom": "thin solid rgb(204, 204, 204), height: 20px"
          }
        }, [_vm._v(_vm._s(button.title) + " "), _c('br')])
      })], 2)])
    }))], 1)]) : (typeof msg.message != "string" && msg.message[0].elements) ? _c('section', {
      staticClass: "carousel message"
    }, [_vm._l((msg.message[0].elements), function(element) {
      return _c('div', {
        staticClass: "carousel-div"
      }, [_c('div', {
        staticClass: "carousel-cart"
      }, [_c('span', {
        staticClass: "carousel-title"
      }, [_vm._v(_vm._s(element.title))]), _c('br'), _c('span', {
        staticClass: "carousel-subtitle"
      }, [_vm._v(_vm._s(element.subtitle))]), _c('br'), _c('br'), _c('span', {
        staticClass: "carousel-list-button"
      }, [_vm._v(_vm._s(element.buttons[0].title))])])])
    }), _c('div', {
      staticClass: "carousel-div-last"
    }, [_c('div', {
      staticClass: "carousel-cart"
    }, [_c('span', {
      staticClass: "carousel-list-button"
    }, [_vm._v(_vm._s(msg.message[0].buttons[0].title))])])])], 2) : _c('span', [_vm._v(_vm._s(msg.message))]), _c('br'), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v("sent " + _vm._s(_vm._f("moment")(msg.timestamp, 'from', 'now')) + " from"), (msg.dashboard) ? _c('span', [_c('i', [_vm._v(" Enchatment Engine")])]) : _c('span', [_c('i', [_vm._v(" Bot")])]), (msg.platform) ? _c('span', [_vm._v(" via"), (msg.platform.bot) ? _c('span', [_vm._v(" " + _vm._s(_vm._f("parseBot")(msg.platform.bot)))]) : _vm._e(), _vm._v(" " + _vm._s(_vm._f("parsePlatform")(msg.platform.source)))]) : _vm._e()])])]), _c('div', {
      staticClass: "col-md-2"
    }, [_c('img', {
      staticClass: "img-avatar",
      attrs: {
        "src": _vm.botPic
      }
    })])]) : _vm._e()]) : _vm._e()]) : _vm._e()]), (!msg.fromUser && (typeof msg.message != "string" && msg.message[0].quickReplies)) ? _c('div', {
      staticClass: "col md-12"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-2"
    }), _c('div', {
      staticClass: "col-md-10"
    }, [_c('div', {
      staticClass: "row quick-replies"
    }, _vm._l((msg.message[0].quickReplies), function(quickReply) {
      return _c('div', [(_vm.msgs[index + 1] && _vm.msgs[index + 1].fromUser && quickReply === _vm.msgs[index + 1].message && quickReply.content_type) ? _c('div', {
        staticClass: "quick-reply-highlighted"
      }, [_vm._v(_vm._s(quickReply.content_type))]) : (_vm.msgs[index + 1] && _vm.msgs[index + 1].fromUser && quickReply === _vm.msgs[index + 1].message) ? _c('div', {
        staticClass: "quick-reply-highlighted"
      }, [_vm._v(_vm._s(quickReply))]) : (quickReply.content_type) ? _c('div', {
        staticClass: "quick-reply-dimmed"
      }, [_vm._v(_vm._s(quickReply.content_type))]) : _c('div', {
        staticClass: "quick-reply-dimmed"
      }, [_vm._v(_vm._s(quickReply))])])
    }))])])])]) : _vm._e(), _c('div', {
      staticClass: "clearfix"
    })])
  }), (_vm.takeover) ? _c('h6', {
    staticStyle: {
      "margin-bottom": "-2px",
      "margin-left": "-1px"
    }
  }, [_c('b-badge', {
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v("Agent Takeover Active")])], 1) : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Charts_vue__ = __webpack_require__(1393);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Charts_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



var brandInfo = 'transparent';

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Line"].extend({
  props: {
    'height': String,
    'dataInput': {
      type: Array,
      default: function _default() {
        return [1, 18, 9, 17, 34, 22, 11];
      }
    },
    'labelInput': {
      type: Array,
      default: function _default() {
        return ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
      }
    }
  },
  mounted: function mounted() {
    var datasets = [{
      label: '',
      backgroundColor: brandInfo,
      borderColor: 'rgba(255,255,255,.55)',
      data: this.dataInput
    }];
    this.renderChart({
      labels: this.labelInput,
      datasets: datasets
    }, {
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          gridLines: {
            color: 'transparent',
            zeroLineColor: 'transparent'
          },
          ticks: {
            fontSize: 2,
            fontColor: 'transparent'
          }

        }],
        yAxes: [{
          display: false,
          ticks: {
            display: false,
            min: Math.min.apply(Math, datasets[0].data) - 5,
            max: Math.max.apply(Math, datasets[0].data) + 5
          }
        }]
      },
      elements: {
        line: {
          tension: 0.00001,
          borderWidth: 1
        },
        point: {
          radius: 3,
          hitRadius: 10,
          hoverRadius: 4
        }
      }
    });
  }
}));

/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return db; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return auth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return metadb; });
/* unused harmony export notif */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_messaging__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_database__ = __webpack_require__(298);





var configServer = {
  apiKey: 'AIzaSyAH0CRmCV6zWB8rqZAgtPD6tO6QZl8tXHU',
  authDomain: 'chat-infinite.firebaseapp.com',
  databaseURL: 'https://chat-infinite.firebaseio.com',
  projectId: 'chat-infinite',
  storageBucket: 'chat-infinite.appspot.com',
  messagingSenderId: '921907784236'
};

var configClient = {
  apiKey: 'AIzaSyCHU86xU-M2zxWg8lnuJOD9WhdPVhQ5CTM',
  authDomain: 'ci-bank-f7673.firebaseapp.com',
  databaseURL: 'https://ci-bank-f7673.firebaseio.com',
  projectId: 'ci-bank-f7673',
  storageBucket: 'ci-bank-f7673.appspot.com',
  messagingSenderId: '931934724781'
};

var firebaseServer = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.initializeApp(configServer, 'server');
var firebaseClient = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.initializeApp(configClient, 'client');

var db = firebaseClient.database();
var auth = firebaseServer.auth();
var metadb = firebaseServer.database();
var notif = firebaseServer.messaging();

/***/ }),

/***/ 1535:
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@2.8.2","C:\\Users\\borin\\Desktop\\BL\\work\\dash"]],"_from":"vue-chartjs@2.8.2","_id":"vue-chartjs@2.8.2","_inBundle":false,"_integrity":"sha512-6NsAf3gdLKV1jOYKv/HekdArmbGzFr2S7GNokD5eLNu9aIb4u1nJ1JP3hYgLDNOcGPNKNBSn/ZKJaZyFHeNAIA==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@2.8.2","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"2.8.2","saveSpec":null,"fetchSpec":"2.8.2"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-2.8.2.tgz","_spec":"2.8.2","_where":"C:\\Users\\borin\\Desktop\\BL\\work\\dash","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash":"^4.17.4"},"description":"vue.js wrapper for chart.js","devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.6.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.2","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"^2.6.0","vue":"^2.4.2"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublish":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.full.min.js","version":"2.8.2"}

/***/ }),

/***/ 1536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateSelection_vue__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_194c6b2f_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_DateSelection_vue__ = __webpack_require__(1538);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateSelection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_194c6b2f_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_DateSelection_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(14);





var anaRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* db */].ref('analytics');
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-dateselection',
  data: function data() {
    return {
      includesmalltalk: false,
      showModalXlsx: false,
      errorDate: false
    };
  },

  props: {
    userAccessLevel: String,
    data: String,
    bot: String,
    loading: false
  },
  computed: {
    bot: function bot() {
      return this.botProp || this.$store.state.bot;
    },
    refreshNeeded: function refreshNeeded() {
      return this.$store.getters.getRefreshNeeded;
    }
  },
  methods: {
    drawGraphAsDate: function drawGraphAsDate() {
      var _this = this;

      var that = this;
      var startDate = document.getElementById('startDate').value;
      var endDate = document.getElementById('endDate').value;
      var sDate = this.formatDateSpace(new Date(startDate));
      var eDate = this.formatDateSpace(new Date(endDate));
      var singDate = new Date(startDate);
      var eingDate = new Date(endDate);
      var dayDifference = (eingDate - singDate) / (24 * 60 * 60 * 1000);
      if (!document.getElementById('startDate').value || !document.getElementById('endDate').value) {
        that.errorDate = true;
      } else if (startDate > endDate) {
        that.errorDate = true;
      } else if (dayDifference > 31) {
        that.errorDate = true;
      } else {
        this.showModalXlsx = false;
        var startToCount = false;
        var labels;
        var data;
        var data1;
        var noOfDay;
        var noOfDay1;
        labels = [];
        data = [];
        data1 = [];
        var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        anaRef.child('daily').once('value', function (snapshot) {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(snapshot.val()).forEach(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                key = _ref2[0],
                val = _ref2[1];

            if (key === sDate) {
              startToCount = true;
            }
            if (startToCount === true) {
              var DD = key.substring(6, 8);
              var MM = key.substring(4, 6);
              var MMName = monthNames[parseInt(MM) - 1];
              labels.push(DD + '/' + MMName);
              noOfDay = val.totals.users.total;
              data.push(noOfDay);
              noOfDay1 = val.totals.interactions.total;
              data1.push(noOfDay1);
            }
            if (key === eDate) {
              startToCount = false;
            }
          });

          var graphData = {
            graphLabels: labels,
            userData: data,
            interactionsData: data1,
            timestamp: new Date()
          };
          sDate = _this.formatDate(new Date(startDate));
          eDate = _this.formatDate(new Date(endDate));
          var startEndDate = {
            startingDate: sDate,
            endingDate: eDate
          };
          var graphStatus = 'selectionDays';
          that.$store.dispatch('setGraphStatus', graphStatus);
          that.$store.dispatch('setStartEndDate', startEndDate);
          that.$store.dispatch('setGraphData', graphData);
        });
      }
    },
    testing: function testing() {
      var d = new Date(document.getElementById('startDate').value);
      d.setHours(d.getHours() - 8);

      console.log(d);
    },
    setWeek: function setWeek() {
      document.getElementById('endDate').value = this.formatDate(new Date());
      var d = new Date();
      d.setDate(d.getDate() - 7);
      document.getElementById('startDate').value = this.formatDate(d);
    },
    setMonth: function setMonth() {
      document.getElementById('endDate').value = this.formatDate(new Date());
      var minimumDate = new Date('March 22, 2018');
      var d = new Date();
      d.setDate(d.getDate() - 30);
      if (d <= minimumDate) {
        d = minimumDate;
      }
      document.getElementById('startDate').value = this.formatDate(d);
    },
    clearError: function clearError() {
      this.errorDate = false;
    },
    formatDate: function formatDate(date) {
      var d = new Date(date);
      var month = '' + (d.getMonth() + 1);
      var day = '' + d.getDate();
      var year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      return [year, month, day].join('-');
    },
    formatDateSpace: function formatDateSpace(date) {
      var d = new Date(date);
      var month = '' + (d.getMonth() + 1);
      var day = '' + d.getDate();
      var year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      return [year, month, day].join('');
    },
    refresh: function refresh() {
      this.$store.dispatch('setRefresh', true);
      this.$store.dispatch('setRefreshNeeded', false);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('setRefreshNeeded', false);
  }
});

/***/ }),

/***/ 1538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('b-button', {
    staticClass: "float-right",
    attrs: {
      "type": "button",
      "disabled": "disabled",
      "variant": "danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Loading")]) : ((_vm.data == "total")) ? _c('b-button', {
    staticClass: "float-right",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "button",
      "variant": "link"
    },
    on: {
      "click": function($event) {
        _vm.showModalXlsx = true
      }
    }
  }, [_vm._v("Date Selection")]) : _c('b-button', {
    staticClass: "float-right",
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.showModalXlsx = true
      }
    }
  }, [_vm._v("Date Selection")]), (_vm.refreshNeeded && (_vm.data == "customer" || _vm.data == "crm")) ? _c('b-button', {
    staticClass: "float-right mr-2",
    attrs: {
      "type": "button",
      "variant": "success"
    },
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v("Data updated, please refresh")]) : _vm._e(), _c('b-modal', {
    attrs: {
      "title": "Date Selection",
      "lazy": "lazy"
    },
    on: {
      "shown": _vm.clearError
    },
    model: {
      value: (_vm.showModalXlsx),
      callback: function($$v) {
        _vm.showModalXlsx = $$v
      },
      expression: "showModalXlsx"
    }
  }, [_c('b-btn-group', {
    staticClass: "w-100"
  }, [_c('b-button', {
    staticClass: "btn-block",
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.setWeek()
      }
    }
  }, [_vm._v(" Last 7 days")]), _c('b-button', {
    staticClass: "btn-block",
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.setMonth()
      }
    }
  }, [_vm._v(" Last 30 days")])], 1), _c('br'), _c('br'), (_vm.errorDate) ? _c('h4', {
    staticClass: "card-title mb-0",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" Invalid input date")]) : _vm._e(), (_vm.errorDate) ? _c('br') : _vm._e(), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('h6', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Start: ")])]), _c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "size": "sm",
      "id": "startDate",
      "min": "2018-03-22"
    }
  })], 1)], 1), _c('br'), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('h6', {
    staticClass: "card-title mb-0"
  }, [_vm._v("End: ")])]), _c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "size": "sm",
      "id": "endDate",
      "min": "2018-03-22"
    }
  })], 1)], 1), _c('br'), (_vm.data == "intent") ? _c('b-form-checkbox', {
    attrs: {
      "id": "smalltalk",
      "value": "true",
      "unchecked-value": "false"
    },
    model: {
      value: (_vm.includesmalltalk),
      callback: function($$v) {
        _vm.includesmalltalk = $$v
      },
      expression: "includesmalltalk"
    }
  }, [_vm._v("Include Small Talk")]) : _vm._e(), _c('div', {
    slot: "modal-footer"
  }, [_c('b-button', {
    staticClass: "float-right ml-1",
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.showModalXlsx = false;
        _vm.errorDate = false
      }
    }
  }, [_vm._v("Cancel")]), _c('b-button', {
    staticClass: "float-right ml-1",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.drawGraphAsDate
    }
  }, [_vm._v("Show Graph")])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateSelectionPie_vue__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_194d7be6_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_DateSelectionPie_vue__ = __webpack_require__(1541);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateSelectionPie_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_194d7be6_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_DateSelectionPie_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(14);





var anaRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* db */].ref('analytics');
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-dateselectionpie',
  data: function data() {
    return {
      includesmalltalk: false,
      showModalXlsx: false,
      errorDate: false
    };
  },

  props: {
    userAccessLevel: String,
    data: String,
    bot: String,
    loading: false
  },
  computed: {
    bot: function bot() {
      return this.botProp || this.$store.state.bot;
    },
    refreshNeeded: function refreshNeeded() {
      return this.$store.getters.getRefreshNeeded;
    }
  },
  methods: {
    drawGraphAsDate: function drawGraphAsDate() {
      var _this = this;

      var that = this;
      var initialise = true;
      var userArrayTop9 = [];
      var keyArrayTop9 = [];
      var summedTopics = {};
      var keyArray = [];
      var interationsArray = [];
      var userArray = [];
      var closemodal = false;
      var startDate = document.getElementById('startDate').value;
      var endDate = document.getElementById('endDate').value;
      var sDate = this.formatDateSpace(new Date(startDate));
      var eDate = this.formatDateSpace(new Date(endDate));
      var singDate = new Date(startDate);
      var eingDate = new Date(endDate);
      var dayDifference = (eingDate - singDate) / (24 * 60 * 60 * 1000);
      if (!document.getElementById('startDate').value || !document.getElementById('endDate').value) {
        that.errorDate = true;
      } else if (startDate > endDate) {
        that.errorDate = true;
      } else if (dayDifference > 31) {
        that.errorDate = true;
      } else {
        closemodal = true;
        var startToCount = false;
        anaRef.child('daily').once('value', function (snapshot) {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(snapshot.val()).forEach(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                key = _ref2[0],
                val = _ref2[1];

            if (key === sDate) {
              startToCount = true;
            }
            if (startToCount === true) {
              var topics = val.topics;

              __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(topics).forEach(function (_ref3) {
                var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                    intentName = _ref4[0],
                    intentData = _ref4[1];

                if (initialise == true) {
                  summedTopics['SmallTalks'] = {
                    users: 0,
                    interactions: 0
                  };
                  initialise = false;
                }
                if (!summedTopics[intentName]) {
                  summedTopics[intentName] = {
                    users: 0,
                    interactions: 0
                  };
                }
                if (intentName.indexOf('SmallTalk') != -1) {
                  summedTopics['SmallTalks'].users += intentData.users || 0;
                  summedTopics['SmallTalks'].interactions += intentData.interactions || 0;
                } else {
                  summedTopics[intentName].users += intentData.users || 0;
                  summedTopics[intentName].interactions += intentData.interactions || 0;
                }
              });
            }
            if (key === eDate) {
              startToCount = false;
            }
          });
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(summedTopics).forEach(function (_ref5) {
            var _ref6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
                intentName = _ref6[0],
                intentData = _ref6[1];

            keyArray.push(intentName);
            intentData.interactions = intentData.interactions || 0;
            interationsArray.push(intentData.interactions);
            intentData.users = intentData.users || 0;
            userArray.push(intentData.users);
          });

          var keysSorted = [];
          for (var i = 0; i < userArray.length; i++) {
            keysSorted.push(i);
            if (keysSorted.length > 10) {
              keysSorted.sort(function (a, b) {
                return userArray[b] - userArray[a];
              });
              keysSorted.pop();
            }
          }
          var matchExist = false;
          for (var _i = 0; _i < 9; _i += 1) {
            userArrayTop9.push(userArray[keysSorted[_i]]);
            keyArrayTop9.push(keyArray[keysSorted[_i]]);
          }
          userArrayTop9.push(0);
          keyArrayTop9.push('Others');
          for (var _i2 = 11; _i2 < userArray.length; _i2 += 1) {
            for (var j = 0; j < keysSorted.length; j++) {
              if (_i2 == keysSorted[j]) {
                matchExist = true;
              }
            }
            if (matchExist == false) {
              userArrayTop9[9] += userArray[_i2];
            } else {
              matchExist = false;
            }
          }

          var keysSortedInteraction = [];
          for (i = 0; i < interationsArray.length; i++) {
            keysSortedInteraction.push(i);
            if (keysSortedInteraction.length > 10) {
              keysSortedInteraction.sort(function (a, b) {
                return interationsArray[b] - interationsArray[a];
              });
              keysSortedInteraction.pop();
            }
          }
          var interationsArrayTop9 = [];
          var keyInteractionArrayTop9 = [];
          matchExist = false;
          for (var _i3 = 0; _i3 < 9; _i3 += 1) {
            interationsArrayTop9.push(interationsArray[keysSortedInteraction[_i3]]);
            keyInteractionArrayTop9.push(keyArray[keysSortedInteraction[_i3]]);
          }
          interationsArrayTop9.push(0);
          keyInteractionArrayTop9.push('Others');
          for (var _i4 = 11; _i4 < interationsArray.length; _i4 += 1) {
            for (var _j = 0; _j < keysSortedInteraction.length; _j++) {
              if (_i4 == keysSortedInteraction[_j]) {
                matchExist = true;
              }
            }
            if (matchExist == false) {
              interationsArrayTop9[9] += interationsArray[_i4];
            } else {
              matchExist = false;
            }
          }
          var graphPieData = {
            graphPieLabels: keyArrayTop9,
            graphPieInteractionLabels: keyInteractionArrayTop9,
            userPieData: userArrayTop9,
            interactionPieData: interationsArrayTop9,
            timestamp: new Date()
          };
          sDate = _this.formatDate(new Date(startDate));
          eDate = _this.formatDate(new Date(endDate));
          var startEndDate = {
            startingDate: sDate,
            endingDate: eDate
          };
          var graphStatus = 'selectionDays';
          that.$store.dispatch('setGraphStatus', graphStatus);
          _this.$store.dispatch('setGraphPieData', graphPieData);
          _this.$store.dispatch('setStartEndDate', startEndDate);
          if (closemodal == true) {
            _this.showModalXlsx = false;
          }
        });
      }
    },
    testing: function testing() {
      var d = new Date(document.getElementById('startDate').value);
      d.setHours(d.getHours() - 8);

      console.log(d);
    },
    setToday: function setToday() {
      document.getElementById('startDate').value = this.formatDate(new Date());
      document.getElementById('endDate').value = this.formatDate(new Date());
    },
    setWeek: function setWeek() {
      document.getElementById('endDate').value = this.formatDate(new Date());
      var d = new Date();
      d.setDate(d.getDate() - 7);
      document.getElementById('startDate').value = this.formatDate(d);
    },
    setMonth: function setMonth() {
      document.getElementById('endDate').value = this.formatDate(new Date());
      var minimumDate = new Date('March 22, 2018');
      var d = new Date();
      d.setDate(d.getDate() - 30);
      if (d <= minimumDate) {
        d = minimumDate;
      }
      document.getElementById('startDate').value = this.formatDate(d);
    },
    clearError: function clearError() {
      this.errorDate = false;
    },
    formatDate: function formatDate(date) {
      var d = new Date(date);
      var month = '' + (d.getMonth() + 1);
      var day = '' + d.getDate();
      var year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      return [year, month, day].join('-');
    },
    formatDateSpace: function formatDateSpace(date) {
      var d = new Date(date);
      var month = '' + (d.getMonth() + 1);
      var day = '' + d.getDate();
      var year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      return [year, month, day].join('');
    },
    refresh: function refresh() {
      this.$store.dispatch('setRefresh', true);
      this.$store.dispatch('setRefreshNeeded', false);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('setRefreshNeeded', false);
  }
});

/***/ }),

/***/ 1541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('b-button', {
    staticClass: "float-right",
    attrs: {
      "type": "button",
      "disabled": "disabled",
      "variant": "danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Loading")]) : ((_vm.data == "total")) ? _c('b-button', {
    staticClass: "float-right",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "button",
      "variant": "link"
    },
    on: {
      "click": function($event) {
        _vm.showModalXlsx = true
      }
    }
  }, [_vm._v("Date Selection")]) : _c('b-button', {
    staticClass: "float-right",
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.showModalXlsx = true
      }
    }
  }, [_vm._v("Date Selection")]), (_vm.refreshNeeded && (_vm.data == "customer" || _vm.data == "crm")) ? _c('b-button', {
    staticClass: "float-right mr-2",
    attrs: {
      "type": "button",
      "variant": "success"
    },
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v("Data updated, please refresh")]) : _vm._e(), _c('b-modal', {
    attrs: {
      "title": "Date Selection",
      "lazy": "lazy"
    },
    on: {
      "shown": _vm.clearError
    },
    model: {
      value: (_vm.showModalXlsx),
      callback: function($$v) {
        _vm.showModalXlsx = $$v
      },
      expression: "showModalXlsx"
    }
  }, [_c('b-btn-group', {
    staticClass: "w-100"
  }, [_c('b-button', {
    staticClass: "btn-block",
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.setWeek()
      }
    }
  }, [_vm._v(" Last 7 days")]), _c('b-button', {
    staticClass: "btn-block",
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.setMonth()
      }
    }
  }, [_vm._v(" Last 30 days")])], 1), _c('br'), _c('br'), (_vm.errorDate) ? _c('h4', {
    staticClass: "card-title mb-0",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" Invalid input date")]) : _vm._e(), (_vm.errorDate) ? _c('br') : _vm._e(), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('h6', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Start: ")])]), _c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "size": "sm",
      "id": "startDate",
      "min": "2018-03-22"
    }
  })], 1)], 1), _c('br'), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('h6', {
    staticClass: "card-title mb-0"
  }, [_vm._v("End: ")])]), _c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "size": "sm",
      "id": "endDate",
      "min": "2018-03-22"
    }
  })], 1)], 1), _c('br'), (_vm.data == "intent") ? _c('b-form-checkbox', {
    attrs: {
      "id": "smalltalk",
      "value": "true",
      "unchecked-value": "false"
    },
    model: {
      value: (_vm.includesmalltalk),
      callback: function($$v) {
        _vm.includesmalltalk = $$v
      },
      expression: "includesmalltalk"
    }
  }, [_vm._v("Include Small Talk")]) : _vm._e(), _c('div', {
    slot: "modal-footer"
  }, [_c('b-button', {
    staticClass: "float-right ml-1",
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.showModalXlsx = false;
        _vm.errorDate = false
      }
    }
  }, [_vm._v("Cancel")]), _c('b-button', {
    staticClass: "float-right ml-1",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.drawGraphAsDate
    }
  }, [_vm._v("Show Graph")])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InteractionsTable_vue__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_695ab55e_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_InteractionsTable_vue__ = __webpack_require__(1544);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InteractionsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_695ab55e_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_InteractionsTable_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-interactionsTable',
  data: function data() {
    return {
      messageModel: {},
      firstNameOfAgent: this.$store.state.profile.firstName,
      uniqueIDOfAgent: this.$store.state.profile.uniqueID,
      sortDesc: true,
      sortBy: null
    };
  },
  props: {
    small: false,
    rowClick: false,
    rowBroadcastClick: false,
    sending: false,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    label: {
      type: Object,
      default: function _default() {
        return {
          avatar: {
            label: '<i class="icon-people"></i>',
            class: 'text-center'
          },
          user: {
            label: 'User'
          },
          country: {
            label: 'Country',
            class: 'text-center'
          },
          usage: {
            label: 'Usage'
          },
          payment: {
            label: 'Payment method',
            class: 'text-center'
          },
          activity: {
            label: 'Activity'
          },
          actions: {
            label: '',
            thStyle: {
              minWidth: '14em'
            }
          }
        };
      }
    }
  },
  methods: {
    focus: function focus(id) {
      setTimeout(function () {
        document.getElementById('input' + id).focus();
      }, 100);
    },
    ping: function ping(e) {
      if (this.rowClick) {
        var routeData = this.$router.resolve({ name: 'Interaction', params: { userId: e.userId } });
        window.open(routeData.href, '_blank');
      }
    },
    chatLink: function chatLink(value) {
      return { name: 'Interaction', params: { userId: value } };
    },
    userIdString: function userIdString(value) {
      return value ? value.toString() : '';
    }
  }
});

/***/ }),

/***/ 1544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-table', {
    staticClass: "table-outline mb-0",
    attrs: {
      "hover": "hover",
      "responsive": "responsive",
      "outline": "outline",
      "head-variant": "default",
      "items": _vm.data,
      "fields": _vm.label,
      "small": _vm.small,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc
    },
    on: {
      "row-clicked": _vm.ping,
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "avatar",
      fn: function(item) {
        return [_c('div', {
          staticClass: "avatar"
        }, [(item.value.tooltip) ? _c('img', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: (_vm.userIdString(item.value.tooltip)),
            expression: "userIdString(item.value.tooltip)",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "img-avatar",
          attrs: {
            "src": item.value.url || "static/img/avatars/0.png",
            "alt": ""
          }
        }) : _vm._e(), (item.value.status) ? _c('span', {
          staticClass: "avatar-status",
          class: item.value.status ? "bg-" + item.value.status : "bg-danger"
        }) : _vm._e(), (item.value.platform) ? _c('span', {
          staticClass: "avatar-platform fa",
          class: [item.value.platform == "fb" && "fa-facebook-official", item.value.platform == "whatsapp" && "fa-whatsapp", item.value.platform != "whatsapp" && item.value.platform != "fb" && "fa-globe"]
        }) : _vm._e()])]
      }
    }, {
      key: "messageId",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "message",
      fn: function(item) {
        return [_c('div', [_vm._v(_vm._s(item.value))])]
      }
    }, {
      key: "flagHandleBy",
      fn: function(item) {
        return [_c('b-form', {
          attrs: {
            "inline": "inline"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
            },
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('b-input-group', [_c('b-form-input', {
          staticClass: "table-flaghandle",
          attrs: {
            "value": item.value.flagHandleBy[0],
            "readonly": "readonly"
          }
        }), _c('b-input-group-button', {
          slot: "right"
        }, [_c('b-btn', {
          attrs: {
            "variant": "outline-primary",
            "id": "flagHandleBy" + item.value.id
          }
        }, [_c('i', {
          staticClass: "fa fa-caret-left"
        })])], 1)], 1)], 1), _c('b-popover', {
          ref: "popover",
          attrs: {
            "target": "flagHandleBy" + item.value.id,
            "placement": "left",
            "triggers": "click"
          }
        }, [_vm._v(_vm._s(item.value.flagHandleByString))])]
      }
    }, {
      key: "firstInteraction",
      fn: function(item) {
        return [(item.value != null && item.value != "" && item.value != "-") ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(item.value, 'from', 'now')))]) : _c('span', [_vm._v("Invalid Date")])]
      }
    }, {
      key: "numTimestamp",
      fn: function(item) {
        return [(item.value != null && item.value != "" && item.value != "-") ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(item.value, 'from', 'now')))]) : _c('span', [_vm._v("Invalid Date")])]
      }
    }, {
      key: "agent",
      fn: function(item) {
        return [_c('div', {
          staticClass: "avatar"
        }, [_c('img', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            value: (_vm.userIdString(item.value.tooltip)),
            expression: "userIdString(item.value.tooltip)",
            modifiers: {
              "hover": true,
              "right": true
            }
          }],
          staticClass: "img-avatar",
          attrs: {
            "src": item.value.url,
            "alt": ""
          }
        })])]
      }
    }, {
      key: "sentiment",
      fn: function(item) {
        return [(item.value && item.value.number >= 0) ? _c('button', {
          staticClass: "btn btn-success"
        }, [_vm._v(_vm._s(item.value.score) + "  "), _c('span', {
          staticClass: "fa fa-thumbs-o-up"
        })]) : (item.value && item.value.number < 0) ? _c('button', {
          staticClass: "btn btn-danger"
        }, [_vm._v(_vm._s(item.value.score) + "  "), _c('span', {
          staticClass: "fa fa-thumbs-o-down"
        })]) : _c('button', {
          staticClass: "btn btn-secondary"
        }, [_vm._v("-")])]
      }
    }])
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntentTable_vue__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_566036fa_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_IntentTable_vue__ = __webpack_require__(1547);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntentTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_566036fa_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_IntentTable_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__filter__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'intent-table',
  data: function data() {
    return {
      selectedQuestions: [],
      selectedQuickReplies: []
    };
  },

  props: {
    sortBy: null,
    sortDesc: true,
    loading: true,
    small: false,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    label: {
      type: Object,
      default: function _default() {}
    }
  },
  methods: {
    toggleIntentEditor: function toggleIntentEditor(item) {
      var that = this;

      if (document.getElementsByClassName('aside-menu-hidden').length === 0 && item !== this.$store.state.editIntentDetails) {
        document.body.classList.toggle('aside-menu-hidden');
        this.$store.dispatch('setAsideStatus', false);
        this.$store.dispatch('setEditIntents', item);
        setTimeout(function () {
          if (document.getElementsByClassName('aside-menu-hidden').length !== 0) {
            document.body.classList.toggle('aside-menu-hidden');
            that.$store.dispatch('setAsideStatus', true);
          }
        }, 500);
      } else if (document.getElementsByClassName('aside-menu-hidden').length === 0 && item === this.$store.state.editIntentDetails) {
        document.body.classList.toggle('aside-menu-hidden');
        this.$store.dispatch('setAsideStatus', false);
      } else {
        document.body.classList.toggle('aside-menu-hidden');
        this.$store.dispatch('setEditIntents', item);
        this.$store.dispatch('setAsideStatus', true);
      }
    },
    editIntent: function editIntent(item) {
      this.$store.dispatch('setActionInIntentPage', 'edit Intent');
      this.toggleIntentEditor(item);
    },
    removeIntent: function removeIntent(item) {
      this.$store.dispatch('setRemoveIntent', item.item);
    },
    cutMessages: function cutMessages(message) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__filter__["parseMessage"])(message, 100);
    },
    collapseAnswer: function collapseAnswer(item) {
      if (!item.item.answerCollapseIs) {
        item.item.answerCollapseIs = true;
      } else {
        item.item.answerCollapseIs = false;
      }
    }
  }
});

/***/ }),

/***/ 1547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-table', {
    staticClass: "table-outline mb-0",
    attrs: {
      "hover": "hover",
      "outline": "outline",
      "head-variant": "default",
      "items": _vm.data,
      "fields": _vm.label,
      "small": _vm.small,
      "fixed": "fixed"
    },
    on: {
      "row-clicked": _vm.editIntent
    },
    scopedSlots: _vm._u([{
      key: "intentId",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "intentTitle",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "intentAnswers",
      fn: function(item) {
        return [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-sm-9"
        }, [_c('b-collapse', {
          attrs: {
            "id": 'answerCollapse-' + item.index
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(item.value)
          }
        })]), (!item.item.answerCollapseIs) ? _c('span', [_vm._v(_vm._s(_vm.cutMessages(item.value)))]) : _vm._e()], 1), _c('div', {
          staticClass: "col-sm-3"
        }, [_c('b-btn', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle",
            value: (("answerCollapse-" + (item.index))),
            expression: "`answerCollapse-${item.index}`"
          }],
          staticClass: "float-left",
          staticStyle: {
            "background-color": "white",
            "border-color": "white"
          },
          on: {
            "click": function($event) {
              _vm.collapseAnswer(item)
            }
          }
        }, [(!item.item.answerCollapseIs) ? _c('i', {
          staticClass: "fa fa-chevron-down"
        }) : _vm._e(), (item.item.answerCollapseIs) ? _c('i', {
          staticClass: "fa fa-chevron-up"
        }) : _vm._e()])], 1)])]
      }
    }, {
      key: "noOfTrainings",
      fn: function(item) {
        return [_c('span', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.value))])]
      }
    }, {
      key: "answerType",
      fn: function(item) {
        return [_c('span', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.value))])]
      }
    }, {
      key: "quickReplies",
      fn: function(item) {
        return [(item.value === 'None') ? _c('div', {
          staticClass: "row"
        }, [_c('span', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.value))])]) : _vm._l((item.value), function(value) {
          return _c('div', {
            staticClass: "row"
          }, [_c('span', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(value))])])
        })]
      }
    }, {
      key: "noOfBubble",
      fn: function(item) {
        return [_c('span', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.value))])]
      }
    }, {
      key: "show_details",
      fn: function(row) {
        return [_c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "size": "sm"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              row.toggleDetails($event)
            }
          }
        }, [_vm._v(_vm._s(row.detailsShowing ? 'Hide' : 'Show more'))])]
      }
    }, {
      key: "row-details",
      fn: function(row) {
        return [_c('b-card', [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-form-group', {
          attrs: {
            "label": "Questions / Triggering Bubble"
          }
        }, [_c('b-form-checkbox', {
          attrs: {
            "aria-describedby": "row.item.intentQuestions",
            "aria-constrol": "row.item.intentQuestions"
          },
          model: {
            value: (_vm.selectAllQuestions),
            callback: function($$v) {
              _vm.selectAllQuestions = $$v
            },
            expression: "selectAllQuestions"
          }
        }), _c('b-form-checkbox-group', {
          attrs: {
            "stacked": "stacked",
            "name": "Questions",
            "options": row.item.intentQuestions
          },
          model: {
            value: (_vm.selectedQuestions),
            callback: function($$v) {
              _vm.selectedQuestions = $$v
            },
            expression: "selectedQuestions"
          }
        })], 1)], 1), _c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-form-group', {
          attrs: {
            "label": "Quick Reply Bubble"
          }
        }, [_c('b-form-checkbox-group', {
          attrs: {
            "stacked": "stacked",
            "name": "QuickReplies",
            "options": row.item.quickReplies
          },
          model: {
            value: (_vm.selectedQuickReplies),
            callback: function($$v) {
              _vm.selectedQuickReplies = $$v
            },
            expression: "selectedQuickReplies"
          }
        })], 1)], 1)])])]
      }
    }, {
      key: "actions",
      fn: function(item) {
        return [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-btn', [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          },
          on: {
            "click": [function($event) {
              _vm.removeIntent(item)
            }, function($event) {
              $event.stopPropagation();
            }]
          }
        }, [_vm._v(" Remove")])])], 1)])]
      }
    }])
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1548:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConversationTopicTable_vue__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bebbf3e_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ConversationTopicTable_vue__ = __webpack_require__(1550);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConversationTopicTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bebbf3e_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ConversationTopicTable_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-conversationtopictable',
  data: function data() {
    return {
      messageModel: {},
      firstNameOfAgent: this.$store.state.profile.firstName,
      uniqueIDOfAgent: this.$store.state.profile.uniqueID,
      sortDesc: true,
      sortBy: null
    };
  },
  props: {
    small: false,
    rowClick: false,
    rowBroadcastClick: false,
    sending: false,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    label: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    focus: function focus(id) {
      setTimeout(function () {
        document.getElementById('input' + id).focus();
      }, 100);
    },
    ping: function ping(e) {
      this.rowClick && this.$router.push({ name: 'Interaction', params: { userId: e.userId } });
    },
    convertTimeFormat: function convertTimeFormat(timestamp) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp, 'x').format("Do MMM 'YY, hh:mmA");
    },
    chatLink: function chatLink(value) {
      return { name: 'Interaction', params: { userId: value } };
    },
    userIdString: function userIdString(value) {
      return value ? value.toString() : '';
    }
  }
});

/***/ }),

/***/ 1550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-table', {
    staticClass: "table-outline mb-0",
    attrs: {
      "hover": "hover",
      "responsive": "responsive",
      "outline": "outline",
      "head-variant": "default",
      "items": _vm.data,
      "fields": _vm.label,
      "small": _vm.small,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc
    },
    on: {
      "row-clicked": _vm.ping,
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function(item) {
        return [(item.value == "Total Intents" || item.value == "Total Unmatched" || item.value == "Total Matched" || item.value == "Total Conversations") ? _c('span', {
          staticClass: "bold"
        }, [_vm._v(_vm._s(item.value))]) : _c('span', [_vm._v(_vm._s(item.value))])]
      }
    }, {
      key: "number",
      fn: function(item) {
        return [_c('span', {
          staticClass: "bold"
        }, [_vm._v(_vm._s(item.value))])]
      }
    }, {
      key: "percent",
      fn: function(item) {
        return [_c('span', {
          staticClass: "bold"
        }, [_vm._v(_vm._s(item.value))])]
      }
    }, {
      key: "timestamp",
      fn: function(item) {
        return [_vm._v(_vm._s(_vm._f("moment")(item.value, "from", "now")))]
      }
    }])
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__crmTable_vue__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__crmTableAppointment_vue__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__crmTableAccountOpening_vue__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__crmTableMotor_vue__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crmTableTM_vue__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__userTable_vue__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__broadcastTable_vue__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__broadcastModal_vue__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__interactionsRightbar_vue__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fallbackTable_vue__ = __webpack_require__(1585);











/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.component(__WEBPACK_IMPORTED_MODULE_0__crmTable_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__crmTable_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_9__fallbackTable_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_9__fallbackTable_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_1__crmTableAppointment_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__crmTableAppointment_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_2__crmTableAccountOpening_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__crmTableAccountOpening_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_3__crmTableMotor_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__crmTableMotor_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_4__crmTableTM_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__crmTableTM_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_5__userTable_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__userTable_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_6__broadcastTable_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_6__broadcastTable_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_7__broadcastModal_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_7__broadcastModal_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_8__interactionsRightbar_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_8__interactionsRightbar_vue__["a" /* default */]);
  }
});

/***/ }),

/***/ 1552:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_crmTable_vue__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_293807f4_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_crmTable_vue__ = __webpack_require__(1554);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_crmTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_293807f4_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_crmTable_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(14);







var customRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* db */].ref('custom');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'crm-table',
  data: function data() {
    return {
      cls: {},
      loading: true,
      tableItems: [],
      tableFields: {
        messageId: {
          label: 'ID'
        },
        endDate: {
          label: 'Name'
        },
        startDate: {
          label: 'Date',
          sortable: true,
          thStyle: {
            minWidth: '8em'
          }
        },
        topic: {
          label: 'Time'
        },
        phoneID: {
          label: 'Mobile No'
        },
        timestamp: {
          label: 'Timestamp'
        },
        statusString: {
          label: '<i></i>',
          class: 'text-right',
          thStyle: {
            minWidth: '23em'
          }
        }
      }
    };
  },

  mounted: function mounted() {
    var _this = this;

    var customs;
    customRef.child('appointmentRequests').on('value', function (snapshot) {
      customs = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(snapshot.val()).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];

        customs.unshift({
          messageId: key,
          startDate: val.date,
          endDate: val.name,
          topic: val.time,
          phoneID: val.phoneNumber,

          timestamp: parseInt(val.timestamp),

          statusString: { formUrl: val.formUrl || 'https://firebasestorage.googleapis.com/v0/b/insurbot-5754a.appspot.com/o/appointment_281117.pdf?alt=media&token=3dc5f980-cba9-41c5-8eda-732246336bdb', mapUrl: val.location.googleMapsLink, carUrl: 'null', imageUrl: 'null' }
        });
      });
      console.log(customs);
      _this.tableItems = customs;
      _this.loading = false;
    });
  }
});

/***/ }),

/***/ 1554:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('p') : _c('app-table', {
    attrs: {
      "data": _vm.tableItems,
      "label": _vm.tableFields
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1555:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_crmTableAppointment_vue__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e6a0469_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_crmTableAppointment_vue__ = __webpack_require__(1557);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_crmTableAppointment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e6a0469_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_crmTableAppointment_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1556:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(14);







var customRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* db */].ref('custom');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'crm-table-appointment',
  data: function data() {
    return {
      cls: {},
      loading: true,
      tableItems: [],
      tableFields: {
        avatar: {
          label: '<i class="icon-people"></i>',
          class: 'text-center'
        },
        upperCase: {
          label: 'Car Plate'
        },
        intent: {
          label: 'Workshop Name'
        },
        timestamp: {
          label: 'Timestamp',
          sortable: true
        },
        statusString: {
          label: '<i></i>',
          class: 'text-right',
          thStyle: {
            minWidth: '26em'
          }
        }
      }
    };
  },

  mounted: function mounted() {
    var _this = this;

    var customs;
    customRef.child('motorAccident').on('value', function (snapshot) {
      customs = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(snapshot.val()).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];

        customs.unshift({
          avatar: { url: val.profilePic, tooltip: key },
          name: val.name,
          upperCase: val.carplate,
          timestamp: parseInt(val.timestamp),
          intent: val.workshopName,

          statusString: { formUrl: 'null', mapUrl: val.location.googleMapsLink, carUrl: 'null', imageUrl: val.imageUrl, btn1: 'Followed Up', btn2: 'Email', btn3: 'Make Remark', email: 'null', id: key, crm: 'motorAccident', resolved: val.resolved, userAccessLevel: self.userAccessLevel, remark: val.remark },
          _rowVariant: val.resolved && 'success'
        });
      });

      _this.tableItems = customs;
      _this.loading = false;
    });
  }
});

/***/ }),

/***/ 1557:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('p') : _c('app-table', {
    attrs: {
      "data": _vm.tableItems,
      "label": _vm.tableFields,
      "sortBy": "timestamp",
      "sortDesc": true
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1558:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_crmTableAccountOpening_vue__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94270ede_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_crmTableAccountOpening_vue__ = __webpack_require__(1560);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_crmTableAccountOpening_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94270ede_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_crmTableAccountOpening_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(14);







var customRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* db */].ref('custom');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'crm-table-account-opening',
  data: function data() {
    return {
      cls: {},
      loading: true,
      tableItems: [],
      tableFields: {
        name: {
          label: 'Name'
        },
        phone: {
          label: 'Phone'
        },
        accountCompany: {
          label: 'Company'
        },
        address: {
          label: 'Address',
          sortable: true
        },
        branch: {
          label: 'Branch',
          sortable: true
        },
        timestamp: {
          label: 'Time',
          sortable: true
        }
      }
    };
  },

  mounted: function mounted() {
    var _this = this;

    var customs;
    customRef.child('account').on('value', function (snapshot) {
      customs = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(snapshot.val()).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];

        customs.unshift({
          name: val.name,
          phone: val.phone,
          accountCompany: val.company,
          address: val.address,
          branch: val.branch,
          timestamp: parseInt(val.timestamp)
        });
      });

      _this.tableItems = customs;
      _this.loading = false;
    });
  },
  beforeDestroy: function beforeDestroy() {
    customRef.off('value');
  }
});

/***/ }),

/***/ 1560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('p') : _c('app-table', {
    attrs: {
      "data": _vm.tableItems,
      "label": _vm.tableFields,
      "sortBy": "timestamp",
      "sortDesc": true
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_crmTableMotor_vue__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cc19882_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_crmTableMotor_vue__ = __webpack_require__(1563);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_crmTableMotor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cc19882_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_crmTableMotor_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(14);







var customRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* db */].ref('custom');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'crm-table-motor',
  data: function data() {
    return {
      cls: {},
      loading: true,
      tableItems: [],
      tableFields: {
        avatar: {
          label: '<i class="icon-people"></i>',
          class: 'text-center'
        },
        name: {
          label: 'Name'
        },
        nric: {
          label: 'NRIC',
          sortable: true
        },
        upperCase: {
          label: 'Car Plate',
          sortable: true
        },
        timestamp: {
          label: 'Timestamp'
        },
        statusString: {
          label: '<i></i>',
          class: 'text-right',
          thStyle: {
            minWidth: '20em'
          }
        }
      }
    };
  },

  mounted: function mounted() {
    var _this = this;

    var customs;
    customRef.child('motorInsurance').on('value', function (snapshot) {
      customs = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(snapshot.val()).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];

        customs.unshift({
          avatar: { url: val.profilePic, tooltip: key },
          name: val.fullName,
          nric: val.nric,
          upperCase: val.carplate,
          timestamp: parseInt(val.timestamp),
          statusString: { carUrl: val.imageUrl, mapUrl: 'null', formUrl: 'null', imageUrl: 'null' }
        });
      });
      console.log(customs);
      _this.tableItems = customs;
      _this.loading = false;
    });
  }
});

/***/ }),

/***/ 1563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('p') : _c('app-table', {
    attrs: {
      "data": _vm.tableItems,
      "label": _vm.tableFields
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_crmTableTM_vue__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e690302_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_crmTableTM_vue__ = __webpack_require__(1566);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_crmTableTM_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e690302_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_crmTableTM_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(14);







var customRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* db */].ref('custom');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'crm-table-tm',
  data: function data() {
    return {
      cls: {},
      loading: true,
      userAccessLevel: this.$store.state.profile.accessLevel,
      tableItems: [],
      tableFields: {
        name: {
          label: 'Client Name'
        },
        nric: {
          label: 'Company'
        },
        message: {
          label: 'Phone No.'
        },
        numTimestamp: {
          label: 'Submitted on',
          sortable: true
        },
        statusString: {
          label: '<i></i>',
          class: 'text-right',
          thStyle: {
            minWidth: '25em'
          }
        }
      }
    };
  },

  mounted: function mounted() {
    var _this = this;

    var customs;
    var self = this;
    customRef.child('appt').on('value', function (snapshot) {
      customs = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(snapshot.val()).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];

        var address = val.address ? 'https://www.google.com/maps/search/?api=1&query=' + val.address.replace(/ /g, '%20').replace(/,/g, '%2C') : '';
        customs.unshift({
          avatar: { url: val.profilePic, tooltip: key },
          name: val.name,
          intent: val.cusSerial,
          message: val.phone,
          nric: val.company,
          audience: '',

          numTimestamp: parseInt(val.timestamp),
          statusString: { formUrl: 'null', mapUrl: address, carUrl: 'null', imageUrl: val.imageUrl, btn1: 'Followed Up', btn2: 'Email', btn3: 'Make Remark', email: 'null', id: key, crm: 'appt', resolved: val.resolved, userAccessLevel: self.userAccessLevel, remark: val.remark },
          _rowVariant: val.resolved && 'success'
        });
      });

      _this.tableItems = customs;
      _this.loading = false;
    });
  },
  methods: {
    extractFromObject: function extractFromObject(object, key) {
      return object.filter(function (component) {
        return component.types.indexOf(key) === 0;
      }).map(function (item) {
        return item.long_name;
      }).pop() || null;
    }
  }
});

/***/ }),

/***/ 1566:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('p') : _c('app-table', {
    attrs: {
      "data": _vm.tableItems,
      "label": _vm.tableFields,
      "sortBy": "numTimestamp",
      "sortDesc": true
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1567:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userTable_vue__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55f86ebd_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_userTable_vue__ = __webpack_require__(1569);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55f86ebd_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_userTable_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1568:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(14);






var usersRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* db */].ref('users');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'user-table',
  data: function data() {
    return {
      usersCount: 0,
      loading: true,
      tableItems: [],
      tableFields: {
        avatar: {
          label: '<i class="icon-people"></i>',
          class: 'text-center'
        },
        user: {
          label: 'Customer'
        },
        fbId: {
          label: 'Facebook Messenger ID'
        },
        phoneId: {
          label: 'Phone Number'
        },
        timezone: {
          label: 'GMT'
        },

        intent: {
          label: 'Language'
        },
        actions: {
          label: '<i></i>',
          class: 'text-right',
          thStyle: {
            minWidth: '9em'
          }
        }
      }
    };
  },

  mounted: function mounted() {
    var _this = this;

    usersRef.once('value').then(function (snapshot) {
      _this.usersCount = snapshot.numChildren();
    });
    var msgs;
    usersRef.limitToLast(3).on('value', function (snapshot) {
      msgs = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(snapshot.val()).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];

        var msg = {
          avatar: { url: val.profilePic, tooltip: key },
          userId: key,
          user: { name: val.firstName && val.lastName ? val.firstName + ' ' + val.lastName : val.shortID, new: val.new, registered: val.registered, gender: val.gender },
          actions: { id: key, paused: false },

          fbId: val.fb,
          intent: 'English (UK)',

          phoneId: val.phoneNumber,
          timezone: val.timezone
        };
        msgs.unshift(msg);
      });
      console.log(msgs);
      _this.loading = false;
      _this.tableItems = msgs;
    });
  }
});

/***/ }),

/***/ 1569:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('p') : _c('app-table', {
    attrs: {
      "data": _vm.tableItems,
      "label": _vm.tableFields
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1570:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_broadcastTable_vue__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f797f3fa_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_broadcastTable_vue__ = __webpack_require__(1572);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_broadcastTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f797f3fa_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_broadcastTable_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1571:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(14);






var campRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* db */].ref('campaign');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'broadcast-table',
  data: function data() {
    return {
      usersCount: 0,
      loading: true,
      tableItems: [],
      tableFields: {
        campaign: {
          label: 'Campaign'
        },
        startDate: {
          label: 'Start Date',
          sortable: true,
          thStyle: {
            minWidth: '7em'
          }
        },
        endDate: {
          label: 'End Date',
          sortable: true,
          thStyle: {
            minWidth: '7em'
          }
        },
        audience: {
          label: 'Audience'
        },
        platform: {
          label: 'Platforms',

          thStyle: {
            minWidth: '8em'
          }
        },
        approval: {
          label: 'Approval',
          class: 'text-center'
        },
        sent: {
          label: 'Status',
          class: 'text-center'
        },
        broadcastActions: {
          label: '<i></i>',
          class: 'text-right'
        }
      }
    };
  },

  mounted: function mounted() {
    var _this = this;

    var msgs;
    campRef.on('value', function (snapshot) {
      msgs = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(snapshot.val()).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];

        var msg = {
          campaign: { campaign: val.message, campaignTitle: val.name },
          startDate: val.start_date,
          endDate: val.end_date,
          platform: { messenger: val.messenger, email: val.email, sms: val.sms },
          audience: val.audience,
          sent: val.sent,
          approval: val.approval,
          broadcastActions: key
        };
        msgs.unshift(msg);
      });
      console.log(msgs);
      _this.loading = false;
      _this.tableItems = msgs;
    });
  }
});

/***/ }),

/***/ 1572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('p') : _c('app-table', {
    attrs: {
      "data": _vm.tableItems,
      "label": _vm.tableFields,
      "rowBroadcastClick": "rowBroadcastClick"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_broadcastModal_vue__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c0f3d62_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_broadcastModal_vue__ = __webpack_require__(1575);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_broadcastModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c0f3d62_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_broadcastModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1574:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(14);




var campRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('campaign');
var campGRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('campaignGroups');
var d = new Date();
var today = d.getFullYear() + '-' + (d.getMonth() < 9 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) + '-' + (d.getDate() < 10 ? '0' + d.getDate() : d.getDate());

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'broadcast-modal',
  data: function data() {
    return {
      dataLength: 0,
      loading: true,
      largeModal: false,
      form: {
        sms: true,
        messenger: true,
        email: true,
        start_date: today,
        end_date: today,
        platform: 'webPopup',
        campaignGroup: '',
        campaignNumberGroup: ''
      },
      campaignGroups: null,
      campaignNumberGroups: null
    };
  },

  mounted: function mounted() {
    var _this = this;

    campRef.once('value').then(function (snapshot) {
      _this.dataLength = snapshot.numChildren();
    });
    var cGroups = [];
    campGRef.once('value').then(function (snapshot) {
      snapshot.forEach(function (item) {
        cGroups.push(item.key);
      });
      _this.campaignGroups = cGroups;
      _this.form.campaignGroup = cGroups[0];
    });
    this.campaignNumberGroups = ['011-1700 0785'];
    this.form.campaignNumberGroup = this.campaignNumberGroups[0];
  },
  methods: {
    onSubmit: function onSubmit() {
      var form = {
        audience: this.form.campaignGroup,
        message: this.form.campaign,
        name: this.form.campaignTitle,
        messenger: this.form.messenger,
        email: this.form.email,
        sms: this.form.sms,
        start_date: this.form.start_date,
        end_date: this.form.end_date,
        sent: false,
        approval: 'pending',
        end: false
      };
      console.log(form);
      this.dataLength += 1;
      campRef.child(this.dataLength).set(form);
      this.largeModal = false;
      this.$snotify.success('Campaign ' + form.name + ' is sent for approval!');
    }
  }
});

/***/ }),

/***/ 1575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-btn', {
    staticClass: "pull-right mr-1",
    attrs: {
      "type": "button",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.largeModal = true
      }
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  }), _vm._v("  Create New")]), _c('b-modal', {
    attrs: {
      "lazy": "lazy",
      "title": "Create new campaign",
      "size": "lg",
      "ok-title": "Launch"
    },
    on: {
      "ok": function($event) {
        _vm.largeModal = false
      }
    },
    model: {
      value: (_vm.largeModal),
      callback: function($$v) {
        _vm.largeModal = $$v
      },
      expression: "largeModal"
    }
  }, [_c('b-form', {
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "broadcastInputGroup1",
      "label": "Campaign Title:",
      "label-for": "broadcastInput1"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "broadcastInput1",
      "type": "text",
      "required": "required",
      "placeholder": "Enter Campaign Title"
    },
    model: {
      value: (_vm.form.campaignTitle),
      callback: function($$v) {
        _vm.form.campaignTitle = $$v
      },
      expression: "form.campaignTitle"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "id": "broadcastInputGroup2",
      "label": "Campaign Message:",
      "label-for": "broadcastInput2"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "broadcastInput2",
      "type": "text",
      "required": "required",
      "placeholder": "Enter Campaign Message"
    },
    model: {
      value: (_vm.form.campaign),
      callback: function($$v) {
        _vm.form.campaign = $$v
      },
      expression: "form.campaign"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "id": "broadcastInputGroup3",
      "label": "Audience:",
      "label-for": "broadcastInput3"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "broadcastInput3",
      "options": _vm.campaignGroups,
      "required": "required"
    },
    model: {
      value: (_vm.form.campaignGroup),
      callback: function($$v) {
        _vm.form.campaignGroup = $$v
      },
      expression: "form.campaignGroup"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "id": "broadcastInputGroupNumber",
      "label": "Number:",
      "label-for": "broadcastInputNumber"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "broadcastInputNumber",
      "options": _vm.campaignNumberGroups,
      "required": "required"
    },
    model: {
      value: (_vm.form.campaignNumberGroup),
      callback: function($$v) {
        _vm.form.campaignNumberGroup = $$v
      },
      expression: "form.campaignNumberGroup"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "id": "broadcastInputGroup4",
      "label": "Campaign Start Date:",
      "label-for": "broadcastInput4"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "broadcastInput4",
      "type": "date",
      "required": "required"
    },
    model: {
      value: (_vm.form.start_date),
      callback: function($$v) {
        _vm.form.start_date = $$v
      },
      expression: "form.start_date"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "id": "broadcastInputGroup5",
      "label": "Campaign End Date:",
      "label-for": "broadcastInput5"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "broadcastInput5",
      "type": "date",
      "required": "required"
    },
    model: {
      value: (_vm.form.end_date),
      callback: function($$v) {
        _vm.form.end_date = $$v
      },
      expression: "form.end_date"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "id": "broadcastGroup6",
      "label": "<i class='fa fa-envelope-o'></i> Email",
      "label-for": "broadcastInput6",
      "horizontal": "horizontal"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "broadcastInput6"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "id": "broadcastGroup7",
      "label": "<i class='fa fa-mobile'></i> SMS",
      "label-for": "broadcastInput7",
      "horizontal": "horizontal"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "broadcastInput7"
    },
    model: {
      value: (_vm.form.sms),
      callback: function($$v) {
        _vm.form.sms = $$v
      },
      expression: "form.sms"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "id": "broadcastGroup8",
      "label": "<i class='fa fa-facebook'></i> Messenger",
      "label-for": "broadcastInput8",
      "horizontal": "horizontal"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "broadcastInput8"
    },
    model: {
      value: (_vm.form.messenger),
      callback: function($$v) {
        _vm.form.messenger = $$v
      },
      expression: "form.messenger"
    }
  })], 1)], 1), _c('div', {
    slot: "modal-footer"
  }, [_c('b-button', {
    staticClass: "mr-1",
    attrs: {
      "type": "submit",
      "variant": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Submit")]), _c('b-button', {
    attrs: {
      "type": "button",
      "variant": "outline-secondary"
    },
    on: {
      "click": function($event) {
        _vm.largeModal = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_interactionsRightbar_vue__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cba8baa4_hasScoped_true_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_interactionsRightbar_vue__ = __webpack_require__(1584);
function injectStyle (ssrContext) {
  __webpack_require__(1577)
}
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cba8baa4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_interactionsRightbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cba8baa4_hasScoped_true_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_interactionsRightbar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1577:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1578:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dbApi__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dayjs__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dayjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_dayjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dayjs_plugin_relativeTime__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dayjs_plugin_relativeTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_dayjs_plugin_relativeTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utility_textToHTMLHelpers__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utility_preferUserName__ = __webpack_require__(1583);










__WEBPACK_IMPORTED_MODULE_3_dayjs___default.a.extend(__WEBPACK_IMPORTED_MODULE_4_dayjs_plugin_relativeTime___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'interaction-rightbar',
  data: function data() {
    return {
      userID: null,
      userInfo: null,

      name: null,
      preferredName: null,
      email: null,
      CRMname: null,
      CRMemail: null,
      shortID: null,

      uploadedPics: [],
      notes: [],

      displayAddNoteTextarea: false,
      addNoteText: '',
      dayjs: __WEBPACK_IMPORTED_MODULE_3_dayjs___default.a,
      showPropt: false,
      mobileNumber: null,
      requestType: null,
      comment: null,
      errors: [],
      requestTypeOptions: ['Registration', 'Account', 'Events', 'E-learning course', 'Website', 'Others']
    };
  },

  computed: {
    notesReversed: function notesReversed() {
      return this.notes.slice().reverse();
    },
    onlineStatus: function onlineStatus() {
      var _userInfo = this.userInfo,
          status = _userInfo.status,
          lastOnline = _userInfo.lastOnline;

      var statusText = '';
      if (status == 'success') {
        statusText = 'currently online';
      } else {
        statusText = lastOnline ? 'last seen ' + this.formatTimeAgo(lastOnline) : 'offline';
      }
      return statusText;
    }
  },
  methods: {
    checkForm: function checkForm(e) {
      if (this.mobileNumber && this.requestType && this.name && this.email && this.userID) {
        this.showPropt = false;

        return true;
      }

      this.errors = [];

      if (!this.mobileNumber) {
        this.errors.push('Mobile Number required.');
      }
      if (!this.requestType) {
        this.errors.push('Request Type required.');
      }

      e.preventDefault();
    },
    extractUserInfo: function extractUserInfo(userInfo) {
      if (userInfo) {
        this.shortID = userInfo.shortID;
      }
      this.preferredName = Object(__WEBPACK_IMPORTED_MODULE_6__utility_preferUserName__["a" /* fullNameElseID */])(null, userInfo) || '';
      this.userLineNumber = userInfo.userLineNumber || '';
      this.osUserId = userInfo.osUserId || '';
      this.mtxUserId = userInfo.matrixUserId || '';

      if (userInfo && userInfo.orderInfoByText) {
        var info = userInfo.orderInfoByText;
        this.name = info.name || '';
        this.email = info.email || '';
        this.CRMname = info.name || '';
        this.CRMemail = info.email || '';
      }
      if (userInfo && userInfo.userName) {
        this.name = userInfo.userName;
      } else if (userInfo && userInfo.firstName && userInfo.lastName) {
        this.name = userInfo.firstName + ' ' + userInfo.lastName || '';
      } else if (userInfo && userInfo.name) {
        this.name = userInfo.name;
      }
      if (userInfo && userInfo.userEmail) {
        this.email = userInfo.userEmail;
      } else if (userInfo && userInfo.email) {
        this.email = userInfo.email;
      }
    },
    deleteNote: function deleteNote(noteID) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var agentNotes;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.notes = _this.notes.filter(function (note) {
                  return note.id !== noteID;
                });
                agentNotes = Object(__WEBPACK_IMPORTED_MODULE_2__dbApi__["a" /* AgentNotes */])(_this.userID);
                _context.next = 4;
                return agentNotes.delete(noteID);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    addNote: function addNote() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var noteText, note, agentNotes, noteID;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                noteText = _this2.addNoteText.trim();

                _this2.hideAddNoteTextarea();
                _this2.addNoteText = '';
                note = { text: noteText, timestamp: Date.now() };

                _this2.notes.push(note);
                agentNotes = Object(__WEBPACK_IMPORTED_MODULE_2__dbApi__["a" /* AgentNotes */])(_this2.userID);
                _context2.next = 8;
                return agentNotes.push(note);

              case 8:
                noteID = _context2.sent;

                note.id = noteID;

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    formatTimeAgo: function formatTimeAgo(timestamp) {
      return __WEBPACK_IMPORTED_MODULE_3_dayjs___default()(timestamp).from(__WEBPACK_IMPORTED_MODULE_3_dayjs___default()());
    },
    replaceNewlineToBr: function replaceNewlineToBr(str) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__utility_textToHTMLHelpers__["a" /* replaceNewlineToBr */])(str);
    },
    showAddNoteTextarea: function showAddNoteTextarea() {
      this.displayAddNoteTextarea = true;
    },
    hideAddNoteTextarea: function hideAddNoteTextarea() {
      this.displayAddNoteTextarea = false;
    },
    focusTextarea: function focusTextarea() {
      this.$refs['note-input'].focus();
    },
    addNoteClickHandler: function addNoteClickHandler() {
      this.showAddNoteTextarea();
      this.$nextTick(function () {
        this.focusTextarea();
      });
    },
    grabData: function grabData() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var userID, uploadedPics, agentNotes, notes;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                userID = _this3.userID;

                Object(__WEBPACK_IMPORTED_MODULE_2__dbApi__["d" /* streamUserInfo */])(userID, function (userInfo) {
                  _this3.userInfo = userInfo;
                  _this3.extractUserInfo(userInfo);
                });

                uploadedPics = Object(__WEBPACK_IMPORTED_MODULE_2__dbApi__["c" /* getUploadedPics */])();

                _this3.uploadedPics = uploadedPics;

                agentNotes = Object(__WEBPACK_IMPORTED_MODULE_2__dbApi__["a" /* AgentNotes */])(userID);
                _context3.next = 7;
                return agentNotes.get();

              case 7:
                notes = _context3.sent;

                _this3.notes = notes;

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    cleanup: function cleanup() {
      Object(__WEBPACK_IMPORTED_MODULE_2__dbApi__["b" /* cleanupStreamingRefs */])();
    },
    handleEnter: function handleEnter(event) {
      event.preventDefault();

      if (!event.shiftKey) {
        this.addNote();
      }
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var path, userID, complainForm, processComplainForm;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              processComplainForm = function processComplainForm(e) {
                e.preventDefault();

                alert('Submitted.');
              };

              path = _this4.$route.path;
              userID = path.split('/')[2];

              _this4.userID = userID;

              _this4.grabData();
              complainForm = document.getElementById('complainForm');

              complainForm.addEventListener('submit', processComplainForm);

            case 7:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },

  watch: {
    $route: function $route(to, from) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var path, userID;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.cleanup();

                path = to.path;
                userID = path.split('/')[2];

                _this5.userID = userID;

                _this5.grabData();

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.cleanup();
  }
});

/***/ }),

/***/ 1579:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getUserInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return streamUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getUploadedPics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AgentNotes; });
/* unused harmony export UploadComplain */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cleanupStreamingRefs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__firebase__ = __webpack_require__(14);







var getUserInfo = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee(user) {
    var data;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_6__firebase__["b" /* db */].ref('users/' + user).once('value').then(function (snapshot) {
              return snapshot.val();
            });

          case 2:
            data = _context.sent;
            return _context.abrupt('return', data);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getUserInfo(_x) {
    return _ref.apply(this, arguments);
  };
}();

var streamUserInfo = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2(user, callback) {
    var ref, onUserInfoUpdate;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            ref = __WEBPACK_IMPORTED_MODULE_6__firebase__["b" /* db */].ref('users/' + user);
            onUserInfoUpdate = ref.on('value', function (snapshot) {
              callback(snapshot.val());
            });

            streamingRefs.push({ ref: ref, listener: onUserInfoUpdate });

          case 3:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function streamUserInfo(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();



var streamingRefs = [];

function cleanupStreamingRefs() {
  streamingRefs.map(function (refObj) {
    refObj.ref.off('value', refObj.listener);
  });
}

function getUploadedPics(user) {
  return [];
}

function AgentNotes(user) {
  var ref = __WEBPACK_IMPORTED_MODULE_6__firebase__["b" /* db */].ref('users/' + user + '/agentNotes');
  return {
    get: function get() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return ref.once('value').then(function (snapshot) {
                  var val = snapshot.val();
                  if (val) {
                    var entries = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(val);
                    var notes = [];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                      for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(entries), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var entry = _step.value;

                        var _entry = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(entry, 2),
                            key = _entry[0],
                            value = _entry[1];

                        var note = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ id: key }, value);
                        notes.push(note);
                      }
                    } catch (err) {
                      _didIteratorError = true;
                      _iteratorError = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                          _iterator.return();
                        }
                      } finally {
                        if (_didIteratorError) {
                          throw _iteratorError;
                        }
                      }
                    }

                    return notes;
                  } else {
                    return [];
                  }
                });

              case 2:
                data = _context3.sent;
                return _context3.abrupt('return', data);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this);
      }))();
    },
    push: function push(note) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var noteRef;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                noteRef = ref.push();
                _context4.next = 3;
                return noteRef.set(note);

              case 3:
                return _context4.abrupt('return', noteRef.key);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }))();
    },
    delete: function _delete(noteID) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var noteRef;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                noteRef = ref.child(noteID);
                _context5.next = 3;
                return noteRef.set(null);

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this3);
      }))();
    }
  };
}

function UploadComplain(timestamp) {
  var ref = __WEBPACK_IMPORTED_MODULE_6__firebase__["b" /* db */].ref('custom/CRM/' + timestamp);
  return {
    update: function update(complain) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return ref.update(complain);

              case 2:
                return _context6.abrupt('return', ref.key);

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this4);
      }))();
    }
  };
}



/***/ }),

/***/ 1582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return replaceNewlineToBr; });
function replaceNewlineToBr(innerHTML) {
  if (typeof innerHTML !== 'string') {
    console.warn('Supplied innerHTML is not of type \'string\'');
    return '';
  }
  return innerHTML.replace(/\n/g, '<br>');
}



/***/ }),

/***/ 1583:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fullNameElseID;
function fullNameElseID(key, val) {
  if (val.osUserId && val.osUserId !== '') {
    if (val.userPreferredName && val.userPreferredName !== '') {
      return val.userPreferredName;
    } else if (val.name && val.name !== '') {
      return val.name;
    } else if (val.userName && val.userName !== '') {
      var username = jsUcfirst(val.userName.split(' ')[0]);
      return username;
    } else if (val.shortID) {
      return 'Guest ' + val.shortID;
    } else {
      return 'Guest';
    }
  } else if (val.firstName && val.lastName) {
    return val.firstName + ' ' + val.lastName;
  } else if (val.name) {
    return val.name;
  } else if (val.orderInfoByText && val.orderInfoByText.name) {
    return val.orderInfoByText.name;
  } else if (val.shortID) {
    return 'Guest ' + val.shortID;
  } else {
      return 'Guest';
    }
}
function jsUcfirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),

/***/ 1584:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "interaction-rightbar mb-2 py-3"
  }, [_c('div', [_c('div', {
    staticClass: "mb-0 px-3"
  }, [_c('h5', {
    staticClass: "mb-1",
    staticStyle: {
      "color": "#536c79"
    }
  }, [_vm._v("User Info")]), (_vm.userInfo) ? _c('div', [(_vm.userInfo.status) ? _c('div', [_c('span', [_c('i', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.onlineStatus))])]), _c('div', {
    staticClass: "avatar",
    staticStyle: {
      "width": "14px",
      "top": "1px"
    }
  }, [_c('span', {
    staticClass: "avatar-status",
    class: _vm.userInfo ? "bg-" + _vm.userInfo.status : "bg-danger"
  })]), _c('br')]) : _vm._e(), (_vm.name) ? _c('div', [_vm._v("Name: " + _vm._s(_vm.name))]) : _vm._e(), (_vm.preferredName) ? _c('div', [_vm._v("Preferred Name: " + _vm._s(_vm.preferredName))]) : _vm._e(), (_vm.email) ? _c('div', [_vm._v("Email: " + _vm._s(_vm.email || _vm.userEmail))]) : _vm._e(), (_vm.userLineNumber) ? _c('div', [_vm._v("giga Number: " + _vm._s(_vm.userLineNumber))]) : _vm._e(), (_vm.osUserId) ? _c('div', [_vm._v("OutSystems User ID: " + _vm._s(_vm.osUserId))]) : _vm._e(), (_vm.mtxUserId) ? _c('div', [_vm._v("Matrixx User ID: " + _vm._s(_vm.mtxUserId))]) : _vm._e()]) : _vm._e()]), _c('hr')]), (_vm.uploadedPics.length) ? _c('div', [_vm._m(0), _c('hr')]) : _vm._e(), _c('div', [_c('div', {
    staticClass: "mb-0 px-3"
  }, [_c('h5', {
    staticClass: "mb-1",
    staticStyle: {
      "color": "#536c79"
    }
  }, [_vm._v("CRM Info")]), (_vm.userInfo) ? _c('div', [(_vm.CRMname) ? _c('div', [_vm._v("Name: " + _vm._s(_vm.CRMname))]) : _vm._e(), (_vm.CRMemail) ? _c('div', [_vm._v("Email: " + _vm._s(_vm.CRMemail))]) : _vm._e()]) : _vm._e()]), _c('hr')]), _c('div', [_c('div', {
    staticClass: "mb-0 px-3"
  }, [_c('span', {
    staticClass: "add-note-button",
    on: {
      "click": _vm.addNoteClickHandler
    }
  }, [_vm._v("Add Note")]), _c('h5', {
    staticClass: "mb-3",
    staticStyle: {
      "color": "#536c79"
    }
  }, [_vm._v("Notes")]), (_vm.displayAddNoteTextarea) ? _c('b-form-textarea', {
    ref: "note-input",
    staticClass: "mb-1",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "rows": 3,
      "max-rows": 6,
      "placeholder": "Jot down something..."
    },
    nativeOn: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleEnter($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.hideAddNoteTextarea($event)
      }]
    },
    model: {
      value: (_vm.addNoteText),
      callback: function($$v) {
        _vm.addNoteText = $$v
      },
      expression: "addNoteText"
    }
  }) : _vm._e(), (_vm.notes.length == 0 && !_vm.displayAddNoteTextarea) ? _c('div', [_c('i', {
    staticClass: "text-muted"
  }, [_vm._v("No notes available")])]) : _vm._l((_vm.notesReversed), function(note, index) {
    return _c('div', {
      staticClass: "note"
    }, [_c('div', {
      staticClass: "note-text",
      domProps: {
        "innerHTML": _vm._s(_vm.replaceNewlineToBr(note.text))
      }
    }), _c('div', {
      staticClass: "note-others"
    }, [_c('span', [_vm._v(_vm._s(_vm.formatTimeAgo(note.timestamp)))]), _c('span', [_vm._v(" · ")]), _c('span', {
      staticClass: "delete-note-button",
      on: {
        "click": function($event) {
          _vm.deleteNote(note.id)
        }
      }
    }, [_vm._v("Delete")])]), (index != _vm.notes.length - 1) ? _c('hr') : _vm._e()])
  })], 2), _c('hr')]), _c('div', {
    staticStyle: {
      "position": "absolute",
      "bottom": "40px",
      "text-align": "center",
      "width": "100%",
      "margin": "5px"
    }
  }, [_c('div', {
    staticClass: "mb-2 px-3"
  }, [_c('b-button', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        _vm.showPropt = true
      }
    }
  }, [_vm._v("Create New Service Request")])], 1)]), _c('b-modal', {
    attrs: {
      "title": "Create New Service Request"
    },
    model: {
      value: (_vm.showPropt),
      callback: function($$v) {
        _vm.showPropt = $$v
      },
      expression: "showPropt"
    }
  }, [_c('b-form', {
    attrs: {
      "id": "complainForm"
    },
    on: {
      "submit": _vm.checkForm
    }
  }, [(_vm.errors.length) ? _c('span', [_vm._v("Please correct the following error(s):"), _c('ul', _vm._l((_vm.errors), function(error) {
    return _c('li', [_vm._v(_vm._s(error))])
  }))]) : _vm._e(), _c('span', [_vm._v("Mobile Number")]), _c('b-input', {
    attrs: {
      "id": "mobileNumber",
      "type": "text",
      "name": "mobileNumber",
      "placeholder": "Enter Mobile Number"
    },
    model: {
      value: (_vm.mobileNumber),
      callback: function($$v) {
        _vm.mobileNumber = $$v
      },
      expression: "mobileNumber"
    }
  }), _c('span', [_vm._v("Request Type")]), _c('b-form-select', {
    attrs: {
      "id": "requestType",
      "name": "requestType",
      "placeholder": "Select Request Type",
      "options": _vm.requestTypeOptions
    },
    model: {
      value: (_vm.requestType),
      callback: function($$v) {
        _vm.requestType = $$v
      },
      expression: "requestType"
    }
  }, [_c('template', {
    slot: "first"
  }, [_c('option', {
    attrs: {
      "disabled": "disabled"
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("-- Please select a Request Type --")])])], 2), _c('span', [_vm._v("Comment")]), _c('b-textarea', {
    attrs: {
      "id": "comment",
      "type": "text",
      "name": "comment",
      "rows": "3",
      "placeholder": "Enter Comment"
    },
    model: {
      value: (_vm.comment),
      callback: function($$v) {
        _vm.comment = $$v
      },
      expression: "comment"
    }
  }), _c('span', [_vm._v("User ID")]), _c('b-input', {
    attrs: {
      "id": "userID",
      "type": "text",
      "name": "userID",
      "placeholder": "Enter User ID",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.userID),
      callback: function($$v) {
        _vm.userID = $$v
      },
      expression: "userID"
    }
  }), _c('span', [_vm._v("Email")]), _c('b-input', {
    attrs: {
      "id": "email",
      "type": "text",
      "name": "email",
      "placeholder": "Enter Email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _c('span', [_vm._v("Name")]), _c('b-textarea', {
    attrs: {
      "id": "name",
      "type": "text",
      "name": "name",
      "placeholder": "Enter Name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _c('div', {
    slot: "modal-footer"
  }, [_c('b-button', {
    staticClass: "float-right ml-1",
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.showPropt = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('b-button', {
    staticClass: "float-right ml-1",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.checkForm
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-0 px-3"
  }, [_c('h5', {
    staticClass: "mb-1",
    staticStyle: {
      "color": "#536c79"
    }
  }, [_vm._v("Media")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1585:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fallbackTable_vue__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc3606f4_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_fallbackTable_vue__ = __webpack_require__(1587);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fallbackTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc3606f4_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_fallbackTable_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1586:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(14);







var defaultRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* db */].ref('defaultFallbackIntentWord');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fallback-table',
  data: function data() {
    return {
      cls: {},
      loading: true,
      tableItems: [],
      tableFields: {
        number: {
          label: 'No'
        },
        messages: {
          label: 'Messages',
          tdClass: 'messagesInTable'
        },
        userId: {
          label: 'User ID'
        },
        timestamp: {
          label: 'Timestamp'
        },
        count: {
          label: 'Count'
        }
      }
    };
  },

  mounted: function mounted() {
    var _this = this;

    var customs;
    defaultRef.limitToLast(1000).once('value', function (snapshot) {
      customs = [];
      var number = snapshot.numChildren();
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(snapshot.val()).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];

        customs.unshift({
          number: number,
          messages: val.messages,
          userId: val.userID,
          timestamp: parseInt(val.timestamp),
          count: val.count
        });
        number -= 1;
      });
      _this.tableItems = customs;
      _this.loading = false;
    });
  }
});

/***/ }),

/***/ 1587:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('p') : _c('app-conversationtopictable', {
    attrs: {
      "data": _vm.tableItems,
      "label": _vm.tableFields,
      "rowClick": "rowClick"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1592:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_DateRangePicker_vue__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1c66ed8c_hasScoped_false_vue_loader_lib_selector_type_template_index_0_DateRangePicker_vue__ = __webpack_require__(1596);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_DateRangePicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1c66ed8c_hasScoped_false_vue_loader_lib_selector_type_template_index_0_DateRangePicker_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_daterangepicker_daterangepicker__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_daterangepicker_daterangepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_daterangepicker_daterangepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_daterangepicker_daterangepicker_css__ = __webpack_require__(1595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_daterangepicker_daterangepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_daterangepicker_daterangepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "date-range-picker",
  props: {
    value: {},
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    format: {
      type: String,
      default: "DD/MM/YYYY"
    },
    className: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      range: []
    };
  },
  computed: {
    isSingleDatePicker: function isSingleDatePicker() {
      return this.options.singleDatePicker;
    },
    startDate: function startDate() {
      if (this.isSingleDatePicker) {
        return this.range;
      }
      return this.range[0];
    },
    endDate: function endDate() {
      if (this.isSingleDatePicker) {
        return this.range;
      }
      return this.range[1];
    },
    customOptions: function customOptions() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        locale: {
          format: this.format
        }
      }, this.options);
    }
  },
  watch: {
    value: function value(_value) {
      this.range = _value;
    },
    range: function range(value) {
      this.$emit("change", value);
      this.$emit("input", value);
    }
  },
  created: function created() {
    this.range = this.value;
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      var el = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el);
      el.daterangepicker(_this.customOptions);
      el.on("apply.daterangepicker", function (event, picker) {
        var startDate = picker.startDate.format(_this.format);
        var endDate = picker.endDate.format(_this.format);
        if (_this.isSingleDatePicker) {
          _this.range = startDate;
        } else {
          _this.range = [startDate, endDate];
        }
      });
      el.on("cancel.daterangepicker", function () {
        if (_this.isSingleDatePicker) {
          _this.range = "";
        } else {
          _this.range = [];
        }
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).daterangepicker("hide").daterangepicker("destroy");
  }
});

/***/ }),

/***/ 1595:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1596:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    class: _vm.className,
    attrs: {
      "type": "text"
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 232:
/***/ (function(module, exports) {

module.exports = {"daily":{"20190702":{"topics":{"Default Fallback Intent":{"interactions":20,"users":6},"Default Welcome Intent":{"interactions":34,"users":11},"ST0003 Ignore Replies":{"interactions":3,"users":1},"ST0060 You are so clever":{"interactions":1,"users":1},"ST0076 That is bad":{"interactions":2,"users":1},"ST0084 Bye-bye!":{"interactions":1,"users":1},"ST0303 Good nite":{"interactions":2,"users":2},"i1012 Theme Park":{"interactions":1,"users":1},"i1024 Best Time to Visit":{"interactions":1,"users":1},"i1029 Contact Center Operation Hours":{"interactions":1,"users":1},"i1035 Surau":{"interactions":1,"users":1},"i1101 Reset Password":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":3,"users":1},"i1105 Hotline Busy":{"interactions":1,"users":1},"i1107 Email":{"interactions":2,"users":2},"i1200 Getting There":{"interactions":3,"users":2},"i1201 Express Bus":{"interactions":1,"users":1},"i1206 Getting There KLIA":{"interactions":1,"users":1},"i1210 Book Complimentary Limousine":{"interactions":1,"users":1},"i2001 Extra Bed":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":13,"users":5},"i2102 Stock Selling":{"interactions":1,"users":1},"i2103 Stock Buying":{"interactions":2,"users":2},"i2106 Check In On Behalf":{"interactions":1,"users":1},"i2109 Transfer Room Booking":{"interactions":1,"users":1},"i2129 Room Reservation Under Different Category":{"interactions":1,"users":1},"i2135 Book Room Using - Image":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":1,"users":1},"i2302 Retrieve Membership ID":{"interactions":6,"users":5},"i2303 Lost Card":{"interactions":2,"users":2},"i2306 Tier Points":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":1,"users":1},"i3300 Theme Park Attractions":{"interactions":2,"users":1},"i3307 Where is toilet":{"interactions":1,"users":1},"i3316 Wedding Plans":{"interactions":1,"users":1},"i3401 Salary Payment":{"interactions":1,"users":1}},"totals":{"interactions":{"total":117},"users":{"total":17}}},"20190703":{"topics":{"Default Fallback Intent":{"interactions":162,"users":85},"Default Welcome Intent":{"interactions":237,"users":159},"Get Started - Extract Facebook User Info":{"interactions":3,"users":1},"Room-FreeRoom":{"interactions":1,"users":1},"ST0001 Thank You":{"interactions":15,"users":11},"ST0002 Are You Human":{"interactions":3,"users":3},"ST0003 Ignore Replies":{"interactions":6,"users":5},"ST0052 Chatbot Wrong Answer":{"interactions":1,"users":1},"ST0058 Can you help me?":{"interactions":4,"users":4},"ST0060 You are so clever":{"interactions":1},"ST0070 Where do you work?":{"interactions":1,"users":1},"ST0079 Thank you!":{"interactions":6,"users":6},"ST0115 Yes":{"interactions":1,"users":1},"ST0116 No":{"interactions":1,"users":1},"ST0122 What do you mean?":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":2,"users":2},"ST0316 Can you hear me?":{"interactions":1,"users":1},"ST0338 I'm bored":{"interactions":1,"users":1},"ST0342 i need help in buying":{"interactions":1,"users":1},"ST0800 Profanity 1":{"interactions":2,"users":1},"i1001 About Us":{"interactions":4,"users":4},"i1002 Wheel Chair Stroller":{"interactions":1,"users":1},"i1003 Operating Hours":{"interactions":2,"users":2},"i1004 Promotions":{"interactions":17,"users":14},"i1006 Download Mobile App":{"interactions":3,"users":3},"i1010 Theme Park":{"interactions":6,"users":6},"i1012 Theme Park":{"interactions":5,"users":3},"i1016 Clinic":{"interactions":1,"users":1},"i1019 School":{"interactions":1,"users":1},"i1022 Convenient Stores":{"interactions":1,"users":1},"i1028 Where is police station":{"interactions":1,"users":1},"i1029 Contact Center Operation Hours":{"interactions":6,"users":5},"i1039 Tourism Tax":{"interactions":1,"users":1},"i1044 Job Opening":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":26,"users":21},"i1101 Reset Password":{"interactions":12,"users":10},"i1102 Room Lost and Found":{"interactions":4,"users":3},"i1103 Forgot Email":{"interactions":7,"users":7},"i1104 Contact Number":{"interactions":9,"users":7},"i1105 Hotline Busy":{"interactions":1,"users":1},"i1107 Email":{"interactions":4,"users":4},"i1200 Getting There":{"interactions":9,"users":6},"i1201 Express Bus":{"interactions":7,"users":4},"i1202 Parking Rates":{"interactions":1,"users":1},"i1203  Bus Terminal":{"interactions":6,"users":2},"i1204 Parking Map":{"interactions":1,"users":1},"i1207 Free Shuttle Bus":{"interactions":6,"users":3},"i1218 Shuttle From Airport":{"interactions":1,"users":1},"i1220 Parking Lot Issue":{"interactions":1,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":2,"users":1},"i2000 Adjoining Room":{"interactions":5,"users":5},"i2001 Extra Bed":{"interactions":2,"users":2},"i2002 Smoking Room":{"interactions":1,"users":1},"i2003 Room Late Check Out":{"interactions":2,"users":1},"i2004 Room Check In Time":{"interactions":2,"users":2},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2006 Room Check In Age":{"interactions":1,"users":1},"i2014 Reception Operating Hours":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":149,"users":83},"i2101 Complimentary Room Request":{"interactions":11,"users":10},"i2102 Stock Selling":{"interactions":9,"users":7},"i2103 Stock Buying":{"interactions":5,"users":4},"i2104 Room Reservation Full":{"interactions":5,"users":4},"i2105 Early Check In":{"interactions":4,"users":4},"i2106 Check In On Behalf":{"interactions":10,"users":7},"i2107 Multiroom Booking":{"interactions":5,"users":3},"i2108 Room Upgrade Request":{"interactions":1,"users":1},"i2109 Transfer Room Booking":{"interactions":7,"users":7},"i2110 Change Booking Date":{"interactions":7,"users":5},"i2111 Help Reserve A Room":{"interactions":9,"users":6},"i2114 Room Complimentary Birthday":{"interactions":9,"users":8},"i2115 Stock FAQ":{"interactions":11,"users":8},"i2118 Room Complimentary How to know free room":{"interactions":3,"users":1},"i2119 Room Reservation Combine Nights":{"interactions":1,"users":1},"i2121 OTT Booking":{"interactions":3,"users":2},"i2122 Room Amenities":{"interactions":4,"users":3},"i2126 Family Room Reservations":{"interactions":3,"users":3},"i2133 Book Room Using Membership":{"interactions":16,"users":13},"i2134 Book Room Using - Video":{"interactions":9,"users":8},"i2135 Book Room Using - Image":{"interactions":21,"users":14},"i2200 Make Payment For Booking":{"interactions":4,"users":3},"i2205 Third Party Sites Booking":{"interactions":2,"users":2},"i2301 Cannot Log In":{"interactions":18,"users":13},"i2302 Retrieve Membership ID":{"interactions":17,"users":13},"i2303 Lost Card":{"interactions":11,"users":11},"i2305 Earn Points":{"interactions":1,"users":1},"i2306 Tier Points":{"interactions":4,"users":2},"i2308 No Points Added":{"interactions":2,"users":2},"i2309 Membership Benefits":{"interactions":2,"users":2},"i2310 Apply for Membership":{"interactions":4,"users":3},"i2311 Under 18 Join Membership":{"interactions":1,"users":1},"i2312 Number of Member Card Can Apply":{"interactions":2,"users":1},"i2319 Member Renew Membership":{"interactions":1,"users":1},"i3101 Theme Park Dress Code":{"interactions":1,"users":1},"i3200 Concert Collect Tickets":{"interactions":5,"users":4},"i3201 Concet Collect On Behalf":{"interactions":1,"users":1},"i3202 Concert Transfer Ticket":{"interactions":1,"users":1},"i3203 Concert Refund Ticket":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":3,"users":2},"i3210 Concert Event Info":{"interactions":9,"users":6},"i3300 Theme Park Attractions":{"interactions":8,"users":5},"i3304 Product Price":{"interactions":4,"users":3},"i3306 Where is Box Office":{"interactions":1,"users":1},"i3307 Where is toilet":{"interactions":2,"users":1},"i3308 Where is the indoor themepark?":{"interactions":1,"users":1},"i3312 Where is cinema?":{"interactions":1,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":2,"users":2},"i3327 Salary Claims":{"interactions":1,"users":1},"i3400 Dining":{"interactions":7,"users":5},"i3402 Interest Charged":{"interactions":1,"users":1},"i3403 Interest Gained":{"interactions":2,"users":1}},"totals":{"interactions":{"total":1034},"users":{"total":190}}},"20190704":{"topics":{"Default Fallback Intent":{"interactions":188,"users":94},"Default Welcome Intent":{"interactions":177,"users":126},"Room-FreeRoom":{"interactions":1,"users":1},"ST0001 Thank You":{"interactions":6,"users":6},"ST0002 Are You Human":{"interactions":2,"users":2},"ST0003 Ignore Replies":{"interactions":5,"users":4},"ST0052 Chatbot Wrong Answer":{"interactions":3,"users":3},"ST0058 Can you help me?":{"interactions":5,"users":4},"ST0075 Are you there?":{"interactions":1,"users":1},"ST0079 Thank you!":{"interactions":5,"users":4},"ST0084 Bye-bye!":{"interactions":1,"users":1},"ST0092 I can't sleep":{"interactions":2,"users":1},"ST0112 I'd like to see you again":{"interactions":1,"users":1},"ST0114 I'll be back":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":1,"users":1},"ST0121 Sorry":{"interactions":1,"users":1},"ST0122 What do you mean?":{"interactions":2,"users":1},"ST0300 Good morning":{"interactions":1,"users":1},"ST0301 Good afternoon":{"interactions":2,"users":2},"ST0317 Can you learn?":{"interactions":1,"users":1},"ST0342 i need help in buying":{"interactions":1,"users":1},"ST0800 Profanity 1":{"interactions":1,"users":1},"i1001 About Us":{"interactions":4,"users":4},"i1002 Wheel Chair Stroller":{"interactions":2,"users":1},"i1003 Operating Hours":{"interactions":3,"users":1},"i1004 Promotions":{"interactions":7,"users":5},"i1006 Download Mobile App":{"interactions":6,"users":5},"i1010 Theme Park":{"interactions":4,"users":4},"i1012 Theme Park":{"interactions":1,"users":1},"i1013 Weather":{"interactions":1,"users":1},"i1021 History":{"interactions":1,"users":1},"i1027 Durian allowed?":{"interactions":3,"users":1},"i1035 Surau":{"interactions":1,"users":1},"i1044 Job Opening":{"interactions":2,"users":1},"i1100 General Complaint":{"interactions":37,"users":25},"i1101 Reset Password":{"interactions":14,"users":11},"i1103 Forgot Email":{"interactions":7,"users":5},"i1104 Contact Number":{"interactions":5,"users":5},"i1105 Hotline Busy":{"interactions":1,"users":1},"i1107 Email":{"interactions":9,"users":9},"i1200 Getting There":{"interactions":10,"users":9},"i1201 Express Bus":{"interactions":5,"users":3},"i1202 Parking Rates":{"interactions":3,"users":2},"i1203  Bus Terminal":{"interactions":3,"users":3},"i1204 Parking Map":{"interactions":1,"users":1},"i1205 Free Parking":{"interactions":1,"users":1},"i1206 Getting There KLIA":{"interactions":3,"users":2},"i1207 Free Shuttle Bus":{"interactions":4,"users":2},"i1209 Parking Grace Period":{"interactions":1,"users":1},"i1210 Book Complimentary Limousine":{"interactions":2,"users":2},"i1211 Taxi to ":{"interactions":1,"users":1},"i1218 Shuttle From Airport":{"interactions":1,"users":1},"i1220 Parking Lot Issue":{"interactions":1,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":3,"users":2},"i2000 Adjoining Room":{"interactions":4,"users":1},"i2002 Smoking Room":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":4,"users":3},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2006 Room Check In Age":{"interactions":2,"users":2},"i2015 Room Breakfast":{"interactions":1,"users":1},"i2020 Room Special Request":{"interactions":1,"users":1},"i2021 Hotel Breakfast Starting":{"interactions":3,"users":1},"i2100 Stock Price":{"interactions":85,"users":69},"i2101 Complimentary Room Request":{"interactions":12,"users":11},"i2102 Stock Selling":{"interactions":10,"users":8},"i2103 Stock Buying":{"interactions":8,"users":7},"i2104 Room Reservation Full":{"interactions":4,"users":3},"i2105 Early Check In":{"interactions":2,"users":2},"i2106 Check In On Behalf":{"interactions":10,"users":6},"i2107 Multiroom Booking":{"interactions":4,"users":4},"i2108 Room Upgrade Request":{"interactions":4,"users":3},"i2109 Transfer Room Booking":{"interactions":7,"users":6},"i2110 Change Booking Date":{"interactions":9,"users":6},"i2111 Help Reserve A Room":{"interactions":5,"users":5},"i2113 Room Wheelchair Friendly":{"interactions":2,"users":1},"i2114 Room Complimentary Birthday":{"interactions":5,"users":5},"i2115 Stock FAQ":{"interactions":18,"users":14},"i2118 Room Complimentary How to know free room":{"interactions":1,"users":1},"i2119 Room Reservation Combine Nights":{"interactions":1,"users":1},"i2120 OTA Points Redemption":{"interactions":1,"users":1},"i2121 OTT Booking":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":4,"users":2},"i2125 Room Reservation Cancel Comp Room":{"interactions":1,"users":1},"i2126 Family Room Reservations":{"interactions":8,"users":4},"i2132 Foreigner Passport Number":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":8,"users":7},"i2134 Book Room Using - Video":{"interactions":7,"users":7},"i2135 Book Room Using - Image":{"interactions":21,"users":16},"i2200 Make Payment For Booking":{"interactions":5,"users":2},"i2204 Sales Office":{"interactions":3,"users":3},"i2301 Cannot Log In":{"interactions":26,"users":20},"i2302 Retrieve Membership ID":{"interactions":16,"users":12},"i2303 Lost Card":{"interactions":8,"users":8},"i2305 Earn Points":{"interactions":2,"users":2},"i2306 Tier Points":{"interactions":1,"users":1},"i2307 Activate Membership":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":1,"users":1},"i2310 Apply for Membership":{"interactions":9,"users":1},"i2311 Under 18 Join Membership":{"interactions":4,"users":3},"i2319 Member Renew Membership":{"interactions":3,"users":2},"i3200 Concert Collect Tickets":{"interactions":3,"users":2},"i3207 Concert Package":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":7,"users":6},"i3300 Theme Park Attractions":{"interactions":2,"users":2},"i3303 Operating Hours":{"interactions":1,"users":1},"i3304 Product Price":{"interactions":1,"users":1},"i3312 Where is cinema?":{"interactions":1,"users":1},"i3316 Wedding Plans":{"interactions":2,"users":1},"i3318 Itinerary Advisor":{"interactions":1,"users":1},"i3320 Wedding Price":{"interactions":1,"users":1},"i3400 Dining":{"interactions":4,"users":3},"i3401 Salary Payment":{"interactions":2,"users":2},"i3404 Payment Card":{"interactions":1,"users":1},"tt - testing":{"interactions":1,"users":1}},"totals":{"interactions":{"total":918},"users":{"total":179}}},"20190705":{"topics":{"Default Fallback Intent":{"interactions":142,"users":84},"Default Welcome Intent":{"interactions":174,"users":115},"ST0001 Thank You":{"interactions":6,"users":6},"ST0002 Are You Human":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":14,"users":11},"ST0052 Chatbot Wrong Answer":{"interactions":4,"users":4},"ST0058 Can you help me?":{"interactions":2,"users":2},"ST0082 Ha ha ha!":{"interactions":1,"users":1},"ST0093":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":4,"users":4},"ST0303 Good nite":{"interactions":1,"users":1},"i1001 About Us":{"interactions":1,"users":1},"i1002 Wheel Chair Stroller":{"interactions":4,"users":1},"i1003 Operating Hours":{"interactions":3,"users":2},"i1004 Promotions":{"interactions":12,"users":10},"i1006 Download Mobile App":{"interactions":5,"users":4},"i1007 Map":{"interactions":1,"users":1},"i1009 Leisure":{"interactions":4,"users":4},"i1010 Theme Park":{"interactions":8,"users":7},"i1012 Theme Park":{"interactions":1,"users":1},"i1033 Free Wifi":{"interactions":1,"users":1},"i1044 Job Opening":{"interactions":2,"users":1},"i1100 General Complaint":{"interactions":49,"users":42},"i1101 Reset Password":{"interactions":4,"users":3},"i1102 Room Lost and Found":{"interactions":1,"users":1},"i1103 Forgot Email":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":9,"users":7},"i1107 Email":{"interactions":1},"i1200 Getting There":{"interactions":3,"users":3},"i1201 Express Bus":{"interactions":2,"users":2},"i1202 Parking Rates":{"interactions":2,"users":2},"i1203  Bus Terminal":{"interactions":1,"users":1},"i1204 Parking Map":{"interactions":1,"users":1},"i1205 Free Parking":{"interactions":3,"users":1},"i1208 Lost Parking Ticket":{"interactions":1,"users":1},"i1209 Parking Grace Period":{"interactions":1,"users":1},"i1216 Travel Duration":{"interactions":1,"users":1},"i1220 Parking Lot Issue":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":6,"users":3},"i2003 Room Late Check Out":{"interactions":3,"users":3},"i2004 Room Check In Time":{"interactions":11,"users":7},"i2005 Room Check Out Time":{"interactions":3,"users":3},"i2006 Room Check In Age":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":80,"users":56},"i2101 Complimentary Room Request":{"interactions":29,"users":19},"i2102 Stock Selling":{"interactions":14,"users":8},"i2103 Stock Buying":{"interactions":18,"users":12},"i2104 Room Reservation Full":{"interactions":2,"users":2},"i2105 Early Check In":{"interactions":11,"users":5},"i2106 Check In On Behalf":{"interactions":14,"users":7},"i2107 Multiroom Booking":{"interactions":5,"users":5},"i2108 Room Upgrade Request":{"interactions":1,"users":1},"i2109 Transfer Room Booking":{"interactions":8,"users":5},"i2110 Change Booking Date":{"interactions":16,"users":11},"i2111 Help Reserve A Room":{"interactions":2,"users":2},"i2113 Room Wheelchair Friendly":{"interactions":1,"users":1},"i2114 Room Complimentary Birthday":{"interactions":5,"users":3},"i2115 Stock FAQ":{"interactions":63,"users":25},"i2118 Room Complimentary How to know free room":{"interactions":2,"users":2},"i2119 Room Reservation Combine Nights":{"interactions":4,"users":2},"i2122 Room Amenities":{"interactions":4,"users":3},"i2126 Family Room Reservations":{"interactions":3,"users":3},"i2131 Maximum People in Room":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":13,"users":10},"i2134 Book Room Using - Video":{"interactions":10,"users":9},"i2135 Book Room Using - Image":{"interactions":11,"users":7},"i2200 Make Payment For Booking":{"interactions":1,"users":1},"i2206 Third Party Vouchers":{"interactions":3,"users":2},"i2301 Cannot Log In":{"interactions":11,"users":8},"i2302 Retrieve Membership ID":{"interactions":6,"users":4},"i2303 Lost Card":{"interactions":3,"users":3},"i2305 Earn Points":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":1,"users":1},"i2309 Membership Benefits":{"interactions":2,"users":2},"i2310 Apply for Membership":{"interactions":1,"users":1},"i2311 Under 18 Join Membership":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":1,"users":1},"i2319 Member Renew Membership":{"interactions":1,"users":1},"i2320 Check Points":{"interactions":2,"users":2},"i3100 Where Is SkyTheme Park":{"interactions":1,"users":1},"i3200 Concert Collect Tickets":{"interactions":2,"users":2},"i3204 Concert Lost Ticket":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":2,"users":2},"i3207 Concert Package":{"interactions":2,"users":2},"i3209 Concert Complimentary Ticket":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":3,"users":3},"i3300 Theme Park Attractions":{"interactions":8,"users":7},"i3301 Fees For Adults":{"interactions":1,"users":1},"i3304 Product Price":{"interactions":1,"users":1},"i3306 Where is Box Office":{"interactions":2,"users":1},"i3307 Where is toilet":{"interactions":2,"users":2},"i3314 Theme Park Ticket Purchase":{"interactions":2,"users":2},"i3318 Itinerary Advisor":{"interactions":1,"users":1},"i3324 Corporate Event":{"interactions":1,"users":1},"i3327 Salary Claims":{"interactions":1,"users":1},"i3403 Interest Gained":{"interactions":3,"users":2},"i3405 Restaurant Reservation":{"interactions":1,"users":1},"tt - testing":{"interactions":1,"users":1}},"totals":{"interactions":{"total":885},"users":{"total":162}}},"20190706":{"topics":{"Default Fallback Intent":{"interactions":59,"users":32},"Default Welcome Intent":{"interactions":94,"users":72},"ST0001 Thank You":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":14,"users":10},"ST0052 Chatbot Wrong Answer":{"interactions":2,"users":2},"ST0060 You are so clever":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":1,"users":1},"i1002 Wheel Chair Stroller":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":9,"users":8},"i1006 Download Mobile App":{"interactions":1,"users":1},"i1020 Hospital":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":18,"users":18},"i1102 Room Lost and Found":{"interactions":1,"users":1},"i1103 Forgot Email":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":2,"users":2},"i1105 Hotline Busy":{"interactions":1,"users":1},"i1201 Express Bus":{"interactions":3,"users":1},"i1203  Bus Terminal":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":3,"users":3},"i2001 Extra Bed":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":5,"users":2},"i2005 Room Check Out Time":{"interactions":1},"i2016 Non Smoking Room":{"interactions":1,"users":1},"i2024 First World Bed Type":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":41,"users":27},"i2101 Complimentary Room Request":{"interactions":15,"users":13},"i2102 Stock Selling":{"interactions":5,"users":4},"i2103 Stock Buying":{"interactions":3,"users":3},"i2105 Early Check In":{"interactions":9,"users":4},"i2106 Check In On Behalf":{"interactions":4,"users":4},"i2107 Multiroom Booking":{"interactions":1,"users":1},"i2110 Change Booking Date":{"interactions":1,"users":1},"i2111 Help Reserve A Room":{"interactions":2,"users":2},"i2114 Room Complimentary Birthday":{"interactions":16,"users":13},"i2115 Stock FAQ":{"interactions":12,"users":10},"i2122 Room Amenities":{"interactions":2,"users":1},"i2126 Family Room Reservations":{"interactions":1,"users":1},"i2131 Maximum People in Room":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":11,"users":9},"i2134 Book Room Using - Video":{"interactions":7,"users":6},"i2135 Book Room Using - Image":{"interactions":1,"users":1},"i2200 Make Payment For Booking":{"interactions":4,"users":2},"i2206 Third Party Vouchers":{"interactions":3,"users":2},"i2301 Cannot Log In":{"interactions":2,"users":2},"i2302 Retrieve Membership ID":{"interactions":2,"users":1},"i2303 Lost Card":{"interactions":5,"users":3},"i2315 Update Membership Details":{"interactions":3,"users":2},"i2320 Check Points":{"interactions":1,"users":1},"i3200 Concert Collect Tickets":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":3,"users":2},"i3303 Operating Hours":{"interactions":1,"users":1},"i3307 Where is toilet":{"interactions":1,"users":1},"i3308 Where is the indoor themepark?":{"interactions":1,"users":1},"i3311 Where to Shop":{"interactions":1,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":2,"users":1},"i3403 Interest Gained":{"interactions":1,"users":1}},"totals":{"interactions":{"total":386},"users":{"total":87}}},"20190707":{"topics":{"Default Fallback Intent":{"interactions":45,"users":27},"Default Welcome Intent":{"interactions":85,"users":67},"ST0001 Thank You":{"interactions":5,"users":5},"ST0002 Are You Human":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":5,"users":3},"ST0320 Can you think?":{"interactions":1,"users":1},"ST0339 Have a nice day!":{"interactions":1,"users":1},"ST0800 Profanity 1":{"interactions":1,"users":1},"i1002 Wheel Chair Stroller":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":8,"users":7},"i1010 Theme Park":{"interactions":3,"users":1},"i1044 Job Opening":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":10,"users":8},"i1101 Reset Password":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":1,"users":1},"i1107 Email":{"interactions":1,"users":1},"i1200 Getting There":{"interactions":4,"users":4},"i1201 Express Bus":{"interactions":4,"users":1},"i1203  Bus Terminal":{"interactions":1},"i1210 Book Complimentary Limousine":{"interactions":3,"users":1},"i1220 Parking Lot Issue":{"interactions":1,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":2},"i2000 Adjoining Room":{"interactions":4,"users":4},"i2001 Extra Bed":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":9,"users":3},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":30,"users":22},"i2101 Complimentary Room Request":{"interactions":9,"users":8},"i2102 Stock Selling":{"interactions":8,"users":7},"i2103 Stock Buying":{"interactions":10,"users":8},"i2104 Room Reservation Full":{"interactions":1,"users":1},"i2105 Early Check In":{"interactions":9,"users":5},"i2106 Check In On Behalf":{"interactions":13,"users":9},"i2107 Multiroom Booking":{"interactions":1,"users":1},"i2108 Room Upgrade Request":{"interactions":1,"users":1},"i2109 Transfer Room Booking":{"interactions":5,"users":5},"i2110 Change Booking Date":{"interactions":6,"users":5},"i2111 Help Reserve A Room":{"interactions":1,"users":1},"i2113 Room Wheelchair Friendly":{"interactions":1,"users":1},"i2114 Room Complimentary Birthday":{"interactions":8,"users":7},"i2115 Stock FAQ":{"interactions":31,"users":22},"i2120 OTA Points Redemption":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":1,"users":1},"i2126 Family Room Reservations":{"interactions":3,"users":2},"i2131 Maximum People in Room":{"interactions":2,"users":1},"i2133 Book Room Using Membership":{"interactions":7,"users":7},"i2134 Book Room Using - Video":{"interactions":7,"users":6},"i2135 Book Room Using - Image":{"interactions":1,"users":1},"i2136 Did Not Receive Booking Confirmation":{"interactions":1,"users":1},"i2205 Third Party Sites Booking":{"interactions":2,"users":1},"i2206 Third Party Vouchers":{"interactions":3,"users":1},"i2301 Cannot Log In":{"interactions":3,"users":3},"i2302 Retrieve Membership ID":{"interactions":1,"users":1},"i2303 Lost Card":{"interactions":2,"users":2},"i3200 Concert Collect Tickets":{"interactions":1,"users":1},"i3207 Concert Package":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":2,"users":2},"i3212 Concert Preferred Seats":{"interactions":1,"users":1},"i3300 Theme Park Attractions":{"interactions":1,"users":1},"i3301 Fees For Adults":{"interactions":3,"users":2},"i3314 Theme Park Ticket Purchase":{"interactions":2,"users":2},"i3327 Salary Claims":{"interactions":1,"users":1},"i3400 Dining":{"interactions":2,"users":1},"i3402 Interest Charged":{"interactions":1,"users":1},"i3403 Interest Gained":{"interactions":1,"users":1}},"totals":{"interactions":{"total":384},"users":{"total":79}}},"20190708":{"topics":{"Default Fallback Intent":{"interactions":127,"users":68},"Default Welcome Intent":{"interactions":193,"users":157},"Room-FreeRoom":{"interactions":3,"users":2},"ST0001 Thank You":{"interactions":5,"users":5},"ST0003 Ignore Replies":{"interactions":20,"users":17},"ST0058 Can you help me?":{"interactions":2,"users":2},"ST0070 Where do you work?":{"interactions":1,"users":1},"ST0116 No":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":1,"users":1},"ST0342 i need help in buying":{"interactions":2,"users":1},"ST0800 Profanity 1":{"interactions":1,"users":1},"i1001 About Us":{"interactions":1,"users":1},"i1003 Operating Hours":{"interactions":3,"users":2},"i1004 Promotions":{"interactions":11,"users":11},"i1006 Download Mobile App":{"interactions":3,"users":3},"i1010 Theme Park":{"interactions":4,"users":2},"i1033 Free Wifi":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":32,"users":24},"i1101 Reset Password":{"interactions":10,"users":6},"i1102 Room Lost and Found":{"interactions":3,"users":2},"i1103 Forgot Email":{"interactions":3,"users":3},"i1104 Contact Number":{"interactions":9,"users":7},"i1105 Hotline Busy":{"interactions":3,"users":3},"i1107 Email":{"interactions":5,"users":5},"i1200 Getting There":{"interactions":7,"users":7},"i1201 Express Bus":{"interactions":7,"users":3},"i1202 Parking Rates":{"interactions":3,"users":2},"i1203  Bus Terminal":{"interactions":5,"users":3},"i1204 Parking Map":{"interactions":1,"users":1},"i1207 Free Shuttle Bus":{"interactions":4,"users":4},"i1210 Book Complimentary Limousine":{"interactions":1,"users":1},"i1214 Valet Parking":{"interactions":1,"users":1},"i1216 Travel Duration":{"interactions":2,"users":2},"i1218 Shuttle From Airport":{"interactions":1,"users":1},"i1221 Motobike Parking":{"interactions":1,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":8,"users":5},"i2001 Extra Bed":{"interactions":2,"users":2},"i2004 Room Check In Time":{"interactions":3,"users":2},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2006 Room Check In Age":{"interactions":2,"users":2},"i2024 First World Bed Type":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":104,"users":71},"i2101 Complimentary Room Request":{"interactions":37,"users":31},"i2102 Stock Selling":{"interactions":18,"users":14},"i2103 Stock Buying":{"interactions":4,"users":4},"i2104 Room Reservation Full":{"interactions":1,"users":1},"i2105 Early Check In":{"interactions":3,"users":2},"i2106 Check In On Behalf":{"interactions":8,"users":7},"i2108 Room Upgrade Request":{"interactions":1,"users":1},"i2109 Transfer Room Booking":{"interactions":10,"users":9},"i2110 Change Booking Date":{"interactions":12,"users":10},"i2111 Help Reserve A Room":{"interactions":2,"users":2},"i2114 Room Complimentary Birthday":{"interactions":29,"users":23},"i2115 Stock FAQ":{"interactions":61,"users":44},"i2125 Room Reservation Cancel Comp Room":{"interactions":2,"users":2},"i2126 Family Room Reservations":{"interactions":2,"users":2},"i2127 Book Hour Use":{"interactions":2,"users":2},"i2131 Maximum People in Room":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":33,"users":24},"i2134 Book Room Using - Video":{"interactions":18,"users":16},"i2135 Book Room Using - Image":{"interactions":14,"users":11},"i2136 Did Not Receive Booking Confirmation":{"interactions":2,"users":2},"i2301 Cannot Log In":{"interactions":11,"users":8},"i2302 Retrieve Membership ID":{"interactions":14,"users":9},"i2303 Lost Card":{"interactions":2,"users":2},"i2306 Tier Points":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":7,"users":5},"i2310 Apply for Membership":{"interactions":2,"users":2},"i2311 Under 18 Join Membership":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":8,"users":7},"i3205 Concert Where to Buy":{"interactions":3,"users":3},"i3210 Concert Event Info":{"interactions":5,"users":5},"i3300 Theme Park Attractions":{"interactions":2,"users":2},"i3304 Product Price":{"interactions":1,"users":1},"i3307 Where is toilet":{"interactions":2,"users":2},"i3311 Where to Shop":{"interactions":1,"users":1},"i3321 Entrance Price":{"interactions":1,"users":1},"i3322 Golf Booking":{"interactions":3,"users":2},"i3323 Child Rates":{"interactions":1,"users":1},"i3401 Salary Payment":{"interactions":1,"users":1}},"totals":{"interactions":{"total":925},"users":{"total":172}}},"20190709":{"topics":{"Default Fallback Intent":{"interactions":154,"users":95},"Default Welcome Intent":{"interactions":202,"users":161},"ST0001 Thank You":{"interactions":8,"users":8},"ST0002 Are You Human":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":11,"users":11},"ST0052 Chatbot Wrong Answer":{"interactions":4,"users":4},"ST0058 Can you help me?":{"interactions":2,"users":2},"ST0073 Are you sure?":{"interactions":1,"users":1},"ST0084 Bye-bye!":{"interactions":1,"users":1},"ST0116 No":{"interactions":2,"users":2},"ST0117 Cancel":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":1,"users":1},"ST0301 Good afternoon":{"interactions":1,"users":1},"ST0303 Good nite":{"interactions":1,"users":1},"ST700 Emoji Happy":{"interactions":1,"users":1},"i1003 Operating Hours":{"interactions":5,"users":4},"i1004 Promotions":{"interactions":16,"users":13},"i1006 Download Mobile App":{"interactions":3,"users":2},"i1010 Theme Park":{"interactions":9,"users":7},"i1016 Clinic":{"interactions":1,"users":1},"i1022 Convenient Stores":{"interactions":2,"users":1},"i1027 Durian allowed?":{"interactions":1,"users":1},"i1037 Pharmacy":{"interactions":1,"users":1},"i1040  ATM Machine":{"interactions":1,"users":1},"i1042 Subscribe Newsletter":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":49,"users":42},"i1101 Reset Password":{"interactions":5,"users":5},"i1102 Room Lost and Found":{"interactions":1,"users":1},"i1103 Forgot Email":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":10,"users":9},"i1105 Hotline Busy":{"interactions":1,"users":1},"i1107 Email":{"interactions":7,"users":6},"i1200 Getting There":{"interactions":6,"users":6},"i1201 Express Bus":{"interactions":2,"users":1},"i1202 Parking Rates":{"interactions":6,"users":5},"i1203  Bus Terminal":{"interactions":1,"users":1},"i1205 Free Parking":{"interactions":5,"users":5},"i1206 Getting There KLIA":{"interactions":3,"users":3},"i1207 Free Shuttle Bus":{"interactions":2,"users":2},"i1210 Book Complimentary Limousine":{"interactions":3,"users":3},"i1216 Travel Duration":{"interactions":2,"users":2},"i1222 Shuttle Bus Schedule":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":4,"users":4},"i2001 Extra Bed":{"interactions":2,"users":1},"i2003 Room Late Check Out":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":3,"users":3},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2006 Room Check In Age":{"interactions":3,"users":3},"i2016 Non Smoking Room":{"interactions":2,"users":1},"i2020 Room Special Request":{"interactions":3,"users":3},"i2100 Stock Price":{"interactions":87,"users":65},"i2101 Complimentary Room Request":{"interactions":33,"users":29},"i2102 Stock Selling":{"interactions":19,"users":16},"i2103 Stock Buying":{"interactions":12,"users":9},"i2104 Room Reservation Full":{"interactions":5,"users":4},"i2105 Early Check In":{"interactions":5,"users":4},"i2106 Check In On Behalf":{"interactions":10,"users":6},"i2108 Room Upgrade Request":{"interactions":4,"users":4},"i2109 Transfer Room Booking":{"interactions":7,"users":7},"i2110 Change Booking Date":{"interactions":12,"users":10},"i2111 Help Reserve A Room":{"interactions":2,"users":2},"i2114 Room Complimentary Birthday":{"interactions":35,"users":22},"i2115 Stock FAQ":{"interactions":63,"users":41},"i2119 Room Reservation Combine Nights":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":2,"users":2},"i2123 Room Reservation Ammend Comp Room":{"interactions":1,"users":1},"i2126 Family Room Reservations":{"interactions":3,"users":3},"i2133 Book Room Using Membership":{"interactions":37,"users":27},"i2134 Book Room Using - Video":{"interactions":32,"users":24},"i2135 Book Room Using - Image":{"interactions":10,"users":10},"i2200 Make Payment For Booking":{"interactions":2,"users":2},"i2205 Third Party Sites Booking":{"interactions":4,"users":1},"i2206 Third Party Vouchers":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":13,"users":12},"i2302 Retrieve Membership ID":{"interactions":19,"users":13},"i2303 Lost Card":{"interactions":17,"users":13},"i2307 Activate Membership":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":1,"users":1},"i2309 Membership Benefits":{"interactions":1,"users":1},"i2310 Apply for Membership":{"interactions":5,"users":3},"i2312 Number of Member Card Can Apply":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":5,"users":5},"i2319 Member Renew Membership":{"interactions":1,"users":1},"i2320 Check Points":{"interactions":3,"users":3},"i3102 Theme Park Operating Hours":{"interactions":1,"users":1},"i3200 Concert Collect Tickets":{"interactions":4,"users":3},"i3205 Concert Where to Buy":{"interactions":1,"users":1},"i3206 Concert Kids Ticket":{"interactions":2,"users":1},"i3207 Concert Package":{"interactions":2,"users":2},"i3210 Concert Event Info":{"interactions":2,"users":1},"i3212 Concert Preferred Seats":{"interactions":3,"users":3},"i3300 Theme Park Attractions":{"interactions":2,"users":2},"i3304 Product Price":{"interactions":7,"users":5},"i3307 Where is toilet":{"interactions":4,"users":3},"i3314 Theme Park Ticket Purchase":{"interactions":1,"users":1},"i3321 Entrance Price":{"interactions":1},"i3400 Dining":{"interactions":3,"users":3},"i3401 Salary Payment":{"interactions":1,"users":1}},"totals":{"interactions":{"total":1043},"users":{"total":235}}},"20190710":{"topics":{"Default Fallback Intent":{"interactions":87,"users":53},"Default Welcome Intent":{"interactions":137,"users":107},"Room-FreeRoom":{"interactions":1,"users":1},"ST0001 Thank You":{"interactions":5,"users":4},"ST0003 Ignore Replies":{"interactions":12,"users":11},"ST0052 Chatbot Wrong Answer":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":1,"users":1},"ST0302 Good evening":{"interactions":2,"users":2},"ST0339 Have a nice day!":{"interactions":2,"users":2},"ST0800 Profanity 1":{"interactions":1,"users":1},"ST700 Emoji Happy":{"interactions":1,"users":1},"i1001 About Us":{"interactions":1,"users":1},"i1002 Wheel Chair Stroller":{"interactions":5,"users":1},"i1004 Promotions":{"interactions":6,"users":6},"i1018 Can I Bring Pets":{"interactions":1,"users":1},"i1027 Durian allowed?":{"interactions":1,"users":1},"i1029 Contact Center Operation Hours":{"interactions":2,"users":2},"i1100 General Complaint":{"interactions":30,"users":26},"i1101 Reset Password":{"interactions":2,"users":1},"i1102 Room Lost and Found":{"interactions":1,"users":1},"i1103 Forgot Email":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":9,"users":8},"i1105 Hotline Busy":{"interactions":1,"users":1},"i1107 Email":{"interactions":6,"users":4},"i1200 Getting There":{"interactions":1,"users":1},"i1201 Express Bus":{"interactions":2,"users":1},"i1202 Parking Rates":{"interactions":2,"users":1},"i1203  Bus Terminal":{"interactions":1,"users":1},"i1204 Parking Map":{"interactions":1,"users":1},"i1205 Free Parking":{"interactions":2,"users":1},"i1207 Free Shuttle Bus":{"interactions":2,"users":1},"i1210 Book Complimentary Limousine":{"interactions":2,"users":2},"i1214 Valet Parking":{"interactions":1,"users":1},"i1218 Shuttle From Airport":{"interactions":1,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":2,"users":1},"i2000 Adjoining Room":{"interactions":2,"users":2},"i2001 Extra Bed":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":7,"users":5},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2020 Room Special Request":{"interactions":1,"users":1},"i2023 Room Comes with Free Meal":{"interactions":1,"users":1},"i2024 First World Bed Type":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":58,"users":39},"i2101 Complimentary Room Request":{"interactions":11,"users":9},"i2102 Stock Selling":{"interactions":4,"users":3},"i2103 Stock Buying":{"interactions":7,"users":6},"i2104 Room Reservation Full":{"interactions":4,"users":4},"i2105 Early Check In":{"interactions":10,"users":8},"i2106 Check In On Behalf":{"interactions":6,"users":4},"i2107 Multiroom Booking":{"interactions":5,"users":4},"i2108 Room Upgrade Request":{"interactions":1,"users":1},"i2109 Transfer Room Booking":{"interactions":4,"users":4},"i2110 Change Booking Date":{"interactions":9,"users":6},"i2111 Help Reserve A Room":{"interactions":3,"users":2},"i2113 Room Wheelchair Friendly":{"interactions":2,"users":1},"i2114 Room Complimentary Birthday":{"interactions":9,"users":6},"i2115 Stock FAQ":{"interactions":29,"users":22},"i2118 Room Complimentary How to know free room":{"interactions":1,"users":1},"i2120 OTA Points Redemption":{"interactions":2,"users":1},"i2122 Room Amenities":{"interactions":2,"users":2},"i2126 Family Room Reservations":{"interactions":2,"users":2},"i2130 Room Invoice":{"interactions":2,"users":1},"i2133 Book Room Using Membership":{"interactions":10,"users":7},"i2134 Book Room Using - Video":{"interactions":8,"users":8},"i2135 Book Room Using - Image":{"interactions":3,"users":3},"i2136 Did Not Receive Booking Confirmation":{"interactions":3,"users":3},"i2200 Make Payment For Booking":{"interactions":4,"users":2},"i2205 Third Party Sites Booking":{"interactions":4,"users":3},"i2301 Cannot Log In":{"interactions":4,"users":3},"i2302 Retrieve Membership ID":{"interactions":7,"users":5},"i2303 Lost Card":{"interactions":6,"users":6},"i2306 Tier Points":{"interactions":1,"users":1},"i2307 Activate Membership":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":1,"users":1},"i2309 Membership Benefits":{"interactions":3,"users":2},"i2312 Number of Member Card Can Apply":{"interactions":1,"users":1},"i2314 Tier Points Expiry":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":6,"users":4},"i2319 Member Renew Membership":{"interactions":3,"users":2},"i3100 Where Is SkyTheme Park":{"interactions":1,"users":1},"i3103 Sign Up Minimum Age":{"interactions":1,"users":1},"i3200 Concert Collect Tickets":{"interactions":4,"users":3},"i3201 Concert Collect On Behalf":{"interactions":2,"users":2},"i3202 Concert Transfer Ticket":{"interactions":1,"users":1},"i3207 Concert Package":{"interactions":3,"users":2},"i3210 Concert Event Info":{"interactions":3,"users":3},"i3311 Where to Shop":{"interactions":1,"users":1},"i3317 Wedding Package":{"interactions":1,"users":1},"i3322 Golf Booking":{"interactions":1,"users":1},"i3400 Dining":{"interactions":3,"users":2},"i3403 Interest Gained":{"interactions":2,"users":1}},"totals":{"interactions":{"total":608},"users":{"total":117}}},"20190711":{"topics":{"Default Fallback Intent":{"interactions":73,"users":38},"Default Welcome Intent":{"interactions":128,"users":104},"ST0001 Thank You":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":10,"users":9},"ST0052 Chatbot Wrong Answer":{"interactions":1,"users":1},"ST0067 Are you hungry?":{"interactions":1,"users":1},"ST0086 Nice to see you!":{"interactions":1,"users":1},"ST0111 I'm waiting":{"interactions":2,"users":2},"ST0300 Good morning":{"interactions":1,"users":1},"ST0338 I'm bored":{"interactions":2,"users":2},"i1001 About Us":{"interactions":1,"users":1},"i1002 Wheel Chair Stroller":{"interactions":7,"users":2},"i1003 Operating Hours":{"interactions":2,"users":2},"i1004 Promotions":{"interactions":6,"users":6},"i1006 Download Mobile App":{"interactions":1,"users":1},"i1009 Leisure":{"interactions":2,"users":2},"i1010 Theme Park":{"interactions":7,"users":6},"i1012 Theme Park":{"interactions":1,"users":1},"i1029 Contact Center Operation Hours":{"interactions":1,"users":1},"i1033 Free Wifi":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":20,"users":15},"i1101 Reset Password":{"interactions":2,"users":2},"i1103 Forgot Email":{"interactions":3,"users":2},"i1104 Contact Number":{"interactions":2,"users":2},"i1107 Email":{"interactions":5,"users":2},"i1200 Getting There":{"interactions":9,"users":8},"i1201 Express Bus":{"interactions":6,"users":4},"i1202 Parking Rates":{"interactions":5,"users":2},"i1203  Bus Terminal":{"interactions":3,"users":3},"i1204 Parking Map":{"interactions":3,"users":2},"i1205 Free Parking":{"interactions":1,"users":1},"i1206 Getting There KLIA":{"interactions":1,"users":1},"i1207 Free Shuttle Bus":{"interactions":2,"users":1},"i1214 Valet Parking":{"interactions":1,"users":1},"i1216 Travel Duration":{"interactions":2,"users":2},"i1221 Motobike Parking":{"interactions":1,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":2,"users":1},"i2000 Adjoining Room":{"interactions":5,"users":5},"i2001 Extra Bed":{"interactions":4,"users":2},"i2003 Room Late Check Out":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":3,"users":3},"i2012 Resort World Sentosa":{"interactions":1,"users":1},"i2024 First World Bed Type":{"interactions":2,"users":2},"i2100 Stock Price":{"interactions":55,"users":42},"i2101 Complimentary Room Request":{"interactions":14,"users":12},"i2102 Stock Selling":{"interactions":8,"users":7},"i2103 Stock Buying":{"interactions":8,"users":6},"i2104 Room Reservation Full":{"interactions":2,"users":2},"i2105 Early Check In":{"interactions":8,"users":6},"i2106 Check In On Behalf":{"interactions":7,"users":7},"i2108 Room Upgrade Request":{"interactions":1,"users":1},"i2109 Transfer Room Booking":{"interactions":4,"users":4},"i2110 Change Booking Date":{"interactions":3,"users":3},"i2111 Help Reserve A Room":{"interactions":1,"users":1},"i2114 Room Complimentary Birthday":{"interactions":7,"users":7},"i2115 Stock FAQ":{"interactions":31,"users":20},"i2117 Room Complimentary Dynamic Stay":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":2,"users":1},"i2126 Family Room Reservations":{"interactions":2,"users":2},"i2131 Maximum People in Room":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":11,"users":8},"i2134 Book Room Using - Video":{"interactions":12,"users":9},"i2135 Book Room Using - Image":{"interactions":2,"users":2},"i2301 Cannot Log In":{"interactions":4,"users":3},"i2302 Retrieve Membership ID":{"interactions":1,"users":1},"i2303 Lost Card":{"interactions":3,"users":3},"i2305 Earn Points":{"interactions":2,"users":2},"i2309 Membership Benefits":{"interactions":1,"users":1},"i2311 Under 18 Join Membership":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":2,"users":2},"i2317 Member Card Lost and Found":{"interactions":1,"users":1},"i2319 Member Renew Membership":{"interactions":1,"users":1},"i3103 Sign Up Minimum Age":{"interactions":3,"users":3},"i3200 Concert Collect Tickets":{"interactions":4},"i3201 Concert Collect On Behalf":{"interactions":3,"users":1},"i3202 Concert Transfer Ticket":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":1,"users":1},"i3207 Concert Package":{"interactions":1,"users":1},"i3208 Concert Sold Out":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":6,"users":5},"i3300 Theme Park Attractions":{"interactions":5,"users":3},"i3304 Product Price":{"interactions":5,"users":3},"i3307 Where is toilet":{"interactions":2,"users":2},"i3308 Where is the indoor themepark?":{"interactions":1,"users":1},"i3311 Where to Shop":{"interactions":2,"users":2},"i3321 Entrance Price":{"interactions":2,"users":2},"i3322 Golf Booking":{"interactions":1,"users":1},"i3324 Corporate Event":{"interactions":1,"users":1},"i3400 Dining":{"interactions":1,"users":1}},"totals":{"interactions":{"total":569},"users":{"total":112}}},"20190712":{"topics":{"Default Fallback Intent":{"interactions":82,"users":43},"Default Welcome Intent":{"interactions":105,"users":81},"ST0001 Thank You":{"interactions":4,"users":4},"ST0003 Ignore Replies":{"interactions":3,"users":2},"ST0052 Chatbot Wrong Answer":{"interactions":1,"users":1},"ST0058 Can you help me?":{"interactions":2,"users":2},"ST0070 Where do you work?":{"interactions":2,"users":1},"ST0115 Yes":{"interactions":2,"users":2},"ST0116 No":{"interactions":1,"users":1},"ST0117 Cancel":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":1,"users":1},"ST0301 Good afternoon":{"interactions":1,"users":1},"ST0302 Good evening":{"interactions":1,"users":1},"ST0308 Okay Google":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":4,"users":4},"i1006 Download Mobile App":{"interactions":2,"users":1},"i1010 Theme Park":{"interactions":1,"users":1},"i1012 Theme Park":{"interactions":1,"users":1},"i1013 Weather":{"interactions":2,"users":2},"i1100 General Complaint":{"interactions":22,"users":18},"i1101 Reset Password":{"interactions":2,"users":2},"i1104 Contact Number":{"interactions":2,"users":2},"i1107 Email":{"interactions":2,"users":2},"i1200 Getting There":{"interactions":3,"users":3},"i1201 Express Bus":{"interactions":6,"users":4},"i1203  Bus Terminal":{"interactions":3,"users":3},"i1206 Getting There KLIA":{"interactions":2,"users":1},"i1207 Free Shuttle Bus":{"interactions":1,"users":1},"i1210 Book Complimentary Limousine":{"interactions":3,"users":2},"i2000 Adjoining Room":{"interactions":1,"users":1},"i2003 Room Late Check Out":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":3,"users":3},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2016 Non Smoking Room":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":39,"users":32},"i2101 Complimentary Room Request":{"interactions":9,"users":8},"i2102 Stock Selling":{"interactions":14,"users":8},"i2103 Stock Buying":{"interactions":8,"users":6},"i2104 Room Reservation Full":{"interactions":4,"users":4},"i2105 Early Check In":{"interactions":5,"users":3},"i2106 Check In On Behalf":{"interactions":5,"users":4},"i2107 Multiroom Booking":{"interactions":5,"users":4},"i2109 Transfer Room Booking":{"interactions":4,"users":3},"i2110 Change Booking Date":{"interactions":5,"users":3},"i2111 Help Reserve A Room":{"interactions":3,"users":2},"i2114 Room Complimentary Birthday":{"interactions":4,"users":4},"i2115 Stock FAQ":{"interactions":27,"users":17},"i2118 Room Complimentary How to know free room":{"interactions":1,"users":1},"i2120 OTA Points Redemption":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":1,"users":1},"i2126 Family Room Reservations":{"interactions":1,"users":1},"i2132 Foreigner Passport Number":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":6,"users":6},"i2134 Book Room Using - Video":{"interactions":5,"users":4},"i2135 Book Room Using - Image":{"interactions":1,"users":1},"i2206 Third Party Vouchers":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":4,"users":3},"i2302 Retrieve Membership ID":{"interactions":1},"i2305 Earn Points":{"interactions":1,"users":1},"i2310 Apply for Membership":{"interactions":2,"users":2},"i2315 Update Membership Details":{"interactions":1,"users":1},"i2320 Check Points":{"interactions":1,"users":1},"i3200 Concert Collect Tickets":{"interactions":6,"users":3},"i3201 Concert Collect On Behalf":{"interactions":2,"users":2},"i3202 Concert Transfer Ticket":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":3,"users":3},"i3307 Where is toilet":{"interactions":1,"users":1},"i3311 Where to Shop":{"interactions":1,"users":1},"i3318 Itinerary Advisor":{"interactions":1,"users":1},"i3326 Salary Deduction":{"interactions":1,"users":1},"i3327 Salary Claims":{"interactions":1,"users":1},"tt - testing":{"interactions":1,"users":1}},"totals":{"interactions":{"total":449},"users":{"total":92}}},"20190713":{"topics":{"Default Fallback Intent":{"interactions":45,"users":25},"Default Welcome Intent":{"interactions":63,"users":52},"ST0003 Ignore Replies":{"interactions":7,"users":5},"ST0115 Yes":{"interactions":1,"users":1},"i1003 Operating Hours":{"interactions":1},"i1004 Promotions":{"interactions":3,"users":3},"i1010 Theme Park":{"interactions":1,"users":1},"i1012 Theme Park":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":9,"users":9},"i1101 Reset Password":{"interactions":5,"users":5},"i1102 Room Lost and Found":{"interactions":1,"users":1},"i1103 Forgot Email":{"interactions":2,"users":2},"i1200 Getting There":{"interactions":1,"users":1},"i1201 Express Bus":{"interactions":2,"users":1},"i1202 Parking Rates":{"interactions":2,"users":1},"i1203  Bus Terminal":{"interactions":1,"users":1},"i1204 Parking Map":{"interactions":2,"users":1},"i1205 Free Parking":{"interactions":1,"users":1},"i1216 Travel Duration":{"interactions":1},"i2000 Adjoining Room":{"interactions":2,"users":1},"i2003 Room Late Check Out":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":1,"users":1},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2006 Room Check In Age":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":27,"users":22},"i2101 Complimentary Room Request":{"interactions":11,"users":9},"i2102 Stock Selling":{"interactions":6,"users":6},"i2103 Stock Buying":{"interactions":2,"users":2},"i2104 Room Reservation Full":{"interactions":1,"users":1},"i2105 Early Check In":{"interactions":4,"users":3},"i2106 Check In On Behalf":{"interactions":1,"users":1},"i2107 Multiroom Booking":{"interactions":1,"users":1},"i2108 Room Upgrade Request":{"interactions":1,"users":1},"i2109 Transfer Room Booking":{"interactions":2,"users":2},"i2110 Change Booking Date":{"interactions":1,"users":1},"i2114 Room Complimentary Birthday":{"interactions":6,"users":4},"i2115 Stock FAQ":{"interactions":17,"users":12},"i2122 Room Amenities":{"interactions":2,"users":2},"i2126 Family Room Reservations":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":10,"users":7},"i2134 Book Room Using - Video":{"interactions":6,"users":4},"i2135 Book Room Using - Image":{"interactions":2,"users":2},"i2301 Cannot Log In":{"interactions":4,"users":4},"i2302 Retrieve Membership ID":{"interactions":1,"users":1},"i2303 Lost Card":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":2,"users":1},"i2315 Update Membership Details":{"interactions":1,"users":1},"i2320 Check Points":{"interactions":1,"users":1},"i3200 Concert Collect Tickets":{"interactions":1},"i3201 Concert Collect On Behalf":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":1,"users":1},"i3300 Theme Park Attractions":{"interactions":1,"users":1},"i3304 Product Price":{"interactions":2},"i3311 Where to Shop":{"interactions":1,"users":1},"i3326 Salary Deduction":{"interactions":1,"users":1}},"totals":{"interactions":{"total":275},"users":{"total":61}}},"20190714":{"topics":{"Default Fallback Intent":{"interactions":50,"users":35},"Default Welcome Intent":{"interactions":88,"users":69},"ST0001 Thank You":{"interactions":2,"users":2},"ST0003 Ignore Replies":{"interactions":9,"users":7},"ST0058 Can you help me?":{"interactions":3,"users":2},"ST0097 I am happy":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":1,"users":1},"ST0320 Can you think?":{"interactions":1,"users":1},"ST0339 Have a nice day!":{"interactions":1},"ST0700 Happy Emoji":{"interactions":1,"users":1},"ST0800 Profanity 1":{"interactions":1,"users":1},"i1006 Download Mobile App":{"interactions":3,"users":2},"i1010 Theme Park":{"interactions":4,"users":3},"i1044 Job Opening":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":24,"users":22},"i1103 Forgot Email":{"interactions":1,"users":1},"i1107 Email":{"interactions":1,"users":1},"i1200 Getting There":{"interactions":5,"users":5},"i1201 Express Bus":{"interactions":2,"users":1},"i1202 Parking Rates":{"interactions":1,"users":1},"i1203  Bus Terminal":{"interactions":1,"users":1},"i1205 Free Parking":{"interactions":1,"users":1},"i1206 Getting There KLIA":{"interactions":1,"users":1},"i1210 Book Complimentary Limousine":{"interactions":3,"users":3},"i1211 Taxi to ":{"interactions":2,"users":1},"i1218 Shuttle From Airport":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":3,"users":3},"i2001 Extra Bed":{"interactions":3,"users":3},"i2003 Room Late Check Out":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":1,"users":1},"i2005 Room Check Out Time":{"interactions":2,"users":1},"i2006 Room Check In Age":{"interactions":2,"users":1},"i2020 Room Special Request":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":28,"users":18},"i2101 Complimentary Room Request":{"interactions":8,"users":7},"i2102 Stock Selling":{"interactions":3,"users":3},"i2103 Stock Buying":{"interactions":2,"users":2},"i2104 Room Reservation Full":{"interactions":1,"users":1},"i2105 Early Check In":{"interactions":3,"users":2},"i2106 Check In On Behalf":{"interactions":8,"users":5},"i2107 Multiroom Booking":{"interactions":4,"users":3},"i2109 Transfer Room Booking":{"interactions":2,"users":2},"i2110 Change Booking Date":{"interactions":1,"users":1},"i2113 Room Wheelchair Friendly":{"interactions":1,"users":1},"i2115 Stock FAQ":{"interactions":18,"users":13},"i2122 Room Amenities":{"interactions":5,"users":4},"i2126 Family Room Reservations":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":4,"users":3},"i2134 Book Room Using - Video":{"interactions":8,"users":4},"i2135 Book Room Using - Image":{"interactions":1,"users":1},"i2200 Make Payment For Booking":{"interactions":1},"i2301 Cannot Log In":{"interactions":5,"users":4},"i2302 Retrieve Membership ID":{"interactions":4,"users":3},"i2303 Lost Card":{"interactions":2,"users":2},"i2305 Earn Points":{"interactions":1,"users":1},"i2306 Tier Points":{"interactions":1,"users":1},"i2307 Activate Membership":{"interactions":2,"users":1},"i2308 No Points Added":{"interactions":1,"users":1},"i2314 Tier Points Expiry":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":1,"users":1},"i2319 Member Renew Membership":{"interactions":1,"users":1},"i3200 Concert Collect Tickets":{"interactions":2,"users":1},"i3201 Concert Collect On Behalf":{"interactions":1,"users":1},"i3206 Concert Kids Ticket":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":2,"users":2},"i3212 Concert Preferred Seats":{"interactions":1,"users":1},"i3300 Theme Park Attractions":{"interactions":2},"i3306 Where is Box Office":{"interactions":1,"users":1},"i3307 Where is toilet":{"interactions":1,"users":1},"i3311 Where to Shop":{"interactions":1,"users":1},"i3322 Golf Booking":{"interactions":1,"users":1},"i3400 Dining":{"interactions":3,"users":3},"i3401 Salary Payment":{"interactions":1,"users":1}},"totals":{"interactions":{"total":358},"users":{"total":81}}},"20190715":{"topics":{"Default Fallback Intent":{"interactions":70,"users":36},"Default Welcome Intent":{"interactions":113,"users":96},"ST0001 Thank You":{"interactions":8,"users":8},"ST0002 Are You Human":{"interactions":2,"users":2},"ST0003 Ignore Replies":{"interactions":6,"users":5},"ST0058 Can you help me?":{"interactions":3,"users":3},"ST0106 I need some advice":{"interactions":1,"users":1},"ST0301 Good afternoon":{"interactions":2,"users":2},"ST0302 Good evening":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":8,"users":7},"i1006 Download Mobile App":{"interactions":1,"users":1},"i1010 Theme Park":{"interactions":7,"users":5},"i1030 Emergency Disaster":{"interactions":1,"users":1},"i1044 Job Opening":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":26,"users":20},"i1101 Reset Password":{"interactions":3,"users":2},"i1103 Forgot Email":{"interactions":3,"users":1},"i1104 Contact Number":{"interactions":1,"users":1},"i1105 Hotline Busy":{"interactions":1,"users":1},"i1107 Email":{"interactions":6,"users":5},"i1200 Getting There":{"interactions":2,"users":2},"i1201 Express Bus":{"interactions":6,"users":2},"i1203  Bus Terminal":{"interactions":4,"users":2},"i1207 Free Shuttle Bus":{"interactions":1,"users":1},"i1213 Safe to Drive to ?":{"interactions":1,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":2,"users":2},"i2000 Adjoining Room":{"interactions":2,"users":2},"i2001 Extra Bed":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":5,"users":5},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2006 Room Check In Age":{"interactions":1,"users":1},"i2023 Room Comes with Free Meal":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":59,"users":41},"i2101 Complimentary Room Request":{"interactions":10,"users":10},"i2102 Stock Selling":{"interactions":3,"users":3},"i2103 Stock Buying":{"interactions":6,"users":5},"i2104 Room Reservation Full":{"interactions":2,"users":2},"i2105 Early Check In":{"interactions":10,"users":7},"i2106 Check In On Behalf":{"interactions":5,"users":4},"i2107 Multiroom Booking":{"interactions":4,"users":4},"i2108 Room Upgrade Request":{"interactions":2,"users":2},"i2109 Transfer Room Booking":{"interactions":7,"users":6},"i2110 Change Booking Date":{"interactions":3,"users":2},"i2111 Help Reserve A Room":{"interactions":3,"users":3},"i2114 Room Complimentary Birthday":{"interactions":10,"users":7},"i2115 Stock FAQ":{"interactions":24,"users":19},"i2118 Room Complimentary How to know free room":{"interactions":2,"users":1},"i2120 OTA Points Redemption":{"interactions":1,"users":1},"i2127 Book Hour Use":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":8,"users":7},"i2134 Book Room Using - Video":{"interactions":7,"users":7},"i2136 Did Not Receive Booking Confirmation":{"interactions":1,"users":1},"i2200 Make Payment For Booking":{"interactions":2,"users":1},"i2205 Third Party Sites Booking":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":5,"users":5},"i2302 Retrieve Membership ID":{"interactions":5,"users":3},"i2303 Lost Card":{"interactions":3,"users":3},"i2304 Point Expiry":{"interactions":1,"users":1},"i2307 Activate Membership":{"interactions":3,"users":2},"i2315 Update Membership Details":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":1,"users":1},"i3300 Theme Park Attractions":{"interactions":3,"users":3},"i3311 Where to Shop":{"interactions":2,"users":2},"i3327 Salary Claims":{"interactions":2,"users":1},"i3400 Dining":{"interactions":4,"users":2}},"totals":{"interactions":{"total":492},"users":{"total":106}}},"20190716":{"topics":{"Default Fallback Intent":{"interactions":100,"users":44},"Default Welcome Intent":{"interactions":115,"users":94},"ST0001 Thank You":{"interactions":3,"users":3},"ST0003 Ignore Replies":{"interactions":8,"users":5},"ST0058 Can you help me?":{"interactions":2,"users":2},"ST0086 Nice to see you!":{"interactions":1,"users":1},"ST0111 I'm waiting":{"interactions":1,"users":1},"ST0116 No":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":1,"users":1},"ST0301 Good afternoon":{"interactions":1,"users":1},"ST0302 Good evening":{"interactions":1,"users":1},"ST0334 What am I?":{"interactions":1,"users":1},"ST0800 Profanity 1":{"interactions":1,"users":1},"ST700 Emoji Happy":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":5,"users":3},"i1006 Download Mobile App":{"interactions":2,"users":2},"i1009 Leisure":{"interactions":1,"users":1},"i1010 Theme Park":{"interactions":6,"users":5},"i1100 General Complaint":{"interactions":33,"users":25},"i1101 Reset Password":{"interactions":11,"users":7},"i1103 Forgot Email":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":5,"users":5},"i1107 Email":{"interactions":11,"users":4},"i1200 Getting There":{"interactions":2,"users":2},"i1202 Parking Rates":{"interactions":1,"users":1},"i1205 Free Parking":{"interactions":2,"users":1},"i1213 Safe to Drive to ?":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":6,"users":5},"i2001 Extra Bed":{"interactions":2,"users":2},"i2003 Room Late Check Out":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":5,"users":5},"i2005 Room Check Out Time":{"interactions":2,"users":2},"i2007 Room Swimming Pool":{"interactions":2,"users":1},"i2018 Using Hotel SPA":{"interactions":5,"users":1},"i2100 Stock Price":{"interactions":43,"users":36},"i2101 Complimentary Room Request":{"interactions":8,"users":8},"i2102 Stock Selling":{"interactions":2,"users":2},"i2103 Stock Buying":{"interactions":6,"users":5},"i2104 Room Reservation Full":{"interactions":4,"users":4},"i2105 Early Check In":{"interactions":13,"users":5},"i2106 Check In On Behalf":{"interactions":3,"users":3},"i2107 Multiroom Booking":{"interactions":3,"users":2},"i2108 Room Upgrade Request":{"interactions":2,"users":1},"i2109 Transfer Room Booking":{"interactions":3,"users":3},"i2110 Change Booking Date":{"interactions":7,"users":4},"i2111 Help Reserve A Room":{"interactions":4,"users":4},"i2114 Room Complimentary Birthday":{"interactions":4,"users":4},"i2115 Stock FAQ":{"interactions":23,"users":15},"i2121 OTT Booking":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":7,"users":6},"i2125 Room Reservation Cancel Comp Room":{"interactions":1,"users":1},"i2126 Family Room Reservations":{"interactions":3,"users":3},"i2130 Room Invoice":{"interactions":4},"i2133 Book Room Using Membership":{"interactions":8,"users":6},"i2134 Book Room Using - Video":{"interactions":3,"users":3},"i2135 Book Room Using - Image":{"interactions":3,"users":3},"i2136 Did Not Receive Booking Confirmation":{"interactions":3,"users":3},"i2205 Third Party Sites Booking":{"interactions":2,"users":2},"i2301 Cannot Log In":{"interactions":17,"users":11},"i2302 Retrieve Membership ID":{"interactions":6,"users":4},"i2303 Lost Card":{"interactions":6,"users":4},"i2305 Earn Points":{"interactions":2,"users":2},"i2308 No Points Added":{"interactions":1,"users":1},"i2309 Membership Benefits":{"interactions":4,"users":4},"i2310 Apply for Membership":{"interactions":2,"users":2},"i2311 Under 18 Join Membership":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":3,"users":3},"i3200 Concert Collect Tickets":{"interactions":9,"users":6},"i3201 Concert Collect On Behalf":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":3,"users":2},"i3206 Concert Kids Ticket":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":3,"users":3},"i3300 Theme Park Attractions":{"interactions":2,"users":2},"i3301 Fees For Adults":{"interactions":1,"users":1},"i3304 Product Price":{"interactions":1},"i3306 Where is Box Office":{"interactions":4,"users":3},"i3314 Theme Park Ticket Purchase":{"interactions":10,"users":3},"i3321 Entrance Price":{"interactions":1,"users":1},"i3322 Golf Booking":{"interactions":1,"users":1},"i3324 Corporate Event":{"interactions":1,"users":1}},"totals":{"interactions":{"total":581},"users":{"total":104}}},"20190717":{"topics":{"Default Fallback Intent":{"interactions":99,"users":40},"Default Welcome Intent":{"interactions":116,"users":86},"ST0001 Thank You":{"interactions":7,"users":7},"ST0003 Ignore Replies":{"interactions":14,"users":8},"ST0052 Chatbot Wrong Answer":{"interactions":1,"users":1},"ST0058 Can you help me?":{"interactions":2,"users":2},"ST0115 Yes":{"interactions":2,"users":1},"ST0121 Sorry":{"interactions":2,"users":2},"ST0123 You're wrong":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":4,"users":3},"ST0301 Good afternoon":{"interactions":2,"users":2},"ST0302 Good evening":{"interactions":1,"users":1},"i1003 Operating Hours":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":2,"users":2},"i1009 Leisure":{"interactions":1,"users":1},"i1010 Theme Park":{"interactions":4,"users":3},"i1012 Theme Park":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":32,"users":22},"i1101 Reset Password":{"interactions":5,"users":3},"i1102 Room Lost and Found":{"interactions":2,"users":2},"i1103 Forgot Email":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":2,"users":2},"i1107 Email":{"interactions":2,"users":2},"i1200 Getting There":{"interactions":4,"users":4},"i1201 Express Bus":{"interactions":1,"users":1},"i1202 Parking Rates":{"interactions":1,"users":1},"i1204 Parking Map":{"interactions":2,"users":1},"i1206 Getting There KLIA":{"interactions":3,"users":1},"i1214 Valet Parking":{"interactions":1,"users":1},"i1215 Walking around ":{"interactions":1,"users":1},"i1216 Travel Duration":{"interactions":1,"users":1},"i1221 Motobike Parking":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":6,"users":4},"i2001 Extra Bed":{"interactions":3,"users":2},"i2004 Room Check In Time":{"interactions":1,"users":1},"i2006 Room Check In Age":{"interactions":2,"users":2},"i2015 Room Breakfast":{"interactions":1,"users":1},"i2024 First World Bed Type":{"interactions":2,"users":1},"i2100 Stock Price":{"interactions":38,"users":25},"i2101 Complimentary Room Request":{"interactions":10,"users":9},"i2102 Stock Selling":{"interactions":9,"users":9},"i2103 Stock Buying":{"interactions":6,"users":5},"i2104 Room Reservation Full":{"interactions":5,"users":3},"i2105 Early Check In":{"interactions":4,"users":3},"i2106 Check In On Behalf":{"interactions":3,"users":2},"i2107 Multiroom Booking":{"interactions":4,"users":3},"i2108 Room Upgrade Request":{"interactions":2,"users":2},"i2109 Transfer Room Booking":{"interactions":5,"users":5},"i2110 Change Booking Date":{"interactions":6,"users":3},"i2111 Help Reserve A Room":{"interactions":5,"users":3},"i2114 Room Complimentary Birthday":{"interactions":12,"users":10},"i2115 Stock FAQ":{"interactions":35,"users":23},"i2120 OTA Points Redemption":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":1,"users":1},"i2125 Room Reservation Cancel Comp Room":{"interactions":3,"users":2},"i2126 Family Room Reservations":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":11,"users":11},"i2134 Book Room Using - Video":{"interactions":6,"users":6},"i2135 Book Room Using - Image":{"interactions":3,"users":3},"i2200 Make Payment For Booking":{"interactions":2,"users":1},"i2204 Sales Office":{"interactions":1,"users":1},"i2205 Third Party Sites Booking":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":4,"users":4},"i2302 Retrieve Membership ID":{"interactions":6,"users":5},"i2303 Lost Card":{"interactions":3,"users":2},"i2305 Earn Points":{"interactions":1,"users":1},"i2306 Tier Points":{"interactions":2,"users":1},"i2308 No Points Added":{"interactions":1,"users":1},"i2309 Membership Benefits":{"interactions":2,"users":2},"i2314 Tier Points Expiry":{"interactions":2,"users":2},"i2315 Update Membership Details":{"interactions":2,"users":2},"i2319 Member Renew Membership":{"interactions":1,"users":1},"i3101 Theme Park Dress Code":{"interactions":1,"users":1},"i3200 Concert Collect Tickets":{"interactions":9,"users":5},"i3201 Concert Collect On Behalf":{"interactions":3,"users":2},"i3202 Concert Transfer Ticket":{"interactions":1,"users":1},"i3204 Concert Lost Ticket":{"interactions":2,"users":1},"i3205 Concert Where to Buy":{"interactions":3,"users":1},"i3206 Concert Kids Ticket":{"interactions":1,"users":1},"i3207 Concert Package":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":3,"users":3},"i3300 Theme Park Attractions":{"interactions":1,"users":1},"i3304 Product Price":{"interactions":1,"users":1},"i3306 Where is Box Office":{"interactions":2,"users":2},"i3307 Where is toilet":{"interactions":2,"users":2},"i3313 Branch Operating Hours":{"interactions":1,"users":1},"tt - Vendor Test":{"interactions":2,"users":1}},"totals":{"interactions":{"total":565},"users":{"total":98}}},"20190718":{"topics":{"Default Fallback Intent":{"interactions":98,"users":53},"Default Welcome Intent":{"interactions":110,"users":91},"ST0001 Thank You":{"interactions":4,"users":4},"ST0003 Ignore Replies":{"interactions":8,"users":7},"ST0052 Chatbot Wrong Answer":{"interactions":1,"users":1},"ST0058 Can you help me?":{"interactions":2,"users":1},"ST0086 Nice to see you!":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":3,"users":3},"ST0301 Good afternoon":{"interactions":1,"users":1},"ST0800 Profanity 1":{"interactions":1,"users":1},"i1002 Wheel Chair Stroller":{"interactions":4,"users":1},"i1003 Operating Hours":{"interactions":2,"users":2},"i1004 Promotions":{"interactions":12,"users":4},"i1006 Download Mobile App":{"interactions":1,"users":1},"i1010 Theme Park":{"interactions":3,"users":3},"i1012 Theme Park":{"interactions":6,"users":4},"i1100 General Complaint":{"interactions":27,"users":20},"i1101 Reset Password":{"interactions":11,"users":8},"i1103 Forgot Email":{"interactions":3,"users":1},"i1104 Contact Number":{"interactions":4,"users":3},"i1107 Email":{"interactions":5,"users":5},"i1200 Getting There":{"interactions":2,"users":2},"i1201 Express Bus":{"interactions":3,"users":2},"i1202 Parking Rates":{"interactions":2,"users":1},"i1203  Bus Terminal":{"interactions":2,"users":1},"i1204 Parking Map":{"interactions":1,"users":1},"i1205 Free Parking":{"interactions":1,"users":1},"i1206 Getting There KLIA":{"interactions":4,"users":2},"i1207 Free Shuttle Bus":{"interactions":2,"users":2},"i1216 Travel Duration":{"interactions":1,"users":1},"i1220 Parking Lot Issue":{"interactions":1,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":3,"users":2},"i2000 Adjoining Room":{"interactions":3,"users":2},"i2001 Extra Bed":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":1,"users":1},"i2005 Room Check Out Time":{"interactions":2,"users":2},"i2006 Room Check In Age":{"interactions":3,"users":3},"i2012 Resort World Sentosa":{"interactions":1,"users":1},"i2020 Room Special Request":{"interactions":1,"users":1},"i2024 First World Bed Type":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":39,"users":31},"i2101 Complimentary Room Request":{"interactions":10,"users":10},"i2102 Stock Selling":{"interactions":7,"users":6},"i2103 Stock Buying":{"interactions":11,"users":9},"i2104 Room Reservation Full":{"interactions":2,"users":2},"i2105 Early Check In":{"interactions":6,"users":2},"i2106 Check In On Behalf":{"interactions":5,"users":4},"i2109 Transfer Room Booking":{"interactions":4,"users":4},"i2110 Change Booking Date":{"interactions":2,"users":2},"i2111 Help Reserve A Room":{"interactions":2,"users":2},"i2113 Room Wheelchair Friendly":{"interactions":1,"users":1},"i2114 Room Complimentary Birthday":{"interactions":6,"users":5},"i2115 Stock FAQ":{"interactions":35,"users":26},"i2126 Family Room Reservations":{"interactions":2,"users":1},"i2131 Maximum People in Room":{"interactions":1,"users":1},"i2132 Foreigner Passport Number":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":7,"users":6},"i2134 Book Room Using - Video":{"interactions":4,"users":3},"i2135 Book Room Using - Image":{"interactions":4,"users":3},"i2136 Did Not Receive Booking Confirmation":{"interactions":2,"users":2},"i2204 Sales Office":{"interactions":1},"i2301 Cannot Log In":{"interactions":20,"users":15},"i2302 Retrieve Membership ID":{"interactions":10,"users":6},"i2303 Lost Card":{"interactions":5,"users":4},"i2307 Activate Membership":{"interactions":3,"users":2},"i2308 No Points Added":{"interactions":4,"users":2},"i2310 Apply for Membership":{"interactions":1,"users":1},"i2311 Under 18 Join Membership":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":2,"users":2},"i2318 Reward Alliance Website":{"interactions":1,"users":1},"i2319 Member Renew Membership":{"interactions":2,"users":2},"i3200 Concert Collect Tickets":{"interactions":7,"users":5},"i3201 Concert Collect On Behalf":{"interactions":3,"users":2},"i3202 Concert Transfer Ticket":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":1,"users":1},"i3206 Concert Kids Ticket":{"interactions":1,"users":1},"i3207 Concert Package":{"interactions":2,"users":2},"i3304 Product Price":{"interactions":2,"users":2},"i3307 Where is toilet":{"interactions":1,"users":1},"i3311 Where to Shop":{"interactions":4,"users":4},"i3314 Theme Park Ticket Purchase":{"interactions":2,"users":1},"i3322 Golf Booking":{"interactions":1,"users":1},"i3323 Child Rates":{"interactions":1,"users":1},"i3400 Dining":{"interactions":2,"users":1},"i3401 Salary Payment":{"interactions":3,"users":1},"tt - testing":{"interactions":1},"tt New Complaint":{"interactions":3,"users":1}},"totals":{"interactions":{"total":579},"users":{"total":99}}},"20190719":{"topics":{"Default Fallback Intent":{"interactions":66,"users":35},"Default Welcome Intent":{"interactions":117,"users":86},"Room-FreeRoom":{"interactions":1,"users":1},"ST0001 Thank You":{"interactions":1,"users":1},"ST0002 Are You Human":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":15,"users":9},"ST0058 Can you help me?":{"interactions":2,"users":2},"ST0081 Well done!":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":1,"users":1},"ST0121 Sorry":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":2,"users":2},"ST0339 Have a nice day!":{"interactions":1},"ST0800 Profanity 1":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":7,"users":6},"i1006 Download Mobile App":{"interactions":2,"users":2},"i1010 Theme Park":{"interactions":1,"users":1},"i1044 Job Opening":{"interactions":2,"users":1},"i1100 General Complaint":{"interactions":31,"users":20},"i1101 Reset Password":{"interactions":8,"users":5},"i1104 Contact Number":{"interactions":2,"users":2},"i1107 Email":{"interactions":2,"users":2},"i1200 Getting There":{"interactions":5,"users":5},"i1201 Express Bus":{"interactions":4,"users":3},"i1202 Parking Rates":{"interactions":2,"users":2},"i1206 Getting There KLIA":{"interactions":2,"users":2},"i1207 Free Shuttle Bus":{"interactions":1,"users":1},"i1220 Parking Lot Issue":{"interactions":1,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":3,"users":2},"i2002 Smoking Room":{"interactions":2,"users":1},"i2003 Room Late Check Out":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":5,"users":5},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2009 Any Other Hotels":{"interactions":1,"users":1},"i2013 5 Star Hotels":{"interactions":1,"users":1},"i2020 Room Special Request":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":30,"users":22},"i2101 Complimentary Room Request":{"interactions":11,"users":10},"i2102 Stock Selling":{"interactions":7,"users":6},"i2103 Stock Buying":{"interactions":6,"users":5},"i2105 Early Check In":{"interactions":14,"users":6},"i2106 Check In On Behalf":{"interactions":4,"users":2},"i2107 Multiroom Booking":{"interactions":2,"users":1},"i2109 Transfer Room Booking":{"interactions":4,"users":4},"i2110 Change Booking Date":{"interactions":2,"users":1},"i2114 Room Complimentary Birthday":{"interactions":5,"users":5},"i2115 Stock FAQ":{"interactions":29,"users":21},"i2117 Room Complimentary Dynamic Stay":{"interactions":1,"users":1},"i2118 Room Complimentary How to know free room":{"interactions":1,"users":1},"i2120 OTA Points Redemption":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":2,"users":2},"i2125 Room Reservation Cancel Comp Room":{"interactions":2,"users":2},"i2127 Book Hour Use":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":5,"users":5},"i2134 Book Room Using - Video":{"interactions":8,"users":7},"i2136 Did Not Receive Booking Confirmation":{"interactions":1,"users":1},"i2205 Third Party Sites Booking":{"interactions":2,"users":2},"i2206 Third Party Vouchers":{"interactions":2,"users":2},"i2301 Cannot Log In":{"interactions":9,"users":6},"i2302 Retrieve Membership ID":{"interactions":8,"users":7},"i2303 Lost Card":{"interactions":5,"users":4},"i2305 Earn Points":{"interactions":1,"users":1},"i2306 Tier Points":{"interactions":3,"users":1},"i2307 Activate Membership":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":5,"users":5},"i2309 Membership Benefits":{"interactions":2,"users":2},"i2310 Apply for Membership":{"interactions":1,"users":1},"i2313 Number of Supplimentary Card":{"interactions":2,"users":1},"i2315 Update Membership Details":{"interactions":5,"users":5},"i3103 Sign Up Minimum Age":{"interactions":1,"users":1},"i3200 Concert Collect Tickets":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":1,"users":1},"i3207 Concert Package":{"interactions":3,"users":3},"i3210 Concert Event Info":{"interactions":2,"users":1},"i3300 Theme Park Attractions":{"interactions":1,"users":1},"i3304 Product Price":{"interactions":1,"users":1},"i3400 Dining":{"interactions":1,"users":1}},"totals":{"interactions":{"total":489},"users":{"total":98}}},"20190720":{"topics":{"Default Fallback Intent":{"interactions":40,"users":24},"Default Welcome Intent":{"interactions":63,"users":52},"ST0001 Thank You":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":5,"users":5},"i1004 Promotions":{"interactions":1,"users":1},"i1006 Download Mobile App":{"interactions":1,"users":1},"i1009 Leisure":{"interactions":1,"users":1},"i1010 Theme Park":{"interactions":2,"users":2},"i1036 Luggage Storage":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":10,"users":7},"i1101 Reset Password":{"interactions":1,"users":1},"i1103 Forgot Email":{"interactions":2,"users":1},"i1104 Contact Number":{"interactions":1,"users":1},"i1107 Email":{"interactions":3,"users":2},"i1200 Getting There":{"interactions":1,"users":1},"i1201 Express Bus":{"interactions":1,"users":1},"i1206 Getting There KLIA":{"interactions":1,"users":1},"i1210 Book Complimentary Limousine":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":4,"users":3},"i2001 Extra Bed":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":3,"users":3},"i2005 Room Check Out Time":{"interactions":2,"users":2},"i2006 Room Check In Age":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":12,"users":11},"i2101 Complimentary Room Request":{"interactions":7,"users":6},"i2102 Stock Selling":{"interactions":8,"users":5},"i2103 Stock Buying":{"interactions":5,"users":5},"i2105 Early Check In":{"interactions":8,"users":5},"i2106 Check In On Behalf":{"interactions":2,"users":2},"i2108 Room Upgrade Request":{"interactions":1,"users":1},"i2109 Transfer Room Booking":{"interactions":4,"users":4},"i2110 Change Booking Date":{"interactions":3,"users":3},"i2114 Room Complimentary Birthday":{"interactions":2,"users":2},"i2115 Stock FAQ":{"interactions":25,"users":17},"i2122 Room Amenities":{"interactions":3,"users":2},"i2126 Family Room Reservations":{"interactions":2,"users":1},"i2127 Book Hour Use":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":5,"users":5},"i2134 Book Room Using - Video":{"interactions":8,"users":5},"i2135 Book Room Using - Image":{"interactions":5,"users":4},"i2136 Did Not Receive Booking Confirmation":{"interactions":2,"users":2},"i2301 Cannot Log In":{"interactions":3,"users":2},"i2302 Retrieve Membership ID":{"interactions":1,"users":1},"i2303 Lost Card":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":1,"users":1},"i2310 Apply for Membership":{"interactions":2,"users":2},"i2315 Update Membership Details":{"interactions":5,"users":4},"i3205 Concert Where to Buy":{"interactions":3,"users":2},"i3300 Theme Park Attractions":{"interactions":1,"users":1}},"totals":{"interactions":{"total":267},"users":{"total":55}}},"20190721":{"topics":{"Default Fallback Intent":{"interactions":40,"users":28},"Default Welcome Intent":{"interactions":78,"users":68},"ST0001 Thank You":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":8,"users":6},"ST0052 Chatbot Wrong Answer":{"interactions":1,"users":1},"ST0097 I am happy":{"interactions":1},"ST0115 Yes":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":8,"users":7},"i1010 Theme Park":{"interactions":4,"users":3},"i1012 Theme Park":{"interactions":1,"users":1},"i1031 Cruise Ship Booking":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":19,"users":15},"i1101 Reset Password":{"interactions":3,"users":3},"i1102 Room Lost and Found":{"interactions":3,"users":2},"i1103 Forgot Email":{"interactions":1,"users":1},"i1200 Getting There":{"interactions":2,"users":2},"i1201 Express Bus":{"interactions":7,"users":3},"i1203  Bus Terminal":{"interactions":1},"i1209 Parking Grace Period":{"interactions":1,"users":1},"i1218 Shuttle From Airport":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":6,"users":4},"i2001 Extra Bed":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":2,"users":2},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2006 Room Check In Age":{"interactions":1,"users":1},"i2015 Room Breakfast":{"interactions":1,"users":1},"i2024 First World Bed Type":{"interactions":2,"users":2},"i2100 Stock Price":{"interactions":31,"users":23},"i2101 Complimentary Room Request":{"interactions":15,"users":7},"i2102 Stock Selling":{"interactions":4,"users":3},"i2103 Stock Buying":{"interactions":6,"users":4},"i2104 Room Reservation Full":{"interactions":5,"users":5},"i2105 Early Check In":{"interactions":5,"users":2},"i2107 Multiroom Booking":{"interactions":3,"users":3},"i2108 Room Upgrade Request":{"interactions":4,"users":3},"i2109 Transfer Room Booking":{"interactions":5,"users":4},"i2110 Change Booking Date":{"interactions":5,"users":4},"i2111 Help Reserve A Room":{"interactions":3,"users":3},"i2114 Room Complimentary Birthday":{"interactions":5,"users":4},"i2115 Stock FAQ":{"interactions":27,"users":19},"i2122 Room Amenities":{"interactions":3,"users":3},"i2127 Book Hour Use":{"interactions":3,"users":2},"i2133 Book Room Using Membership":{"interactions":6,"users":5},"i2134 Book Room Using - Video":{"interactions":3,"users":3},"i2135 Book Room Using - Image":{"interactions":1,"users":1},"i2136 Did Not Receive Booking Confirmation":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":5,"users":5},"i2302 Retrieve Membership ID":{"interactions":2,"users":2},"i2303 Lost Card":{"interactions":6,"users":3},"i2308 No Points Added":{"interactions":1,"users":1},"i2314 Tier Points Expiry":{"interactions":2,"users":1},"i3205 Concert Where to Buy":{"interactions":1,"users":1},"i3300 Theme Park Attractions":{"interactions":3,"users":2},"i3304 Product Price":{"interactions":2,"users":1},"i3306 Where is Box Office":{"interactions":1,"users":1},"i3307 Where is toilet":{"interactions":1,"users":1},"i3311 Where to Shop":{"interactions":1,"users":1},"i3327 Salary Claims":{"interactions":1,"users":1},"i3401 Salary Payment":{"interactions":3,"users":1},"i3403 Interest Gained":{"interactions":1,"users":1}},"totals":{"interactions":{"total":361},"users":{"total":77}}},"20190722":{"topics":{"Default Fallback Intent":{"interactions":110,"users":49},"Default Welcome Intent":{"interactions":141,"users":102},"ST0001 Thank You":{"interactions":4,"users":3},"ST0003 Ignore Replies":{"interactions":17,"users":11},"ST0058 Can you help me?":{"interactions":7,"users":5},"ST0086 Nice to see you!":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":3,"users":2},"ST0116 No":{"interactions":1,"users":1},"ST0121 Sorry":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":2,"users":2},"ST0339 Have a nice day!":{"interactions":1},"ST0342 i need help in buying":{"interactions":1,"users":1},"i1001 About Us":{"interactions":1,"users":1},"i1002 Wheel Chair Stroller":{"interactions":3,"users":1},"i1004 Promotions":{"interactions":3,"users":3},"i1006 Download Mobile App":{"interactions":1,"users":1},"i1009 Leisure":{"interactions":1,"users":1},"i1010 Theme Park":{"interactions":8,"users":7},"i1012 Theme Park":{"interactions":2,"users":1},"i1018 Can I Bring Pets":{"interactions":1,"users":1},"i1021 History":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":38,"users":23},"i1101 Reset Password":{"interactions":2,"users":2},"i1103 Forgot Email":{"interactions":3,"users":2},"i1107 Email":{"interactions":4,"users":2},"i1200 Getting There":{"interactions":2,"users":2},"i1201 Express Bus":{"interactions":2,"users":2},"i1202 Parking Rates":{"interactions":1,"users":1},"i1203  Bus Terminal":{"interactions":1,"users":1},"i1204 Parking Map":{"interactions":1,"users":1},"i1207 Free Shuttle Bus":{"interactions":3,"users":2},"i1220 Parking Lot Issue":{"interactions":1,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":11,"users":5},"i2001 Extra Bed":{"interactions":2,"users":2},"i2003 Room Late Check Out":{"interactions":3,"users":2},"i2004 Room Check In Time":{"interactions":6,"users":6},"i2005 Room Check Out Time":{"interactions":4,"users":4},"i2014 Reception Operating Hours":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":56,"users":39},"i2101 Complimentary Room Request":{"interactions":18,"users":18},"i2102 Stock Selling":{"interactions":12,"users":6},"i2103 Stock Buying":{"interactions":15,"users":9},"i2104 Room Reservation Full":{"interactions":5,"users":2},"i2105 Early Check In":{"interactions":10,"users":8},"i2106 Check In On Behalf":{"interactions":9,"users":8},"i2107 Multiroom Booking":{"interactions":4,"users":2},"i2108 Room Upgrade Request":{"interactions":1,"users":1},"i2109 Transfer Room Booking":{"interactions":3,"users":3},"i2110 Change Booking Date":{"interactions":6,"users":5},"i2111 Help Reserve A Room":{"interactions":3,"users":3},"i2113 Room Wheelchair Friendly":{"interactions":2,"users":1},"i2114 Room Complimentary Birthday":{"interactions":11,"users":9},"i2115 Stock FAQ":{"interactions":58,"users":36},"i2117 Room Complimentary Dynamic Stay":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":2,"users":2},"i2126 Family Room Reservations":{"interactions":2,"users":2},"i2133 Book Room Using Membership":{"interactions":20,"users":15},"i2134 Book Room Using - Video":{"interactions":9,"users":9},"i2135 Book Room Using - Image":{"interactions":6,"users":6},"i2200 Make Payment For Booking":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":1,"users":1},"i2302 Retrieve Membership ID":{"interactions":1},"i2303 Lost Card":{"interactions":3,"users":3},"i2314 Tier Points Expiry":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":6,"users":6},"i2317 Member Card Lost and Found":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":1,"users":1},"i3300 Theme Park Attractions":{"interactions":1,"users":1},"i3307 Where is toilet":{"interactions":2,"users":2},"i3308 Where is the indoor themepark?":{"interactions":1,"users":1},"i3311 Where to Shop":{"interactions":1,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":3,"users":2},"i3322 Golf Booking":{"interactions":1,"users":1},"i3327 Salary Claims":{"interactions":2,"users":1},"i3400 Dining":{"interactions":2,"users":2},"i3401 Salary Payment":{"interactions":2,"users":2},"i3403 Interest Gained":{"interactions":2,"users":1},"i3405 Restaurant Reservation":{"interactions":1,"users":1}},"totals":{"interactions":{"total":683},"users":{"total":108}}},"20190723":{"topics":{"Default Fallback Intent":{"interactions":111,"users":57},"Default Welcome Intent":{"interactions":143,"users":108},"ST0001 Thank You":{"interactions":2,"users":2},"ST0003 Ignore Replies":{"interactions":8,"users":6},"ST0058 Can you help me?":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":2,"users":2},"ST0116 No":{"interactions":2,"users":2},"ST0300 Good morning":{"interactions":2,"users":2},"ST0339 Have a nice day!":{"interactions":1},"i1001 About Us":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":6,"users":5},"i1006 Download Mobile App":{"interactions":2,"users":2},"i1009 Leisure":{"interactions":2,"users":2},"i1010 Theme Park":{"interactions":4,"users":4},"i1100 General Complaint":{"interactions":34,"users":20},"i1101 Reset Password":{"interactions":6,"users":5},"i1102 Room Lost and Found":{"interactions":3,"users":3},"i1103 Forgot Email":{"interactions":2,"users":2},"i1104 Contact Number":{"interactions":4,"users":4},"i1105 Hotline Busy":{"interactions":3,"users":2},"i1107 Email":{"interactions":3,"users":3},"i1200 Getting There":{"interactions":8,"users":3},"i1201 Express Bus":{"interactions":3,"users":1},"i1203  Bus Terminal":{"interactions":1,"users":1},"i1204 Parking Map":{"interactions":1,"users":1},"i1205 Free Parking":{"interactions":1,"users":1},"i1207 Free Shuttle Bus":{"interactions":1,"users":1},"i1210 Book Complimentary Limousine":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":7,"users":7},"i2001 Extra Bed":{"interactions":2,"users":2},"i2004 Room Check In Time":{"interactions":2,"users":2},"i2021 Hotel Breakfast Starting":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":47,"users":36},"i2101 Complimentary Room Request":{"interactions":25,"users":21},"i2102 Stock Selling":{"interactions":13,"users":9},"i2103 Stock Buying":{"interactions":10,"users":10},"i2104 Room Reservation Full":{"interactions":2,"users":1},"i2105 Early Check In":{"interactions":4,"users":3},"i2106 Check In On Behalf":{"interactions":9,"users":7},"i2107 Multiroom Booking":{"interactions":4,"users":2},"i2108 Room Upgrade Request":{"interactions":3,"users":2},"i2109 Transfer Room Booking":{"interactions":5,"users":5},"i2110 Change Booking Date":{"interactions":3,"users":3},"i2111 Help Reserve A Room":{"interactions":1,"users":1},"i2114 Room Complimentary Birthday":{"interactions":16,"users":15},"i2115 Stock FAQ":{"interactions":33,"users":22},"i2122 Room Amenities":{"interactions":3,"users":3},"i2125 Room Reservation Cancel Comp Room":{"interactions":2,"users":1},"i2126 Family Room Reservations":{"interactions":1,"users":1},"i2130 Room Invoice":{"interactions":5,"users":2},"i2133 Book Room Using Membership":{"interactions":19,"users":17},"i2134 Book Room Using - Video":{"interactions":16,"users":14},"i2135 Book Room Using - Image":{"interactions":4,"users":4},"i2136 Did Not Receive Booking Confirmation":{"interactions":1,"users":1},"i2204 Sales Office":{"interactions":1,"users":1},"i2206 Third Party Vouchers":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":11,"users":9},"i2302 Retrieve Membership ID":{"interactions":7,"users":7},"i2303 Lost Card":{"interactions":7,"users":6},"i2306 Tier Points":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":5,"users":4},"i2309 Membership Benefits":{"interactions":2,"users":2},"i2314 Tier Points Expiry":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":2,"users":2},"i2319 Member Renew Membership":{"interactions":1,"users":1},"i2320 Check Points":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":1,"users":1},"i3303 Operating Hours":{"interactions":1,"users":1},"i3306 Where is Box Office":{"interactions":2,"users":2},"i3307 Where is toilet":{"interactions":1,"users":1},"i3308 Where is the indoor themepark?":{"interactions":2,"users":2},"i3314 Theme Park Ticket Purchase":{"interactions":2,"users":1},"i3323 Child Rates":{"interactions":1,"users":1},"i3400 Dining":{"interactions":3,"users":3}},"totals":{"interactions":{"total":650},"users":{"total":116}}},"20190724":{"topics":{"Default Fallback Intent":{"interactions":71,"users":48},"Default Welcome Intent":{"interactions":130,"users":108},"ST0001 Thank You":{"interactions":4,"users":4},"ST0002 Are You Human":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":11,"users":8},"ST0058 Can you help me?":{"interactions":1,"users":1},"ST0071 Are you ready?":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":6,"users":3},"ST0121 Sorry":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":5,"users":4},"ST0322 Are you there?":{"interactions":1,"users":1},"ST0337 What language do you speak?":{"interactions":1,"users":1},"ST0339 Have a nice day!":{"interactions":1,"users":1},"ST0340 how to win in Theme Park?":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":7,"users":6},"i1006 Download Mobile App":{"interactions":2,"users":2},"i1010 Theme Park":{"interactions":2,"users":2},"i1100 General Complaint":{"interactions":40,"users":19},"i1101 Reset Password":{"interactions":2,"users":2},"i1102 Room Lost and Found":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":7,"users":7},"i1105 Hotline Busy":{"interactions":2,"users":1},"i1107 Email":{"interactions":5,"users":5},"i1200 Getting There":{"interactions":3,"users":3},"i1201 Express Bus":{"interactions":2,"users":1},"i1202 Parking Rates":{"interactions":2,"users":1},"i1203  Bus Terminal":{"interactions":1,"users":1},"i1204 Parking Map":{"interactions":1,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":2,"users":2},"i2001 Extra Bed":{"interactions":2,"users":2},"i2004 Room Check In Time":{"interactions":6,"users":4},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2007 Room Swimming Pool":{"interactions":1,"users":1},"i2020 Room Special Request":{"interactions":1,"users":1},"i2021 Hotel Breakfast Starting":{"interactions":1,"users":1},"i2024 First World Bed Type":{"interactions":7,"users":4},"i2100 Stock Price":{"interactions":64,"users":51},"i2101 Complimentary Room Request":{"interactions":18,"users":17},"i2102 Stock Selling":{"interactions":11,"users":8},"i2103 Stock Buying":{"interactions":14,"users":9},"i2104 Room Reservation Full":{"interactions":4,"users":3},"i2105 Early Check In":{"interactions":11,"users":7},"i2106 Check In On Behalf":{"interactions":9,"users":5},"i2107 Multiroom Booking":{"interactions":9,"users":7},"i2108 Room Upgrade Request":{"interactions":2,"users":2},"i2109 Transfer Room Booking":{"interactions":5,"users":5},"i2111 Help Reserve A Room":{"interactions":4,"users":4},"i2114 Room Complimentary Birthday":{"interactions":7,"users":7},"i2115 Stock FAQ":{"interactions":37,"users":27},"i2116 Room Complimentary Give Away":{"interactions":1,"users":1},"i2117 Room Complimentary Dynamic Stay":{"interactions":2,"users":2},"i2119 Room Reservation Combine Nights":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":2,"users":2},"i2126 Family Room Reservations":{"interactions":4,"users":3},"i2133 Book Room Using Membership":{"interactions":8,"users":7},"i2134 Book Room Using - Video":{"interactions":6,"users":6},"i2135 Book Room Using - Image":{"interactions":7,"users":7},"i2136 Did Not Receive Booking Confirmation":{"interactions":1,"users":1},"i2205 Third Party Sites Booking":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":2,"users":2},"i2302 Retrieve Membership ID":{"interactions":7,"users":5},"i2303 Lost Card":{"interactions":1,"users":1},"i2307 Activate Membership":{"interactions":1},"i2308 No Points Added":{"interactions":3,"users":2},"i2309 Membership Benefits":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":2,"users":2},"i3200 Concert Collect Tickets":{"interactions":5,"users":3},"i3201 Concert Collect On Behalf":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":1,"users":1},"i3206 Concert Kids Ticket":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":1,"users":1},"i3300 Theme Park Attractions":{"interactions":2,"users":2},"i3303 Operating Hours":{"interactions":1,"users":1},"i3306 Where is Box Office":{"interactions":1,"users":1},"i3315 Office Operating Hours":{"interactions":1,"users":1},"i3400 Dining":{"interactions":2,"users":2},"i3405 Restaurant Reservation":{"interactions":1,"users":1}},"totals":{"interactions":{"total":596},"users":{"total":121}}},"20190725":{"topics":{"Default Fallback Intent":{"interactions":103,"users":47},"Default Welcome Intent":{"interactions":136,"users":104},"ST0001 Thank You":{"interactions":4,"users":4},"ST0003 Ignore Replies":{"interactions":20,"users":10},"ST0058 Can you help me?":{"interactions":3,"users":3},"ST0111 I'm waiting":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":4,"users":3},"ST0116 No":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":5,"users":5},"ST0301 Good afternoon":{"interactions":1,"users":1},"ST0337 What language do you speak?":{"interactions":1,"users":1},"ST0800 Profanity 1":{"interactions":1,"users":1},"i1002 Wheel Chair Stroller":{"interactions":3,"users":2},"i1004 Promotions":{"interactions":6,"users":4},"i1006 Download Mobile App":{"interactions":2,"users":2},"i1010 Theme Park":{"interactions":6,"users":4},"i1012 Theme Park":{"interactions":1,"users":1},"i1031 Cruise Ship Booking":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":60,"users":35},"i1101 Reset Password":{"interactions":6,"users":4},"i1102 Room Lost and Found":{"interactions":1,"users":1},"i1103 Forgot Email":{"interactions":2,"users":2},"i1104 Contact Number":{"interactions":7,"users":7},"i1105 Hotline Busy":{"interactions":1,"users":1},"i1107 Email":{"interactions":5,"users":5},"i1200 Getting There":{"interactions":1,"users":1},"i1201 Express Bus":{"interactions":6,"users":2},"i1202 Parking Rates":{"interactions":2,"users":1},"i1203  Bus Terminal":{"interactions":4,"users":2},"i1204 Parking Map":{"interactions":1,"users":1},"i1205 Free Parking":{"interactions":2,"users":1},"i1207 Free Shuttle Bus":{"interactions":2,"users":1},"i1211 Taxi to ":{"interactions":1,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":2,"users":2},"i2000 Adjoining Room":{"interactions":4,"users":4},"i2001 Extra Bed":{"interactions":2,"users":2},"i2003 Room Late Check Out":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":2,"users":2},"i2100 Stock Price":{"interactions":50,"users":37},"i2101 Complimentary Room Request":{"interactions":24,"users":20},"i2102 Stock Selling":{"interactions":11,"users":10},"i2103 Stock Buying":{"interactions":11,"users":6},"i2104 Room Reservation Full":{"interactions":3,"users":1},"i2105 Early Check In":{"interactions":8,"users":5},"i2106 Check In On Behalf":{"interactions":5,"users":3},"i2107 Multiroom Booking":{"interactions":3,"users":3},"i2109 Transfer Room Booking":{"interactions":5,"users":5},"i2110 Change Booking Date":{"interactions":1,"users":1},"i2111 Help Reserve A Room":{"interactions":1,"users":1},"i2113 Room Wheelchair Friendly":{"interactions":1,"users":1},"i2114 Room Complimentary Birthday":{"interactions":23,"users":17},"i2115 Stock FAQ":{"interactions":34,"users":28},"i2122 Room Amenities":{"interactions":2,"users":2},"i2125 Room Reservation Cancel Comp Room":{"interactions":1,"users":1},"i2126 Family Room Reservations":{"interactions":3,"users":2},"i2131 Maximum People in Room":{"interactions":2,"users":2},"i2133 Book Room Using Membership":{"interactions":24,"users":19},"i2134 Book Room Using - Video":{"interactions":21,"users":15},"i2135 Book Room Using - Image":{"interactions":5,"users":5},"i2200 Make Payment For Booking":{"interactions":2,"users":2},"i2204 Sales Office":{"interactions":1,"users":1},"i2206 Third Party Vouchers":{"interactions":3,"users":1},"i2301 Cannot Log In":{"interactions":11,"users":7},"i2302 Retrieve Membership ID":{"interactions":15,"users":9},"i2303 Lost Card":{"interactions":4,"users":3},"i2308 No Points Added":{"interactions":2,"users":1},"i2310 Apply for Membership":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":2,"users":2},"i2319 Member Renew Membership":{"interactions":2,"users":2},"i3200 Concert Collect Tickets":{"interactions":1,"users":1},"i3202 Concert Transfer Ticket":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":1,"users":1},"i3206 Concert Kids Ticket":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":2,"users":2},"i3212 Concert Preferred Seats":{"interactions":1,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":1,"users":1},"i3327 Salary Claims":{"interactions":1,"users":1},"i3400 Dining":{"interactions":1,"users":1},"i3401 Salary Payment":{"interactions":1,"users":1},"i3402 Interest Charged":{"interactions":1,"users":1}},"totals":{"interactions":{"total":704},"users":{"total":107}}},"20190726":{"topics":{"Default Fallback Intent":{"interactions":74,"users":36},"Default Welcome Intent":{"interactions":84,"users":67},"ST0001 Thank You":{"interactions":1},"ST0003 Ignore Replies":{"interactions":15,"users":12},"ST0058 Can you help me?":{"interactions":1,"users":1},"ST0084 Bye-bye!":{"interactions":1,"users":1},"ST0112 I'd like to see you again":{"interactions":1,"users":1},"ST0116 No":{"interactions":1,"users":1},"ST0117 Cancel":{"interactions":2,"users":1},"ST0300 Good morning":{"interactions":2,"users":2},"ST0339 Have a nice day!":{"interactions":1},"ST0342 i need help in buying":{"interactions":1,"users":1},"i1001 About Us":{"interactions":1,"users":1},"i1003 Operating Hours":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":1},"i1009 Leisure":{"interactions":3,"users":1},"i1010 Theme Park":{"interactions":3,"users":3},"i1012 Theme Park":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":28,"users":16},"i1101 Reset Password":{"interactions":6,"users":4},"i1104 Contact Number":{"interactions":6,"users":4},"i1107 Email":{"interactions":1,"users":1},"i1200 Getting There":{"interactions":4,"users":3},"i1201 Express Bus":{"interactions":3,"users":1},"i1203  Bus Terminal":{"interactions":2,"users":2},"i1207 Free Shuttle Bus":{"interactions":2,"users":1},"i1216 Travel Duration":{"interactions":1,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":5,"users":1},"i2000 Adjoining Room":{"interactions":3,"users":2},"i2001 Extra Bed":{"interactions":1},"i2004 Room Check In Time":{"interactions":5,"users":2},"i2024 First World Bed Type":{"interactions":1},"i2100 Stock Price":{"interactions":34,"users":24},"i2101 Complimentary Room Request":{"interactions":13,"users":12},"i2102 Stock Selling":{"interactions":6,"users":4},"i2103 Stock Buying":{"interactions":4,"users":3},"i2104 Room Reservation Full":{"interactions":5,"users":2},"i2105 Early Check In":{"interactions":4,"users":3},"i2106 Check In On Behalf":{"interactions":3,"users":2},"i2107 Multiroom Booking":{"interactions":2,"users":2},"i2108 Room Upgrade Request":{"interactions":1,"users":1},"i2109 Transfer Room Booking":{"interactions":3,"users":2},"i2110 Change Booking Date":{"interactions":2,"users":1},"i2114 Room Complimentary Birthday":{"interactions":7,"users":5},"i2115 Stock FAQ":{"interactions":14,"users":10},"i2117 Room Complimentary Dynamic Stay":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":3,"users":3},"i2126 Family Room Reservations":{"interactions":2,"users":1},"i2127 Book Hour Use":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":9,"users":7},"i2134 Book Room Using - Video":{"interactions":9,"users":8},"i2135 Book Room Using - Image":{"interactions":4,"users":4},"i2206 Third Party Vouchers":{"interactions":3,"users":1},"i2301 Cannot Log In":{"interactions":4,"users":3},"i2302 Retrieve Membership ID":{"interactions":6,"users":5},"i2303 Lost Card":{"interactions":2,"users":2},"i2306 Tier Points":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":3,"users":2},"i2315 Update Membership Details":{"interactions":2,"users":2},"i2318 Reward Alliance Website":{"interactions":1,"users":1},"i2319 Member Renew Membership":{"interactions":1,"users":1},"i3202 Concert Transfer Ticket":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":3,"users":3},"i3206 Concert Kids Ticket":{"interactions":3,"users":1},"i3210 Concert Event Info":{"interactions":5,"users":5},"i3211 Concert Early Bird Booking":{"interactions":1,"users":1},"i3300 Theme Park Attractions":{"interactions":3,"users":3},"i3303 Operating Hours":{"interactions":2,"users":2},"i3304 Product Price":{"interactions":2,"users":2},"i3307 Where is toilet":{"interactions":1,"users":1},"i3311 Where to Shop":{"interactions":1,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":3,"users":3},"i3322 Golf Booking":{"interactions":1,"users":1},"i3327 Salary Claims":{"interactions":1,"users":1},"i3400 Dining":{"interactions":1,"users":1},"i3402 Interest Charged":{"interactions":1,"users":1}},"totals":{"interactions":{"total":441},"users":{"total":78}}},"20190727":{"topics":{"Default Fallback Intent":{"interactions":45,"users":28},"Default Welcome Intent":{"interactions":80,"users":64},"ST0001 Thank You":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":6,"users":5},"ST0052 Chatbot Wrong Answer":{"interactions":1,"users":1},"ST0058 Can you help me?":{"interactions":2,"users":2},"ST0115 Yes":{"interactions":1,"users":1},"ST0337 What language do you speak?":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":1,"users":1},"i1007 Map":{"interactions":1,"users":1},"i1010 Theme Park":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":13,"users":10},"i1101 Reset Password":{"interactions":4,"users":4},"i1102 Room Lost and Found":{"interactions":1,"users":1},"i1103 Forgot Email":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":3,"users":3},"i1107 Email":{"interactions":1,"users":1},"i1200 Getting There":{"interactions":1,"users":1},"i1207 Free Shuttle Bus":{"interactions":1,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":8,"users":1},"i2000 Adjoining Room":{"interactions":3,"users":3},"i2001 Extra Bed":{"interactions":2,"users":1},"i2004 Room Check In Time":{"interactions":3,"users":3},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2006 Room Check In Age":{"interactions":2,"users":1},"i2024 First World Bed Type":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":18,"users":15},"i2101 Complimentary Room Request":{"interactions":8,"users":7},"i2102 Stock Selling":{"interactions":6,"users":6},"i2103 Stock Buying":{"interactions":5,"users":5},"i2104 Room Reservation Full":{"interactions":3,"users":2},"i2105 Early Check In":{"interactions":8,"users":4},"i2106 Check In On Behalf":{"interactions":2,"users":2},"i2109 Transfer Room Booking":{"interactions":1,"users":1},"i2114 Room Complimentary Birthday":{"interactions":2,"users":2},"i2115 Stock FAQ":{"interactions":24,"users":18},"i2117 Room Complimentary Dynamic Stay":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":2,"users":2},"i2126 Family Room Reservations":{"interactions":3,"users":2},"i2133 Book Room Using Membership":{"interactions":6,"users":3},"i2134 Book Room Using - Video":{"interactions":5,"users":3},"i2135 Book Room Using - Image":{"interactions":2,"users":1},"i2136 Did Not Receive Booking Confirmation":{"interactions":1,"users":1},"i2206 Third Party Vouchers":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":6,"users":4},"i2302 Retrieve Membership ID":{"interactions":2,"users":2},"i2303 Lost Card":{"interactions":1,"users":1},"i2305 Earn Points":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":4,"users":3},"i3210 Concert Event Info":{"interactions":3,"users":3},"i3303 Operating Hours":{"interactions":1,"users":1},"i3306 Where is Box Office":{"interactions":1},"i3307 Where is toilet":{"interactions":1,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":1,"users":1},"i3401 Salary Payment":{"interactions":1,"users":1},"i3403 Interest Gained":{"interactions":1,"users":1}},"totals":{"interactions":{"total":307},"users":{"total":68}}},"20190728":{"topics":{"Default Fallback Intent":{"interactions":47,"users":30},"Default Welcome Intent":{"interactions":79,"users":61},"ST0001 Thank You":{"interactions":2,"users":1},"ST0003 Ignore Replies":{"interactions":8,"users":8},"ST0004 What Is Your Name":{"interactions":1,"users":1},"ST0052 Chatbot Wrong Answer":{"interactions":1,"users":1},"ST0058 Can you help me?":{"interactions":2,"users":2},"ST0122 What do you mean?":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":1,"users":1},"ST0332 That is great":{"interactions":1,"users":1},"ST0800 Profanity 1":{"interactions":1,"users":1},"i1003 Operating Hours":{"interactions":3,"users":1},"i1004 Promotions":{"interactions":7,"users":4},"i1006 Download Mobile App":{"interactions":1,"users":1},"i1009 Leisure":{"interactions":2,"users":1},"i1010 Theme Park":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":19,"users":14},"i1101 Reset Password":{"interactions":4,"users":2},"i1102 Room Lost and Found":{"interactions":2,"users":2},"i1103 Forgot Email":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":1,"users":1},"i1200 Getting There":{"interactions":2,"users":2},"i1201 Express Bus":{"interactions":2,"users":1},"i1202 Parking Rates":{"interactions":1,"users":1},"i1203  Bus Terminal":{"interactions":1,"users":1},"i1204 Parking Map":{"interactions":1},"i1206 Getting There KLIA":{"interactions":3,"users":2},"i1207 Free Shuttle Bus":{"interactions":2,"users":2},"i1210 Book Complimentary Limousine":{"interactions":2,"users":1},"i1216 Travel Duration":{"interactions":1},"i1220 Parking Lot Issue":{"interactions":1,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":3,"users":3},"i2004 Room Check In Time":{"interactions":5,"users":5},"i2024 First World Bed Type":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":24,"users":17},"i2101 Complimentary Room Request":{"interactions":14,"users":10},"i2102 Stock Selling":{"interactions":6,"users":6},"i2103 Stock Buying":{"interactions":5,"users":4},"i2104 Room Reservation Full":{"interactions":2,"users":2},"i2105 Early Check In":{"interactions":14,"users":7},"i2106 Check In On Behalf":{"interactions":6,"users":4},"i2108 Room Upgrade Request":{"interactions":2,"users":1},"i2109 Transfer Room Booking":{"interactions":1,"users":1},"i2110 Change Booking Date":{"interactions":1,"users":1},"i2111 Help Reserve A Room":{"interactions":1,"users":1},"i2114 Room Complimentary Birthday":{"interactions":8,"users":5},"i2115 Stock FAQ":{"interactions":28,"users":17},"i2118 Room Complimentary How to know free room":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":1,"users":1},"i2125 Room Reservation Cancel Comp Room":{"interactions":2,"users":2},"i2126 Family Room Reservations":{"interactions":3,"users":1},"i2131 Maximum People in Room":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":9,"users":9},"i2134 Book Room Using - Video":{"interactions":9,"users":7},"i2135 Book Room Using - Image":{"interactions":3,"users":3},"i2136 Did Not Receive Booking Confirmation":{"interactions":1,"users":1},"i2200 Make Payment For Booking":{"interactions":4,"users":3},"i2202 Payment in Singapore":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":8,"users":5},"i2302 Retrieve Membership ID":{"interactions":2,"users":2},"i2303 Lost Card":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":1,"users":1},"i2311 Under 18 Join Membership":{"interactions":1},"i2315 Update Membership Details":{"interactions":3,"users":3},"i3205 Concert Where to Buy":{"interactions":4,"users":2},"i3210 Concert Event Info":{"interactions":4,"users":4},"i3211 Concert Early Bird Booking":{"interactions":1,"users":1},"i3300 Theme Park Attractions":{"interactions":2,"users":1},"i3304 Product Price":{"interactions":3,"users":2},"i3306 Where is Box Office":{"interactions":1,"users":1},"i3311 Where to Shop":{"interactions":1,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":1,"users":1},"i3400 Dining":{"interactions":4,"users":1},"i3405 Restaurant Reservation":{"interactions":1,"users":1}},"totals":{"interactions":{"total":396},"users":{"total":69}}},"20190729":{"topics":{"Default Fallback Intent":{"interactions":137,"users":76},"Default Welcome Intent":{"interactions":153,"users":112},"ST0001 Thank You":{"interactions":2,"users":2},"ST0002 Are You Human":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":17,"users":12},"ST0004 What Is Your Name":{"interactions":1,"users":1},"ST0058 Can you help me?":{"interactions":4,"users":4},"ST0074 Talk to me":{"interactions":2,"users":1},"ST0113 I just want to talk":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":3,"users":3},"ST0116 No":{"interactions":3,"users":3},"ST0117 Cancel":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":2,"users":2},"ST0308 Okay Google":{"interactions":2,"users":2},"ST0337 What language do you speak?":{"interactions":1,"users":1},"ST0800 Profanity 1":{"interactions":2,"users":1},"i1002 Wheel Chair Stroller":{"interactions":1,"users":1},"i1003 Operating Hours":{"interactions":3,"users":2},"i1004 Promotions":{"interactions":6,"users":6},"i1006 Download Mobile App":{"interactions":2,"users":2},"i1009 Leisure":{"interactions":1,"users":1},"i1010 Theme Park":{"interactions":3,"users":3},"i1017 Where is money changer?":{"interactions":1,"users":1},"i1029 Contact Center Operation Hours":{"interactions":1,"users":1},"i1036 Luggage Storage":{"interactions":1,"users":1},"i1038 Baby Changing Room":{"interactions":1,"users":1},"i1039 Tourism Tax":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":50,"users":20},"i1101 Reset Password":{"interactions":5,"users":5},"i1103 Forgot Email":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":6,"users":6},"i1105 Hotline Busy":{"interactions":3,"users":2},"i1107 Email":{"interactions":3,"users":3},"i1200 Getting There":{"interactions":3,"users":3},"i1201 Express Bus":{"interactions":5,"users":4},"i1202 Parking Rates":{"interactions":2,"users":1},"i1203  Bus Terminal":{"interactions":2,"users":2},"i1204 Parking Map":{"interactions":2,"users":2},"i1205 Free Parking":{"interactions":2,"users":2},"i1206 Getting There KLIA":{"interactions":1,"users":1},"i1207 Free Shuttle Bus":{"interactions":3,"users":3},"i1210 Book Complimentary Limousine":{"interactions":1,"users":1},"i1212 Where is  Hotel":{"interactions":1,"users":1},"i1214 Valet Parking":{"interactions":1,"users":1},"i1216 Travel Duration":{"interactions":2,"users":2},"i1219 Limo Service":{"interactions":1,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":5,"users":4},"i2001 Extra Bed":{"interactions":6,"users":4},"i2003 Room Late Check Out":{"interactions":3,"users":3},"i2004 Room Check In Time":{"interactions":12,"users":9},"i2005 Room Check Out Time":{"interactions":2,"users":2},"i2006 Room Check In Age":{"interactions":3,"users":1},"i2009 Any Other Hotels":{"interactions":3,"users":3},"i2020 Room Special Request":{"interactions":1,"users":1},"i2024 First World Bed Type":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":55,"users":40},"i2101 Complimentary Room Request":{"interactions":17,"users":16},"i2102 Stock Selling":{"interactions":13,"users":12},"i2103 Stock Buying":{"interactions":8,"users":7},"i2104 Room Reservation Full":{"interactions":9,"users":5},"i2105 Early Check In":{"interactions":21,"users":11},"i2106 Check In On Behalf":{"interactions":4,"users":4},"i2107 Multiroom Booking":{"interactions":5,"users":5},"i2108 Room Upgrade Request":{"interactions":1,"users":1},"i2109 Transfer Room Booking":{"interactions":6,"users":6},"i2110 Change Booking Date":{"interactions":4,"users":3},"i2111 Help Reserve A Room":{"interactions":3,"users":2},"i2114 Room Complimentary Birthday":{"interactions":2,"users":2},"i2115 Stock FAQ":{"interactions":45,"users":31},"i2122 Room Amenities":{"interactions":5,"users":4},"i2126 Family Room Reservations":{"interactions":6,"users":3},"i2131 Maximum People in Room":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":1,"users":1},"i2134 Book Room Using - Video":{"interactions":12,"users":12},"i2136 Did Not Receive Booking Confirmation":{"interactions":4,"users":4},"i2206 Third Party Vouchers":{"interactions":6,"users":4},"i2301 Cannot Log In":{"interactions":14,"users":10},"i2302 Retrieve Membership ID":{"interactions":16,"users":10},"i2303 Lost Card":{"interactions":4,"users":3},"i2307 Activate Membership":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":3,"users":2},"i2309 Membership Benefits":{"interactions":2,"users":2},"i2310 Apply for Membership":{"interactions":7,"users":6},"i2312 Number of Member Card Can Apply":{"interactions":2,"users":1},"i2315 Update Membership Details":{"interactions":6,"users":6},"i2320 Check Points":{"interactions":1,"users":1},"i3200 Concert Collect Tickets":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":4,"users":4},"i3300 Theme Park Attractions":{"interactions":2,"users":2},"i3303 Operating Hours":{"interactions":2,"users":2},"i3304 Product Price":{"interactions":2,"users":2},"i3307 Where is toilet":{"interactions":5,"users":4},"i3311 Where to Shop":{"interactions":1,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":1,"users":1},"i3321 Entrance Price":{"interactions":1,"users":1},"i3323 Child Rates":{"interactions":1,"users":1},"i3401 Salary Payment":{"interactions":1,"users":1}},"totals":{"interactions":{"total":789},"users":{"total":134}}},"20190730":{"topics":{"Default Fallback Intent":{"interactions":117,"users":50},"Default Welcome Intent":{"interactions":115,"users":93},"ST0001 Thank You":{"interactions":5,"users":5},"ST0002 Are You Human":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":16,"users":9},"ST0058 Can you help me?":{"interactions":4,"users":4},"ST0084 Bye-bye!":{"interactions":1,"users":1},"ST0086 Nice to see you!":{"interactions":1,"users":1},"ST0088 I'm very angry right now":{"interactions":2,"users":1},"ST0115 Yes":{"interactions":4,"users":3},"ST0116 No":{"interactions":3,"users":3},"ST0117 Cancel":{"interactions":1,"users":1},"ST0121 Sorry":{"interactions":2,"users":1},"ST0122 What do you mean?":{"interactions":1,"users":1},"ST0123 You're wrong":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":1,"users":1},"ST0301 Good afternoon":{"interactions":1,"users":1},"ST0308 Okay Google":{"interactions":1,"users":1},"ST0319 Can you talk to me":{"interactions":1,"users":1},"ST0337 What language do you speak?":{"interactions":1,"users":1},"ST0339 Have a nice day!":{"interactions":1,"users":1},"i1002 Wheel Chair Stroller":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":10,"users":9},"i1006 Download Mobile App":{"interactions":2,"users":1},"i1009 Leisure":{"interactions":1,"users":1},"i1010 Theme Park":{"interactions":4,"users":4},"i1012 Theme Park":{"interactions":2,"users":1},"i1036 Luggage Storage":{"interactions":1,"users":1},"i1044 Job Opening":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":20,"users":14},"i1101 Reset Password":{"interactions":3,"users":3},"i1103 Forgot Email":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":4,"users":3},"i1105 Hotline Busy":{"interactions":1,"users":1},"i1107 Email":{"interactions":4,"users":4},"i1220 Parking Lot Issue":{"interactions":1,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":6,"users":6},"i2001 Extra Bed":{"interactions":2,"users":2},"i2004 Room Check In Time":{"interactions":3,"users":2},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2006 Room Check In Age":{"interactions":5,"users":4},"i2024 First World Bed Type":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":42,"users":28},"i2101 Complimentary Room Request":{"interactions":19,"users":16},"i2102 Stock Selling":{"interactions":21,"users":12},"i2103 Stock Buying":{"interactions":8,"users":6},"i2104 Room Reservation Full":{"interactions":7,"users":4},"i2105 Early Check In":{"interactions":8,"users":4},"i2106 Check In On Behalf":{"interactions":3,"users":3},"i2107 Multiroom Booking":{"interactions":3,"users":3},"i2109 Transfer Room Booking":{"interactions":4,"users":4},"i2110 Change Booking Date":{"interactions":2,"users":2},"i2111 Help Reserve A Room":{"interactions":2,"users":2},"i2114 Room Complimentary Birthday":{"interactions":10,"users":9},"i2115 Stock FAQ":{"interactions":46,"users":27},"i2117 Room Complimentary Dynamic Stay":{"interactions":2,"users":2},"i2122 Room Amenities":{"interactions":3,"users":2},"i2125 Room Reservation Cancel Comp Room":{"interactions":2,"users":2},"i2127 Book Hour Use":{"interactions":1,"users":1},"i2131 Maximum People in Room":{"interactions":1,"users":1},"i2132 Foreigner Passport Number":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":8,"users":7},"i2134 Book Room Using - Video":{"interactions":8,"users":7},"i2136 Did Not Receive Booking Confirmation":{"interactions":3,"users":3},"i2200 Make Payment For Booking":{"interactions":2,"users":1},"i2205 Third Party Sites Booking":{"interactions":1,"users":1},"i2206 Third Party Vouchers":{"interactions":4,"users":4},"i2301 Cannot Log In":{"interactions":8,"users":5},"i2302 Retrieve Membership ID":{"interactions":10,"users":7},"i2303 Lost Card":{"interactions":3,"users":3},"i2305 Earn Points":{"interactions":1,"users":1},"i2307 Activate Membership":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":2,"users":2},"i2309 Membership Benefits":{"interactions":3,"users":3},"i2314 Tier Points Expiry":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":3,"users":3},"i2317 Member Card Lost and Found":{"interactions":1,"users":1},"i2318 Reward Alliance Website":{"interactions":1,"users":1},"i3200 Concert Collect Tickets":{"interactions":3,"users":2},"i3201 Concert Collect On Behalf":{"interactions":1,"users":1},"i3206 Concert Kids Ticket":{"interactions":2,"users":1},"i3207 Concert Package":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":3,"users":3},"i3300 Theme Park Attractions":{"interactions":1,"users":1},"i3304 Product Price":{"interactions":1,"users":1},"i3308 Where is the indoor themepark?":{"interactions":2,"users":2},"i3309 Get To HQ":{"interactions":1,"users":1},"i3311 Where to Shop":{"interactions":2,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":1,"users":1},"i3327 Salary Claims":{"interactions":1,"users":1},"i3400 Dining":{"interactions":3,"users":2},"i3401 Salary Payment":{"interactions":1,"users":1}},"totals":{"interactions":{"total":623},"users":{"total":98}}},"20190731":{"topics":{"Default Fallback Intent":{"interactions":107,"users":45},"Default Welcome Intent":{"interactions":119,"users":90},"ST0001 Thank You":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":29,"users":10},"ST0052 Chatbot Wrong Answer":{"interactions":2,"users":2},"ST0058 Can you help me?":{"interactions":3,"users":3},"ST0084 Bye-bye!":{"interactions":1,"users":1},"ST0085 Nice to meet you!":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":5,"users":3},"ST0122 What do you mean?":{"interactions":1,"users":1},"ST0301 Good afternoon":{"interactions":1,"users":1},"ST0319 Can you talk to me":{"interactions":1,"users":1},"ST0332 That is great":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":7,"users":5},"i1006 Download Mobile App":{"interactions":4,"users":4},"i1010 Theme Park":{"interactions":1,"users":1},"i1012 Theme Park":{"interactions":4,"users":3},"i1044 Job Opening":{"interactions":1},"i1100 General Complaint":{"interactions":41,"users":21},"i1101 Reset Password":{"interactions":7,"users":5},"i1102 Room Lost and Found":{"interactions":2,"users":2},"i1103 Forgot Email":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":3,"users":3},"i1107 Email":{"interactions":1,"users":1},"i1200 Getting There":{"interactions":3,"users":1},"i1201 Express Bus":{"interactions":3,"users":1},"i1202 Parking Rates":{"interactions":3,"users":1},"i1203  Bus Terminal":{"interactions":5,"users":1},"i1204 Parking Map":{"interactions":3,"users":1},"i1205 Free Parking":{"interactions":2,"users":1},"i1207 Free Shuttle Bus":{"interactions":4,"users":2},"i1222 Shuttle Bus Schedule":{"interactions":3,"users":2},"i2000 Adjoining Room":{"interactions":6,"users":6},"i2001 Extra Bed":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":4,"users":4},"i2005 Room Check Out Time":{"interactions":3,"users":3},"i2020 Room Special Request":{"interactions":1,"users":1},"i2023 Room Comes with Free Meal":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":29,"users":25},"i2101 Complimentary Room Request":{"interactions":13,"users":12},"i2102 Stock Selling":{"interactions":13,"users":9},"i2103 Stock Buying":{"interactions":6,"users":6},"i2105 Early Check In":{"interactions":5,"users":3},"i2106 Check In On Behalf":{"interactions":2,"users":2},"i2107 Multiroom Booking":{"interactions":3,"users":2},"i2109 Transfer Room Booking":{"interactions":4,"users":4},"i2110 Change Booking Date":{"interactions":2,"users":2},"i2114 Room Complimentary Birthday":{"interactions":7,"users":7},"i2115 Stock FAQ":{"interactions":28,"users":16},"i2117 Room Complimentary Dynamic Stay":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":5,"users":4},"i2126 Family Room Reservations":{"interactions":4,"users":3},"i2133 Book Room Using Membership":{"interactions":9,"users":7},"i2134 Book Room Using - Video":{"interactions":5,"users":5},"i2135 Book Room Using - Image":{"interactions":1,"users":1},"i2136 Did Not Receive Booking Confirmation":{"interactions":2,"users":2},"i2206 Third Party Vouchers":{"interactions":6,"users":1},"i2301 Cannot Log In":{"interactions":13,"users":9},"i2302 Retrieve Membership ID":{"interactions":18,"users":8},"i2303 Lost Card":{"interactions":8,"users":8},"i2307 Activate Membership":{"interactions":3,"users":2},"i2308 No Points Added":{"interactions":1,"users":1},"i2309 Membership Benefits":{"interactions":1,"users":1},"i2310 Apply for Membership":{"interactions":1,"users":1},"i2319 Member Renew Membership":{"interactions":2,"users":1},"i3100 Where Is SkyTheme Park":{"interactions":2,"users":2},"i3101 Theme Park Dress Code":{"interactions":2,"users":2},"i3200 Concert Collect Tickets":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":1,"users":1},"i3207 Concert Package":{"interactions":2,"users":2},"i3210 Concert Event Info":{"interactions":1,"users":1},"i3300 Theme Park Attractions":{"interactions":1,"users":1},"i3306 Where is Box Office":{"interactions":2,"users":2},"i3311 Where to Shop":{"interactions":3,"users":1},"i3326 Salary Deduction":{"interactions":4,"users":1},"tt - testing":{"interactions":1,"users":1}},"totals":{"interactions":{"total":598},"users":{"total":96}}},"20190801":{"topics":{"Default Fallback Intent":{"interactions":124,"users":65},"Default Welcome Intent":{"interactions":135,"users":96},"Room-FreeRoom":{"interactions":2,"users":2},"ST0001 Thank You":{"interactions":6,"users":5},"ST0002 Are You Human":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":30,"users":12},"ST0052 Chatbot Wrong Answer":{"interactions":1,"users":1},"ST0058 Can you help me?":{"interactions":3,"users":2},"ST0070 Where do you work?":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":2,"users":2},"ST0121 Sorry":{"interactions":2,"users":2},"ST0123 You're wrong":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":3,"users":3},"ST0302 Good evening":{"interactions":2,"users":2},"ST0328 I like you":{"interactions":1,"users":1},"ST0337 What language do you speak?":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":8,"users":6},"i1006 Download Mobile App":{"interactions":1,"users":1},"i1009 Leisure":{"interactions":2,"users":1},"i1010 Theme Park":{"interactions":5,"users":5},"i1029 Contact Center Operation Hours":{"interactions":1,"users":1},"i1044 Job Opening":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":58,"users":25},"i1101 Reset Password":{"interactions":2,"users":2},"i1102 Room Lost and Found":{"interactions":4,"users":1},"i1103 Forgot Email":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":7,"users":6},"i1105 Hotline Busy":{"interactions":2,"users":1},"i1107 Email":{"interactions":7,"users":4},"i1200 Getting There":{"interactions":4,"users":4},"i1201 Express Bus":{"interactions":6,"users":3},"i1202 Parking Rates":{"interactions":1,"users":1},"i1203  Bus Terminal":{"interactions":8,"users":3},"i1204 Parking Map":{"interactions":1,"users":1},"i1205 Free Parking":{"interactions":1,"users":1},"i1207 Free Shuttle Bus":{"interactions":3,"users":3},"i1209 Parking Grace Period":{"interactions":1,"users":1},"i1220 Parking Lot Issue":{"interactions":1,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":10,"users":7},"i2001 Extra Bed":{"interactions":2,"users":1},"i2004 Room Check In Time":{"interactions":6,"users":4},"i2006 Room Check In Age":{"interactions":3,"users":3},"i2024 First World Bed Type":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":43,"users":33},"i2101 Complimentary Room Request":{"interactions":13,"users":12},"i2102 Stock Selling":{"interactions":10,"users":9},"i2103 Stock Buying":{"interactions":13,"users":7},"i2104 Room Reservation Full":{"interactions":3,"users":3},"i2105 Early Check In":{"interactions":9,"users":5},"i2106 Check In On Behalf":{"interactions":6,"users":4},"i2109 Transfer Room Booking":{"interactions":4,"users":4},"i2110 Change Booking Date":{"interactions":2,"users":2},"i2111 Help Reserve A Room":{"interactions":7,"users":5},"i2114 Room Complimentary Birthday":{"interactions":13,"users":11},"i2115 Stock FAQ":{"interactions":42,"users":27},"i2119 Room Reservation Combine Nights":{"interactions":2,"users":2},"i2122 Room Amenities":{"interactions":4,"users":3},"i2123 Room Reservation Ammend Comp Room":{"interactions":1,"users":1},"i2126 Family Room Reservations":{"interactions":7,"users":5},"i2129 Room Reservation Under Different Category":{"interactions":1,"users":1},"i2131 Maximum People in Room":{"interactions":3,"users":3},"i2133 Book Room Using Membership":{"interactions":15,"users":10},"i2134 Book Room Using - Video":{"interactions":3,"users":2},"i2135 Book Room Using - Image":{"interactions":3,"users":2},"i2136 Did Not Receive Booking Confirmation":{"interactions":2,"users":2},"i2206 Third Party Vouchers":{"interactions":4,"users":2},"i2301 Cannot Log In":{"interactions":8,"users":8},"i2302 Retrieve Membership ID":{"interactions":7,"users":4},"i2303 Lost Card":{"interactions":5,"users":4},"i2305 Earn Points":{"interactions":1,"users":1},"i2306 Tier Points":{"interactions":1,"users":1},"i2309 Membership Benefits":{"interactions":1,"users":1},"i2310 Apply for Membership":{"interactions":1,"users":1},"i2312 Number of Member Card Can Apply":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":3,"users":3},"i2319 Member Renew Membership":{"interactions":2,"users":2},"i3200 Concert Collect Tickets":{"interactions":2,"users":1},"i3201 Concert Collect On Behalf":{"interactions":2,"users":2},"i3202 Concert Transfer Ticket":{"interactions":1,"users":1},"i3209 Concert Complimentary Ticket":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":1},"i3300 Theme Park Attractions":{"interactions":4,"users":4},"i3308 Where is the indoor themepark?":{"interactions":2,"users":2},"i3311 Where to Shop":{"interactions":2,"users":2},"i3314 Theme Park Ticket Purchase":{"interactions":6,"users":3},"i3327 Salary Claims":{"interactions":3,"users":3},"i3401 Salary Payment":{"interactions":1,"users":1},"i3403 Interest Gained":{"interactions":1,"users":1}},"totals":{"interactions":{"total":729},"users":{"total":117}}},"20190802":{"topics":{"Default Fallback Intent":{"interactions":97,"users":52},"Default Welcome Intent":{"interactions":157,"users":119},"Room-FreeRoom":{"interactions":1,"users":1},"ST0001 Thank You":{"interactions":5,"users":5},"ST0002 Are You Human":{"interactions":4,"users":3},"ST0003 Ignore Replies":{"interactions":16,"users":13},"ST0058 Can you help me?":{"interactions":7,"users":5},"ST0074 Talk to me":{"interactions":1,"users":1},"ST0093":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":3,"users":3},"ST0116 No":{"interactions":2,"users":2},"ST0122 What do you mean?":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":3,"users":3},"ST0317 Can you learn?":{"interactions":1,"users":1},"ST0320 Can you think?":{"interactions":1,"users":1},"i1002 Wheel Chair Stroller":{"interactions":3,"users":2},"i1003 Operating Hours":{"interactions":2,"users":1},"i1004 Promotions":{"interactions":8,"users":7},"i1006 Download Mobile App":{"interactions":1,"users":1},"i1009 Leisure":{"interactions":2,"users":2},"i1010 Theme Park":{"interactions":6,"users":4},"i1012 Theme Park":{"interactions":1,"users":1},"i1027 Durian allowed?":{"interactions":1,"users":1},"i1033 Free Wifi":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":51,"users":24},"i1101 Reset Password":{"interactions":10,"users":6},"i1102 Room Lost and Found":{"interactions":2},"i1103 Forgot Email":{"interactions":3,"users":1},"i1104 Contact Number":{"interactions":7,"users":7},"i1105 Hotline Busy":{"interactions":1,"users":1},"i1107 Email":{"interactions":8,"users":8},"i1200 Getting There":{"interactions":1,"users":1},"i1201 Express Bus":{"interactions":1},"i1202 Parking Rates":{"interactions":5,"users":3},"i1204 Parking Map":{"interactions":5,"users":3},"i1214 Valet Parking":{"interactions":4,"users":3},"i2000 Adjoining Room":{"interactions":8,"users":7},"i2003 Room Late Check Out":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":8,"users":6},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2006 Room Check In Age":{"interactions":2,"users":2},"i2017 Room Size":{"interactions":1,"users":1},"i2024 First World Bed Type":{"interactions":2,"users":2},"i2100 Stock Price":{"interactions":63,"users":44},"i2101 Complimentary Room Request":{"interactions":20,"users":18},"i2102 Stock Selling":{"interactions":14,"users":9},"i2103 Stock Buying":{"interactions":14,"users":9},"i2104 Room Reservation Full":{"interactions":5,"users":5},"i2105 Early Check In":{"interactions":19,"users":11},"i2106 Check In On Behalf":{"interactions":6,"users":5},"i2107 Multiroom Booking":{"interactions":10,"users":6},"i2108 Room Upgrade Request":{"interactions":1,"users":1},"i2109 Transfer Room Booking":{"interactions":4,"users":4},"i2110 Change Booking Date":{"interactions":2,"users":2},"i2111 Help Reserve A Room":{"interactions":5,"users":5},"i2113 Room Wheelchair Friendly":{"interactions":1,"users":1},"i2114 Room Complimentary Birthday":{"interactions":14,"users":11},"i2115 Stock FAQ":{"interactions":45,"users":28},"i2116 Room Complimentary Give Away":{"interactions":1,"users":1},"i2117 Room Complimentary Dynamic Stay":{"interactions":1,"users":1},"i2118 Room Complimentary How to know free room":{"interactions":1,"users":1},"i2121 OTT Booking":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":1,"users":1},"i2126 Family Room Reservations":{"interactions":3,"users":3},"i2127 Book Hour Use":{"interactions":1,"users":1},"i2130 Room Invoice":{"interactions":2,"users":1},"i2133 Book Room Using Membership":{"interactions":12,"users":11},"i2134 Book Room Using - Video":{"interactions":11,"users":10},"i2135 Book Room Using - Image":{"interactions":2,"users":2},"i2136 Did Not Receive Booking Confirmation":{"interactions":1,"users":1},"i2200 Make Payment For Booking":{"interactions":1,"users":1},"i2205 Third Party Sites Booking":{"interactions":2,"users":1},"i2301 Cannot Log In":{"interactions":6,"users":4},"i2302 Retrieve Membership ID":{"interactions":12,"users":10},"i2303 Lost Card":{"interactions":7,"users":7},"i2306 Tier Points":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":4,"users":2},"i2315 Update Membership Details":{"interactions":3,"users":3},"i2319 Member Renew Membership":{"interactions":3,"users":2},"i2320 Check Points":{"interactions":1,"users":1},"i3200 Concert Collect Tickets":{"interactions":2,"users":2},"i3201 Concert Collect On Behalf":{"interactions":2,"users":1},"i3202 Concert Transfer Ticket":{"interactions":1,"users":1},"i3203 Concert Refund Ticket":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":2,"users":2},"i3206 Concert Kids Ticket":{"interactions":1,"users":1},"i3207 Concert Package":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":3,"users":3},"i3300 Theme Park Attractions":{"interactions":4,"users":3},"i3301 Fees For Adults":{"interactions":1,"users":1},"i3304 Product Price":{"interactions":1,"users":1},"i3306 Where is Box Office":{"interactions":1,"users":1},"i3307 Where is toilet":{"interactions":2,"users":1},"i3308 Where is the indoor themepark?":{"interactions":1,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":2,"users":2},"i3316 Wedding Plans":{"interactions":1,"users":1},"i3318 Itinerary Advisor":{"interactions":2,"users":1},"i3327 Salary Claims":{"interactions":1,"users":1},"i3400 Dining":{"interactions":3,"users":2},"i3403 Interest Gained":{"interactions":1,"users":1}},"totals":{"interactions":{"total":779},"users":{"total":131}}},"20190803":{"topics":{"Default Fallback Intent":{"interactions":32,"users":21},"Default Welcome Intent":{"interactions":84,"users":64},"Room-FreeRoom":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":7,"users":6},"ST0058 Can you help me?":{"interactions":1,"users":1},"ST0074 Talk to me":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":1,"users":1},"ST0117 Cancel":{"interactions":3,"users":1},"ST0300 Good morning":{"interactions":1,"users":1},"ST0310 Do you have a mother?":{"interactions":1,"users":1},"ST0312 Do you have children?":{"interactions":1,"users":1},"i1002 Wheel Chair Stroller":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":4,"users":3},"i1010 Theme Park":{"interactions":2,"users":1},"i1024 Best Time to Visit":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":11,"users":10},"i1101 Reset Password":{"interactions":3,"users":1},"i1104 Contact Number":{"interactions":1,"users":1},"i1200 Getting There":{"interactions":3,"users":2},"i1201 Express Bus":{"interactions":1,"users":1},"i1202 Parking Rates":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":3,"users":3},"i2004 Room Check In Time":{"interactions":3,"users":3},"i2006 Room Check In Age":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":24,"users":20},"i2101 Complimentary Room Request":{"interactions":7,"users":6},"i2102 Stock Selling":{"interactions":7,"users":6},"i2103 Stock Buying":{"interactions":7,"users":5},"i2104 Room Reservation Full":{"interactions":2,"users":2},"i2105 Early Check In":{"interactions":5,"users":4},"i2106 Check In On Behalf":{"interactions":1,"users":1},"i2108 Room Upgrade Request":{"interactions":3,"users":3},"i2109 Transfer Room Booking":{"interactions":4,"users":4},"i2112 Room Cancellation Special Reason":{"interactions":1,"users":1},"i2114 Room Complimentary Birthday":{"interactions":5,"users":3},"i2115 Stock FAQ":{"interactions":14,"users":11},"i2117 Room Complimentary Dynamic Stay":{"interactions":1,"users":1},"i2120 OTA Points Redemption":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":1,"users":1},"i2126 Family Room Reservations":{"interactions":1,"users":1},"i2127 Book Hour Use":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":8,"users":7},"i2134 Book Room Using - Video":{"interactions":8,"users":7},"i2135 Book Room Using - Image":{"interactions":3,"users":3},"i2136 Did Not Receive Booking Confirmation":{"interactions":1,"users":1},"i2205 Third Party Sites Booking":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":5,"users":4},"i2302 Retrieve Membership ID":{"interactions":4,"users":3},"i2305 Earn Points":{"interactions":3,"users":1},"i2307 Activate Membership":{"interactions":1,"users":1},"i2310 Apply for Membership":{"interactions":3,"users":3},"i2313 Number of Supplimentary Card":{"interactions":2,"users":2},"i2319 Member Renew Membership":{"interactions":1,"users":1},"i2320 Check Points":{"interactions":2,"users":2},"i3103 Sign Up Minimum Age":{"interactions":2,"users":1},"i3200 Concert Collect Tickets":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":2,"users":1},"i3300 Theme Park Attractions":{"interactions":1},"i3307 Where is toilet":{"interactions":2,"users":1}},"totals":{"interactions":{"total":303},"users":{"total":68}}},"20190804":{"topics":{"Default Fallback Intent":{"interactions":43,"users":33},"Default Welcome Intent":{"interactions":99,"users":76},"ST0001 Thank You":{"interactions":4,"users":4},"ST0003 Ignore Replies":{"interactions":11,"users":10},"ST0052 Chatbot Wrong Answer":{"interactions":1,"users":1},"ST0086 Nice to see you!":{"interactions":1,"users":1},"ST0117 Cancel":{"interactions":2,"users":2},"ST0312 Do you have children?":{"interactions":1,"users":1},"i1002 Wheel Chair Stroller":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":4,"users":4},"i1010 Theme Park":{"interactions":4,"users":2},"i1100 General Complaint":{"interactions":26,"users":22},"i1101 Reset Password":{"interactions":1,"users":1},"i1102 Room Lost and Found":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":5,"users":3},"i1200 Getting There":{"interactions":3,"users":3},"i1201 Express Bus":{"interactions":7,"users":4},"i1202 Parking Rates":{"interactions":1,"users":1},"i1203  Bus Terminal":{"interactions":7,"users":4},"i1205 Free Parking":{"interactions":1,"users":1},"i1207 Free Shuttle Bus":{"interactions":4,"users":3},"i1222 Shuttle Bus Schedule":{"interactions":1,"users":1},"i2003 Room Late Check Out":{"interactions":4,"users":2},"i2004 Room Check In Time":{"interactions":2,"users":2},"i2005 Room Check Out Time":{"interactions":4,"users":3},"i2012 Resort World Sentosa":{"interactions":1,"users":1},"i2024 First World Bed Type":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":27,"users":19},"i2101 Complimentary Room Request":{"interactions":8,"users":8},"i2102 Stock Selling":{"interactions":8,"users":6},"i2103 Stock Buying":{"interactions":4,"users":3},"i2105 Early Check In":{"interactions":4,"users":4},"i2106 Check In On Behalf":{"interactions":2,"users":2},"i2107 Multiroom Booking":{"interactions":2,"users":1},"i2108 Room Upgrade Request":{"interactions":1,"users":1},"i2109 Transfer Room Booking":{"interactions":4,"users":3},"i2110 Change Booking Date":{"interactions":4,"users":3},"i2111 Help Reserve A Room":{"interactions":1,"users":1},"i2114 Room Complimentary Birthday":{"interactions":6,"users":5},"i2115 Stock FAQ":{"interactions":14,"users":9},"i2117 Room Complimentary Dynamic Stay":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":1,"users":1},"i2125 Room Reservation Cancel Comp Room":{"interactions":1,"users":1},"i2129 Room Reservation Under Different Category":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":5,"users":5},"i2134 Book Room Using - Video":{"interactions":8,"users":6},"i2301 Cannot Log In":{"interactions":6,"users":4},"i2302 Retrieve Membership ID":{"interactions":10,"users":5},"i2303 Lost Card":{"interactions":3,"users":3},"i2309 Membership Benefits":{"interactions":1,"users":1},"i2314 Tier Points Expiry":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":1,"users":1},"i3200 Concert Collect Tickets":{"interactions":2,"users":1},"i3205 Concert Where to Buy":{"interactions":1,"users":1},"i3206 Concert Kids Ticket":{"interactions":2,"users":2},"i3300 Theme Park Attractions":{"interactions":5,"users":4},"i3304 Product Price":{"interactions":3,"users":1},"i3306 Where is Box Office":{"interactions":1,"users":1},"i3307 Where is toilet":{"interactions":2,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":4,"users":3},"i3321 Entrance Price":{"interactions":1,"users":1},"i3323 Child Rates":{"interactions":2,"users":1},"i3400 Dining":{"interactions":1,"users":1}},"totals":{"interactions":{"total":388},"users":{"total":84}}},"20190805":{"topics":{"Default Fallback Intent":{"interactions":94,"users":55},"Default Welcome Intent":{"interactions":163,"users":115},"Room-FreeRoom":{"interactions":1,"users":1},"ST0001 Thank You":{"interactions":5,"users":5},"ST0002 Are You Human":{"interactions":2,"users":2},"ST0003 Ignore Replies":{"interactions":14,"users":12},"ST0052 Chatbot Wrong Answer":{"interactions":1,"users":1},"ST0058 Can you help me?":{"interactions":6,"users":6},"ST0074 Talk to me":{"interactions":6,"users":5},"ST0111 I'm waiting":{"interactions":1,"users":1},"ST0112 I'd like to see you again":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":2,"users":2},"ST0116 No":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":4,"users":4},"ST0301 Good afternoon":{"interactions":1,"users":1},"ST0302 Good evening":{"interactions":1,"users":1},"ST0316 Can you hear me?":{"interactions":1,"users":1},"ST0339 Have a nice day!":{"interactions":2,"users":2},"i1001 About Us":{"interactions":1,"users":1},"i1002 Wheel Chair Stroller":{"interactions":4,"users":2},"i1003 Operating Hours":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":7,"users":6},"i1006 Download Mobile App":{"interactions":2,"users":2},"i1009 Leisure":{"interactions":2,"users":1},"i1010 Theme Park":{"interactions":3,"users":2},"i1024 Best Time to Visit":{"interactions":1,"users":1},"i1036 Luggage Storage":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":69,"users":29},"i1101 Reset Password":{"interactions":3,"users":2},"i1102 Room Lost and Found":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":6,"users":6},"i1105 Hotline Busy":{"interactions":1,"users":1},"i1107 Email":{"interactions":4,"users":4},"i1200 Getting There":{"interactions":3,"users":3},"i1205 Free Parking":{"interactions":1,"users":1},"i1216 Travel Duration":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":12,"users":10},"i2001 Extra Bed":{"interactions":3,"users":2},"i2003 Room Late Check Out":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":5,"users":3},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2006 Room Check In Age":{"interactions":6,"users":5},"i2015 Room Breakfast":{"interactions":1,"users":1},"i2021 Hotel Breakfast Starting":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":47,"users":38},"i2101 Complimentary Room Request":{"interactions":18,"users":15},"i2102 Stock Selling":{"interactions":13,"users":11},"i2103 Stock Buying":{"interactions":11,"users":9},"i2104 Room Reservation Full":{"interactions":3,"users":2},"i2105 Early Check In":{"interactions":5,"users":3},"i2106 Check In On Behalf":{"interactions":5,"users":5},"i2107 Multiroom Booking":{"interactions":6,"users":5},"i2108 Room Upgrade Request":{"interactions":5,"users":4},"i2109 Transfer Room Booking":{"interactions":9,"users":8},"i2110 Change Booking Date":{"interactions":4,"users":2},"i2111 Help Reserve A Room":{"interactions":3,"users":3},"i2113 Room Wheelchair Friendly":{"interactions":2,"users":2},"i2114 Room Complimentary Birthday":{"interactions":10,"users":10},"i2115 Stock FAQ":{"interactions":34,"users":24},"i2119 Room Reservation Combine Nights":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":4,"users":4},"i2126 Family Room Reservations":{"interactions":2,"users":2},"i2133 Book Room Using Membership":{"interactions":14,"users":12},"i2134 Book Room Using - Video":{"interactions":6,"users":6},"i2135 Book Room Using - Image":{"interactions":1,"users":1},"i2136 Did Not Receive Booking Confirmation":{"interactions":1,"users":1},"i2200 Make Payment For Booking":{"interactions":4,"users":2},"i2205 Third Party Sites Booking":{"interactions":4,"users":3},"i2301 Cannot Log In":{"interactions":7,"users":6},"i2302 Retrieve Membership ID":{"interactions":20,"users":9},"i2303 Lost Card":{"interactions":3,"users":2},"i2306 Tier Points":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":3,"users":2},"i2315 Update Membership Details":{"interactions":5,"users":5},"i2320 Check Points":{"interactions":1,"users":1},"i3101 Theme Park Dress Code":{"interactions":1,"users":1},"i3103 Sign Up Minimum Age":{"interactions":1,"users":1},"i3200 Concert Collect Tickets":{"interactions":3,"users":2},"i3205 Concert Where to Buy":{"interactions":2,"users":2},"i3206 Concert Kids Ticket":{"interactions":1,"users":1},"i3207 Concert Package":{"interactions":1,"users":1},"i3209 Concert Complimentary Ticket":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":4,"users":4},"i3300 Theme Park Attractions":{"interactions":2,"users":2},"i3301 Fees For Adults":{"interactions":1,"users":1},"i3304 Product Price":{"interactions":1,"users":1},"i3307 Where is toilet":{"interactions":3,"users":2},"i3314 Theme Park Ticket Purchase":{"interactions":4,"users":4},"i3318 Itinerary Advisor":{"interactions":1,"users":1},"i3323 Child Rates":{"interactions":2,"users":1},"i3326 Salary Deduction":{"interactions":1,"users":1},"i3400 Dining":{"interactions":1,"users":1},"i3401 Salary Payment":{"interactions":1,"users":1},"i3403 Interest Gained":{"interactions":3,"users":1}},"totals":{"interactions":{"total":733},"users":{"total":125}}},"20190806":{"topics":{"Default Fallback Intent":{"interactions":71,"users":38},"Default Welcome Intent":{"interactions":116,"users":88},"ST0001 Thank You":{"interactions":3,"users":3},"ST0002 Are You Human":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":26,"users":14},"ST0052 Chatbot Wrong Answer":{"interactions":2,"users":2},"ST0058 Can you help me?":{"interactions":7,"users":3},"ST0098 Today is my birthday":{"interactions":1,"users":1},"ST0111 I'm waiting":{"interactions":2,"users":1},"ST0115 Yes":{"interactions":7,"users":5},"ST0300 Good morning":{"interactions":4,"users":4},"ST0301 Good afternoon":{"interactions":1,"users":1},"ST0328 I like you":{"interactions":2,"users":2},"ST0338 I'm bored":{"interactions":1,"users":1},"ST0342 i need help in buying":{"interactions":2,"users":1},"i1002 Wheel Chair Stroller":{"interactions":1},"i1003 Operating Hours":{"interactions":3,"users":2},"i1004 Promotions":{"interactions":4,"users":4},"i1006 Download Mobile App":{"interactions":5,"users":3},"i1010 Theme Park":{"interactions":4,"users":3},"i1015 Childcare Center":{"interactions":1,"users":1},"i1038 Baby Changing Room":{"interactions":1,"users":1},"i1045 Baby Cot":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":39,"users":19},"i1101 Reset Password":{"interactions":6,"users":4},"i1104 Contact Number":{"interactions":3,"users":3},"i1107 Email":{"interactions":10,"users":6},"i1200 Getting There":{"interactions":4,"users":3},"i1201 Express Bus":{"interactions":6,"users":3},"i1203  Bus Terminal":{"interactions":3,"users":3},"i1206 Getting There KLIA":{"interactions":2,"users":2},"i1207 Free Shuttle Bus":{"interactions":3,"users":2},"i1212 Where is  Hotel":{"interactions":1,"users":1},"i1216 Travel Duration":{"interactions":2,"users":2},"i1222 Shuttle Bus Schedule":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":5,"users":5},"i2001 Extra Bed":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":3,"users":3},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2020 Room Special Request":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":36,"users":31},"i2101 Complimentary Room Request":{"interactions":8,"users":7},"i2102 Stock Selling":{"interactions":16,"users":13},"i2103 Stock Buying":{"interactions":5,"users":5},"i2104 Room Reservation Full":{"interactions":4,"users":3},"i2105 Early Check In":{"interactions":9,"users":7},"i2106 Check In On Behalf":{"interactions":3,"users":3},"i2107 Multiroom Booking":{"interactions":3,"users":2},"i2109 Transfer Room Booking":{"interactions":5,"users":5},"i2110 Change Booking Date":{"interactions":3,"users":2},"i2111 Help Reserve A Room":{"interactions":3,"users":3},"i2114 Room Complimentary Birthday":{"interactions":6,"users":5},"i2115 Stock FAQ":{"interactions":28,"users":23},"i2118 Room Complimentary How to know free room":{"interactions":2,"users":1},"i2122 Room Amenities":{"interactions":2,"users":2},"i2126 Family Room Reservations":{"interactions":1,"users":1},"i2132 Foreigner Passport Number":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":6,"users":5},"i2134 Book Room Using - Video":{"interactions":1},"i2135 Book Room Using - Image":{"interactions":3,"users":2},"i2136 Did Not Receive Booking Confirmation":{"interactions":1,"users":1},"i2205 Third Party Sites Booking":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":11,"users":6},"i2302 Retrieve Membership ID":{"interactions":11,"users":6},"i2303 Lost Card":{"interactions":5,"users":5},"i2310 Apply for Membership":{"interactions":1,"users":1},"i2312 Number of Member Card Can Apply":{"interactions":2,"users":1},"i2315 Update Membership Details":{"interactions":4,"users":3},"i2318 Reward Alliance Website":{"interactions":1,"users":1},"i2319 Member Renew Membership":{"interactions":2,"users":1},"i3100 Where Is SkyTheme Park":{"interactions":1,"users":1},"i3200 Concert Collect Tickets":{"interactions":1,"users":1},"i3201 Concert Collect On Behalf":{"interactions":2,"users":1},"i3202 Concert Transfer Ticket":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":1,"users":1},"i3206 Concert Kids Ticket":{"interactions":2,"users":1},"i3210 Concert Event Info":{"interactions":3,"users":2},"i3300 Theme Park Attractions":{"interactions":1,"users":1},"i3304 Product Price":{"interactions":5,"users":3},"i3306 Where is Box Office":{"interactions":1,"users":1},"i3307 Where is toilet":{"interactions":1,"users":1},"i3308 Where is the indoor themepark?":{"interactions":1,"users":1},"i3311 Where to Shop":{"interactions":1,"users":1},"i3313 Branch Operating Hours":{"interactions":3,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":3,"users":2},"i3322 Golf Booking":{"interactions":1,"users":1},"i3323 Child Rates":{"interactions":2,"users":1},"i3400 Dining":{"interactions":4,"users":3},"i3401 Salary Payment":{"interactions":1,"users":1},"i3405 Restaurant Reservation":{"interactions":2,"users":1}},"totals":{"interactions":{"total":578},"users":{"total":98}}},"20190807":{"topics":{"Default Fallback Intent":{"interactions":75,"users":39},"Default Welcome Intent":{"interactions":135,"users":99},"ST0001 Thank You":{"interactions":3,"users":3},"ST0003 Ignore Replies":{"interactions":10,"users":5},"ST0058 Can you help me?":{"interactions":2,"users":2},"ST0115 Yes":{"interactions":2,"users":2},"ST0123 You're wrong":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":2,"users":1},"ST0302 Good evening":{"interactions":1,"users":1},"ST0303 Good nite":{"interactions":1,"users":1},"ST0316 Can you hear me?":{"interactions":1,"users":1},"ST0320 Can you think?":{"interactions":1,"users":1},"i1001 About Us":{"interactions":1,"users":1},"i1002 Wheel Chair Stroller":{"interactions":7,"users":3},"i1004 Promotions":{"interactions":4,"users":3},"i1006 Download Mobile App":{"interactions":1,"users":1},"i1007 Map":{"interactions":1,"users":1},"i1009 Leisure":{"interactions":1,"users":1},"i1010 Theme Park":{"interactions":2,"users":2},"i1034 Fitness Center":{"interactions":3,"users":2},"i1044 Job Opening":{"interactions":2,"users":1},"i1100 General Complaint":{"interactions":40,"users":21},"i1101 Reset Password":{"interactions":2,"users":2},"i1102 Room Lost and Found":{"interactions":3,"users":1},"i1103 Forgot Email":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":6,"users":5},"i1107 Email":{"interactions":3,"users":2},"i1200 Getting There":{"interactions":2,"users":2},"i1201 Express Bus":{"interactions":2,"users":1},"i1202 Parking Rates":{"interactions":1,"users":1},"i1204 Parking Map":{"interactions":1,"users":1},"i1214 Valet Parking":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":5,"users":5},"i2003 Room Late Check Out":{"interactions":2,"users":2},"i2004 Room Check In Time":{"interactions":8,"users":7},"i2005 Room Check Out Time":{"interactions":3,"users":3},"i2016 Non Smoking Room":{"interactions":1,"users":1},"i2018 Using Hotel SPA":{"interactions":3,"users":1},"i2024 First World Bed Type":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":40,"users":32},"i2101 Complimentary Room Request":{"interactions":6,"users":6},"i2102 Stock Selling":{"interactions":15,"users":14},"i2103 Stock Buying":{"interactions":12,"users":9},"i2104 Room Reservation Full":{"interactions":2,"users":2},"i2105 Early Check In":{"interactions":13,"users":9},"i2106 Check In On Behalf":{"interactions":3,"users":3},"i2107 Multiroom Booking":{"interactions":1},"i2108 Room Upgrade Request":{"interactions":2,"users":2},"i2109 Transfer Room Booking":{"interactions":5,"users":5},"i2110 Change Booking Date":{"interactions":2,"users":2},"i2111 Help Reserve A Room":{"interactions":2,"users":2},"i2113 Room Wheelchair Friendly":{"interactions":1,"users":1},"i2114 Room Complimentary Birthday":{"interactions":7,"users":7},"i2115 Stock FAQ":{"interactions":41,"users":26},"i2118 Room Complimentary How to know free room":{"interactions":1,"users":1},"i2119 Room Reservation Combine Nights":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":4,"users":4},"i2126 Family Room Reservations":{"interactions":1,"users":1},"i2129 Room Reservation Under Different Category":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":7,"users":5},"i2134 Book Room Using - Video":{"interactions":6,"users":6},"i2135 Book Room Using - Image":{"interactions":3,"users":3},"i2136 Did Not Receive Booking Confirmation":{"interactions":3,"users":3},"i2204 Sales Office":{"interactions":1,"users":1},"i2206 Third Party Vouchers":{"interactions":4,"users":3},"i2301 Cannot Log In":{"interactions":7,"users":3},"i2302 Retrieve Membership ID":{"interactions":10,"users":5},"i2303 Lost Card":{"interactions":3,"users":3},"i2306 Tier Points":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":1,"users":1},"i2309 Membership Benefits":{"interactions":4,"users":3},"i2310 Apply for Membership":{"interactions":4,"users":3},"i2311 Under 18 Join Membership":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":3,"users":3},"i2317 Member Card Lost and Found":{"interactions":1,"users":1},"i2320 Check Points":{"interactions":3,"users":2},"i3103 Sign Up Minimum Age":{"interactions":2,"users":1},"i3200 Concert Collect Tickets":{"interactions":3,"users":2},"i3202 Concert Transfer Ticket":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":3,"users":2},"i3210 Concert Event Info":{"interactions":4,"users":3},"i3300 Theme Park Attractions":{"interactions":3,"users":2},"i3303 Operating Hours":{"interactions":2,"users":2},"i3306 Where is Box Office":{"interactions":1,"users":1},"i3307 Where is toilet":{"interactions":2,"users":1},"i3308 Where is the indoor themepark?":{"interactions":1,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":1,"users":1},"i3318 Itinerary Advisor":{"interactions":2,"users":1},"i3321 Entrance Price":{"interactions":2,"users":2},"i3326 Salary Deduction":{"interactions":1,"users":1},"i3400 Dining":{"interactions":3,"users":2}},"totals":{"interactions":{"total":594},"users":{"total":107}}},"20190808":{"topics":{"Default Fallback Intent":{"interactions":65,"users":38},"Default Welcome Intent":{"interactions":106,"users":83},"ST0001 Thank You":{"interactions":5,"users":5},"ST0002 Are You Human":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":14,"users":11},"ST0052 Chatbot Wrong Answer":{"interactions":2,"users":2},"ST0058 Can you help me?":{"interactions":6,"users":3},"ST0103 What do I look like?":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":6,"users":3},"ST0300 Good morning":{"interactions":3,"users":2},"ST0319 Can you talk to me":{"interactions":1,"users":1},"ST0329 I want to talk with you":{"interactions":1,"users":1},"ST0800 Profanity 1":{"interactions":2,"users":1},"ST700 Emoji Happy":{"interactions":2,"users":1},"i1002 Wheel Chair Stroller":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":10,"users":7},"i1006 Download Mobile App":{"interactions":5,"users":5},"i1009 Leisure":{"interactions":1,"users":1},"i1010 Theme Park":{"interactions":8,"users":7},"i1027 Durian allowed?":{"interactions":2,"users":1},"i1036 Luggage Storage":{"interactions":2,"users":2},"i1044 Job Opening":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":36,"users":18},"i1101 Reset Password":{"interactions":3,"users":2},"i1102 Room Lost and Found":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":3,"users":3},"i1105 Hotline Busy":{"interactions":1,"users":1},"i1107 Email":{"interactions":2,"users":2},"i1200 Getting There":{"interactions":7,"users":6},"i1201 Express Bus":{"interactions":5,"users":3},"i1203  Bus Terminal":{"interactions":3,"users":2},"i1207 Free Shuttle Bus":{"interactions":2,"users":2},"i1220 Parking Lot Issue":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":5,"users":4},"i2001 Extra Bed":{"interactions":2,"users":1},"i2004 Room Check In Time":{"interactions":4,"users":2},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2016 Non Smoking Room":{"interactions":1,"users":1},"i2017 Room Size":{"interactions":1,"users":1},"i2024 First World Bed Type":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":38,"users":28},"i2101 Complimentary Room Request":{"interactions":16,"users":13},"i2102 Stock Selling":{"interactions":7,"users":6},"i2103 Stock Buying":{"interactions":11,"users":11},"i2104 Room Reservation Full":{"interactions":3,"users":3},"i2105 Early Check In":{"interactions":11,"users":4},"i2106 Check In On Behalf":{"interactions":7,"users":5},"i2107 Multiroom Booking":{"interactions":1,"users":1},"i2108 Room Upgrade Request":{"interactions":2,"users":2},"i2109 Transfer Room Booking":{"interactions":2,"users":2},"i2110 Change Booking Date":{"interactions":6,"users":4},"i2111 Help Reserve A Room":{"interactions":6,"users":5},"i2114 Room Complimentary Birthday":{"interactions":11,"users":10},"i2115 Stock FAQ":{"interactions":37,"users":21},"i2118 Room Complimentary How to know free room":{"interactions":3,"users":3},"i2122 Room Amenities":{"interactions":1,"users":1},"i2126 Family Room Reservations":{"interactions":1,"users":1},"i2131 Maximum People in Room":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":25,"users":9},"i2134 Book Room Using - Video":{"interactions":7,"users":7},"i2135 Book Room Using - Image":{"interactions":3,"users":3},"i2205 Third Party Sites Booking":{"interactions":3,"users":2},"i2206 Third Party Vouchers":{"interactions":8,"users":5},"i2301 Cannot Log In":{"interactions":5,"users":4},"i2302 Retrieve Membership ID":{"interactions":2,"users":2},"i2303 Lost Card":{"interactions":6,"users":4},"i2306 Tier Points":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":7,"users":3},"i2309 Membership Benefits":{"interactions":1,"users":1},"i2310 Apply for Membership":{"interactions":1,"users":1},"i2312 Number of Member Card Can Apply":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":4,"users":3},"i2317 Member Card Lost and Found":{"interactions":2,"users":1},"i2320 Check Points":{"interactions":2,"users":2},"i3200 Concert Collect Tickets":{"interactions":6,"users":4},"i3202 Concert Transfer Ticket":{"interactions":1,"users":1},"i3203 Concert Refund Ticket":{"interactions":1,"users":1},"i3204 Concert Lost Ticket":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":1,"users":1},"i3206 Concert Kids Ticket":{"interactions":1,"users":1},"i3208 Concert Sold Out":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":4,"users":2},"i3212 Concert Preferred Seats":{"interactions":3,"users":2},"i3300 Theme Park Attractions":{"interactions":3,"users":3},"i3303 Operating Hours":{"interactions":1,"users":1},"i3304 Product Price":{"interactions":1,"users":1},"i3306 Where is Box Office":{"interactions":3,"users":3},"i3308 Where is the indoor themepark?":{"interactions":2,"users":1},"i3310 Shopping Directory":{"interactions":1,"users":1},"i3311 Where to Shop":{"interactions":1,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":4,"users":4},"i3318 Itinerary Advisor":{"interactions":1},"i3327 Salary Claims":{"interactions":1,"users":1},"i3400 Dining":{"interactions":2,"users":2}},"totals":{"interactions":{"total":605},"users":{"total":96}}},"20190809":{"topics":{"Default Fallback Intent":{"interactions":58,"users":31},"Default Welcome Intent":{"interactions":74,"users":57},"ST0001 Thank You":{"interactions":3,"users":3},"ST0002 Are You Human":{"interactions":3,"users":2},"ST0003 Ignore Replies":{"interactions":12,"users":11},"ST0058 Can you help me?":{"interactions":6,"users":5},"ST0074 Talk to me":{"interactions":2,"users":2},"ST0115 Yes":{"interactions":2,"users":2},"ST0122 What do you mean?":{"interactions":1,"users":1},"ST0301 Good afternoon":{"interactions":1,"users":1},"ST0328 I like you":{"interactions":1,"users":1},"ST0337 What language do you speak?":{"interactions":1,"users":1},"i1001 About Us":{"interactions":1,"users":1},"i1002 Wheel Chair Stroller":{"interactions":3,"users":1},"i1004 Promotions":{"interactions":4,"users":3},"i1006 Download Mobile App":{"interactions":1},"i1010 Theme Park":{"interactions":7,"users":4},"i1012 Theme Park":{"interactions":2,"users":2},"i1100 General Complaint":{"interactions":32,"users":15},"i1104 Contact Number":{"interactions":2,"users":2},"i1107 Email":{"interactions":5,"users":4},"i1201 Express Bus":{"interactions":4,"users":1},"i1203  Bus Terminal":{"interactions":3,"users":1},"i1206 Getting There KLIA":{"interactions":1,"users":1},"i1207 Free Shuttle Bus":{"interactions":1,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":2,"users":1},"i2004 Room Check In Time":{"interactions":3,"users":3},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2006 Room Check In Age":{"interactions":1,"users":1},"i2012 Resort World Sentosa":{"interactions":1,"users":1},"i2015 Room Breakfast":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":19,"users":17},"i2101 Complimentary Room Request":{"interactions":13,"users":11},"i2102 Stock Selling":{"interactions":8,"users":7},"i2103 Stock Buying":{"interactions":11,"users":9},"i2104 Room Reservation Full":{"interactions":4,"users":4},"i2105 Early Check In":{"interactions":4,"users":3},"i2106 Check In On Behalf":{"interactions":3,"users":3},"i2109 Transfer Room Booking":{"interactions":5,"users":5},"i2110 Change Booking Date":{"interactions":5,"users":4},"i2111 Help Reserve A Room":{"interactions":2,"users":2},"i2113 Room Wheelchair Friendly":{"interactions":1,"users":1},"i2114 Room Complimentary Birthday":{"interactions":8,"users":8},"i2115 Stock FAQ":{"interactions":30,"users":19},"i2117 Room Complimentary Dynamic Stay":{"interactions":2,"users":2},"i2122 Room Amenities":{"interactions":2,"users":1},"i2133 Book Room Using Membership":{"interactions":7,"users":6},"i2134 Book Room Using - Video":{"interactions":11,"users":10},"i2135 Book Room Using - Image":{"interactions":1,"users":1},"i2200 Make Payment For Booking":{"interactions":1,"users":1},"i2205 Third Party Sites Booking":{"interactions":1,"users":1},"i2206 Third Party Vouchers":{"interactions":3,"users":1},"i2301 Cannot Log In":{"interactions":3,"users":3},"i2302 Retrieve Membership ID":{"interactions":5,"users":5},"i2306 Tier Points":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":4,"users":4},"i2315 Update Membership Details":{"interactions":2,"users":2},"i2319 Member Renew Membership":{"interactions":2,"users":2},"i3200 Concert Collect Tickets":{"interactions":3,"users":2},"i3205 Concert Where to Buy":{"interactions":3,"users":3},"i3207 Concert Package":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":2,"users":2},"i3212 Concert Preferred Seats":{"interactions":3,"users":1},"i3306 Where is Box Office":{"interactions":1,"users":1},"i3307 Where is toilet":{"interactions":3,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":1,"users":1},"i3321 Entrance Price":{"interactions":1,"users":1},"i3323 Child Rates":{"interactions":2,"users":1},"i3400 Dining":{"interactions":3,"users":2}},"totals":{"interactions":{"total":421},"users":{"total":69}}},"20190810":{"topics":{"Default Fallback Intent":{"interactions":47,"users":19},"Default Welcome Intent":{"interactions":51,"users":42},"ST0001 Thank You":{"interactions":1},"ST0003 Ignore Replies":{"interactions":12,"users":8},"ST0052 Chatbot Wrong Answer":{"interactions":3,"users":3},"ST0074 Talk to me":{"interactions":2,"users":1},"ST0336 What are you wearing?":{"interactions":1,"users":1},"ST0337 What language do you speak?":{"interactions":2,"users":1},"i1001 About Us":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":3,"users":2},"i1006 Download Mobile App":{"interactions":1,"users":1},"i1009 Leisure":{"interactions":1,"users":1},"i1010 Theme Park":{"interactions":2,"users":2},"i1012 Theme Park":{"interactions":2,"users":2},"i1100 General Complaint":{"interactions":7,"users":5},"i1102 Room Lost and Found":{"interactions":3,"users":3},"i1104 Contact Number":{"interactions":1,"users":1},"i1200 Getting There":{"interactions":1,"users":1},"i1201 Express Bus":{"interactions":3,"users":2},"i1202 Parking Rates":{"interactions":1,"users":1},"i1203  Bus Terminal":{"interactions":1,"users":1},"i1204 Parking Map":{"interactions":1,"users":1},"i1205 Free Parking":{"interactions":2,"users":1},"i1214 Valet Parking":{"interactions":2,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":4,"users":2},"i2001 Extra Bed":{"interactions":2,"users":1},"i2003 Room Late Check Out":{"interactions":1,"users":1},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2006 Room Check In Age":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":9,"users":6},"i2101 Complimentary Room Request":{"interactions":3,"users":1},"i2102 Stock Selling":{"interactions":5,"users":3},"i2103 Stock Buying":{"interactions":4,"users":3},"i2104 Room Reservation Full":{"interactions":1,"users":1},"i2105 Early Check In":{"interactions":1,"users":1},"i2106 Check In On Behalf":{"interactions":2,"users":2},"i2108 Room Upgrade Request":{"interactions":2,"users":2},"i2109 Transfer Room Booking":{"interactions":1,"users":1},"i2110 Change Booking Date":{"interactions":1,"users":1},"i2111 Help Reserve A Room":{"interactions":1,"users":1},"i2114 Room Complimentary Birthday":{"interactions":7,"users":1},"i2115 Stock FAQ":{"interactions":9,"users":6},"i2118 Room Complimentary How to know free room":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":1,"users":1},"i2126 Family Room Reservations":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":3,"users":2},"i2134 Book Room Using - Video":{"interactions":1,"users":1},"i2135 Book Room Using - Image":{"interactions":1,"users":1},"i2200 Make Payment For Booking":{"interactions":1,"users":1},"i2206 Third Party Vouchers":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":1,"users":1},"i2302 Retrieve Membership ID":{"interactions":2,"users":2},"i2303 Lost Card":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":2,"users":2},"i2309 Membership Benefits":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":6,"users":5},"i3101 Theme Park Dress Code":{"interactions":2,"users":2},"i3103 Sign Up Minimum Age":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":1,"users":1},"i3207 Concert Package":{"interactions":2,"users":1},"i3210 Concert Event Info":{"interactions":1,"users":1},"i3300 Theme Park Attractions":{"interactions":1,"users":1},"i3304 Product Price":{"interactions":1,"users":1},"i3306 Where is Box Office":{"interactions":3,"users":1},"i3308 Where is the indoor themepark?":{"interactions":2,"users":1},"i3311 Where to Shop":{"interactions":1,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":1,"users":1},"i3321 Entrance Price":{"interactions":4,"users":2},"i3323 Child Rates":{"interactions":1,"users":1},"i3327 Salary Claims":{"interactions":2,"users":2},"i3400 Dining":{"interactions":2,"users":1}},"totals":{"interactions":{"total":255},"users":{"total":47}}},"20190811":{"topics":{"Default Fallback Intent":{"interactions":39,"users":22},"Default Welcome Intent":{"interactions":65,"users":52},"ST0002 Are You Human":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":8,"users":6},"ST0052 Chatbot Wrong Answer":{"interactions":1,"users":1},"ST0058 Can you help me?":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":1},"ST0339 Have a nice day!":{"interactions":1,"users":1},"ST0800 Profanity 1":{"interactions":1,"users":1},"i1006 Download Mobile App":{"interactions":1,"users":1},"i1010 Theme Park":{"interactions":1,"users":1},"i1034 Fitness Center":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":17,"users":12},"i1102 Room Lost and Found":{"interactions":1},"i1103 Forgot Email":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":2,"users":2},"i1202 Parking Rates":{"interactions":2},"i1204 Parking Map":{"interactions":2},"i2004 Room Check In Time":{"interactions":2,"users":2},"i2006 Room Check In Age":{"interactions":2,"users":1},"i2018 Using Hotel SPA":{"interactions":1,"users":1},"i2020 Room Special Request":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":24,"users":19},"i2101 Complimentary Room Request":{"interactions":2,"users":2},"i2102 Stock Selling":{"interactions":3,"users":2},"i2103 Stock Buying":{"interactions":5,"users":2},"i2104 Room Reservation Full":{"interactions":2,"users":1},"i2105 Early Check In":{"interactions":6,"users":4},"i2106 Check In On Behalf":{"interactions":4,"users":3},"i2107 Multiroom Booking":{"interactions":3,"users":3},"i2109 Transfer Room Booking":{"interactions":1,"users":1},"i2111 Help Reserve A Room":{"interactions":3,"users":2},"i2114 Room Complimentary Birthday":{"interactions":5,"users":3},"i2115 Stock FAQ":{"interactions":12,"users":8},"i2117 Room Complimentary Dynamic Stay":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":1,"users":1},"i2126 Family Room Reservations":{"interactions":2,"users":2},"i2129 Room Reservation Under Different Category":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":3,"users":3},"i2134 Book Room Using - Video":{"interactions":6,"users":2},"i2135 Book Room Using - Image":{"interactions":1,"users":1},"i2136 Did Not Receive Booking Confirmation":{"interactions":1,"users":1},"i2200 Make Payment For Booking":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":6,"users":4},"i2308 No Points Added":{"interactions":3,"users":1},"i2310 Apply for Membership":{"interactions":8,"users":3},"i2315 Update Membership Details":{"interactions":1,"users":1},"i2319 Member Renew Membership":{"interactions":2,"users":2},"i2320 Check Points":{"interactions":2,"users":2},"i3300 Theme Park Attractions":{"interactions":1,"users":1},"i3304 Product Price":{"interactions":1,"users":1},"i3307 Where is toilet":{"interactions":2,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":1,"users":1},"i3400 Dining":{"interactions":1,"users":1},"i3403 Interest Gained":{"interactions":1,"users":1}},"totals":{"interactions":{"total":268},"users":{"total":56}}},"20190812":{"topics":{"Default Fallback Intent":{"interactions":42,"users":24},"Default Welcome Intent":{"interactions":83,"users":68},"ST0001 Thank You":{"interactions":3,"users":3},"ST0003 Ignore Replies":{"interactions":9,"users":8},"ST0052 Chatbot Wrong Answer":{"interactions":2,"users":2},"ST0117 Cancel":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":1,"users":1},"i1003 Operating Hours":{"interactions":3,"users":2},"i1004 Promotions":{"interactions":6,"users":5},"i1006 Download Mobile App":{"interactions":2,"users":1},"i1010 Theme Park":{"interactions":3,"users":2},"i1027 Durian allowed?":{"interactions":2,"users":1},"i1044 Job Opening":{"interactions":2,"users":1},"i1100 General Complaint":{"interactions":22,"users":15},"i1101 Reset Password":{"interactions":6,"users":5},"i1103 Forgot Email":{"interactions":2,"users":2},"i1104 Contact Number":{"interactions":2,"users":2},"i1200 Getting There":{"interactions":1,"users":1},"i1216 Travel Duration":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":1,"users":1},"i2003 Room Late Check Out":{"interactions":3,"users":1},"i2004 Room Check In Time":{"interactions":2,"users":2},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":26,"users":22},"i2101 Complimentary Room Request":{"interactions":8,"users":7},"i2102 Stock Selling":{"interactions":6,"users":6},"i2103 Stock Buying":{"interactions":1,"users":1},"i2104 Room Reservation Full":{"interactions":1,"users":1},"i2105 Early Check In":{"interactions":1,"users":1},"i2106 Check In On Behalf":{"interactions":4,"users":3},"i2107 Multiroom Booking":{"interactions":2,"users":1},"i2109 Transfer Room Booking":{"interactions":3,"users":3},"i2110 Change Booking Date":{"interactions":1,"users":1},"i2114 Room Complimentary Birthday":{"interactions":4,"users":4},"i2115 Stock FAQ":{"interactions":8,"users":7},"i2117 Room Complimentary Dynamic Stay":{"interactions":1,"users":1},"i2126 Family Room Reservations":{"interactions":2,"users":1},"i2129 Room Reservation Under Different Category":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":9,"users":9},"i2134 Book Room Using - Video":{"interactions":3,"users":3},"i2135 Book Room Using - Image":{"interactions":3,"users":3},"i2205 Third Party Sites Booking":{"interactions":1,"users":1},"i2206 Third Party Vouchers":{"interactions":2,"users":2},"i2301 Cannot Log In":{"interactions":11,"users":6},"i2302 Retrieve Membership ID":{"interactions":9,"users":7},"i2303 Lost Card":{"interactions":2,"users":2},"i2305 Earn Points":{"interactions":1,"users":1},"i2306 Tier Points":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":1,"users":1},"i2310 Apply for Membership":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":4,"users":3},"i3200 Concert Collect Tickets":{"interactions":4,"users":2},"i3201 Concert Collect On Behalf":{"interactions":2,"users":1},"i3202 Concert Transfer Ticket":{"interactions":2,"users":1},"i3205 Concert Where to Buy":{"interactions":3,"users":1},"i3206 Concert Kids Ticket":{"interactions":2,"users":1},"i3207 Concert Package":{"interactions":1,"users":1},"i3212 Concert Preferred Seats":{"interactions":1,"users":1},"i3304 Product Price":{"interactions":2,"users":2},"i3306 Where is Box Office":{"interactions":1,"users":1},"i3307 Where is toilet":{"interactions":4,"users":3},"i3311 Where to Shop":{"interactions":1,"users":1},"i3312 Where is cinema?":{"interactions":3,"users":2},"i3314 Theme Park Ticket Purchase":{"interactions":1,"users":1},"i3400 Dining":{"interactions":4,"users":2},"i3403 Interest Gained":{"interactions":1,"users":1}},"totals":{"interactions":{"total":349},"users":{"total":72}}},"20190813":{"topics":{"Default Fallback Intent":{"interactions":87,"users":51},"Default Welcome Intent":{"interactions":133,"users":96},"ST0001 Thank You":{"interactions":3,"users":3},"ST0003 Ignore Replies":{"interactions":18,"users":8},"ST0052 Chatbot Wrong Answer":{"interactions":5,"users":5},"ST0058 Can you help me?":{"interactions":6,"users":5},"ST0077 Great!":{"interactions":1,"users":1},"ST0078 No problem":{"interactions":3,"users":3},"ST0099 I am here":{"interactions":1,"users":1},"ST0111 I'm waiting":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":6,"users":5},"ST0300 Good morning":{"interactions":1,"users":1},"ST0301 Good afternoon":{"interactions":1,"users":1},"ST0303 Good nite":{"interactions":2,"users":1},"ST0310 Do you have a mother?":{"interactions":2,"users":1},"ST0325 I am a robot":{"interactions":1,"users":1},"ST0337 What language do you speak?":{"interactions":2,"users":2},"i1004 Promotions":{"interactions":3,"users":3},"i1006 Download Mobile App":{"interactions":2,"users":2},"i1010 Theme Park":{"interactions":5,"users":3},"i1012 Theme Park":{"interactions":1,"users":1},"i1029 Contact Center Operation Hours":{"interactions":1,"users":1},"i1040  ATM Machine":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":68,"users":28},"i1101 Reset Password":{"interactions":7,"users":5},"i1103 Forgot Email":{"interactions":2,"users":2},"i1104 Contact Number":{"interactions":4,"users":4},"i1106 Lost Ticket":{"interactions":3,"users":1},"i1107 Email":{"interactions":5,"users":5},"i1200 Getting There":{"interactions":2,"users":1},"i1201 Express Bus":{"interactions":1,"users":1},"i1207 Free Shuttle Bus":{"interactions":1,"users":1},"i1212 Where is  Hotel":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":1},"i2001 Extra Bed":{"interactions":4,"users":4},"i2003 Room Late Check Out":{"interactions":2,"users":1},"i2004 Room Check In Time":{"interactions":4,"users":4},"i2014 Reception Operating Hours":{"interactions":1,"users":1},"i2020 Room Special Request":{"interactions":4,"users":4},"i2024 First World Bed Type":{"interactions":3,"users":1},"i2100 Stock Price":{"interactions":39,"users":32},"i2101 Complimentary Room Request":{"interactions":11,"users":10},"i2102 Stock Selling":{"interactions":6,"users":5},"i2103 Stock Buying":{"interactions":10,"users":5},"i2104 Room Reservation Full":{"interactions":11,"users":7},"i2105 Early Check In":{"interactions":8,"users":6},"i2106 Check In On Behalf":{"interactions":4,"users":3},"i2107 Multiroom Booking":{"interactions":1,"users":1},"i2108 Room Upgrade Request":{"interactions":3,"users":3},"i2109 Transfer Room Booking":{"interactions":3,"users":2},"i2110 Change Booking Date":{"interactions":2,"users":2},"i2111 Help Reserve A Room":{"interactions":2,"users":1},"i2114 Room Complimentary Birthday":{"interactions":7,"users":6},"i2115 Stock FAQ":{"interactions":30,"users":22},"i2118 Room Complimentary How to know free room":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":4,"users":4},"i2131 Maximum People in Room":{"interactions":2,"users":2},"i2133 Book Room Using Membership":{"interactions":5,"users":5},"i2134 Book Room Using - Video":{"interactions":5,"users":5},"i2135 Book Room Using - Image":{"interactions":1,"users":1},"i2136 Did Not Receive Booking Confirmation":{"interactions":2,"users":2},"i2200 Make Payment For Booking":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":16,"users":9},"i2302 Retrieve Membership ID":{"interactions":3,"users":3},"i2303 Lost Card":{"interactions":5,"users":4},"i2306 Tier Points":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":1,"users":1},"i2313 Number of Supplimentary Card":{"interactions":1,"users":1},"i2314 Tier Points Expiry":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":3,"users":3},"i2319 Member Renew Membership":{"interactions":1,"users":1},"i2320 Check Points":{"interactions":1,"users":1},"i3200 Concert Collect Tickets":{"interactions":1,"users":1},"i3201 Concert Collect On Behalf":{"interactions":1,"users":1},"i3202 Concert Transfer Ticket":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":4,"users":3},"i3206 Concert Kids Ticket":{"interactions":1,"users":1},"i3207 Concert Package":{"interactions":4,"users":1},"i3208 Concert Sold Out":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":6,"users":4},"i3304 Product Price":{"interactions":1,"users":1},"i3306 Where is Box Office":{"interactions":1,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":4,"users":1},"i3324 Corporate Event":{"interactions":1,"users":1},"i3400 Dining":{"interactions":2,"users":2},"i3401 Salary Payment":{"interactions":1,"users":1}},"totals":{"interactions":{"total":619},"users":{"total":107}}},"20190814":{"topics":{"Default Fallback Intent":{"interactions":96,"users":44},"Default Welcome Intent":{"interactions":118,"users":90},"ST0001 Thank You":{"interactions":3,"users":3},"ST0003 Ignore Replies":{"interactions":11,"users":8},"ST0052 Chatbot Wrong Answer":{"interactions":1,"users":1},"ST0058 Can you help me?":{"interactions":7,"users":5},"ST0078 No problem":{"interactions":1,"users":1},"ST0086 Nice to see you!":{"interactions":1,"users":1},"ST0099 I am here":{"interactions":1,"users":1},"ST0101 I like you":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":1,"users":1},"ST0116 No":{"interactions":3,"users":2},"ST0300 Good morning":{"interactions":1,"users":1},"ST0308 Okay Google":{"interactions":1,"users":1},"ST0310 Do you have a mother?":{"interactions":1,"users":1},"ST0325 I am a robot":{"interactions":1,"users":1},"ST0328 I like you":{"interactions":1,"users":1},"ST0339 Have a nice day!":{"interactions":1,"users":1},"ST0340 how to win in Theme Park?":{"interactions":1,"users":1},"ST0800 Profanity 1":{"interactions":2,"users":2},"TT - Renew Status":{"interactions":2,"users":2},"i1001 About Us":{"interactions":1,"users":1},"i1003 Operating Hours":{"interactions":2,"users":1},"i1004 Promotions":{"interactions":4,"users":4},"i1009 Leisure":{"interactions":1,"users":1},"i1010 Theme Park":{"interactions":6,"users":5},"i1012 Theme Park":{"interactions":1,"users":1},"i1021 History":{"interactions":1,"users":1},"i1029 Contact Center Operation Hours":{"interactions":1,"users":1},"i1031 Cruise Ship Booking":{"interactions":2,"users":1},"i1100 General Complaint":{"interactions":40,"users":22},"i1101 Reset Password":{"interactions":8,"users":5},"i1104 Contact Number":{"interactions":7,"users":4},"i1107 Email":{"interactions":1,"users":1},"i1200 Getting There":{"interactions":8,"users":8},"i1201 Express Bus":{"interactions":4,"users":3},"i1203  Bus Terminal":{"interactions":1,"users":1},"i1207 Free Shuttle Bus":{"interactions":1,"users":1},"i1210 Book Complimentary Limousine":{"interactions":2,"users":2},"i1216 Travel Duration":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":7,"users":5},"i2003 Room Late Check Out":{"interactions":2,"users":2},"i2004 Room Check In Time":{"interactions":7,"users":4},"i2005 Room Check Out Time":{"interactions":2,"users":2},"i2020 Room Special Request":{"interactions":1,"users":1},"i2024 First World Bed Type":{"interactions":2,"users":1},"i2100 Stock Price":{"interactions":37,"users":25},"i2101 Complimentary Room Request":{"interactions":9,"users":8},"i2102 Stock Selling":{"interactions":10,"users":8},"i2103 Stock Buying":{"interactions":9,"users":7},"i2104 Room Reservation Full":{"interactions":4,"users":3},"i2105 Early Check In":{"interactions":5,"users":3},"i2106 Check In On Behalf":{"interactions":5,"users":5},"i2107 Multiroom Booking":{"interactions":4,"users":3},"i2109 Transfer Room Booking":{"interactions":3,"users":3},"i2110 Change Booking Date":{"interactions":2,"users":2},"i2111 Help Reserve A Room":{"interactions":1,"users":1},"i2114 Room Complimentary Birthday":{"interactions":8,"users":7},"i2115 Stock FAQ":{"interactions":30,"users":20},"i2122 Room Amenities":{"interactions":4,"users":3},"i2126 Family Room Reservations":{"interactions":1,"users":1},"i2132 Foreigner Passport Number":{"interactions":2,"users":1},"i2133 Book Room Using Membership":{"interactions":10,"users":9},"i2134 Book Room Using - Video":{"interactions":8,"users":6},"i2135 Book Room Using - Image":{"interactions":2,"users":2},"i2136 Did Not Receive Booking Confirmation":{"interactions":1,"users":1},"i2200 Make Payment For Booking":{"interactions":2,"users":2},"i2205 Third Party Sites Booking":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":16,"users":3},"i2302 Retrieve Membership ID":{"interactions":10,"users":5},"i2303 Lost Card":{"interactions":1,"users":1},"i2305 Earn Points":{"interactions":2,"users":2},"i2306 Tier Points":{"interactions":1,"users":1},"i2307 Activate Membership":{"interactions":1,"users":1},"i2309 Membership Benefits":{"interactions":1,"users":1},"i2310 Apply for Membership":{"interactions":2,"users":2},"i2315 Update Membership Details":{"interactions":7,"users":6},"i2319 Member Renew Membership":{"interactions":1,"users":1},"i2320 Check Points":{"interactions":2,"users":1},"i3200 Concert Collect Tickets":{"interactions":1,"users":1},"i3201 Concert Collect On Behalf":{"interactions":1,"users":1},"i3202 Concert Transfer Ticket":{"interactions":1,"users":1},"i3203 Concert Refund Ticket":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":5,"users":3},"i3210 Concert Event Info":{"interactions":1,"users":1},"i3212 Concert Preferred Seats":{"interactions":1,"users":1},"i3300 Theme Park Attractions":{"interactions":3,"users":3},"i3301 Fees For Adults":{"interactions":1,"users":1},"i3306 Where is Box Office":{"interactions":2,"users":2},"i3314 Theme Park Ticket Purchase":{"interactions":3,"users":3},"i3324 Corporate Event":{"interactions":3,"users":2},"i3326 Salary Deduction":{"interactions":1,"users":1},"i3400 Dining":{"interactions":1,"users":1},"i3403 Interest Gained":{"interactions":1,"users":1}},"totals":{"interactions":{"total":596},"users":{"total":98}}},"20190815":{"topics":{"Default Fallback Intent":{"interactions":100,"users":40},"Default Welcome Intent":{"interactions":95,"users":75},"ST0001 Thank You":{"interactions":5,"users":5},"ST0003 Ignore Replies":{"interactions":26,"users":14},"ST0052 Chatbot Wrong Answer":{"interactions":2,"users":2},"ST0058 Can you help me?":{"interactions":5,"users":2},"ST0302 Good evening":{"interactions":1,"users":1},"ST0337 What language do you speak?":{"interactions":1,"users":1},"ST0800 Profanity 1":{"interactions":2,"users":1},"i1001 About Us":{"interactions":1,"users":1},"i1002 Wheel Chair Stroller":{"interactions":2,"users":1},"i1004 Promotions":{"interactions":7,"users":7},"i1006 Download Mobile App":{"interactions":1,"users":1},"i1010 Theme Park":{"interactions":3,"users":2},"i1040  ATM Machine":{"interactions":1,"users":1},"i1043 Privacy Policy":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":47,"users":22},"i1101 Reset Password":{"interactions":1,"users":1},"i1103 Forgot Email":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":3,"users":3},"i1107 Email":{"interactions":1,"users":1},"i1200 Getting There":{"interactions":2,"users":2},"i1206 Getting There KLIA":{"interactions":1,"users":1},"i1210 Book Complimentary Limousine":{"interactions":2,"users":2},"i2000 Adjoining Room":{"interactions":3,"users":2},"i2001 Extra Bed":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":1,"users":1},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2006 Room Check In Age":{"interactions":1,"users":1},"i2017 Room Size":{"interactions":1,"users":1},"i2024 First World Bed Type":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":40,"users":27},"i2101 Complimentary Room Request":{"interactions":14,"users":12},"i2102 Stock Selling":{"interactions":11,"users":8},"i2103 Stock Buying":{"interactions":15,"users":8},"i2104 Room Reservation Full":{"interactions":3,"users":1},"i2105 Early Check In":{"interactions":3,"users":2},"i2106 Check In On Behalf":{"interactions":7,"users":6},"i2107 Multiroom Booking":{"interactions":2,"users":2},"i2108 Room Upgrade Request":{"interactions":3,"users":3},"i2109 Transfer Room Booking":{"interactions":4,"users":2},"i2110 Change Booking Date":{"interactions":2,"users":2},"i2111 Help Reserve A Room":{"interactions":1,"users":1},"i2113 Room Wheelchair Friendly":{"interactions":1,"users":1},"i2114 Room Complimentary Birthday":{"interactions":9,"users":6},"i2115 Stock FAQ":{"interactions":30,"users":19},"i2122 Room Amenities":{"interactions":1,"users":1},"i2125 Room Reservation Cancel Comp Room":{"interactions":1,"users":1},"i2126 Family Room Reservations":{"interactions":5,"users":5},"i2129 Room Reservation Under Different Category":{"interactions":1,"users":1},"i2131 Maximum People in Room":{"interactions":1,"users":1},"i2132 Foreigner Passport Number":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":13,"users":10},"i2134 Book Room Using - Video":{"interactions":8,"users":7},"i2135 Book Room Using - Image":{"interactions":4,"users":4},"i2136 Did Not Receive Booking Confirmation":{"interactions":6,"users":4},"i2200 Make Payment For Booking":{"interactions":1,"users":1},"i2206 Third Party Vouchers":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":4,"users":4},"i2302 Retrieve Membership ID":{"interactions":4,"users":4},"i2303 Lost Card":{"interactions":2,"users":2},"i2306 Tier Points":{"interactions":2,"users":2},"i2307 Activate Membership":{"interactions":3,"users":3},"i2308 No Points Added":{"interactions":2,"users":2},"i2309 Membership Benefits":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":2,"users":2},"i2319 Member Renew Membership":{"interactions":2,"users":2},"i2320 Check Points":{"interactions":1,"users":1},"i3207 Concert Package":{"interactions":1,"users":1},"i3212 Concert Preferred Seats":{"interactions":1,"users":1},"i3300 Theme Park Attractions":{"interactions":1,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":1,"users":1},"i3324 Corporate Event":{"interactions":1,"users":1},"i3400 Dining":{"interactions":3,"users":1}},"totals":{"interactions":{"total":539},"users":{"total":86}}},"20190816":{"topics":{"Default Fallback Intent":{"interactions":50,"users":32},"Default Welcome Intent":{"interactions":103,"users":68},"ST0002 Are You Human":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":11,"users":8},"ST0058 Can you help me?":{"interactions":1,"users":1},"ST0078 No problem":{"interactions":1,"users":1},"ST0106 I need some advice":{"interactions":1,"users":1},"ST0111 I'm waiting":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":1,"users":1},"ST0301 Good afternoon":{"interactions":1,"users":1},"ST0310 Do you have a mother?":{"interactions":1,"users":1},"ST0337 What language do you speak?":{"interactions":1,"users":1},"ST0339 Have a nice day!":{"interactions":1,"users":1},"i1002 Wheel Chair Stroller":{"interactions":7,"users":3},"i1004 Promotions":{"interactions":8,"users":8},"i1006 Download Mobile App":{"interactions":4,"users":2},"i1010 Theme Park":{"interactions":1,"users":1},"i1012 Theme Park":{"interactions":2,"users":1},"i1044 Job Opening":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":25,"users":12},"i1101 Reset Password":{"interactions":3,"users":2},"i1103 Forgot Email":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":2,"users":2},"i1107 Email":{"interactions":1,"users":1},"i1200 Getting There":{"interactions":3,"users":3},"i1201 Express Bus":{"interactions":4,"users":3},"i1202 Parking Rates":{"interactions":5,"users":3},"i1203  Bus Terminal":{"interactions":3,"users":1},"i1204 Parking Map":{"interactions":1,"users":1},"i1207 Free Shuttle Bus":{"interactions":4,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":6,"users":4},"i2003 Room Late Check Out":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":6,"users":3},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2024 First World Bed Type":{"interactions":2,"users":1},"i2100 Stock Price":{"interactions":20,"users":16},"i2101 Complimentary Room Request":{"interactions":12,"users":10},"i2102 Stock Selling":{"interactions":7,"users":5},"i2103 Stock Buying":{"interactions":10,"users":8},"i2104 Room Reservation Full":{"interactions":3,"users":2},"i2105 Early Check In":{"interactions":11,"users":5},"i2106 Check In On Behalf":{"interactions":1,"users":1},"i2108 Room Upgrade Request":{"interactions":2,"users":2},"i2109 Transfer Room Booking":{"interactions":2,"users":2},"i2110 Change Booking Date":{"interactions":1,"users":1},"i2113 Room Wheelchair Friendly":{"interactions":3,"users":3},"i2114 Room Complimentary Birthday":{"interactions":12,"users":9},"i2115 Stock FAQ":{"interactions":22,"users":11},"i2118 Room Complimentary How to know free room":{"interactions":1,"users":1},"i2119 Room Reservation Combine Nights":{"interactions":1,"users":1},"i2125 Room Reservation Cancel Comp Room":{"interactions":1,"users":1},"i2132 Foreigner Passport Number":{"interactions":2,"users":1},"i2133 Book Room Using Membership":{"interactions":8,"users":8},"i2134 Book Room Using - Video":{"interactions":6,"users":5},"i2200 Make Payment For Booking":{"interactions":1,"users":1},"i2205 Third Party Sites Booking":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":7,"users":5},"i2302 Retrieve Membership ID":{"interactions":7,"users":3},"i2303 Lost Card":{"interactions":2,"users":2},"i2308 No Points Added":{"interactions":1,"users":1},"i2310 Apply for Membership":{"interactions":2,"users":2},"i2311 Under 18 Join Membership":{"interactions":1,"users":1},"i2314 Tier Points Expiry":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":5,"users":5},"i2320 Check Points":{"interactions":5,"users":1},"i3200 Concert Collect Tickets":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":2,"users":2},"i3206 Concert Kids Ticket":{"interactions":2,"users":1},"i3207 Concert Package":{"interactions":3,"users":2},"i3212 Concert Preferred Seats":{"interactions":1,"users":1},"i3300 Theme Park Attractions":{"interactions":1,"users":1},"i3306 Where is Box Office":{"interactions":1,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":1,"users":1},"i3326 Salary Deduction":{"interactions":1,"users":1},"i3327 Salary Claims":{"interactions":1,"users":1},"i3401 Salary Payment":{"interactions":2,"users":1},"i3404 Payment Card":{"interactions":1,"users":1}},"totals":{"interactions":{"total":441},"users":{"total":76}}},"20190817":{"topics":{"Default Fallback Intent":{"interactions":38,"users":31},"Default Welcome Intent":{"interactions":71,"users":60},"ST0001 Thank You":{"interactions":2,"users":2},"ST0002 Are You Human":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":10,"users":7},"ST0058 Can you help me?":{"interactions":3,"users":3},"ST0094 I am so excited":{"interactions":1,"users":1},"ST0117 Cancel":{"interactions":1,"users":1},"ST0122 What do you mean?":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":2,"users":2},"i1009 Leisure":{"interactions":1,"users":1},"i1010 Theme Park":{"interactions":1,"users":1},"i1012 Theme Park":{"interactions":3,"users":2},"i1029 Contact Center Operation Hours":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":14,"users":9},"i1104 Contact Number":{"interactions":5,"users":4},"i1200 Getting There":{"interactions":2,"users":2},"i1201 Express Bus":{"interactions":3,"users":2},"i1202 Parking Rates":{"interactions":1,"users":1},"i1203  Bus Terminal":{"interactions":1,"users":1},"i1205 Free Parking":{"interactions":2,"users":1},"i1210 Book Complimentary Limousine":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":3,"users":3},"i2004 Room Check In Time":{"interactions":4,"users":4},"i2009 Any Other Hotels":{"interactions":1,"users":1},"i2016 Non Smoking Room":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":31,"users":23},"i2101 Complimentary Room Request":{"interactions":8,"users":7},"i2102 Stock Selling":{"interactions":7,"users":5},"i2103 Stock Buying":{"interactions":9,"users":4},"i2105 Early Check In":{"interactions":13,"users":7},"i2106 Check In On Behalf":{"interactions":4,"users":4},"i2107 Multiroom Booking":{"interactions":2,"users":2},"i2109 Transfer Room Booking":{"interactions":3,"users":2},"i2111 Help Reserve A Room":{"interactions":2,"users":2},"i2114 Room Complimentary Birthday":{"interactions":6,"users":3},"i2115 Stock FAQ":{"interactions":24,"users":17},"i2117 Room Complimentary Dynamic Stay":{"interactions":2,"users":2},"i2119 Room Reservation Combine Nights":{"interactions":2,"users":1},"i2122 Room Amenities":{"interactions":1,"users":1},"i2131 Maximum People in Room":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":6,"users":4},"i2134 Book Room Using - Video":{"interactions":5,"users":5},"i2135 Book Room Using - Image":{"interactions":1,"users":1},"i2200 Make Payment For Booking":{"interactions":3,"users":2},"i2303 Lost Card":{"interactions":1,"users":1},"i2305 Earn Points":{"interactions":2,"users":2},"i2315 Update Membership Details":{"interactions":3,"users":3},"i3212 Concert Preferred Seats":{"interactions":1,"users":1},"i3300 Theme Park Attractions":{"interactions":1,"users":1}},"totals":{"interactions":{"total":313},"users":{"total":68}}},"20190818":{"topics":{"Default Fallback Intent":{"interactions":42,"users":29},"Default Welcome Intent":{"interactions":79,"users":64},"ST0003 Ignore Replies":{"interactions":12,"users":6},"ST0058 Can you help me?":{"interactions":3,"users":3},"ST0078 No problem":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":3,"users":3},"i1006 Download Mobile App":{"interactions":1,"users":1},"i1010 Theme Park":{"interactions":2,"users":2},"i1044 Job Opening":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":17,"users":15},"i1102 Room Lost and Found":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":3,"users":2},"i1107 Email":{"interactions":4,"users":3},"i1200 Getting There":{"interactions":7,"users":5},"i1201 Express Bus":{"interactions":6,"users":3},"i1203  Bus Terminal":{"interactions":2,"users":1},"i1205 Free Parking":{"interactions":2,"users":2},"i1206 Getting There KLIA":{"interactions":1,"users":1},"i1210 Book Complimentary Limousine":{"interactions":1,"users":1},"i1220 Parking Lot Issue":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":2,"users":2},"i2004 Room Check In Time":{"interactions":1,"users":1},"i2016 Non Smoking Room":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":25,"users":19},"i2101 Complimentary Room Request":{"interactions":9,"users":9},"i2102 Stock Selling":{"interactions":9,"users":8},"i2103 Stock Buying":{"interactions":5,"users":4},"i2104 Room Reservation Full":{"interactions":2,"users":2},"i2105 Early Check In":{"interactions":5,"users":4},"i2106 Check In On Behalf":{"interactions":7,"users":6},"i2107 Multiroom Booking":{"interactions":1,"users":1},"i2108 Room Upgrade Request":{"interactions":2,"users":2},"i2109 Transfer Room Booking":{"interactions":4,"users":4},"i2110 Change Booking Date":{"interactions":2,"users":2},"i2111 Help Reserve A Room":{"interactions":1,"users":1},"i2114 Room Complimentary Birthday":{"interactions":3,"users":3},"i2115 Stock FAQ":{"interactions":19,"users":12},"i2125 Room Reservation Cancel Comp Room":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":2,"users":2},"i2134 Book Room Using - Video":{"interactions":5,"users":4},"i2135 Book Room Using - Image":{"interactions":1,"users":1},"i2136 Did Not Receive Booking Confirmation":{"interactions":2,"users":1},"i2200 Make Payment For Booking":{"interactions":3,"users":1},"i2204 Sales Office":{"interactions":2,"users":1},"i2205 Third Party Sites Booking":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":2,"users":2},"i2302 Retrieve Membership ID":{"interactions":6,"users":5},"i2303 Lost Card":{"interactions":5,"users":3},"i2307 Activate Membership":{"interactions":1,"users":1},"i2310 Apply for Membership":{"interactions":2,"users":2},"i2318 Reward Alliance Website":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":1,"users":1},"i3303 Operating Hours":{"interactions":1,"users":1},"i3309 Get To HQ":{"interactions":1,"users":1},"i3401 Salary Payment":{"interactions":2,"users":2},"i3403 Interest Gained":{"interactions":2,"users":1}},"totals":{"interactions":{"total":330},"users":{"total":69}}},"20190819":{"topics":{"Default Fallback Intent":{"interactions":87,"users":49},"Default Welcome Intent":{"interactions":149,"users":108},"ST0001 Thank You":{"interactions":4,"users":3},"ST0002 Are You Human":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":21,"users":18},"ST0052 Chatbot Wrong Answer":{"interactions":1,"users":1},"ST0058 Can you help me?":{"interactions":13,"users":9},"ST0089 I am back!":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":3,"users":2},"ST0117 Cancel":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":3,"users":3},"i1003 Operating Hours":{"interactions":1},"i1004 Promotions":{"interactions":3,"users":3},"i1006 Download Mobile App":{"interactions":1,"users":1},"i1009 Leisure":{"interactions":1,"users":1},"i1010 Theme Park":{"interactions":6,"users":5},"i1012 Theme Park":{"interactions":2,"users":2},"i1100 General Complaint":{"interactions":70,"users":33},"i1101 Reset Password":{"interactions":4,"users":2},"i1102 Room Lost and Found":{"interactions":4,"users":3},"i1103 Forgot Email":{"interactions":1},"i1104 Contact Number":{"interactions":8,"users":6},"i1105 Hotline Busy":{"interactions":2,"users":2},"i1107 Email":{"interactions":6,"users":4},"i1201 Express Bus":{"interactions":2,"users":1},"i1203  Bus Terminal":{"interactions":4,"users":2},"i1205 Free Parking":{"interactions":3,"users":2},"i1207 Free Shuttle Bus":{"interactions":1,"users":1},"i1210 Book Complimentary Limousine":{"interactions":1,"users":1},"i1211 Taxi to ":{"interactions":1,"users":1},"i1216 Travel Duration":{"interactions":1,"users":1},"i1218 Shuttle From Airport":{"interactions":1,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":10,"users":8},"i2001 Extra Bed":{"interactions":6,"users":1},"i2002 Smoking Room":{"interactions":2,"users":2},"i2004 Room Check In Time":{"interactions":2,"users":2},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2006 Room Check In Age":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":43,"users":25},"i2101 Complimentary Room Request":{"interactions":6,"users":4},"i2102 Stock Selling":{"interactions":9,"users":7},"i2103 Stock Buying":{"interactions":12,"users":9},"i2104 Room Reservation Full":{"interactions":5,"users":2},"i2105 Early Check In":{"interactions":10,"users":6},"i2106 Check In On Behalf":{"interactions":5,"users":5},"i2107 Multiroom Booking":{"interactions":8,"users":6},"i2108 Room Upgrade Request":{"interactions":1,"users":1},"i2109 Transfer Room Booking":{"interactions":4,"users":4},"i2110 Change Booking Date":{"interactions":4,"users":4},"i2111 Help Reserve A Room":{"interactions":1,"users":1},"i2112 Room Cancellation Special Reason":{"interactions":1,"users":1},"i2114 Room Complimentary Birthday":{"interactions":8,"users":7},"i2115 Stock FAQ":{"interactions":46,"users":30},"i2122 Room Amenities":{"interactions":7,"users":5},"i2126 Family Room Reservations":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":9,"users":8},"i2134 Book Room Using - Video":{"interactions":5,"users":3},"i2135 Book Room Using - Image":{"interactions":1,"users":1},"i2200 Make Payment For Booking":{"interactions":2,"users":2},"i2205 Third Party Sites Booking":{"interactions":2,"users":1},"i2301 Cannot Log In":{"interactions":6,"users":4},"i2302 Retrieve Membership ID":{"interactions":6,"users":4},"i2303 Lost Card":{"interactions":4,"users":3},"i2305 Earn Points":{"interactions":1,"users":1},"i2306 Tier Points":{"interactions":3,"users":2},"i2307 Activate Membership":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":1,"users":1},"i2309 Membership Benefits":{"interactions":3,"users":2},"i2310 Apply for Membership":{"interactions":1,"users":1},"i2313 Number of Supplimentary Card":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":4,"users":4},"i2319 Member Renew Membership":{"interactions":2,"users":2},"i2320 Check Points":{"interactions":3,"users":3},"i3104 Currency Accepted":{"interactions":1,"users":1},"i3200 Concert Collect Tickets":{"interactions":4,"users":3},"i3201 Concert Collect On Behalf":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":1,"users":1},"i3207 Concert Package":{"interactions":3,"users":2},"i3210 Concert Event Info":{"interactions":4,"users":4},"i3212 Concert Preferred Seats":{"interactions":1,"users":1},"i3304 Product Price":{"interactions":1},"i3306 Where is Box Office":{"interactions":1,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":1,"users":1},"i3322 Golf Booking":{"interactions":1,"users":1},"i3400 Dining":{"interactions":1,"users":1},"i3402 Interest Charged":{"interactions":1,"users":1},"i3403 Interest Gained":{"interactions":1,"users":1}},"totals":{"interactions":{"total":678},"users":{"total":116}}},"20190820":{"topics":{"Default Fallback Intent":{"interactions":59,"users":31},"Default Welcome Intent":{"interactions":117,"users":85},"ST0001 Thank You":{"interactions":4,"users":4},"ST0003 Ignore Replies":{"interactions":13,"users":8},"ST0058 Can you help me?":{"interactions":6,"users":3},"ST0100 I am kidding":{"interactions":1,"users":1},"ST0111 I'm waiting":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":2,"users":2},"ST0337 What language do you speak?":{"interactions":1,"users":1},"ST0800 Profanity 1":{"interactions":1,"users":1},"i1002 Wheel Chair Stroller":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":7,"users":5},"i1006 Download Mobile App":{"interactions":1,"users":1},"i1010 Theme Park":{"interactions":8,"users":7},"i1012 Theme Park":{"interactions":2,"users":1},"i1029 Contact Center Operation Hours":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":30,"users":18},"i1101 Reset Password":{"interactions":5,"users":4},"i1102 Room Lost and Found":{"interactions":2,"users":2},"i1104 Contact Number":{"interactions":3,"users":3},"i1107 Email":{"interactions":1,"users":1},"i1202 Parking Rates":{"interactions":2,"users":1},"i1204 Parking Map":{"interactions":2,"users":1},"i1205 Free Parking":{"interactions":1,"users":1},"i1221 Motobike Parking":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":4,"users":4},"i2001 Extra Bed":{"interactions":1,"users":1},"i2002 Smoking Room":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":4,"users":4},"i2012 Resort World Sentosa":{"interactions":4,"users":1},"i2020 Room Special Request":{"interactions":1,"users":1},"i2024 First World Bed Type":{"interactions":6,"users":1},"i2100 Stock Price":{"interactions":34,"users":27},"i2101 Complimentary Room Request":{"interactions":10,"users":10},"i2102 Stock Selling":{"interactions":6,"users":6},"i2103 Stock Buying":{"interactions":12,"users":10},"i2104 Room Reservation Full":{"interactions":3,"users":3},"i2105 Early Check In":{"interactions":8,"users":4},"i2106 Check In On Behalf":{"interactions":4,"users":4},"i2109 Transfer Room Booking":{"interactions":4,"users":3},"i2110 Change Booking Date":{"interactions":2,"users":2},"i2111 Help Reserve A Room":{"interactions":5,"users":5},"i2114 Room Complimentary Birthday":{"interactions":12,"users":8},"i2115 Stock FAQ":{"interactions":27,"users":19},"i2119 Room Reservation Combine Nights":{"interactions":1,"users":1},"i2122 Room Amenities":{"interactions":5,"users":3},"i2123 Room Reservation Ammend Comp Room":{"interactions":1,"users":1},"i2130 Room Invoice":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":7,"users":7},"i2134 Book Room Using - Video":{"interactions":8,"users":6},"i2135 Book Room Using - Image":{"interactions":2,"users":2},"i2136 Did Not Receive Booking Confirmation":{"interactions":3,"users":2},"i2200 Make Payment For Booking":{"interactions":1,"users":1},"i2203 Payment in Singapore using RM":{"interactions":1,"users":1},"i2206 Third Party Vouchers":{"interactions":2,"users":1},"i2301 Cannot Log In":{"interactions":7,"users":6},"i2302 Retrieve Membership ID":{"interactions":8,"users":6},"i2303 Lost Card":{"interactions":2,"users":2},"i2307 Activate Membership":{"interactions":2,"users":1},"i2308 No Points Added":{"interactions":4,"users":2},"i2309 Membership Benefits":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":2,"users":2},"i2317 Member Card Lost and Found":{"interactions":2,"users":1},"i2319 Member Renew Membership":{"interactions":1},"i2320 Check Points":{"interactions":2,"users":2},"i3200 Concert Collect Tickets":{"interactions":2,"users":1},"i3204 Concert Lost Ticket":{"interactions":2,"users":1},"i3206 Concert Kids Ticket":{"interactions":2,"users":2},"i3207 Concert Package":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":1,"users":1},"i3212 Concert Preferred Seats":{"interactions":1,"users":1},"i3300 Theme Park Attractions":{"interactions":1,"users":1},"i3304 Product Price":{"interactions":1,"users":1},"i3306 Where is Box Office":{"interactions":1,"users":1},"i3310 Shopping Directory":{"interactions":1,"users":1},"i3311 Where to Shop":{"interactions":2,"users":2},"i3314 Theme Park Ticket Purchase":{"interactions":3,"users":2},"i3316 Wedding Plans":{"interactions":1,"users":1},"i3400 Dining":{"interactions":2,"users":1},"t1001 - Renew Status":{"interactions":1,"users":1}},"totals":{"interactions":{"total":505},"users":{"total":94}}},"20190821":{"topics":{"Default Fallback Intent":{"interactions":110,"users":45},"Default Welcome Intent":{"interactions":130,"users":88},"ST0001 Thank You":{"interactions":1,"users":1},"ST0002 Are You Human":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":28,"users":19},"ST0058 Can you help me?":{"interactions":3,"users":2},"ST0074 Talk to me":{"interactions":1,"users":1},"ST0086 Nice to see you!":{"interactions":2,"users":2},"ST0111 I'm waiting":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":6,"users":3},"ST0122 What do you mean?":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":1,"users":1},"ST0302 Good evening":{"interactions":1,"users":1},"ST0308 Okay Google":{"interactions":2,"users":2},"ST0319 Can you talk to me":{"interactions":1,"users":1},"ST0800 Profanity 1":{"interactions":1,"users":1},"i1001 About Us":{"interactions":1,"users":1},"i1002 Wheel Chair Stroller":{"interactions":2,"users":1},"i1003 Operating Hours":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":2,"users":2},"i1007 Map":{"interactions":1,"users":1},"i1009 Leisure":{"interactions":2,"users":2},"i1010 Theme Park":{"interactions":3,"users":2},"i1012 Theme Park":{"interactions":2,"users":1},"i1034 Fitness Center":{"interactions":1,"users":1},"i1036 Luggage Storage":{"interactions":2,"users":1},"i1100 General Complaint":{"interactions":36,"users":21},"i1101 Reset Password":{"interactions":10,"users":7},"i1102 Room Lost and Found":{"interactions":3,"users":2},"i1104 Contact Number":{"interactions":5,"users":5},"i1107 Email":{"interactions":1,"users":1},"i1200 Getting There":{"interactions":2,"users":2},"i1201 Express Bus":{"interactions":3,"users":1},"i1203  Bus Terminal":{"interactions":3,"users":1},"i1207 Free Shuttle Bus":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":5,"users":4},"i2001 Extra Bed":{"interactions":4,"users":3},"i2003 Room Late Check Out":{"interactions":1,"users":1},"i2004 Room Check In Time":{"interactions":4,"users":2},"i2005 Room Check Out Time":{"interactions":1,"users":1},"i2020 Room Special Request":{"interactions":1,"users":1},"i2024 First World Bed Type":{"interactions":4,"users":2},"i2100 Stock Price":{"interactions":53,"users":32},"i2101 Complimentary Room Request":{"interactions":22,"users":19},"i2102 Stock Selling":{"interactions":11,"users":7},"i2103 Stock Buying":{"interactions":17,"users":14},"i2104 Room Reservation Full":{"interactions":2,"users":1},"i2105 Early Check In":{"interactions":7,"users":3},"i2106 Check In On Behalf":{"interactions":12,"users":10},"i2109 Transfer Room Booking":{"interactions":3,"users":3},"i2111 Help Reserve A Room":{"interactions":6,"users":5},"i2113 Room Wheelchair Friendly":{"interactions":1,"users":1},"i2114 Room Complimentary Birthday":{"interactions":19,"users":12},"i2115 Stock FAQ":{"interactions":50,"users":28},"i2116 Room Complimentary Give Away":{"interactions":1,"users":1},"i2117 Room Complimentary Dynamic Stay":{"interactions":2,"users":2},"i2122 Room Amenities":{"interactions":5,"users":4},"i2126 Family Room Reservations":{"interactions":2,"users":2},"i2132 Foreigner Passport Number":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":13,"users":9},"i2134 Book Room Using - Video":{"interactions":5,"users":5},"i2135 Book Room Using - Image":{"interactions":5,"users":5},"i2200 Make Payment For Booking":{"interactions":3,"users":3},"i2206 Third Party Vouchers":{"interactions":2,"users":1},"i2301 Cannot Log In":{"interactions":14,"users":8},"i2302 Retrieve Membership ID":{"interactions":6,"users":6},"i2303 Lost Card":{"interactions":4,"users":3},"i2309 Membership Benefits":{"interactions":1,"users":1},"i2310 Apply for Membership":{"interactions":5,"users":5},"i2311 Under 18 Join Membership":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":1,"users":1},"i2319 Member Renew Membership":{"interactions":1,"users":1},"i2320 Check Points":{"interactions":2,"users":2},"i3200 Concert Collect Tickets":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":1,"users":1},"i3206 Concert Kids Ticket":{"interactions":3,"users":1},"i3210 Concert Event Info":{"interactions":2,"users":2},"i3300 Theme Park Attractions":{"interactions":4,"users":4},"i3304 Product Price":{"interactions":2,"users":1},"i3307 Where is toilet":{"interactions":2,"users":2},"i3308 Where is the indoor themepark?":{"interactions":2,"users":2},"i3313 Branch Operating Hours":{"interactions":1,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":1,"users":1},"i3318 Itinerary Advisor":{"interactions":2,"users":2},"i3322 Golf Booking":{"interactions":2,"users":1},"i3325 Medical Claims":{"interactions":1,"users":1},"i3326 Salary Deduction":{"interactions":2,"users":1},"i3400 Dining":{"interactions":3,"users":2},"i3402 Interest Charged":{"interactions":1,"users":1},"i3403 Interest Gained":{"interactions":1,"users":1},"tt - testing":{"interactions":1,"users":1}},"totals":{"interactions":{"total":700},"messages":{"agent":{"fb":47,"total":47},"bot":{"fb":674,"total":674},"total":{"fb":1421,"total":1421},"user":{"fb":700,"total":700}},"users":{"total":101}}},"20190822":{"topics":{"Default Fallback Intent":{"interactions":68,"users":44},"Default Welcome Intent":{"interactions":137,"users":97},"ST0001 Thank You":{"interactions":4,"users":4},"ST0003 Ignore Replies":{"interactions":24,"users":18},"ST0052 Chatbot Wrong Answer":{"interactions":4,"users":4},"ST0058 Can you help me?":{"interactions":5,"users":4},"ST0078 No problem":{"interactions":1,"users":1},"ST0113 I just want to talk":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":1,"users":1},"ST0117 Cancel":{"interactions":1,"users":1},"ST0121 Sorry":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":1,"users":1},"ST0301 Good afternoon":{"interactions":1,"users":1},"ST0310 Do you have a mother?":{"interactions":1,"users":1},"ST0325 I am a robot":{"interactions":1,"users":1},"ST0337 What language do you speak?":{"interactions":1,"users":1},"ST0339 Have a nice day!":{"interactions":1},"i1004 Promotions":{"interactions":9,"users":6},"i1006 Download Mobile App":{"interactions":1,"users":1},"i1010 Theme Park":{"interactions":9,"users":4},"i1026 Suitable Clothes":{"interactions":1,"users":1},"i1044 Job Opening":{"interactions":3,"users":2},"i1100 General Complaint":{"interactions":33,"users":24},"i1101 Reset Password":{"interactions":3,"users":3},"i1104 Contact Number":{"interactions":3,"users":3},"i1108 System App Issue":{"interactions":1,"users":1},"i1200 Getting There":{"interactions":5,"users":4},"i1201 Express Bus":{"interactions":2,"users":1},"i1202 Parking Rates":{"interactions":1,"users":1},"i1203  Bus Terminal":{"interactions":3,"users":1},"i1205 Free Parking":{"interactions":2,"users":1},"i1207 Free Shuttle Bus":{"interactions":1,"users":1},"i1220 Parking Lot Issue":{"interactions":1,"users":1},"i1222 Shuttle Bus Schedule":{"interactions":2,"users":2},"i2000 Adjoining Room":{"interactions":6,"users":3},"i2001 Extra Bed":{"interactions":4,"users":1},"i2003 Room Late Check Out":{"interactions":2,"users":1},"i2004 Room Check In Time":{"interactions":4,"users":4},"i2005 Room Check Out Time":{"interactions":3,"users":2},"i2012 Resort World Sentosa":{"interactions":1,"users":1},"i2024 First World Bed Type":{"interactions":7,"users":3},"i2100 Stock Price":{"interactions":42,"users":32},"i2101 Complimentary Room Request":{"interactions":13,"users":9},"i2102 Stock Selling":{"interactions":14,"users":10},"i2103 Stock Buying":{"interactions":8,"users":5},"i2104 Room Reservation Full":{"interactions":2,"users":2},"i2105 Early Check In":{"interactions":10,"users":6},"i2106 Check In On Behalf":{"interactions":9,"users":9},"i2107 Multiroom Booking":{"interactions":1,"users":1},"i2108 Room Upgrade Request":{"interactions":3,"users":3},"i2109 Transfer Room Booking":{"interactions":9,"users":9},"i2110 Change Booking Date":{"interactions":5,"users":5},"i2111 Help Reserve A Room":{"interactions":3,"users":3},"i2114 Room Complimentary Birthday":{"interactions":3,"users":3},"i2115 Stock FAQ":{"interactions":20,"users":15},"i2122 Room Amenities":{"interactions":1,"users":1},"i2126 Family Room Reservations":{"interactions":1,"users":1},"i2133 Book Room Using Membership":{"interactions":5,"users":4},"i2134 Book Room Using - Video":{"interactions":9,"users":5},"i2135 Book Room Using - Image":{"interactions":2,"users":2},"i2203 Payment in Singapore using RM":{"interactions":1,"users":1},"i2205 Third Party Sites Booking":{"interactions":1,"users":1},"i2206 Third Party Vouchers":{"interactions":3,"users":1},"i2301 Cannot Log In":{"interactions":3,"users":3},"i2302 Retrieve Membership ID":{"interactions":3,"users":3},"i2303 Lost Card":{"interactions":2,"users":2},"i2307 Activate Membership":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":5,"users":4},"i2319 Member Renew Membership":{"interactions":2,"users":2},"i3200 Concert Collect Tickets":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":1,"users":1},"i3206 Concert Kids Ticket":{"interactions":2,"users":2},"i3210 Concert Event Info":{"interactions":1,"users":1},"i3300 Theme Park Attractions":{"interactions":2,"users":2},"i3304 Product Price":{"interactions":1},"i3308 Where is the indoor themepark?":{"interactions":1,"users":1},"i3314 Theme Park Ticket Purchase":{"interactions":4,"users":2},"i3315 Office Operating Hours":{"interactions":1,"users":1},"i3326 Salary Deduction":{"interactions":1,"users":1}},"totals":{"interactions":{"total":557},"messages":{"agent":{"fb":13,"total":13},"bot":{"fb":553,"total":553},"total":{"fb":1123,"total":1123},"user":{"fb":557,"total":557}},"users":{"total":104}}},"20190823":{"topics":{"Default Fallback Intent":{"interactions":40,"users":26},"Default Welcome Intent":{"interactions":103,"users":77},"ST0001 Thank You":{"interactions":5,"users":4},"ST0003 Ignore Replies":{"interactions":8,"users":7},"ST0052 Chatbot Wrong Answer":{"interactions":2,"users":1},"ST0058 Can you help me?":{"interactions":3,"users":2},"ST0070 Where do you work?":{"interactions":1,"users":1},"ST0074 Talk to me":{"interactions":1,"users":1},"ST0115 Yes":{"interactions":1,"users":1},"ST0116 No":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":1,"users":1},"ST0324 Good job":{"interactions":1,"users":1},"ST0329 I want to talk with you":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":6,"users":6},"i1009 Leisure":{"interactions":2,"users":2},"i1045 Baby Cot":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":35,"users":18},"i1101 Reset Password":{"interactions":5,"users":4},"i1102 Room Lost and Found":{"interactions":1},"i1104 Contact Number":{"interactions":3,"users":2},"i1107 Email":{"interactions":1,"users":1},"i1108 System App Issue":{"interactions":2,"users":2},"i1201 Express Bus":{"interactions":3,"users":2},"i1203  Bus Terminal":{"interactions":1,"users":1},"i1211 Taxi to ":{"interactions":1,"users":1},"i1215 Walking around ":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":10,"users":6},"i2001 Extra Bed":{"interactions":1,"users":1},"i2003 Room Late Check Out":{"interactions":2,"users":2},"i2004 Room Check In Time":{"interactions":5,"users":5},"i2005 Room Check Out Time":{"interactions":2,"users":2},"i2006 Room Check In Age":{"interactions":1,"users":1},"i2020 Room Special Request":{"interactions":1,"users":1},"i2021 Hotel Breakfast Starting":{"interactions":2,"users":1},"i2024 First World Bed Type":{"interactions":2,"users":1},"i2100 Stock Price":{"interactions":31,"users":23},"i2101 Complimentary Room Request":{"interactions":13,"users":13},"i2102 Stock Selling":{"interactions":12,"users":10},"i2103 Stock Buying":{"interactions":6,"users":6},"i2104 Room Reservation Full":{"interactions":5,"users":4},"i2105 Early Check In":{"interactions":7,"users":5},"i2106 Check In On Behalf":{"interactions":6,"users":5},"i2107 Multiroom Booking":{"interactions":2,"users":2},"i2108 Room Upgrade Request":{"interactions":3,"users":1},"i2109 Transfer Room Booking":{"interactions":3,"users":3},"i2110 Change Booking Date":{"interactions":4,"users":3},"i2114 Room Complimentary Birthday":{"interactions":12,"users":9},"i2115 Stock FAQ":{"interactions":25,"users":19},"i2122 Room Amenities":{"interactions":4,"users":4},"i2126 Family Room Reservations":{"interactions":3,"users":2},"i2129 Room Reservation Under Different Category":{"interactions":1,"users":1},"i2131 Maximum People in Room":{"interactions":2,"users":2},"i2132 Foreigner Passport Number":{"interactions":2,"users":1},"i2133 Book Room Using Membership":{"interactions":9,"users":8},"i2134 Book Room Using - Video":{"interactions":12,"users":10},"i2135 Book Room Using - Image":{"interactions":2,"users":2},"i2136 Did Not Receive Booking Confirmation":{"interactions":2,"users":2},"i2200 Make Payment For Booking":{"interactions":1,"users":1},"i2202 Payment in Singapore":{"interactions":1,"users":1},"i2206 Third Party Vouchers":{"interactions":4},"i2301 Cannot Log In":{"interactions":5,"users":3},"i2302 Retrieve Membership ID":{"interactions":7,"users":5},"i2303 Lost Card":{"interactions":2,"users":1},"i2307 Activate Membership":{"interactions":5,"users":1},"i2308 No Points Added":{"interactions":1,"users":1},"i2309 Membership Benefits":{"interactions":1,"users":1},"i2310 Apply for Membership":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":4,"users":3},"i2319 Member Renew Membership":{"interactions":2,"users":1},"i2320 Check Points":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":1,"users":1},"i3207 Concert Package":{"interactions":3,"users":1},"i3208 Concert Sold Out":{"interactions":3,"users":1},"i3210 Concert Event Info":{"interactions":2,"users":2},"i3300 Theme Park Attractions":{"interactions":4,"users":3},"i3311 Where to Shop":{"interactions":1,"users":1},"i3321 Entrance Price":{"interactions":1,"users":1},"i3400 Dining":{"interactions":2,"users":2}},"totals":{"interactions":{"total":474},"messages":{"bot":{"fb":473,"total":473},"total":{"fb":947,"total":947},"user":{"fb":474,"total":474}},"users":{"total":81}}},"20190824":{"topics":{"Default Fallback Intent":{"interactions":40,"users":21},"Default Welcome Intent":{"interactions":78,"users":65},"ST0001 Thank You":{"interactions":3,"users":3},"ST0003 Ignore Replies":{"interactions":17,"users":13},"ST0004 What Is Your Name":{"interactions":1,"users":1},"ST0052 Chatbot Wrong Answer":{"interactions":1,"users":1},"ST0058 Can you help me?":{"interactions":1,"users":1},"ST0300 Good morning":{"interactions":1,"users":1},"ST0301 Good afternoon":{"interactions":1,"users":1},"ST0330 It is nice to meet you":{"interactions":1,"users":1},"i1002 Wheel Chair Stroller":{"interactions":2,"users":1},"i1003 Operating Hours":{"interactions":1,"users":1},"i1004 Promotions":{"interactions":4,"users":4},"i1007 Map":{"interactions":2,"users":2},"i1008 Where Is ":{"interactions":1,"users":1},"i1010 Theme Park":{"interactions":1,"users":1},"i1012 Theme Park":{"interactions":1,"users":1},"i1044 Job Opening":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":11,"users":10},"i1101 Reset Password":{"interactions":5,"users":4},"i1102 Room Lost and Found":{"interactions":1},"i1104 Contact Number":{"interactions":2,"users":2},"i1107 Email":{"interactions":1,"users":1},"i1200 Getting There":{"interactions":4,"users":2},"i1201 Express Bus":{"interactions":1,"users":1},"i1202 Parking Rates":{"interactions":3,"users":1},"i1204 Parking Map":{"interactions":2,"users":1},"i1205 Free Parking":{"interactions":1,"users":1},"i1215 Walking around ":{"interactions":2,"users":1},"i1221 Motobike Parking":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":3,"users":3},"i2004 Room Check In Time":{"interactions":3,"users":3},"i2006 Room Check In Age":{"interactions":1,"users":1},"i2020 Room Special Request":{"interactions":1,"users":1},"i2024 First World Bed Type":{"interactions":4,"users":2},"i2100 Stock Price":{"interactions":29,"users":20},"i2101 Complimentary Room Request":{"interactions":8,"users":8},"i2102 Stock Selling":{"interactions":7,"users":6},"i2103 Stock Buying":{"interactions":6,"users":6},"i2104 Room Reservation Full":{"interactions":1,"users":1},"i2105 Early Check In":{"interactions":6,"users":4},"i2106 Check In On Behalf":{"interactions":4,"users":1},"i2107 Multiroom Booking":{"interactions":4,"users":1},"i2108 Room Upgrade Request":{"interactions":1,"users":1},"i2109 Transfer Room Booking":{"interactions":1,"users":1},"i2110 Change Booking Date":{"interactions":1,"users":1},"i2111 Help Reserve A Room":{"interactions":3,"users":3},"i2112 Room Cancellation Special Reason":{"interactions":1,"users":1},"i2113 Room Wheelchair Friendly":{"interactions":2,"users":2},"i2114 Room Complimentary Birthday":{"interactions":5,"users":5},"i2115 Stock FAQ":{"interactions":15,"users":12},"i2122 Room Amenities":{"interactions":2,"users":2},"i2133 Book Room Using Membership":{"interactions":4,"users":4},"i2134 Book Room Using - Video":{"interactions":4,"users":3},"i2205 Third Party Sites Booking":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":2,"users":2},"i2302 Retrieve Membership ID":{"interactions":3,"users":3},"i2303 Lost Card":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":1,"users":1},"i2309 Membership Benefits":{"interactions":1,"users":1},"i2310 Apply for Membership":{"interactions":1,"users":1},"i2311 Under 18 Join Membership":{"interactions":1,"users":1},"i2312 Number of Member Card Can Apply":{"interactions":1,"users":1},"i2314 Tier Points Expiry":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":4,"users":2},"i2319 Member Renew Membership":{"interactions":1,"users":1},"i3101 Theme Park Dress Code":{"interactions":1,"users":1},"i3200 Concert Collect Tickets":{"interactions":3,"users":1},"i3201 Concert Collect On Behalf":{"interactions":2,"users":2},"i3205 Concert Where to Buy":{"interactions":2,"users":2},"i3207 Concert Package":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":2,"users":2},"i3300 Theme Park Attractions":{"interactions":2,"users":1},"i3303 Operating Hours":{"interactions":1,"users":1},"i3306 Where is Box Office":{"interactions":2,"users":2},"i3311 Where to Shop":{"interactions":2,"users":2},"i3312 Where is cinema?":{"interactions":2,"users":1}},"totals":{"interactions":{"total":345},"messages":{"bot":{"fb":342,"total":342},"total":{"fb":687,"total":687},"user":{"fb":345,"total":345}},"users":{"total":74}}},"20190825":{"topics":{"Default Fallback Intent":{"interactions":38,"users":21},"Default Welcome Intent":{"interactions":85,"users":61},"ST0001 Thank You":{"interactions":1,"users":1},"ST0002 Are You Human":{"interactions":1,"users":1},"ST0003 Ignore Replies":{"interactions":15,"users":12},"ST0078 No problem":{"interactions":1,"users":1},"ST0116 No":{"interactions":2,"users":2},"ST0337 What language do you speak?":{"interactions":1,"users":1},"i1002 Wheel Chair Stroller":{"interactions":1,"users":1},"i1003 Operating Hours":{"interactions":2,"users":1},"i1004 Promotions":{"interactions":5,"users":4},"i1006 Download Mobile App":{"interactions":1,"users":1},"i1009 Leisure":{"interactions":1,"users":1},"i1010 Theme Park":{"interactions":6,"users":3},"i1016 Clinic":{"interactions":1,"users":1},"i1044 Job Opening":{"interactions":1},"i1100 General Complaint":{"interactions":11,"users":10},"i1101 Reset Password":{"interactions":1,"users":1},"i1102 Room Lost and Found":{"interactions":1,"users":1},"i1108 System App Issue":{"interactions":1,"users":1},"i1200 Getting There":{"interactions":2,"users":2},"i1202 Parking Rates":{"interactions":3,"users":1},"i1204 Parking Map":{"interactions":3,"users":2},"i1205 Free Parking":{"interactions":1,"users":1},"i1216 Travel Duration":{"interactions":1,"users":1},"i2003 Room Late Check Out":{"interactions":2,"users":2},"i2004 Room Check In Time":{"interactions":8,"users":5},"i2005 Room Check Out Time":{"interactions":4,"users":4},"i2020 Room Special Request":{"interactions":1,"users":1},"i2100 Stock Price":{"interactions":34,"users":24},"i2101 Complimentary Room Request":{"interactions":10,"users":8},"i2102 Stock Selling":{"interactions":9,"users":5},"i2103 Stock Buying":{"interactions":8,"users":7},"i2104 Room Reservation Full":{"interactions":3,"users":1},"i2105 Early Check In":{"interactions":11,"users":7},"i2106 Check In On Behalf":{"interactions":1,"users":1},"i2108 Room Upgrade Request":{"interactions":4,"users":4},"i2109 Transfer Room Booking":{"interactions":5,"users":5},"i2110 Change Booking Date":{"interactions":1,"users":1},"i2111 Help Reserve A Room":{"interactions":3,"users":3},"i2113 Room Wheelchair Friendly":{"interactions":1,"users":1},"i2114 Room Complimentary Birthday":{"interactions":5,"users":5},"i2115 Stock FAQ":{"interactions":26,"users":21},"i2118 Room Complimentary How to know free room":{"interactions":2,"users":1},"i2133 Book Room Using Membership":{"interactions":3,"users":3},"i2134 Book Room Using - Video":{"interactions":8,"users":8},"i2135 Book Room Using - Image":{"interactions":1,"users":1},"i2136 Did Not Receive Booking Confirmation":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":1,"users":1},"i3205 Concert Where to Buy":{"interactions":1,"users":1},"i3207 Concert Package":{"interactions":1,"users":1},"i3210 Concert Event Info":{"interactions":3,"users":2},"i3212 Concert Preferred Seats":{"interactions":2,"users":1},"i3300 Theme Park Attractions":{"interactions":2,"users":2},"i3304 Product Price":{"interactions":1,"users":1},"i3311 Where to Shop":{"interactions":1,"users":1},"i3312 Where is cinema?":{"interactions":1,"users":1},"i3313 Branch Operating Hours":{"interactions":1,"users":1}},"totals":{"interactions":{"total":352},"messages":{"bot":{"fb":352,"total":352},"total":{"fb":704,"total":704},"user":{"fb":352,"total":352}},"users":{"total":66}}},"20190826":{"topics":{"Default Fallback Intent":{"interactions":17,"users":11},"Default Welcome Intent":{"interactions":37,"users":27},"ST0003 Ignore Replies":{"interactions":9,"users":5},"ST0058 Can you help me?":{"interactions":1,"users":1},"ST0074 Talk to me":{"interactions":1,"users":1},"ST0117 Cancel":{"interactions":2,"users":1},"i1003 Operating Hours":{"interactions":1},"i1004 Promotions":{"interactions":3,"users":3},"i1010 Theme Park":{"interactions":1,"users":1},"i1034 Fitness Center":{"interactions":1,"users":1},"i1100 General Complaint":{"interactions":8,"users":5},"i1101 Reset Password":{"interactions":2,"users":1},"i1103 Forgot Email":{"interactions":1,"users":1},"i1104 Contact Number":{"interactions":2,"users":2},"i1107 Email":{"interactions":2,"users":1},"i1108 System App Issue":{"interactions":3,"users":2},"i1200 Getting There":{"interactions":1,"users":1},"i1201 Express Bus":{"interactions":1,"users":1},"i1203  Bus Terminal":{"interactions":2,"users":1},"i1207 Free Shuttle Bus":{"interactions":1,"users":1},"i1215 Walking around ":{"interactions":1},"i1222 Shuttle Bus Schedule":{"interactions":1,"users":1},"i2000 Adjoining Room":{"interactions":4,"users":3},"i2006 Room Check In Age":{"interactions":2,"users":1},"i2100 Stock Price":{"interactions":6,"users":5},"i2101 Complimentary Room Request":{"interactions":2,"users":2},"i2102 Stock Selling":{"interactions":1,"users":1},"i2103 Stock Buying":{"interactions":2,"users":2},"i2105 Early Check In":{"interactions":1,"users":1},"i2106 Check In On Behalf":{"interactions":1,"users":1},"i2108 Room Upgrade Request":{"interactions":1},"i2114 Room Complimentary Birthday":{"interactions":4,"users":4},"i2115 Stock FAQ":{"interactions":14,"users":6},"i2122 Room Amenities":{"interactions":2,"users":2},"i2133 Book Room Using Membership":{"interactions":3,"users":3},"i2135 Book Room Using - Image":{"interactions":1,"users":1},"i2136 Did Not Receive Booking Confirmation":{"interactions":1,"users":1},"i2200 Make Payment For Booking":{"interactions":1,"users":1},"i2301 Cannot Log In":{"interactions":3,"users":2},"i2303 Lost Card":{"interactions":1,"users":1},"i2308 No Points Added":{"interactions":1,"users":1},"i2315 Update Membership Details":{"interactions":5,"users":3},"i2319 Member Renew Membership":{"interactions":2,"users":1},"i3205 Concert Where to Buy":{"interactions":1,"users":1},"i3206 Concert Kids Ticket":{"interactions":1,"users":1},"i3313 Branch Operating Hours":{"interactions":1,"users":1},"i3400 Dining":{"interactions":2,"users":1}},"totals":{"interactions":{"total":161},"messages":{"bot":{"fb":161,"total":161},"total":{"fb":322,"total":322},"user":{"fb":161,"total":161}},"users":{"total":28}}}},"topics":{"Default Fallback Intent":{"exits":0,"intent":"Default Fallback Intent","interactions":4328,"respondTime":0,"users":2323},"Default Welcome Intent":{"exits":0,"intent":"Default Welcome Intent","interactions":6312,"respondTime":0,"users":4783},"Get Started - Extract Facebook User Info":{"exits":0,"intent":"Get Started - Extract Facebook User Info","interactions":3,"respondTime":0,"users":1},"Room-FreeRoom":{"exits":0,"intent":"Room-FreeRoom","interactions":12,"respondTime":0,"users":11},"ST0001 Thank You":{"exits":0,"intent":"ST0001 Thank You","interactions":182,"respondTime":0,"users":170},"ST0002 Are You Human":{"exits":0,"intent":"ST0002 Are You Human","interactions":32,"respondTime":0,"users":30},"ST0003 Ignore Replies":{"exits":0,"intent":"ST0003 Ignore Replies","interactions":722,"respondTime":0,"users":499},"ST0004 What Is Your Name":{"exits":0,"intent":"ST0004 What Is Your Name","interactions":3,"respondTime":0,"users":3},"ST0052 Chatbot Wrong Answer":{"exits":0,"intent":"ST0052 Chatbot Wrong Answer","interactions":53,"respondTime":0,"users":52},"ST0058 Can you help me?":{"exits":0,"intent":"ST0058 Can you help me?","interactions":155,"respondTime":0,"users":123},"ST0060 You are so clever":{"exits":0,"intent":"ST0060 You are so clever","interactions":3,"respondTime":0,"users":2},"ST0067 Are you hungry?":{"exits":0,"intent":"ST0067 Are you hungry?","interactions":1,"respondTime":0,"users":1},"ST0070 Where do you work?":{"exits":0,"intent":"ST0070 Where do you work?","interactions":6,"respondTime":0,"users":5},"ST0071 Are you ready?":{"exits":0,"intent":"ST0071 Are you ready?","interactions":1,"respondTime":0,"users":1},"ST0073 Are you sure?":{"exits":0,"intent":"ST0073 Are you sure?","interactions":1,"respondTime":0,"users":1},"ST0074 Talk to me":{"exits":0,"intent":"ST0074 Talk to me","interactions":17,"respondTime":0,"users":14},"ST0075 Are you there?":{"exits":0,"intent":"ST0075 Are you there?","interactions":1,"respondTime":0,"users":1},"ST0076 That is bad":{"exits":0,"intent":"ST0076 That is bad","interactions":2,"respondTime":0,"users":1},"ST0077 Great!":{"exits":0,"intent":"ST0077 Great!","interactions":1,"respondTime":0,"users":1},"ST0078 No problem":{"exits":0,"intent":"ST0078 No problem","interactions":8,"respondTime":0,"users":8},"ST0079 Thank you!":{"exits":0,"intent":"ST0079 Thank you!","interactions":11,"respondTime":0,"users":10},"ST0081 Well done!":{"exits":0,"intent":"ST0081 Well done!","interactions":1,"respondTime":0,"users":1},"ST0082 Ha ha ha!":{"exits":0,"intent":"ST0082 Ha ha ha!","interactions":1,"respondTime":0,"users":1},"ST0084 Bye-bye!":{"exits":0,"intent":"ST0084 Bye-bye!","interactions":6,"respondTime":0,"users":6},"ST0085 Nice to meet you!":{"exits":0,"intent":"ST0085 Nice to meet you!","interactions":1,"respondTime":0,"users":1},"ST0086 Nice to see you!":{"exits":0,"intent":"ST0086 Nice to see you!","interactions":9,"respondTime":0,"users":9},"ST0088 I'm very angry right now":{"exits":0,"intent":"ST0088 I'm very angry right now","interactions":2,"respondTime":0,"users":1},"ST0089 I am back!":{"exits":0,"intent":"ST0089 I am back!","interactions":1,"respondTime":0,"users":1},"ST0092 I can't sleep":{"exits":0,"intent":"ST0092 I can't sleep","interactions":2,"respondTime":0,"users":1},"ST0093":{"exits":0,"intent":"ST0093","interactions":2,"respondTime":0,"users":2},"ST0094 I am so excited":{"exits":0,"intent":"ST0094 I am so excited","interactions":1,"respondTime":0,"users":1},"ST0097 I am happy":{"exits":0,"intent":"ST0097 I am happy","interactions":2,"respondTime":0,"users":1},"ST0098 Today is my birthday":{"exits":0,"intent":"ST0098 Today is my birthday","interactions":1,"respondTime":0,"users":1},"ST0099 I am here":{"exits":0,"intent":"ST0099 I am here","interactions":2,"respondTime":0,"users":2},"ST0100 I am kidding":{"exits":0,"intent":"ST0100 I am kidding","interactions":1,"respondTime":0,"users":1},"ST0101 I like you":{"exits":0,"intent":"ST0101 I like you","interactions":1,"respondTime":0,"users":1},"ST0103 What do I look like?":{"exits":0,"intent":"ST0103 What do I look like?","interactions":1,"respondTime":0,"users":1},"ST0106 I need some advice":{"exits":0,"intent":"ST0106 I need some advice","interactions":2,"respondTime":0,"users":2},"ST0111 I'm waiting":{"exits":0,"intent":"ST0111 I'm waiting","interactions":11,"respondTime":0,"users":10},"ST0112 I'd like to see you again":{"exits":0,"intent":"ST0112 I'd like to see you again","interactions":3,"respondTime":0,"users":3},"ST0113 I just want to talk":{"exits":0,"intent":"ST0113 I just want to talk","interactions":2,"respondTime":0,"users":2},"ST0114 I'll be back":{"exits":0,"intent":"ST0114 I'll be back","interactions":1,"respondTime":0,"users":1},"ST0115 Yes":{"exits":0,"intent":"ST0115 Yes","interactions":88,"respondTime":0,"users":69},"ST0116 No":{"exits":0,"intent":"ST0116 No","interactions":26,"respondTime":0,"users":25},"ST0117 Cancel":{"exits":0,"intent":"ST0117 Cancel","interactions":18,"respondTime":0,"users":14},"ST0121 Sorry":{"exits":0,"intent":"ST0121 Sorry","interactions":11,"respondTime":0,"users":10},"ST0122 What do you mean?":{"exits":0,"intent":"ST0122 What do you mean?","interactions":10,"respondTime":0,"users":9},"ST0123 You're wrong":{"exits":0,"intent":"ST0123 You're wrong","interactions":4,"respondTime":0,"users":4},"ST0300 Good morning":{"exits":0,"intent":"ST0300 Good morning","interactions":77,"respondTime":0,"users":72},"ST0301 Good afternoon":{"exits":0,"intent":"ST0301 Good afternoon","interactions":20,"respondTime":0,"users":20},"ST0302 Good evening":{"exits":0,"intent":"ST0302 Good evening","interactions":12,"respondTime":0,"users":12},"ST0303 Good nite":{"exits":0,"intent":"ST0303 Good nite","interactions":7,"respondTime":0,"users":6},"ST0308 Okay Google":{"exits":0,"intent":"ST0308 Okay Google","interactions":7,"respondTime":0,"users":7},"ST0310 Do you have a mother?":{"exits":0,"intent":"ST0310 Do you have a mother?","interactions":6,"respondTime":0,"users":5},"ST0312 Do you have children?":{"exits":0,"intent":"ST0312 Do you have children?","interactions":2,"respondTime":0,"users":2},"ST0316 Can you hear me?":{"exits":0,"intent":"ST0316 Can you hear me?","interactions":3,"respondTime":0,"users":3},"ST0317 Can you learn?":{"exits":0,"intent":"ST0317 Can you learn?","interactions":2,"respondTime":0,"users":2},"ST0319 Can you talk to me":{"exits":0,"intent":"ST0319 Can you talk to me","interactions":4,"respondTime":0,"users":4},"ST0320 Can you think?":{"exits":0,"intent":"ST0320 Can you think?","interactions":4,"respondTime":0,"users":4},"ST0322 Are you there?":{"exits":0,"intent":"ST0322 Are you there?","interactions":1,"respondTime":0,"users":1},"ST0324 Good job":{"exits":0,"intent":"ST0324 Good job","interactions":1,"respondTime":0,"users":1},"ST0325 I am a robot":{"exits":0,"intent":"ST0325 I am a robot","interactions":3,"respondTime":0,"users":3},"ST0328 I like you":{"exits":0,"intent":"ST0328 I like you","interactions":5,"respondTime":0,"users":5},"ST0329 I want to talk with you":{"exits":0,"intent":"ST0329 I want to talk with you","interactions":2,"respondTime":0,"users":2},"ST0330 It is nice to meet you":{"exits":0,"intent":"ST0330 It is nice to meet you","interactions":1,"respondTime":0,"users":1},"ST0332 That is great":{"exits":0,"intent":"ST0332 That is great","interactions":2,"respondTime":0,"users":2},"ST0334 What am I?":{"exits":0,"intent":"ST0334 What am I?","interactions":1,"respondTime":0,"users":1},"ST0336 What are you wearing?":{"exits":0,"intent":"ST0336 What are you wearing?","interactions":1,"respondTime":0,"users":1},"ST0337 What language do you speak?":{"exits":0,"intent":"ST0337 What language do you speak?","interactions":16,"respondTime":0,"users":15},"ST0338 I'm bored":{"exits":0,"intent":"ST0338 I'm bored","interactions":4,"respondTime":0,"users":4},"ST0339 Have a nice day!":{"exits":0,"intent":"ST0339 Have a nice day!","interactions":16,"respondTime":0,"users":10},"ST0340 how to win in Theme Park?":{"exits":0,"intent":"ST0340 how to win in Theme Park?","interactions":2,"respondTime":0,"users":2},"ST0342 i need help in buying":{"exits":0,"intent":"ST0342 i need help in buying","interactions":8,"respondTime":0,"users":6},"ST0700 Happy Emoji":{"exits":0,"intent":"ST0700 Happy Emoji","interactions":1,"respondTime":0,"users":1},"ST0800 Profanity 1":{"exits":0,"intent":"ST0800 Profanity 1","interactions":23,"respondTime":0,"users":19},"ST700 Emoji Happy":{"exits":0,"intent":"ST700 Emoji Happy","interactions":5,"respondTime":0,"users":4},"TT - Renew Status":{"exits":0,"intent":"TT - Renew Status","interactions":2,"respondTime":0,"users":2},"i1001 About Us":{"exits":0,"intent":"i1001 About Us","interactions":22,"respondTime":0,"users":22},"i1002 Wheel Chair Stroller":{"exits":0,"intent":"i1002 Wheel Chair Stroller","interactions":69,"respondTime":0,"users":33},"i1003 Operating Hours":{"exits":0,"intent":"i1003 Operating Hours","interactions":46,"respondTime":0,"users":30},"i1004 Promotions":{"exits":0,"intent":"i1004 Promotions","interactions":324,"respondTime":0,"users":270},"i1006 Download Mobile App":{"exits":0,"intent":"i1006 Download Mobile App","interactions":82,"respondTime":0,"users":70},"i1007 Map":{"exits":0,"intent":"i1007 Map","interactions":6,"respondTime":0,"users":6},"i1008 Where Is ":{"exits":0,"intent":"i1008 Where Is ","interactions":1,"respondTime":0,"users":1},"i1009 Leisure":{"exits":0,"intent":"i1009 Leisure","interactions":36,"respondTime":0,"users":31},"i1010 Theme Park":{"exits":0,"intent":"i1010 Theme Park","interactions":206,"respondTime":0,"users":162},"i1012 Theme Park":{"exits":0,"intent":"i1012 Theme Park","interactions":48,"respondTime":0,"users":37},"i1013 Weather":{"exits":0,"intent":"i1013 Weather","interactions":3,"respondTime":0,"users":3},"i1015 Childcare Center":{"exits":0,"intent":"i1015 Childcare Center","interactions":1,"respondTime":0,"users":1},"i1016 Clinic":{"exits":0,"intent":"i1016 Clinic","interactions":3,"respondTime":0,"users":3},"i1017 Where is money changer?":{"exits":0,"intent":"i1017 Where is money changer?","interactions":1,"respondTime":0,"users":1},"i1018 Can I Bring Pets":{"exits":0,"intent":"i1018 Can I Bring Pets","interactions":2,"respondTime":0,"users":2},"i1019 School":{"exits":0,"intent":"i1019 School","interactions":1,"respondTime":0,"users":1},"i1020 Hospital":{"exits":0,"intent":"i1020 Hospital","interactions":1,"respondTime":0,"users":1},"i1021 History":{"exits":0,"intent":"i1021 History","interactions":3,"respondTime":0,"users":3},"i1022 Convenient Stores":{"exits":0,"intent":"i1022 Convenient Stores","interactions":3,"respondTime":0,"users":2},"i1024 Best Time to Visit":{"exits":0,"intent":"i1024 Best Time to Visit","interactions":3,"respondTime":0,"users":3},"i1026 Suitable Clothes":{"exits":0,"intent":"i1026 Suitable Clothes","interactions":1,"respondTime":0,"users":1},"i1027 Durian allowed?":{"exits":0,"intent":"i1027 Durian allowed?","interactions":10,"respondTime":0,"users":6},"i1028 Where is police station":{"exits":0,"intent":"i1028 Where is police station","interactions":1,"respondTime":0,"users":1},"i1029 Contact Center Operation Hours":{"exits":0,"intent":"i1029 Contact Center Operation Hours","interactions":16,"respondTime":0,"users":15},"i1030 Emergency Disaster":{"exits":0,"intent":"i1030 Emergency Disaster","interactions":1,"respondTime":0,"users":1},"i1031 Cruise Ship Booking":{"exits":0,"intent":"i1031 Cruise Ship Booking","interactions":4,"respondTime":0,"users":3},"i1033 Free Wifi":{"exits":0,"intent":"i1033 Free Wifi","interactions":4,"respondTime":0,"users":4},"i1034 Fitness Center":{"exits":0,"intent":"i1034 Fitness Center","interactions":6,"respondTime":0,"users":5},"i1035 Surau":{"exits":0,"intent":"i1035 Surau","interactions":2,"respondTime":0,"users":2},"i1036 Luggage Storage":{"exits":0,"intent":"i1036 Luggage Storage","interactions":8,"respondTime":0,"users":7},"i1037 Pharmacy":{"exits":0,"intent":"i1037 Pharmacy","interactions":1,"respondTime":0,"users":1},"i1038 Baby Changing Room":{"exits":0,"intent":"i1038 Baby Changing Room","interactions":2,"respondTime":0,"users":2},"i1039 Tourism Tax":{"exits":0,"intent":"i1039 Tourism Tax","interactions":2,"respondTime":0,"users":2},"i1040  ATM Machine":{"exits":0,"intent":"i1040  ATM Machine","interactions":3,"respondTime":0,"users":3},"i1042 Subscribe Newsletter":{"exits":0,"intent":"i1042 Subscribe Newsletter","interactions":1,"respondTime":0,"users":1},"i1043 Privacy Policy":{"exits":0,"intent":"i1043 Privacy Policy","interactions":1,"respondTime":0,"users":1},"i1044 Job Opening":{"exits":0,"intent":"i1044 Job Opening","interactions":25,"respondTime":0,"users":17},"i1045 Baby Cot":{"exits":0,"intent":"i1045 Baby Cot","interactions":2,"respondTime":0,"users":2},"i1100 General Complaint":{"exits":0,"intent":"i1100 General Complaint","interactions":1700,"respondTime":0,"users":1053},"i1101 Reset Password":{"exits":0,"intent":"i1101 Reset Password","interactions":235,"respondTime":0,"users":176},"i1102 Room Lost and Found":{"exits":0,"intent":"i1102 Room Lost and Found","interactions":56,"respondTime":0,"users":41},"i1103 Forgot Email":{"exits":0,"intent":"i1103 Forgot Email","interactions":64,"respondTime":0,"users":52},"i1104 Contact Number":{"exits":0,"intent":"i1104 Contact Number","interactions":212,"respondTime":0,"users":186},"i1105 Hotline Busy":{"exits":0,"intent":"i1105 Hotline Busy","interactions":27,"respondTime":0,"users":23},"i1106 Lost Ticket":{"exits":0,"intent":"i1106 Lost Ticket","interactions":3,"respondTime":0,"users":1},"i1107 Email":{"exits":0,"intent":"i1107 Email","interactions":162,"respondTime":0,"users":131},"i1108 System App Issue":{"exits":0,"intent":"i1108 System App Issue","interactions":7,"respondTime":0,"users":6},"i1200 Getting There":{"exits":0,"intent":"i1200 Getting There","interactions":173,"respondTime":0,"users":150},"i1201 Express Bus":{"exits":0,"intent":"i1201 Express Bus","interactions":162,"respondTime":0,"users":89},"i1202 Parking Rates":{"exits":0,"intent":"i1202 Parking Rates","interactions":69,"respondTime":0,"users":44},"i1203  Bus Terminal":{"exits":0,"intent":"i1203  Bus Terminal","interactions":96,"respondTime":0,"users":58},"i1204 Parking Map":{"exits":0,"intent":"i1204 Parking Map","interactions":41,"respondTime":0,"users":28},"i1205 Free Parking":{"exits":0,"intent":"i1205 Free Parking","interactions":41,"respondTime":0,"users":31},"i1206 Getting There KLIA":{"exits":0,"intent":"i1206 Getting There KLIA","interactions":30,"respondTime":0,"users":23},"i1207 Free Shuttle Bus":{"exits":0,"intent":"i1207 Free Shuttle Bus","interactions":66,"respondTime":0,"users":49},"i1208 Lost Parking Ticket":{"exits":0,"intent":"i1208 Lost Parking Ticket","interactions":1,"respondTime":0,"users":1},"i1209 Parking Grace Period":{"exits":0,"intent":"i1209 Parking Grace Period","interactions":4,"respondTime":0,"users":4},"i1210 Book Complimentary Limousine":{"exits":0,"intent":"i1210 Book Complimentary Limousine","interactions":30,"respondTime":0,"users":26},"i1211 Taxi":{"exits":0,"intent":"i1211 Taxi","interactions":6,"respondTime":0,"users":5},"i1212 Where is Hotel":{"exits":0,"intent":"i1212 Where is Hotel","interactions":3,"respondTime":0,"users":3},"i1213 Safe to Buy?":{"exits":0,"intent":"i1213 Safe to Buy?","interactions":2,"respondTime":0,"users":2},"i1214 Valet Parking":{"exits":0,"intent":"i1214 Valet Parking","interactions":12,"respondTime":0,"users":10},"i1215 Walking around ":{"exits":0,"intent":"i1215 Walking around ","interactions":5,"respondTime":0,"users":3},"i1216 Travel Duration":{"exits":0,"intent":"i1216 Travel Duration","interactions":21,"respondTime":0,"users":19},"i1218 Shuttle From Airport":{"exits":0,"intent":"i1218 Shuttle From Airport","interactions":7,"respondTime":0,"users":7},"i1219 Limo Service":{"exits":0,"intent":"i1219 Limo Service","interactions":1,"respondTime":0,"users":1},"i1220 Parking Lot Issue":{"exits":0,"intent":"i1220 Parking Lot Issue","interactions":13,"respondTime":0,"users":13},"i1221 Motobike Parking":{"exits":0,"intent":"i1221 Motobike Parking","interactions":5,"respondTime":0,"users":5},"i1222 Shuttle Bus Schedule":{"exits":0,"intent":"i1222 Shuttle Bus Schedule","interactions":52,"respondTime":0,"users":33},"i2000 Adjoining Room":{"exits":0,"intent":"i2000 Adjoining Room","interactions":246,"respondTime":0,"users":193},"i2001 Extra Bed":{"exits":0,"intent":"i2001 Extra Bed","interactions":77,"respondTime":0,"users":56},"i2002 Smoking Room":{"exits":0,"intent":"i2002 Smoking Room","interactions":7,"respondTime":0,"users":6},"i2003 Room Late Check Out":{"exits":0,"intent":"i2003 Room Late Check Out","interactions":43,"respondTime":0,"users":35},"i2004 Room Check In Time":{"exits":0,"intent":"i2004 Room Check In Time","interactions":221,"respondTime":0,"users":175},"i2005 Room Check Out Time":{"exits":0,"intent":"i2005 Room Check Out Time","interactions":64,"respondTime":0,"users":60},"i2006 Room Check In Age":{"exits":0,"intent":"i2006 Room Check In Age","interactions":52,"respondTime":0,"users":44},"i2007 Room Swimming Pool":{"exits":0,"intent":"i2007 Room Swimming Pool","interactions":3,"respondTime":0,"users":2},"i2009 Any Other Hotels":{"exits":0,"intent":"i2009 Any Other Hotels","interactions":5,"respondTime":0,"users":5},"i2012 Resort World Sentosa":{"exits":0,"intent":"i2012 Resort World Sentosa","interactions":9,"respondTime":0,"users":6},"i2013 5 Star Hotels":{"exits":0,"intent":"i2013 5 Star Hotels","interactions":1,"respondTime":0,"users":1},"i2014 Reception Operating Hours":{"exits":0,"intent":"i2014 Reception Operating Hours","interactions":3,"respondTime":0,"users":3},"i2015 Room Breakfast":{"exits":0,"intent":"i2015 Room Breakfast","interactions":5,"respondTime":0,"users":5},"i2016 Non Smoking Room":{"exits":0,"intent":"i2016 Non Smoking Room","interactions":8,"respondTime":0,"users":7},"i2017 Room Size":{"exits":0,"intent":"i2017 Room Size","interactions":3,"respondTime":0,"users":3},"i2018 Using Hotel SPA":{"exits":0,"intent":"i2018 Using Hotel SPA","interactions":9,"respondTime":0,"users":3},"i2020 Room Special Request":{"exits":0,"intent":"i2020 Room Special Request","interactions":23,"respondTime":0,"users":23},"i2021 Hotel Breakfast Starting":{"exits":0,"intent":"i2021 Hotel Breakfast Starting","interactions":8,"respondTime":0,"users":5},"i2023 Room Comes with Free Meal":{"exits":0,"intent":"i2023 Room Comes with Free Meal","interactions":3,"respondTime":0,"users":3},"i2024 First World Bed Type":{"exits":0,"intent":"i2024 First World Bed Type","interactions":59,"respondTime":0,"users":36},"i2100 Stock Price":{"exits":0,"intent":"i2100 Stock Price","interactions":2327,"respondTime":0,"users":1691},"i2101 Complimentary Room Request":{"exits":0,"intent":"i2101 Complimentary Room Request","interactions":708,"respondTime":0,"users":610},"i2102 Stock Selling":{"exits":0,"intent":"i2102 Stock Selling","interactions":502,"respondTime":0,"users":391},"i2103 Stock Buying":{"exits":0,"intent":"i2103 Stock Buying","interactions":448,"respondTime":0,"users":342},"i2104 Room Reservation Full":{"exits":0,"intent":"i2104 Room Reservation Full","interactions":162,"respondTime":0,"users":121},"i2105 Early Check In":{"exits":0,"intent":"i2105 Early Check In","interactions":418,"respondTime":0,"users":252},"i2106 Check In On Behalf":{"exits":0,"intent":"i2106 Check In On Behalf","interactions":287,"respondTime":0,"users":225},"i2107 Multiroom Booking":{"exits":0,"intent":"i2107 Multiroom Booking","interactions":133,"respondTime":0,"users":103},"i2108 Room Upgrade Request":{"exits":0,"intent":"i2108 Room Upgrade Request","interactions":75,"respondTime":0,"users":66},"i2109 Transfer Room Booking":{"exits":0,"intent":"i2109 Transfer Room Booking","interactions":225,"respondTime":0,"users":209},"i2110 Change Booking Date":{"exits":0,"intent":"i2110 Change Booking Date","interactions":187,"respondTime":0,"users":147},"i2111 Help Reserve A Room":{"exits":0,"intent":"i2111 Help Reserve A Room","interactions":123,"respondTime":0,"users":109},"i2112 Room Cancellation Special Reason":{"exits":0,"intent":"i2112 Room Cancellation Special Reason","interactions":3,"respondTime":0,"users":3},"i2113 Room Wheelchair Friendly":{"exits":0,"intent":"i2113 Room Wheelchair Friendly","interactions":24,"respondTime":0,"users":21},"i2114 Room Complimentary Birthday":{"exits":0,"intent":"i2114 Room Complimentary Birthday","interactions":479,"respondTime":0,"users":382},"i2115 Stock FAQ":{"exits":0,"intent":"i2115 Stock FAQ","interactions":1618,"respondTime":0,"users":1080},"i2116 Room Complimentary Give Away":{"exits":0,"intent":"i2116 Room Complimentary Give Away","interactions":3,"respondTime":0,"users":3},"i2117 Room Complimentary Dynamic Stay":{"exits":0,"intent":"i2117 Room Complimentary Dynamic Stay","interactions":21,"respondTime":0,"users":21},"i2118 Room Complimentary How to know free room":{"exits":0,"intent":"i2118 Room Complimentary How to know free room","interactions":24,"respondTime":0,"users":19},"i2119 Room Reservation Combine Nights":{"exits":0,"intent":"i2119 Room Reservation Combine Nights","interactions":16,"respondTime":0,"users":13},"i2120 OTA Points Redemption":{"exits":0,"intent":"i2120 OTA Points Redemption","interactions":9,"respondTime":0,"users":8},"i2121 OTT Booking":{"exits":0,"intent":"i2121 OTT Booking","interactions":6,"respondTime":0,"users":5},"i2122 Room Amenities":{"exits":0,"intent":"i2122 Room Amenities","interactions":131,"respondTime":0,"users":111},"i2123 Room Reservation Ammend Comp Room":{"exits":0,"intent":"i2123 Room Reservation Ammend Comp Room","interactions":3,"respondTime":0,"users":3},"i2125 Room Reservation Cancel Comp Room":{"exits":0,"intent":"i2125 Room Reservation Cancel Comp Room","interactions":20,"respondTime":0,"users":18},"i2126 Family Room Reservations":{"exits":0,"intent":"i2126 Family Room Reservations","interactions":100,"respondTime":0,"users":79},"i2127 Book Hour Use":{"exits":0,"intent":"i2127 Book Hour Use","interactions":12,"respondTime":0,"users":11},"i2129 Room Reservation Under Different Category":{"exits":0,"intent":"i2129 Room Reservation Under Different Category","interactions":8,"respondTime":0,"users":8},"i2130 Room Invoice":{"exits":0,"intent":"i2130 Room Invoice","interactions":14,"respondTime":0,"users":5},"i2131 Maximum People in Room":{"exits":0,"intent":"i2131 Maximum People in Room","interactions":22,"respondTime":0,"users":21},"i2132 Foreigner Passport Number":{"exits":0,"intent":"i2132 Foreigner Passport Number","interactions":13,"respondTime":0,"users":10},"i2133 Book Room Using Membership":{"exits":0,"intent":"i2133 Book Room Using Membership","interactions":540,"respondTime":0,"users":433},"i2134 Book Room Using - Video":{"exits":0,"intent":"i2134 Book Room Using - Video","interactions":427,"respondTime":0,"users":357},"i2135 Book Room Using - Image":{"exits":0,"intent":"i2135 Book Room Using - Image","interactions":184,"respondTime":0,"users":160},"i2136 Did Not Receive Booking Confirmation":{"exits":0,"intent":"i2136 Did Not Receive Booking Confirmation","interactions":57,"respondTime":0,"users":53},"i2200 Make Payment For Booking":{"exits":0,"intent":"i2200 Make Payment For Booking","interactions":61,"respondTime":0,"users":43},"i2202 Payment in Singapore":{"exits":0,"intent":"i2202 Payment in Singapore","interactions":2,"respondTime":0,"users":2},"i2203 Payment in Singapore using RM":{"exits":0,"intent":"i2203 Payment in Singapore using RM","interactions":2,"respondTime":0,"users":2},"i2204 Sales Office":{"exits":0,"intent":"i2204 Sales Office","interactions":10,"respondTime":0,"users":8},"i2205 Third Party Sites Booking":{"exits":0,"intent":"i2205 Third Party Sites Booking","interactions":40,"respondTime":0,"users":31},"i2206 Third Party Vouchers":{"exits":0,"intent":"i2206 Third Party Vouchers","interactions":71,"respondTime":0,"users":40},"i2301 Cannot Log In":{"exits":0,"intent":"i2301 Cannot Log In","interactions":409,"respondTime":0,"users":292},"i2302 Retrieve Membership ID":{"exits":0,"intent":"i2302 Retrieve Membership ID","interactions":372,"respondTime":0,"users":256},"i2303 Lost Card":{"exits":0,"intent":"i2303 Lost Card","interactions":192,"respondTime":0,"users":165},"i2304 Point Expiry":{"exits":0,"intent":"i2304 Point Expiry","interactions":1,"respondTime":0,"users":1},"i2305 Earn Points":{"exits":0,"intent":"i2305 Earn Points","interactions":24,"respondTime":0,"users":22},"i2306 Tier Points":{"exits":0,"intent":"i2306 Tier Points","interactions":30,"respondTime":0,"users":24},"i2307 Activate Membership":{"exits":0,"intent":"i2307 Activate Membership","interactions":33,"respondTime":0,"users":23},"i2308 No Points Added":{"exits":0,"intent":"i2308 No Points Added","interactions":88,"respondTime":0,"users":67},"i2309 Membership Benefits":{"exits":0,"intent":"i2309 Membership Benefits","interactions":43,"respondTime":0,"users":40},"i2310 Apply for Membership":{"exits":0,"intent":"i2310 Apply for Membership","interactions":71,"respondTime":0,"users":53},"i2311 Under 18 Join Membership":{"exits":0,"intent":"i2311 Under 18 Join Membership","interactions":15,"respondTime":0,"users":13},"i2312 Number of Member Card Can Apply":{"exits":0,"intent":"i2312 Number of Member Card Can Apply","interactions":11,"respondTime":0,"users":8},"i2313 Number of Supplimentary Card":{"exits":0,"intent":"i2313 Number of Supplimentary Card","interactions":6,"respondTime":0,"users":5},"i2314 Tier Points Expiry":{"exits":0,"intent":"i2314 Tier Points Expiry","interactions":13,"respondTime":0,"users":12},"i2315 Update Membership Details":{"exits":0,"intent":"i2315 Update Membership Details","interactions":158,"respondTime":0,"users":141},"i2317 Member Card Lost and Found":{"exits":0,"intent":"i2317 Member Card Lost and Found","interactions":8,"respondTime":0,"users":6},"i2318 Reward Alliance Website":{"exits":0,"intent":"i2318 Reward Alliance Website","interactions":5,"respondTime":0,"users":5},"i2319 Member Renew Membership":{"exits":0,"intent":"i2319 Member Renew Membership","interactions":47,"respondTime":0,"users":39},"i2320 Check Points":{"exits":0,"intent":"i2320 Check Points","interactions":38,"respondTime":0,"users":32},"i3100 Where Is SkyTheme Park":{"exits":0,"intent":"i3100 Where Is SkyTheme Park","interactions":5,"respondTime":0,"users":5},"i3101 Theme Park Dress Code":{"exits":0,"intent":"i3101 Theme Park Dress Code","interactions":8,"respondTime":0,"users":8},"i3102 Theme Park Operating Hours":{"exits":0,"intent":"i3102 Theme Park Operating Hours","interactions":1,"respondTime":0,"users":1},"i3103 Sign Up Minimum Age":{"exits":0,"intent":"i3103 Sign Up Minimum Age","interactions":11,"respondTime":0,"users":9},"i3104 Currency Accepted":{"exits":0,"intent":"i3104 Currency Accepted","interactions":1,"respondTime":0,"users":1},"i3200 Concert Collect Tickets":{"exits":0,"intent":"i3200 Concert Collect Tickets","interactions":111,"respondTime":0,"users":73},"i3201 Concert Collect On Behalf":{"exits":0,"intent":"i3201 Concert Collect On Behalf","interactions":31,"respondTime":0,"users":24},"i3201 Concet Collect On Behalf":{"exits":0,"intent":"i3201 Concet Collect On Behalf","interactions":1,"respondTime":0,"users":1},"i3202 Concert Transfer Ticket":{"exits":0,"intent":"i3202 Concert Transfer Ticket","interactions":17,"respondTime":0,"users":16},"i3203 Concert Refund Ticket":{"exits":0,"intent":"i3203 Concert Refund Ticket","interactions":4,"respondTime":0,"users":4},"i3204 Concert Lost Ticket":{"exits":0,"intent":"i3204 Concert Lost Ticket","interactions":6,"respondTime":0,"users":4},"i3205 Concert Where to Buy":{"exits":0,"intent":"i3205 Concert Where to Buy","interactions":72,"respondTime":0,"users":59},"i3206 Concert Kids Ticket":{"exits":0,"intent":"i3206 Concert Kids Ticket","interactions":33,"respondTime":0,"users":24},"i3207 Concert Package":{"exits":0,"intent":"i3207 Concert Package","interactions":42,"respondTime":0,"users":33},"i3208 Concert Sold Out":{"exits":0,"intent":"i3208 Concert Sold Out","interactions":6,"respondTime":0,"users":4},"i3209 Concert Complimentary Ticket":{"exits":0,"intent":"i3209 Concert Complimentary Ticket","interactions":3,"respondTime":0,"users":3},"i3210 Concert Event Info":{"exits":0,"intent":"i3210 Concert Event Info","interactions":128,"respondTime":0,"users":111},"i3211 Concert Early Bird Booking":{"exits":0,"intent":"i3211 Concert Early Bird Booking","interactions":2,"respondTime":0,"users":2},"i3212 Concert Preferred Seats":{"exits":0,"intent":"i3212 Concert Preferred Seats","interactions":21,"respondTime":0,"users":17},"i3300 Theme Park Attractions":{"exits":0,"intent":"i3300 Theme Park Attractions","interactions":102,"respondTime":0,"users":85},"i3301 Fees For Adults":{"exits":0,"intent":"i3301 Fees For Adults","interactions":8,"respondTime":0,"users":7},"i3303 Operating Hours":{"exits":0,"intent":"i3303 Operating Hours","interactions":14,"respondTime":0,"users":14},"i3304 Product Price":{"exits":0,"intent":"i3304 Product Price","interactions":58,"respondTime":0,"users":41},"i3306 Where is Box Office":{"exits":0,"intent":"i3306 Where is Box Office","interactions":38,"respondTime":0,"users":33},"i3307 Where is toilet":{"exits":0,"intent":"i3307 Where is toilet","interactions":53,"respondTime":0,"users":41},"i3308 Where is the indoor themepark?":{"exits":0,"intent":"i3308 Where is the indoor themepark?","interactions":20,"respondTime":0,"users":18},"i3309 Get To HQ":{"exits":0,"intent":"i3309 Get To HQ","interactions":2,"respondTime":0,"users":2},"i3310 Shopping Directory":{"exits":0,"intent":"i3310 Shopping Directory","interactions":2,"respondTime":0,"users":2},"i3311 Where to Shop":{"exits":0,"intent":"i3311 Where to Shop","interactions":36,"respondTime":0,"users":33},"i3312 Where is cinema?":{"exits":0,"intent":"i3312 Where is cinema?","interactions":8,"respondTime":0,"users":6},"i3313 Branch Operating Hours":{"exits":0,"intent":"i3313 Branch Operating Hours","interactions":7,"respondTime":0,"users":5},"i3314 Theme Park Ticket Purchase":{"exits":0,"intent":"i3314 Theme Park Ticket Purchase","interactions":80,"respondTime":0,"users":58},"i3315 Office Operating Hours":{"exits":0,"intent":"i3315 Office Operating Hours","interactions":2,"respondTime":0,"users":2},"i3316 Wedding Plans":{"exits":0,"intent":"i3316 Wedding Plans","interactions":5,"respondTime":0,"users":4},"i3317 Wedding Package":{"exits":0,"intent":"i3317 Wedding Package","interactions":1,"respondTime":0,"users":1},"i3318 Itinerary Advisor":{"exits":0,"intent":"i3318 Itinerary Advisor","interactions":11,"respondTime":0,"users":8},"i3320 Wedding Price":{"exits":0,"intent":"i3320 Wedding Price","interactions":1,"respondTime":0,"users":1},"i3321 Entrance Price":{"exits":0,"intent":"i3321 Entrance Price","interactions":15,"respondTime":0,"users":12},"i3322 Golf Booking":{"exits":0,"intent":"i3322 Golf Booking","interactions":14,"respondTime":0,"users":12},"i3323 Child Rates":{"exits":0,"intent":"i3323 Child Rates","interactions":13,"respondTime":0,"users":9},"i3324 Corporate Event":{"exits":0,"intent":"i3324 Corporate Event","interactions":8,"respondTime":0,"users":7},"i3325 Medical Claims":{"exits":0,"intent":"i3325 Medical Claims","interactions":1,"respondTime":0,"users":1},"i3326 Salary Deduction":{"exits":0,"intent":"i3326 Salary Deduction","interactions":13,"respondTime":0,"users":9},"i3327 Salary Claims":{"exits":0,"intent":"i3327 Salary Claims","interactions":20,"respondTime":0,"users":18},"i3400 Dining":{"exits":0,"intent":"i3400 Dining","interactions":86,"respondTime":0,"users":62},"i3401 Salary Payment":{"exits":0,"intent":"i3401 Salary Payment","interactions":26,"respondTime":0,"users":21},"i3402 Interest Charged":{"exits":0,"intent":"i3402 Interest Charged","interactions":6,"respondTime":0,"users":6},"i3403 Interest Gained":{"exits":0,"intent":"i3403 Interest Gained","interactions":25,"respondTime":0,"users":18},"i3404 Payment Card":{"exits":0,"intent":"i3404 Payment Card","interactions":2,"respondTime":0,"users":2},"i3405 Restaurant Reservation":{"exits":0,"intent":"i3405 Restaurant Reservation","interactions":6,"respondTime":0,"users":5},"t1001 - Renew Status":{"exits":0,"intent":"t1001 - Renew Status","interactions":1,"respondTime":0,"users":1},"tt - Vendor Test":{"exits":0,"intent":"tt - Vendor Test","interactions":2,"respondTime":0,"users":1},"tt - testing":{"exits":0,"intent":"tt - testing","interactions":6,"respondTime":0,"users":5},"tt New Complaint":{"exits":0,"intent":"tt New Complaint","interactions":3,"respondTime":0,"users":1}},"totals":{"interactions":{"total":29684},"messages":{"agent":{"fb":60,"total":60},"bot":{"fb":2311,"total":2311},"total":{"fb":4713,"total":4713},"user":{"fb":2342,"total":2342}},"users":{"total":5454}}}

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuexfire__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuexfire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuexfire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_auth__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_messaging__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_database__ = __webpack_require__(298);









__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var client = __WEBPACK_IMPORTED_MODULE_4_firebase_app___default.a.initializeApp({
  apiKey: 'AIzaSyCHU86xU-M2zxWg8lnuJOD9WhdPVhQ5CTM',
  authDomain: 'ci-bank-f7673.firebaseapp.com',
  databaseURL: 'https://ci-bank-f7673.firebaseio.com',
  projectId: 'ci-bank-f7673',
  storageBucket: 'ci-bank-f7673.appspot.com',
  messagingSenderId: '931934724781'
}, 'balala').database();
var usersRef = client.ref('users');

var state = {
  bot: 'CI-Bank',
  client: {
    apiKey: 'AIzaSyCHU86xU-M2zxWg8lnuJOD9WhdPVhQ5CTM',
    authDomain: 'ci-bank-f7673.firebaseapp.com',
    databaseURL: 'https://ci-bank-f7673.firebaseio.com',
    projectId: 'ci-bank-f7673',
    storageBucket: 'ci-bank-f7673.appspot.com',
    messagingSenderId: '931934724781'
  },
  users: [],
  profile: {},
  firebaseLoginPushKey: null,
  graphData: {},
  graphPieData: {},
  startEndDate: {},
  graphOutdatedStatus: false,
  graphStatus: 'sevenDays',
  listOfAllQuickReplies: [],
  newIntents: {},
  newEditedIntent: {},
  editIntentDetails: {},
  removeIntent: null,
  actionInIntentPage: null,
  asideStatus: false
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
  switchBot: function switchBot(state, bot) {
    state.bot = bot;
  },
  writeProfile: function writeProfile(state, profile) {
    state.profile = profile;
  },
  writeGraphData: function writeGraphData(state, graphData) {
    state.graphData = graphData;
  },
  writeGraphPieData: function writeGraphPieData(state, graphPieData) {
    state.graphPieData = graphPieData;
  },
  writeStartEndDate: function writeStartEndDate(state, startEndDate) {
    state.startEndDate = startEndDate;
  },
  writeGraphStatus: function writeGraphStatus(state, graphStatus) {
    state.graphStatus = graphStatus;
  },
  writeGraphOutdatedStatus: function writeGraphOutdatedStatus(state, graphOutdatedStatus) {
    state.graphOutdatedStatus = graphOutdatedStatus;
  },
  writeQuickReplies: function writeQuickReplies(state, QuickReplies) {
    state.listOfAllQuickReplies = QuickReplies;
  },
  writeNewIntents: function writeNewIntents(state, newIntents) {
    state.newIntents = newIntents;
  },
  writeNewEditedIntent: function writeNewEditedIntent(state, newEditedIntent) {
    state.newEditedIntent = newEditedIntent;
  },
  writeEditedIntents: function writeEditedIntents(state, editIntentDetails) {
    state.editIntentDetails = editIntentDetails;
  },
  writeRemoveIntent: function writeRemoveIntent(state, removeIntent) {
    state.removeIntent = removeIntent;
  },
  writeActionInIntentPage: function writeActionInIntentPage(state, actionInIntentPage) {
    state.actionInIntentPage = actionInIntentPage;
  },
  writeAsideStatus: function writeAsideStatus(state, asideStatus) {
    state.asideStatus = asideStatus;
  }
}, __WEBPACK_IMPORTED_MODULE_3_vuexfire__["firebaseMutations"]);

var getters = {
  users: function users(state) {
    return state.users;
  },
  getGraphStatus: function getGraphStatus(state) {
    return state.graphStatus;
  },
  getGraphData: function getGraphData(state) {
    return state.graphData;
  },
  getStartEndDate: function getStartEndDate(state) {
    return state.startEndDate;
  },
  getProfile: function getProfile(state) {
    return state.getProfile;
  },
  getListOfAllQuickReplies: function getListOfAllQuickReplies(state) {
    return state.getListOfAllQuickReplies;
  },
  getNewIntents: function getNewIntents(state) {
    return state.getNewIntents;
  },
  getNewEditedIntent: function getNewEditedIntent(state) {
    return state.newEditedIntent;
  },
  getEditIntents: function getEditIntents(state) {
    return state.editIntentDetails;
  },
  getRemoveIntent: function getRemoveIntent(state) {
    return state.removeIntent;
  },
  getActionInIntentPage: function getActionInIntentPage(state) {
    return state.actionInIntentPage;
  }
};

var actions = {
  setRef: Object(__WEBPACK_IMPORTED_MODULE_3_vuexfire__["firebaseAction"])(function (_ref) {
    var bindFirebaseRef = _ref.bindFirebaseRef;

    bindFirebaseRef('users', usersRef);
  }),
  resetRef: Object(__WEBPACK_IMPORTED_MODULE_3_vuexfire__["firebaseAction"])(function (_ref2) {
    var bindFirebaseRef = _ref2.bindFirebaseRef,
        unbindFirebaseRef = _ref2.unbindFirebaseRef;

    var client = __WEBPACK_IMPORTED_MODULE_4_firebase_app___default.a.initializeApp({
      apiKey: 'AIzaSyAtx1NqOWzYQq5slsvK9OTj3DJti8hm4wk',
      authDomain: 'newagent-1faac.firebaseapp.com',
      databaseURL: 'https://newagent-1faac.firebaseio.com',
      messagingSenderId: 293510565120,
      projectId: 'newagent-1faac',
      storageBucket: 'newagent-1faac.appspot.com'
    }, 'balele').database();
    var usersRef = client.ref('users');
    unbindFirebaseRef('users');
    bindFirebaseRef('users', usersRef);
  }),
  changeFBRef: function changeFBRef(_ref3, botName) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    commit('switchBot', botName);
    dispatch('resetRef');
  },
  setProfile: function setProfile(_ref4, profile) {
    var commit = _ref4.commit;

    commit('writeProfile', profile);
  },
  setGraphData: function setGraphData(_ref5, graphData) {
    var commit = _ref5.commit;

    commit('writeGraphData', graphData);
  },
  setGraphPieData: function setGraphPieData(_ref6, graphPieData) {
    var commit = _ref6.commit;

    commit('writeGraphPieData', graphPieData);
  },
  setStartEndDate: function setStartEndDate(_ref7, startEndDate) {
    var commit = _ref7.commit;

    commit('writeStartEndDate', startEndDate);
  },
  setGraphStatus: function setGraphStatus(_ref8, graphStatus) {
    var commit = _ref8.commit;

    commit('writeGraphStatus', graphStatus);
  },
  setGraphOutdatedStatus: function setGraphOutdatedStatus(_ref9, graphOutdatedStatus) {
    var commit = _ref9.commit;

    commit('writeGraphOutdatedStatus', graphOutdatedStatus);
  },
  setListOfAllQuickReplies: function setListOfAllQuickReplies(_ref10, QuickReplies) {
    var commit = _ref10.commit;

    commit('writeQuickReplies', QuickReplies);
  },
  setNewIntents: function setNewIntents(_ref11, newIntents) {
    var commit = _ref11.commit;

    commit('writeNewIntents', newIntents);
  },
  setNewEditedIntent: function setNewEditedIntent(_ref12, newEditedIntent) {
    var commit = _ref12.commit;

    commit('writeNewEditedIntent', newEditedIntent);
  },
  setEditIntents: function setEditIntents(_ref13, editIntentDetails) {
    var commit = _ref13.commit;

    commit('writeEditedIntents', editIntentDetails);
  },
  setRemoveIntent: function setRemoveIntent(_ref14, removeIntent) {
    var commit = _ref14.commit;

    commit('writeRemoveIntent', removeIntent);
  },
  setActionInIntentPage: function setActionInIntentPage(_ref15, actionInIntentPage) {
    var commit = _ref15.commit;

    commit('writeActionInIntentPage', actionInIntentPage);
  },
  setAsideStatus: function setAsideStatus(_ref16, asideStatus) {
    var commit = _ref16.commit;

    document.body.classList.toggle('aside-menu-hidden');
    commit('writeAsideStatus', asideStatus);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
}));

/***/ }),

/***/ 304:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 673:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fragments__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_moment__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_snotify__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_chartjs_plugin_datalabels__ = __webpack_require__(1590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_chartjs_plugin_datalabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_chartjs_plugin_datalabels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__gravitano_vue_date_range_picker__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__gravitano_vue_date_range_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__gravitano_vue_date_range_picker__);















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11__gravitano_vue_date_range_picker___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6__components__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7__fragments__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_snotify__["b" /* default */], {
  toast: {
    position: __WEBPACK_IMPORTED_MODULE_9_vue_snotify__["a" /* SnotifyPosition */].rightTop
  }
});

var app = void 0;

__WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* auth */].onAuthStateChanged(function (user) {
  if (!app) {
    app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
      el: '#app',
      router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
      store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
      template: '<App/>',
      components: {
        App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],
        ChartJsPluginDataLabels: __WEBPACK_IMPORTED_MODULE_10_chartjs_plugin_datalabels___default.a
      },
      data: {}
    });
  }
});

/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return sendMsg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sendMsgGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cancelCountdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCountdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return pauseAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return resumeAll; });
/* unused harmony export assignUserIDnewestChat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return recordDataLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getDFIntents; });
/* unused harmony export createDFIntents */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deleteDFIntents; });
/* unused harmony export patchDFIntents */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return translateServer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);



var base = 'https://cibankdemo-server-1908.herokuapp.com/';

function sendMsg(content) {
  var def = {
    platform: 'webPopup',
    userID: 2051557634917072,
    message: 'Someone sent somethings from dashboard but forgot to type stuff'
  };
  content = content || def;
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    fetch(base + 'dashboard/sendMsg', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(content)
    }).then(function (response) {
      var resObj = response.json();
      resolve(resObj);
    });
  });
}

function sendMsgGroup(content) {
  var def = {
    platform: 'webPopup',
    campaignGroup: 'demo',
    campaign: 'Someone sent somethings from dashboard to everyone but forgot to type stuff'
  };
  content = content || def;
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    fetch(base + 'dashboard/sendCampaign', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(content)
    }).then(function (response) {
      var resObj = response.json();
      resolve(resObj);
    });
  });
}

function cancelCountdown(userID) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    fetch(base + 'dashboard/cancelStump', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ userID: userID })
    }).then(function (response) {
      var resObj = response.json();
      resolve(resObj);
    });
  });
}

function getCountdown(userID, flagKey) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    fetch(base + 'dashboard/remainingFlagTime', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ userID: userID, flagKey: flagKey })
    }).then(function (response) {
      var resObj = response.json();
      resolve(resObj);
    });
  });
}

function pauseAll() {
  fetch(base + 'dashboard/pauseAll');
}

function resumeAll() {
  fetch(base + 'dashboard/resumeAll');
}

function assignUserIDnewestChat(newestChatKey) {
  fetch(base + 'dashboard/assignUserIDnewestChat?nck=' + newestChatKey);
}

function recordDataLog(action, path, logBody, nnk) {
  var noNewKey = nnk || false;
  var body = {
    action: action,
    path: path,
    logBody: logBody,
    noNewKey: noNewKey
  };
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    fetch(base + 'dashboard/recordDataLog', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(body)
    }).then(function (res) {
      resolve(res.json());
    });
  });
}

function deleteDFIntents(intent) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    fetch(base + 'intents/deleteIntent', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(intent)
    }).then(function (res) {
      resolve(res.json());
    });
  });
}

function getDFIntents() {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    fetch(base + 'intents/getDialogflowIntents').then(function (response) {
      resolve(response);
    });
  });
}
function patchDFIntents(intentDetails) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    console.log('Patching Intent', intentDetails);
    fetch(base + 'intents/editIntent', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(intentDetails)
    }).then(function (res) {
      resolve(res.json());
    });
  });
}

function createDFIntents(intentsObj) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    fetch(base + 'intents/createDialogflowIntents', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(intentsObj)
    }).then(function (res) {
      resolve(res.json());
    });
  });
}

function translateServer(translateObject) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    fetch(base + 'webEntry/translateWebhook', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ translateObject: translateObject })
    }).then(function (res) {
      resolve(res.json());
    });
  });
}



/***/ }),

/***/ 743:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__(746);
function injectStyle (ssrContext) {
  __webpack_require__(744)
}
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 744:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 746:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_input__ = __webpack_require__(747);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* default */]);

/***/ }),

/***/ 752:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__(754);
function injectStyle (ssrContext) {
  __webpack_require__(753)
}
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 753:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 754:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_file__ = __webpack_require__(755);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* default */]);

/***/ }),

/***/ 770:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__(772);
function injectStyle (ssrContext) {
  __webpack_require__(771)
}
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 771:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 772:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__(773);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__modal__["a" /* default */]);

/***/ }),

/***/ 793:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__(795);
function injectStyle (ssrContext) {
  __webpack_require__(794)
}
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 794:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 795:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__(796);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__progress__["a" /* default */]);

/***/ }),

/***/ 799:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__(801);
function injectStyle (ssrContext) {
  __webpack_require__(800)
}
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 800:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 801:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__(802);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */]);

/***/ }),

/***/ 817:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5d1f832_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(821);
function injectStyle (ssrContext) {
  __webpack_require__(818)
  __webpack_require__(819)
}
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5d1f832_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 818:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 819:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 820:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ 821:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view'), _vm._v(" "), _c('vue-snotify')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 822:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__firebase__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layouts_Full__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Dashboard__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Interactions__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Interaction__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_InteractionsRT__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_InteractionMenu__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_VideoCall__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Users__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Data__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Graph__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Campaigns__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Campaign__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_CRM__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_Manual__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_Intents_IntentsList__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_CRM_appointment__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_CRM_motor_insurance__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_CRM_accountOpening__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_CRM_tm__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_Analytics_JobAnalytics__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_Analytics_VisitorTimeline__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_Analytics_DailyVisitor__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_Analytics_InteractionsTimeline__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_Analytics_DailyInteractions__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_Analytics_IntentsPie__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_Analytics_IntentsTreemap__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_Analytics_IntentsList__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_Fallback__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_404__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_Login__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_Logout__ = __webpack_require__(1343);











































__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '*',
    redirect: '/login'
  }, {
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_6__layouts_Full__["a" /* default */],
    children: [{
      path: '/dashboard',
      name: 'Dashboard',
      component: __WEBPACK_IMPORTED_MODULE_7__views_Dashboard__["a" /* default */]
    }, {
      path: '/interactions',
      name: 'Interactions',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '/interactions/live',
        name: 'Live',
        component: __WEBPACK_IMPORTED_MODULE_10__views_InteractionsRT__["a" /* default */]
      }, {
        path: '/interactions/supervisor',
        name: 'Supervisor',
        component: __WEBPACK_IMPORTED_MODULE_8__views_Interactions__["a" /* default */],
        props: { boss: true }
      }, {
        path: '/interactions/historical',
        name: 'Historical',
        component: __WEBPACK_IMPORTED_MODULE_8__views_Interactions__["a" /* default */]
      }, {
        path: '/interactions/:userId',
        name: 'Interaction',
        component: __WEBPACK_IMPORTED_MODULE_9__views_Interaction__["a" /* default */]
      }]
    }, {
      path: '/interactionsMenu',
      name: 'Interactions Menu',
      component: __WEBPACK_IMPORTED_MODULE_11__views_InteractionMenu__["a" /* default */]
    }, {
      path: '/videoCall',
      name: 'Video Call',
      component: __WEBPACK_IMPORTED_MODULE_12__views_VideoCall__["a" /* default */]
    }, {
      path: '/customers',
      name: 'Customers',
      component: __WEBPACK_IMPORTED_MODULE_13__views_Users__["a" /* default */]
    }, {
      path: '/chatflow',
      name: 'Chat Flow (Beta)',
      component: __WEBPACK_IMPORTED_MODULE_14__views_Data__["a" /* default */]
    }, {
      path: '/graph',
      name: 'Graph',
      component: __WEBPACK_IMPORTED_MODULE_15__views_Graph__["a" /* default */]
    }, {
      path: '/broadcast',

      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '',
        name: 'List of Broadcasts',
        component: __WEBPACK_IMPORTED_MODULE_16__views_Campaigns__["a" /* default */]
      }, {
        path: '/broadcast/:Id',
        name: 'Broadcast',
        component: __WEBPACK_IMPORTED_MODULE_17__views_Campaign__["a" /* default */]
      }]
    }, {
      path: '/studio',
      name: 'NL Studio',
      component: __WEBPACK_IMPORTED_MODULE_20__views_Intents_IntentsList__["a" /* default */]
    }, {
      path: '/Analytics',
      name: 'Analytics',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '/Analytics/VisitorTimeline',
        name: 'Visitor Timeline',
        component: __WEBPACK_IMPORTED_MODULE_26__views_Analytics_VisitorTimeline__["a" /* default */]
      }, {
        path: '/Analytics/DailyVisitor',
        name: 'Daily Visitor',
        component: __WEBPACK_IMPORTED_MODULE_27__views_Analytics_DailyVisitor__["a" /* default */]
      }, {
        path: '/Analytics/InteractionsTimeline',
        name: 'Interactions Timeline',
        component: __WEBPACK_IMPORTED_MODULE_28__views_Analytics_InteractionsTimeline__["a" /* default */]
      }, {
        path: '/Analytics/DailyInteractions',
        name: 'Daily Interactions',
        component: __WEBPACK_IMPORTED_MODULE_29__views_Analytics_DailyInteractions__["a" /* default */]
      }, {
        path: '/Analytics/IntentsPie',
        name: 'Intents Pie',
        component: __WEBPACK_IMPORTED_MODULE_30__views_Analytics_IntentsPie__["a" /* default */]
      }, {
        path: '/Analytics/IntentsTreemap',
        name: 'Intents Treemap',
        component: __WEBPACK_IMPORTED_MODULE_31__views_Analytics_IntentsTreemap__["a" /* default */]
      }, {
        path: '/Analytics/IntentsList',
        name: 'Intents List',
        component: __WEBPACK_IMPORTED_MODULE_32__views_Analytics_IntentsList__["a" /* default */]
      }]
    }, {
      path: '/crm',
      redirect: '/crm/chatbot'
    }, {
      path: '/crm/chatbot',
      name: 'CRM',
      component: __WEBPACK_IMPORTED_MODULE_24__views_CRM_tm__["a" /* default */]
    }, {
      path: '/crm/accountOpening',
      name: 'Account Opening',
      component: __WEBPACK_IMPORTED_MODULE_23__views_CRM_accountOpening__["a" /* default */]
    }, {
      path: '/crm/appointment',
      name: 'Appointment',
      component: __WEBPACK_IMPORTED_MODULE_21__views_CRM_appointment__["a" /* default */]
    }, {
      path: '/crm/motor-insurance',
      name: 'Motor Insurance',
      component: __WEBPACK_IMPORTED_MODULE_22__views_CRM_motor_insurance__["a" /* default */]
    }, {
      path: '/crm/default',
      name: 'Task Reporting',
      component: __WEBPACK_IMPORTED_MODULE_18__views_CRM__["a" /* default */]
    }, {
      path: '/crm/JobListing',
      name: 'Job Listing',
      component: __WEBPACK_IMPORTED_MODULE_25__views_Analytics_JobAnalytics__["a" /* default */]
    }, {
      path: '/manual',
      name: 'User Manual',
      component: __WEBPACK_IMPORTED_MODULE_19__views_Manual__["a" /* default */]
    }, {
      path: '/fallback',
      name: 'Fallback',
      component: __WEBPACK_IMPORTED_MODULE_33__views_Fallback__["a" /* default */]
    }, { path: '/404',
      name: 'Error 404',
      component: __WEBPACK_IMPORTED_MODULE_34__views_404__["a" /* default */]
    }, {
      path: '/logout',
      name: 'Logout',
      component: __WEBPACK_IMPORTED_MODULE_36__views_Logout__["a" /* default */]
    }],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_35__views_Login__["a" /* default */]
  }]
});

router.beforeEach(function (to, from, next) {
  var currentUser = __WEBPACK_IMPORTED_MODULE_4__firebase__["a" /* auth */].currentUser;
  var requiresAuth = to.matched.some(function (record) {
    return record.meta.requiresAuth;
  });
  var userEmail = currentUser && currentUser.email;
  var userAccessInformation = {};

  var prom = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_4__firebase__["c" /* metadb */].ref('users').orderByChild('email').equalTo(userEmail).once('value').then(function (datasnapshot) {
      datasnapshot.forEach(function (child) {
        if (child.val().email == userEmail) {
          userAccessInformation = child.val();
          resolve(userAccessInformation);
        }
      });
    });
  });

  if (requiresAuth && !currentUser) next('login');else if (requiresAuth && currentUser) {
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.profile).length === 0) {
      prom.then(function (res) {
        __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('setProfile', res);
        next();
      });
    } else {
      next();
    }
  } else if (!requiresAuth && currentUser && to.redirectedFrom) next('404');else if (!requiresAuth && currentUser) next('/');else next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 857:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b966b02_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(863);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b966b02_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 858:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Home__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(14);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  data: function data() {
    return {
      nav: [],
      numOfFlags: Number
    };
  },

  components: {
    Home: __WEBPACK_IMPORTED_MODULE_1__views_Home__["a" /* default */]
  },
  computed: {
    isHome: function isHome() {
      return true;
    },
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    },
    accessLevel: function accessLevel() {
      return this.$store.getters.getProfile;
    }
  },
  mounted: function mounted() {
    var accessLevel = this.$store.state.profile.accessLevel;
    this.nav = __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */][accessLevel];
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* db */].ref('flags').off();
  },

  watch: {
    accessLevel: function accessLevel() {
      this.nav = __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */][this.accessLevel];
    }
  }
});

/***/ }),

/***/ 859:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  supervisor: [{
    title: true,
    name: 'Supervisor'
  }, {
    name: 'Home',
    url: '/',
    icon: 'icon-home'
  }, {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-grid'
  }, {
    name: 'Interactions',
    url: '/interactions',
    icon: 'icon-bubbles',
    badge: {}
  }, {
    name: 'Video Call',
    url: '/videoCall',
    icon: 'icon-bubbles'
  }, {
    name: 'Customers',
    url: '/customers',
    icon: 'icon-people'
  }, {
    name: 'CRM',
    url: '/crm/chatbot',
    icon: 'icon-earphones-alt'
  }, {
    name: 'Broadcast',
    url: '/broadcast',
    icon: 'icon-speech'
  }, {
    name: 'Chat Flow (Beta)',
    url: '/chatflow',
    icon: 'icon-shuffle'
  }, {
    divider: true
  }],
  agent: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-home'
  }, {
    divider: true
  }, {
    title: true,
    name: 'Agent'
  }, {
    name: 'Interactions',
    url: '/interactions/supervisor',
    icon: 'icon-bubbles',
    badge: {}
  }, {
    name: 'Video Call',
    url: '/videoCall',
    icon: 'icon-bubbles'
  }, {
    name: 'Customers',
    url: '/customers',
    icon: 'icon-people'
  }, {
    name: 'CRM',
    icon: 'icon-earphones-alt',
    children: [{
      name: 'Workshop Appt.',
      url: '/crm/appointment',
      icon: 'icon-calendar'
    }, {
      name: 'Motor Insurance',
      url: '/crm/motor-insurance',
      icon: 'icon-wrench'
    }]
  }, {
    name: 'Broadcast',
    url: '/broadcast',
    icon: 'icon-speech'
  }, {
    name: 'Chat Flow (Beta)',
    url: '/chatflow',
    icon: 'icon-shuffle'
  }, {
    divider: true
  }],
  admin: [{
    title: true,
    name: 'Admin'
  }, {
    name: 'Home',
    url: '/',
    icon: 'icon-home'
  }, {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-grid'
  }, {
    name: 'Interactions',
    url: '/interactionsMenu',
    icon: 'icon-bubbles',
    badge: {
      variant: 'danger',
      text: ''
    },
    id: 'interaction',
    children: [{
      name: 'Live',
      url: '/interactions/live',
      icon: 'fa fa-commenting',
      badge: {
        variant: 'danger',
        text: ''
      }
    }, {
      name: 'Historical',
      url: '/interactions/historical',
      icon: 'icon-book-open'
    }]
  }, {
    name: 'Video Call',
    url: '/videoCall',
    icon: 'icon-bubbles'
  }, {
    name: 'Customers',
    url: '/customers',
    icon: 'icon-people'
  }, {
    name: 'CRM',
    icon: 'icon-earphones-alt',
    children: [{
      name: 'Account Opening',
      url: '/crm/accountOpening',
      icon: 'fa fa-id-card-o'
    }, {
      name: 'Task Reporting',
      url: '/crm/chatbot',
      icon: 'fa fa-id-card-o'
    }, {
      name: 'Motor Accident',
      url: '/crm/appointment',
      icon: 'fa fa-car'
    }, {
      name: 'Job Listing',
      url: '/crm/JobListing',
      icon: 'fa fa-bar-chart'
    }]
  }, {
    name: 'Broadcast',
    url: '/broadcast',
    icon: 'icon-speech'
  }, {
    name: 'Analytics',
    icon: 'icon-graph',
    children: [{
      name: 'Visitor Timeline',
      url: '/Analytics/VisitorTimeline',
      icon: 'fa fa-line-chart'
    }, {
      name: 'Daily Visitor',
      url: '/Analytics/DailyVisitor',
      icon: 'fa fa-table'
    }, {
      name: 'Interactions Timeline',
      url: '/Analytics/InteractionsTimeline',
      icon: 'fa fa-line-chart'
    }, {
      name: 'Daily Interactions',
      url: '/Analytics/DailyInteractions',
      icon: 'fa fa-table'
    }, {
      name: 'Intents Pie',
      url: '/Analytics/IntentsPie',
      icon: 'fa fa-pie-chart'
    }, {
      name: 'Intents Treemap',
      url: '/Analytics/IntentsTreemap',
      icon: 'fa fa-pie-chart'
    }, {
      name: 'Intents List',
      url: '/Analytics/IntentsList',
      icon: 'fa fa-table'
    }]
  }, {
    name: 'NL Studio',
    icon: 'fa fa-magic',
    url: '/studio'
  }, {
    name: 'Unmatched Query',
    url: '/fallback/',
    icon: 'fa fa-table'
  }, {
    divider: true
  }],
  items: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-home'
  }, {
    divider: true
  }, {
    title: true,
    name: 'Supervisor'
  }, {
    name: 'Interactions',
    url: '/interactions/supervisor',
    icon: 'icon-bubbles',
    badge: {}
  }, {
    name: 'Customers',
    url: '/customers',
    icon: 'icon-people'
  }, {
    name: 'CRM',
    icon: 'icon-earphones-alt',
    children: [{
      name: 'Workshop Appt.',
      url: '/crm/appointment',
      icon: 'icon-calendar'
    }, {
      name: 'Motor Insurance',
      url: '/crm/motor-insurance',
      icon: 'icon-wrench'
    }]
  }, {
    name: 'Broadcast',
    url: '/broadcast',
    icon: 'icon-speech'
  }, {
    name: 'Chat Flow (Beta)',
    url: '/chatflow',
    icon: 'icon-shuffle'
  }, {
    divider: true
  }]
});

/***/ }),

/***/ 860:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_040eab0a_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(862);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_040eab0a_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 861:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      userAccessLevel: this.$store.state.profile.accessLevel
    };
  },

  mounted: function mounted() {},
  methods: {
    chatLink: function chatLink(value) {
      return '/interactions/' + value.toLowerCase().replace(' ', '-');
    }
  }
});

/***/ }),

/***/ 862:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-row', {
    attrs: {
      "id": "home"
    }
  }, [(_vm.userAccessLevel != "agent") ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "icon-grid"
  }), _c('br'), _vm._v("Dashboard")])])], 1)], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/interactions/live"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "icon-bubbles"
  }), _c('br'), _vm._v("Interactions")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/videoCall"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "icon-bubbles"
  }), _c('br'), _vm._v("Video Call")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/reports"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "icon-people"
  }), _c('br'), _vm._v("Customers")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/broadcast"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "icon-speech"
  }), _c('br'), _vm._v("Broadcast")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/graph"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "icon-graph"
  }), _c('br'), _vm._v("Graph")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/chatflow"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "icon-shuffle"
  }), _c('br'), _vm._v("Chat Flow (Beta)")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/manual"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "icon-notebook"
  }), _c('br'), _vm._v("User Manual")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "icon-user"
  }), _c('br'), _vm._v("Profile")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/crm/chatbot"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "fa fa-id-card-o"
  }), _c('br'), _vm._v("Task Reporting CRM")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/crm/chatbot"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "fa fa-car"
  }), _c('br'), _vm._v("Motor Accident CRM")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/studio"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  }), _c('br'), _vm._v("NL Studio")])])], 1)], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 863:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('app-header'), _c('div', {
    staticClass: "app-body"
  }, [_c('app-sidebar', {
    attrs: {
      "navItems": _vm.nav
    }
  }), _c('main', {
    staticClass: "main"
  }, [_c('app-breadcrumb', {
    attrs: {
      "list": _vm.list
    }
  }), _c('div', {
    staticClass: "container-fluid"
  }, [(_vm.list.length > 1) ? _c('router-view') : _c('Home')], 1)], 1), _c('app-aside')], 1), _c('app-footer')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 864:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b11ac80e_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(884);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b11ac80e_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 865:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsonToXlsx__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filter__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__filter__);








var msgsRef = __WEBPACK_IMPORTED_MODULE_3__firebase__["b" /* db */].ref('newestChats');
var anaRef = __WEBPACK_IMPORTED_MODULE_3__firebase__["b" /* db */].ref('analytics');
var usersRef = __WEBPACK_IMPORTED_MODULE_3__firebase__["b" /* db */].ref('users');

var d = new Date();
var day = d.getDay();
var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var daysLocale = days.slice(day).concat(days.slice(0, day)).reverse();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      userAccessLevel: this.$store.state.profile.accessLevel,
      usersCount: 0,
      actions1: [{ name: 'View More' }],

      stats: function stats() {
        return {
          users: {
            labels: daysLocale,
            data: [0, 1, 1, 3, 3, 3, 3]
          },
          interactions: {
            labels: daysLocale,
            data: [1, 20, 9, 17, 34, 22, 54]
          },
          revenue: {
            labels: daysLocale,
            data: [1, 18, 9, 17, 34, 22, 11]
          },
          orders: {
            labels: daysLocale,
            data: [1, 18, 9, 17, 34, 22, 11]
          }
        };
      },
      total: {
        users: 3,
        interactions: 3,
        revenue: 3,
        orders: 3
      },
      tableItems2: [],
      tableFields2: {
        avatar: {
          label: '<i class="icon-people"></i>',
          class: 'text-center'
        },
        messageId: {
          label: 'Customer Name'
        },
        message: {
          label: 'Message'
        },
        timestamp: {
          label: 'Timestamp'
        }
      },
      tableItems1: [{
        intent: 'Get Started',
        users: 4,
        interactions: 7,
        exits: 20,
        respondTime: 1.3
      }, {
        intent: 'Products',
        users: 2,
        interactions: 5,
        exits: 80,
        respondTime: 1.2
      }, {
        intent: 'Wealth Solution',
        users: 1,
        interactions: 3,
        exits: 33,
        respondTime: 2.3
      }, {
        intent: 'Market Outlook',
        users: 1,
        interactions: 7,
        exits: 71,
        respondTime: 1.4
      }, {
        intent: 'Person Lookup',
        users: 1,
        interactions: 3,
        exits: 67,
        respondTime: 1.8
      }],
      tableFields1: {
        intent: {
          label: 'Topics'
        },
        users: {
          label: 'Users Count'
        },
        interactions: {
          label: 'Interactions Count'
        },
        exits: {
          label: 'Bounce Rate'
        },
        respondTime: {
          label: 'Average Respond Time'
        }
      }
    };
  },

  mounted: function mounted() {
    var _this = this;

    function fullNameElseID(key, val) {
      if (val.firstName && val.lastName) {
        return val.firstName + ' ' + val.lastName;
      } else if (val.name) {
        return val.name;
      } else if (val.shortID) {
        return val.shortID;
      } else {
        return key;
      }
    }

    var stats;
    var total;
    anaRef.on('value', function (snapshot) {
      stats = {};
      total = {};
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(snapshot.val()).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];

        stats[key] = {
          labels: daysLocale,
          data: val.data
        };
        total[key] = key == 'topics' ? val : val.total;
      });
      _this.total = total;
    });

    var users;
    usersRef.on('value', function (snapshot) {
      users = {};
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(snapshot.val()).forEach(function (_ref3) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
            key = _ref4[0],
            val = _ref4[1];

        users[key] = val;
      });
      console.log('users', users);
    });
    var msgs;
    msgsRef.limitToLast(5).on('value', function (snapshot) {
      msgs = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(snapshot.val()).forEach(function (_ref5) {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
            key = _ref6[0],
            val = _ref6[1];

        try {
          var senderID = val.senderID || val.userID;
          if (users[senderID]) {
            val.username = fullNameElseID(senderID, users[senderID]);
            val.url = users[senderID].profilePic || 'static/img/avatars/0.png';
            val.status = users[senderID].status || 'warning';
            val.takeover = users[senderID].takeover || false;
          } else {
            val.username = fullNameElseID(senderID, users[senderID]);
            val.url = 'static/img/avatars/0.png';
            val.status = 'danger';
            val.takeover = false;
          }

          var cutOff = 50;
          var message = Object(__WEBPACK_IMPORTED_MODULE_4__filter__["parseMessage"])(val.message, cutOff);
          msgs.unshift({
            avatar: { url: val.url, status: val.status, tooltip: key },
            userId: senderID,
            messageId: val.username,
            timestamp: val.timestamp,
            message: message
          });
        } catch (err) {
          console.log(err);
        }
      });
      console.log(msgs);
      _this.tableItems2 = msgs;
    });
  },
  methods: {
    variant: function variant(value) {
      var $variant = void 0;
      if (value <= 25) {
        $variant = 'info';
      } else if (value > 25 && value <= 50) {
        $variant = 'success';
      } else if (value > 50 && value <= 75) {
        $variant = 'warning';
      } else if (value > 75 && value <= 100) {
        $variant = 'danger';
      }
      return $variant;
    },
    chatLink: function chatLink(value) {
      return '/interactions/' + value.toLowerCase().replace(' ', '-');
    },

    xlsx: function xlsx() {
      Object(__WEBPACK_IMPORTED_MODULE_2__jsonToXlsx__["e" /* ei */])();
    },
    pdf: function pdf() {
      Object(__WEBPACK_IMPORTED_MODULE_2__jsonToXlsx__["f" /* eip */])();
    }
  }
});

/***/ }),

/***/ 881:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 882:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 883:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 305,
	"./af.js": 305,
	"./ar": 306,
	"./ar-dz": 307,
	"./ar-dz.js": 307,
	"./ar-kw": 308,
	"./ar-kw.js": 308,
	"./ar-ly": 309,
	"./ar-ly.js": 309,
	"./ar-ma": 310,
	"./ar-ma.js": 310,
	"./ar-sa": 311,
	"./ar-sa.js": 311,
	"./ar-tn": 312,
	"./ar-tn.js": 312,
	"./ar.js": 306,
	"./az": 313,
	"./az.js": 313,
	"./be": 314,
	"./be.js": 314,
	"./bg": 315,
	"./bg.js": 315,
	"./bm": 316,
	"./bm.js": 316,
	"./bn": 317,
	"./bn.js": 317,
	"./bo": 318,
	"./bo.js": 318,
	"./br": 319,
	"./br.js": 319,
	"./bs": 320,
	"./bs.js": 320,
	"./ca": 321,
	"./ca.js": 321,
	"./cs": 322,
	"./cs.js": 322,
	"./cv": 323,
	"./cv.js": 323,
	"./cy": 324,
	"./cy.js": 324,
	"./da": 325,
	"./da.js": 325,
	"./de": 326,
	"./de-at": 327,
	"./de-at.js": 327,
	"./de-ch": 328,
	"./de-ch.js": 328,
	"./de.js": 326,
	"./dv": 329,
	"./dv.js": 329,
	"./el": 330,
	"./el.js": 330,
	"./en-au": 331,
	"./en-au.js": 331,
	"./en-ca": 332,
	"./en-ca.js": 332,
	"./en-gb": 333,
	"./en-gb.js": 333,
	"./en-ie": 334,
	"./en-ie.js": 334,
	"./en-il": 335,
	"./en-il.js": 335,
	"./en-nz": 336,
	"./en-nz.js": 336,
	"./eo": 337,
	"./eo.js": 337,
	"./es": 338,
	"./es-do": 339,
	"./es-do.js": 339,
	"./es-us": 340,
	"./es-us.js": 340,
	"./es.js": 338,
	"./et": 341,
	"./et.js": 341,
	"./eu": 342,
	"./eu.js": 342,
	"./fa": 343,
	"./fa.js": 343,
	"./fi": 344,
	"./fi.js": 344,
	"./fo": 345,
	"./fo.js": 345,
	"./fr": 346,
	"./fr-ca": 347,
	"./fr-ca.js": 347,
	"./fr-ch": 348,
	"./fr-ch.js": 348,
	"./fr.js": 346,
	"./fy": 349,
	"./fy.js": 349,
	"./gd": 350,
	"./gd.js": 350,
	"./gl": 351,
	"./gl.js": 351,
	"./gom-latn": 352,
	"./gom-latn.js": 352,
	"./gu": 353,
	"./gu.js": 353,
	"./he": 354,
	"./he.js": 354,
	"./hi": 355,
	"./hi.js": 355,
	"./hr": 356,
	"./hr.js": 356,
	"./hu": 357,
	"./hu.js": 357,
	"./hy-am": 358,
	"./hy-am.js": 358,
	"./id": 359,
	"./id.js": 359,
	"./is": 360,
	"./is.js": 360,
	"./it": 361,
	"./it.js": 361,
	"./ja": 362,
	"./ja.js": 362,
	"./jv": 363,
	"./jv.js": 363,
	"./ka": 364,
	"./ka.js": 364,
	"./kk": 365,
	"./kk.js": 365,
	"./km": 366,
	"./km.js": 366,
	"./kn": 367,
	"./kn.js": 367,
	"./ko": 368,
	"./ko.js": 368,
	"./ky": 369,
	"./ky.js": 369,
	"./lb": 370,
	"./lb.js": 370,
	"./lo": 371,
	"./lo.js": 371,
	"./lt": 372,
	"./lt.js": 372,
	"./lv": 373,
	"./lv.js": 373,
	"./me": 374,
	"./me.js": 374,
	"./mi": 375,
	"./mi.js": 375,
	"./mk": 376,
	"./mk.js": 376,
	"./ml": 377,
	"./ml.js": 377,
	"./mn": 378,
	"./mn.js": 378,
	"./mr": 379,
	"./mr.js": 379,
	"./ms": 380,
	"./ms-my": 381,
	"./ms-my.js": 381,
	"./ms.js": 380,
	"./mt": 382,
	"./mt.js": 382,
	"./my": 383,
	"./my.js": 383,
	"./nb": 384,
	"./nb.js": 384,
	"./ne": 385,
	"./ne.js": 385,
	"./nl": 386,
	"./nl-be": 387,
	"./nl-be.js": 387,
	"./nl.js": 386,
	"./nn": 388,
	"./nn.js": 388,
	"./pa-in": 389,
	"./pa-in.js": 389,
	"./pl": 390,
	"./pl.js": 390,
	"./pt": 391,
	"./pt-br": 392,
	"./pt-br.js": 392,
	"./pt.js": 391,
	"./ro": 393,
	"./ro.js": 393,
	"./ru": 394,
	"./ru.js": 394,
	"./sd": 395,
	"./sd.js": 395,
	"./se": 396,
	"./se.js": 396,
	"./si": 397,
	"./si.js": 397,
	"./sk": 398,
	"./sk.js": 398,
	"./sl": 399,
	"./sl.js": 399,
	"./sq": 400,
	"./sq.js": 400,
	"./sr": 401,
	"./sr-cyrl": 402,
	"./sr-cyrl.js": 402,
	"./sr.js": 401,
	"./ss": 403,
	"./ss.js": 403,
	"./sv": 404,
	"./sv.js": 404,
	"./sw": 405,
	"./sw.js": 405,
	"./ta": 406,
	"./ta.js": 406,
	"./te": 407,
	"./te.js": 407,
	"./tet": 408,
	"./tet.js": 408,
	"./tg": 409,
	"./tg.js": 409,
	"./th": 410,
	"./th.js": 410,
	"./tl-ph": 411,
	"./tl-ph.js": 411,
	"./tlh": 412,
	"./tlh.js": 412,
	"./tr": 413,
	"./tr.js": 413,
	"./tzl": 414,
	"./tzl.js": 414,
	"./tzm": 415,
	"./tzm-latn": 416,
	"./tzm-latn.js": 416,
	"./tzm.js": 415,
	"./ug-cn": 417,
	"./ug-cn.js": 417,
	"./uk": 418,
	"./uk.js": 418,
	"./ur": 419,
	"./ur.js": 419,
	"./uz": 420,
	"./uz-latn": 421,
	"./uz-latn.js": 421,
	"./uz.js": 420,
	"./vi": 422,
	"./vi.js": 422,
	"./x-pseudo": 423,
	"./x-pseudo.js": 423,
	"./yo": 424,
	"./yo.js": 424,
	"./zh-cn": 425,
	"./zh-cn.js": 425,
	"./zh-hk": 426,
	"./zh-hk.js": 426,
	"./zh-tw": 427,
	"./zh-tw.js": 427
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 883;

/***/ }),

/***/ 884:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('statsbox', {
    attrs: {
      "category": "Customers",
      "actions": _vm.actions1
    }
  }, [_vm._v(_vm._s(_vm.total.users))])], 1), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('statsbox', {
    attrs: {
      "category": "Interactions",
      "color": "warning",
      "chartData": _vm.stats.interactions
    }
  }, [_vm._v(_vm._s(_vm.total.interactions))])], 1), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('statsbox', {
    attrs: {
      "category": "Billing",
      "color": "success",
      "chartData": _vm.stats.revenue
    }
  }, [_vm._v(_vm._s(_vm.total.revenue))])], 1), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('statsbox', {
    attrs: {
      "category": "Compaints",
      "color": "danger",
      "chartData": _vm.stats.orders
    }
  }, [_vm._v(_vm._s(_vm.total.orders))])], 1)]), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Top Conversation Topics")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("5 Most Interacted Topics")])]), _c('div', {
    staticClass: "col-sm-7 hidden-sm-down"
  }, [(_vm.userAccessLevel != "agent") ? _c('b-dropdown', {
    staticClass: "float-right",
    attrs: {
      "type": "button",
      "variant": "primary"
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('i', {
    staticClass: "icon-cloud-download"
  }), _vm._v("  Export")]), _c('b-dropdown-item', {
    attrs: {
      "type": "button",
      "variant": "info"
    },
    on: {
      "click": _vm.xlsx
    }
  }, [_vm._v("Download as xlsx")]), _c('b-dropdown-item', {
    attrs: {
      "type": "button",
      "variant": "info"
    },
    on: {
      "click": _vm.pdf
    }
  }, [_vm._v("Download as pdf")])], 2) : _c('b-button', {
    staticClass: "float-right",
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": _vm.pdf
    }
  }, [_c('i', {
    staticClass: "icon-cloud-download"
  }), _vm._v(" Export as pdf")])], 1)]), _c('br'), _c('app-table', {
    attrs: {
      "data": _vm.tableItems1,
      "label": _vm.tableFields1,
      "small": "small"
    }
  })], 1), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Real Time Interactions")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("5 Most Recent Interactions")])]), _c('div', {
    staticClass: "col-sm-7 hidden-sm-down"
  }, [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "type": "button",
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "icon-cloud-download"
  })])], 1)]), _c('br'), _c('app-table', {
    attrs: {
      "data": _vm.tableItems2,
      "label": _vm.tableFields2,
      "small": "small",
      "rowClick": "rowClick"
    }
  })], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 885:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Interactions_vue__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f879268_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Interactions_vue__ = __webpack_require__(892);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Interactions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f879268_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Interactions_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 886:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__firebase__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filter__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__methods_routerPagination__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__methods_routerPagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__methods_routerPagination__);














var msgsRef = __WEBPACK_IMPORTED_MODULE_8__firebase__["b" /* db */].ref('newestChats');
var usersRef = __WEBPACK_IMPORTED_MODULE_8__firebase__["b" /* db */].ref('users');
var flagRef = __WEBPACK_IMPORTED_MODULE_8__firebase__["b" /* db */].ref('flags');
var dRef = __WEBPACK_IMPORTED_MODULE_8__firebase__["b" /* db */].ref('dashboard');

function fullNameElseID(key, val) {
  if (val.firstName && val.lastName) {
    return val.firstName + ' ' + val.lastName;
  } else if (val.name) {
    return val.name;
  } else if (val.shortID) {
    return 'Guest';
  } else {
      return 'Guest';
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  props: ['boss'],
  data: function data() {
    return {
      firstSendObj: {},
      inputPageNumber: '',
      timeout: [],
      currentPage: 1,
      pages: Number,
      userAccessLevel: this.$store.state.profile.accessLevel,
      totalPage: 0,
      loading: true,
      usersCount: 0,
      loadingPause: null,
      actions1: [{ name: 'View More' }],
      loadingText: 'Loading...',
      tableItems: [],
      tableFields: {
        avatar: {
          label: 'Status'
        },
        messageId: {
          label: 'Customer Name / ID'
        },
        message: {
          label: 'Message'
        },
        flagHandleBy: {
          label: 'Resolved By'
        },
        firstInteraction: {
          label: 'First Interaction'
        },
        numTimestamp: {
          label: 'Last Interaction'
        }
      },
      tableItemsFlag: [],
      tableFieldsFlag: {
        avatar: {
          label: 'Status'
        },
        messageId: {
          label: 'Customer Name / ID'
        },
        message: {
          label: 'Message'
        },
        flagHandleBy: {
          label: 'Resolved By'
        },
        firstInteraction: {
          label: 'First Interaction'
        },
        numTimestamp: {
          label: 'Last Interaction'
        }
      }
    };
  },

  computed: {
    inputPageNumberState: function inputPageNumberState() {
      if (this.inputPageNumber == '' || !isNaN(parseInt(this.inputPageNumber)) && parseInt(this.inputPageNumber) > 0 && parseInt(this.inputPageNumber) <= this.totalPage) {
        return null;
      } else {
        return false;
      }
    }
  },
  methods: {
    paginateTo: function paginateTo(e) {
      e.preventDefault();
      if (!isNaN(parseInt(this.inputPageNumber)) && parseInt(this.inputPageNumber) > 0 && parseInt(this.inputPageNumber) <= this.totalPage) {
        this.currentPage = parseInt(this.inputPageNumber);
        document.location.hash = 'interactions?page=' + parseInt(this.inputPageNumber);
      }
    },
    paginate: function paginate(p) {
      var _this = this;

      var self = this;
      return new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(resolve) {
          var msgs, msgsFlag, users, flags, messageKey;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  users = {};

                  msgsRef.limitToLast(p * 10 + 25).once('value', function () {
                    var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(snapshot) {
                      var keys, numOfFlag, currentNumFlag, iterator, promiseArray, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, k, val, senderID, cutOff, message, flagHandleByString, msg, j;

                      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              msgs = [];
                              msgsFlag = [];
                              users = {};
                              keys = [];
                              numOfFlag = 0;
                              currentNumFlag = 0;
                              iterator = 0;
                              promiseArray = [];

                              promiseArray.push(flagRef.once('value').then(function (snapshot) {
                                numOfFlag = snapshot.numChildren();
                                flags = {};
                                messageKey = {};
                                var senderID;
                                if (window.localStorage.getItem('firstSendObj') !== null) {
                                  self.firstSendObj = JSON.parse(window.localStorage.getItem('firstSendObj'));
                                }
                                snapshot.val() && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(snapshot.val()).forEach(function (_ref3) {
                                  var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                                      key = _ref4[0],
                                      val = _ref4[1];

                                  try {
                                    senderID = val.senderID || val.userID;
                                    flags[senderID] = val.agent || ' ';
                                    messageKey[senderID] = key;
                                  } catch (error) {}
                                });
                              }));
                              __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(self.firstSendObj).forEach(function (_ref5) {
                                var _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
                                    key = _ref6[0],
                                    val = _ref6[1];

                                if (messageKey.hasOwnProperty(key) === false) {
                                  delete self.firstSendObj[key];
                                  window.localStorage.setItem('firstSendObj', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(self.firstSendObj));
                                }
                              });

                              snapshot.forEach(function (child) {
                                keys.unshift(child.key);
                                try {
                                  promiseArray.push(usersRef.child(child.val().userID).once('value').then(function (ss) {
                                    users[child.val().userID] = ss.val();
                                  }));
                                } catch (error) {}
                              });
                              _context.next = 13;
                              return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a.all(promiseArray);

                            case 13:
                              _iteratorNormalCompletion = true;
                              _didIteratorError = false;
                              _iteratorError = undefined;
                              _context.prev = 16;
                              _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(keys);

                            case 18:
                              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                _context.next = 41;
                                break;
                              }

                              k = _step.value;

                              if (!(numOfFlag <= currentNumFlag && iterator >= p * 10)) {
                                _context.next = 22;
                                break;
                              }

                              return _context.abrupt('break', 41);

                            case 22:
                              _context.prev = 22;

                              if (!(iterator >= p * 10)) {
                                _context.next = 26;
                                break;
                              }

                              if (snapshot.val()[k].flagged) {
                                _context.next = 26;
                                break;
                              }

                              return _context.abrupt('continue', 38);

                            case 26:
                              val = snapshot.val()[k];
                              senderID = val.senderID || val.userID;

                              if (users[senderID]) {
                                val.username = fullNameElseID(senderID, users[senderID]);
                                val.url = users[senderID].profilePic || 'static/img/avatars/0.png';
                                val.status = users[senderID].status || 'danger';
                                val.takeover = users[senderID].takeover || false;
                                val.firstInteraction = users[senderID].firstInteraction || '-';
                                val.flagHandleBy = users[senderID].flagHandleBy || ['Not Applicable'];
                              } else {
                                val.username = senderID;
                                val.url = 'static/img/avatars/0.png';
                                val.status = 'danger';
                                val.takeover = false;
                                val.firstInteraction = '-';
                                val.flagHandleBy = ['Not Applicable'];
                              }
                              cutOff = 50;
                              message = Object(__WEBPACK_IMPORTED_MODULE_9__filter__["parseMessage"])(val.message, cutOff);

                              if (val.flagHandleBy != ['Not Applicable']) {
                                flagHandleByString = val.flagHandleBy.join(', ');
                              } else {
                                flagHandleByString = 'Not Applicable';
                              }
                              msg = {
                                avatar: { url: val.url, status: val.status, tooltip: k },
                                userId: senderID,
                                rawMsg: val.message,
                                messageId: val.username,
                                flagHandleBy: { id: senderID, flagHandleBy: val.flagHandleBy, flagHandleByString: flagHandleByString },
                                numTimestamp: val.timestamp,
                                firstInteraction: val.firstInteraction,
                                message: message
                              };

                              if (val.flagged == true) {
                                msg._rowVariant = 'danger';
                                for (j = 0; j < msgsFlag.length; j++) {
                                  if (msgsFlag[j].userId == msg.userId) {
                                    msgsFlag.splice(j, 1);
                                  }
                                }
                                msgsFlag.unshift(msg);
                                currentNumFlag += 1;
                              } else {
                                if (iterator >= p * 10 - 10) {
                                  senderID && msgs.push(msg);
                                }
                                msgs.length = msgs.length <= 10 ? msgs.length : 10;
                                iterator += 1;
                              }
                              _context.next = 38;
                              break;

                            case 36:
                              _context.prev = 36;
                              _context.t0 = _context['catch'](22);

                            case 38:
                              _iteratorNormalCompletion = true;
                              _context.next = 18;
                              break;

                            case 41:
                              _context.next = 47;
                              break;

                            case 43:
                              _context.prev = 43;
                              _context.t1 = _context['catch'](16);
                              _didIteratorError = true;
                              _iteratorError = _context.t1;

                            case 47:
                              _context.prev = 47;
                              _context.prev = 48;

                              if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                              }

                            case 50:
                              _context.prev = 50;

                              if (!_didIteratorError) {
                                _context.next = 53;
                                break;
                              }

                              throw _iteratorError;

                            case 53:
                              return _context.finish(50);

                            case 54:
                              return _context.finish(47);

                            case 55:
                              self.tableItemsFlag = msgsFlag;
                              self.tableItems = msgs;
                              resolve('completed');

                            case 58:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this, [[16, 43, 47, 55], [22, 36], [48,, 50, 54]]);
                    }));

                    return function (_x2) {
                      return _ref2.apply(this, arguments);
                    };
                  }());

                case 2:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  },
  watch: {
    currentPage: function currentPage() {
      var _this2 = this;

      var p = this.currentPage;
      var that = this;
      dRef.on('value', function (snapshot) {
        _this2.paused = snapshot.child('pauseToggle').val();
      });
      clearInterval(this.interval);

      this.loading = true;
      this.paginate(p).then(function (res) {
        that.loading = false;
      });
      this.inputPageNumber = this.currentPage;
    }
  },
  mounted: function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var _this3 = this;

      var self;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              this.currentPage = Object(__WEBPACK_IMPORTED_MODULE_10__methods_routerPagination__["routeByURL"])('#/interactions/historical');
              dRef.on('value', function (snapshot) {
                _this3.paused = snapshot.child('pauseToggle').val();
              });
              msgsRef.once('value').then(function (snapshot) {
                _this3.pages = snapshot.numChildren();
                _this3.totalPage = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(_this3.pages / 10) + 1;
              });
              self = this;

              this.paginate(this.currentPage).then(function (res) {
                self.loading = false;
              });
              Object(__WEBPACK_IMPORTED_MODULE_10__methods_routerPagination__["checkURLChanges"])('#/interactions');

            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function mounted() {
      return _ref7.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
    msgsRef.off('value');
    dRef.off('value');
  }
});

/***/ }),

/***/ 891:
/***/ (function(module, exports) {


function routeByURL(pageName) {
  var pageNo;
  if (window.location.hash.slice(window.location.hash.indexOf('=') + 1) === pageName) {
    pageNo = 1;
  } else if (!isNaN(window.location.hash.slice(window.location.hash.indexOf('=') + 1))) {
    pageNo = Number(window.location.hash.slice(window.location.hash.indexOf('=') + 1));
  }
  return pageNo;
}

function checkURLChanges(pageName) {
  var innerDocClick = null;
  document.onmouseover = function () {
    innerDocClick = true;
  };
  document.onmouseleave = function () {
    innerDocClick = false;
  };

  window.addEventListener('hashchange', function (event) {
    if (innerDocClick === false) {
      if (window.location.hash.slice(window.location.hash.indexOf('=') + 1) === pageName && document.getElementsByClassName('pagination-area')[0]) {
        document.getElementsByClassName('pagination-area')[0].__vue__.currentPage = 1;
      } else if (!isNaN(window.location.hash.slice(window.location.hash.indexOf('=') + 1)) && document.getElementsByClassName('pagination-area')[0]) {
        document.getElementsByClassName('pagination-area')[0].__vue__.currentPage = Number(window.location.hash.slice(window.location.hash.indexOf('=') + 1));
      }
    } else {
      if (window.location.hash.slice(window.location.hash.indexOf('=') + 1) === pageName && document.getElementsByClassName('pagination-area')[0]) {
        document.getElementsByClassName('pagination-area')[0].__vue__.currentPage = 1;
      }
    }
  });
}
exports.routeByURL = routeByURL;
exports.checkURLChanges = checkURLChanges;

/***/ }),

/***/ 892:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Interactions (Historical)")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Displaying Past Interactions")])])]), _c('br'), (_vm.loading) ? _c('div', [_vm._v(_vm._s(_vm.loadingText))]) : _c('div', [(_vm.tableItemsFlag.length > 0) ? _c('div', [_c('app-interactionsTable', {
    attrs: {
      "data": _vm.tableItemsFlag,
      "label": _vm.tableFieldsFlag,
      "rowClick": "rowClick"
    }
  }), _c('br')], 1) : _vm._e(), (!_vm.boss) ? _c('app-interactionsTable', {
    attrs: {
      "data": _vm.tableItems,
      "label": _vm.tableFields,
      "rowClick": "rowClick"
    }
  }) : _vm._e(), _c('br'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('b-pagination-nav', {
    staticClass: "pagination-area",
    attrs: {
      "base-url": "/#/interactions/historical?page=",
      "align": "right",
      "size": "md",
      "total-rows": _vm.pages,
      "number-of-pages": _vm.totalPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('b-form', {
    on: {
      "submit": _vm.paginateTo
    }
  }, [_c('b-input-group', {
    attrs: {
      "size": ""
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Page number",
      "state": _vm.inputPageNumberState
    },
    model: {
      value: (_vm.inputPageNumber),
      callback: function($$v) {
        _vm.inputPageNumber = $$v
      },
      expression: "inputPageNumber"
    }
  }), _c('b-input-group-button', {
    slot: "right"
  }, [_c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: ("Paginate"),
      expression: "\"Paginate\"",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "primary",
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-columns"
  })])], 1)], 1)], 1), (_vm.inputPageNumberState == false) ? _c('label', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Wrong input")]) : _vm._e()], 1)])], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 893:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Interaction_vue__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07a19137_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Interaction_vue__ = __webpack_require__(901);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Interaction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07a19137_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Interaction_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 894:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__firebase__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_carousel__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_fuse_js__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_fuse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_fuse_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InteractionFolder_fuseOptions__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__InteractionFolder_fuzzySearchItems__ = __webpack_require__(900);
















var fuse = new __WEBPACK_IMPORTED_MODULE_9_fuse_js___default.a(__WEBPACK_IMPORTED_MODULE_11__InteractionFolder_fuzzySearchItems__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__InteractionFolder_fuseOptions__["a" /* default */]);

var bots = __WEBPACK_IMPORTED_MODULE_6__firebase__["c" /* metadb */].ref('bots');
var chatRef = __WEBPACK_IMPORTED_MODULE_6__firebase__["b" /* db */].ref('chats');
var usersRef = __WEBPACK_IMPORTED_MODULE_6__firebase__["b" /* db */].ref('users');
var flagRef = __WEBPACK_IMPORTED_MODULE_6__firebase__["b" /* db */].ref('flags');
var msgsRef = __WEBPACK_IMPORTED_MODULE_6__firebase__["b" /* db */].ref('newestChats');
var videoRef = __WEBPACK_IMPORTED_MODULE_6__firebase__["b" /* db */].ref('videoCalling');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  components: {
    Carousel: __WEBPACK_IMPORTED_MODULE_8_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_8_vue_carousel__["Slide"]
  },
  data: function data() {
    return {
      usersCount: 0,
      name: null,
      sentiment: '-',
      sentimentValue: '-',
      loading: true,
      profPicUrl: 'static/img/avatars/0.png',
      pageID: this.$route.params.userId,
      chats: [],
      msg: {
        content: ''
      },
      paused: false,
      onlineStatus: 'danger',
      sending: false,
      avatarURL: null,
      countdown: 999,
      dTimer: null,
      flagged: false,
      currentUser: this.$store.state.profile.firstName,
      duplicateAgent: false,
      newestKey: null,
      flagKey: null,
      firstSendObj: {},
      firstNameOfAgent: this.$store.state.profile.firstName,
      uniqueIDOfAgent: this.$store.state.profile.uniqueID,
      cdSync: false,
      noOfChats: 1,
      firstChatID: '',
      clickedOnLoadMore: false,
      maxChatsNotReached: true,
      loadingMore: false,
      pc: null,
      screenFull: false,
      videoIsOn: false,
      autocompleteItems: []
    };
  },

  watch: {
    flagged: function flagged() {
      if (this.flagged) {
        var self = this;
        this.dTimer = setInterval(function () {
          if (self.msg.content && !self.cdSync) {
            Object(__WEBPACK_IMPORTED_MODULE_7__api__["d" /* getCountdown */])(self.pageID, self.flagKey).then(function (jsonObj) {
              var timeLeft = jsonObj.body;
              if (jsonObj.statusCode !== 400 && timeLeft !== 0 && self.firstSendObj[self.pageID] === false) {
                self.countdown = timeLeft;
                self.cdSync = true;
              }
            });
          } else if (self.msg.content == '') {
            self.cdSync = false;
          }
          --self.countdown;
          if (self.countdown <= 0) {
            clearInterval(self.dTimer);
            self.navigation();

            flagRef.child(self.flagKey + '/agent').remove();
          }
        }, 1000);
      }
    },

    'msg.content': function msgContent(val, oldVal) {
      this.generateAutocompleteItems(val);
    }
  },
  mounted: function mounted() {
    var _this = this;

    function fullNameElseID(key, val) {
      if (val.firstName && val.lastName) {
        return val.firstName + ' ' + val.lastName;
      } else if (val.name) {
        return val.name;
      } else if (val.shortID) {
        return 'Guest ' + val.shortID;
      } else {
          return 'Guest';
        }
    }
    var self = this;
    bots.child(this.$store.state.bot).once('value').then(function (snapshot) {
      _this.avatarURL = snapshot.child('avatarURL').val();
    });
    flagRef.orderByChild('userID').equalTo(this.pageID).on('value', function (snapshot) {
      if (snapshot.exists() && self.$router.currentRoute.name === 'Interaction') {
        self.flagged = true;
        self.flagKey = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(snapshot.val())[0];

        if (snapshot.child(self.flagKey + '/agent').exists()) {
          if (snapshot.child(self.flagKey).val().agent != self.currentUser && self.currentUser != null) {
            self.duplicateAgent = true;
          } else {
            self.duplicateAgent = false;
          }
        } else {
          flagRef.child(self.flagKey).update({
            agent: self.currentUser
          });
        }

        Object(__WEBPACK_IMPORTED_MODULE_7__api__["d" /* getCountdown */])(self.pageID, self.flagKey).then(function (jsonObj) {
          var timeLeft = jsonObj.body;

          if (JSON.parse(window.localStorage.getItem('firstSendObj')) === null) {
            window.localStorage.setItem('firstSendObj', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(self.firstSendObj));
          }
          self.firstSendObj = JSON.parse(window.localStorage.getItem('firstSendObj'));
          if (self.firstSendObj.hasOwnProperty(self.pageID) === false) {
            self.firstSendObj[self.pageID] = true;
            window.localStorage.setItem('firstSendObj', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(self.firstSendObj));
          }
          if (jsonObj.statusCode !== 400 && timeLeft !== 0 && self.firstSendObj[self.pageID] === false) {
            self.countdown = timeLeft;
          }
        });
      }
    });
    usersRef.child(this.pageID).on('value', function (snapshot) {
      _this.name = fullNameElseID(_this.pageID, snapshot.val());
      if (snapshot.val().totalSentiment) {
        _this.sentiment = Math.round(snapshot.val().totalSentiment.score * 100) + '%';
        _this.sentimentValue = Math.round(snapshot.val().totalSentiment.score * 100);
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan___default()(_this.sentimentValue)) {
          _this.sentimentValue = '-';
        }
      }
      _this.paused = snapshot.val().takeover;
      _this.newestKey = snapshot.val().newestChatKey;
      _this.onlineStatus = snapshot.val().status;
    });
    this.displayChat(this.noOfChats);
    document.querySelector('button[type=submit]').addEventListener('submit', function (e) {
      e.preventDefault();
    });
    document.getElementsByTagName('form')[0].addEventListener('submit', function (e) {
      e.preventDefault();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var _this2 = this;

    if (this.flagged) {
      Object(__WEBPACK_IMPORTED_MODULE_7__api__["d" /* getCountdown */])(this.pageID, this.flagKey).then(function (jsonObj) {
        var timeLeft = jsonObj.body;
        if (jsonObj.statusCode !== 400 && timeLeft <= 0) {
          _this2.flagged = false;
          delete _this2.firstSendObj[_this2.pageID];
          localStorage.setItem('firstSendObj', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(_this2.firstSendObj));
        }
      });
    }
    clearInterval(this.dTimer);
    flagRef.child(this.flagKey + '/agent').remove();
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll: function handleScroll() {},

    toggleFullscreen: function toggleFullscreen() {
      this.screenFull = !this.screenFull;
    },
    displayChat: function displayChat(noOfChats) {
      var _this3 = this;

      var icPattern = /\d{2}[0-1]\d{1}[0-3]\d{1}-?\d{2}-?\d{4}/;
      var cdsPattern = /\d{10}/;
      chatRef.off('value');
      var chats;
      chatRef.child(this.pageID + '/chats').orderByChild('timestamp').limitToLast(noOfChats * 10).on('value', function (snapshot) {
        chats = [];
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(snapshot.val()).forEach(function (_ref) {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
              key = _ref2[0],
              val = _ref2[1];

          var chat = {
            chatID: key,
            fromUser: val.fromUser,
            message: val.message,
            translatedText: null,
            dashboard: val.matchedIntent == 'N/A from Dashboard',
            timestamp: val.timestamp,
            platform: val.platform,
            sentiment: Math.round(val.sentiment * 100) + '%',
            sentimentValue: val.sentiment,
            agent: val.agent && val.agent.name
          };
          if (Array.isArray(val.message)) {
            try {
              __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(val.message).forEach(function (element) {
                var chatLocal = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, chat);
                if (element[1].text) {
                  chatLocal.message = element[1].text.text[0];
                  chats.push(chatLocal);
                } else if (chat.platform.source == 'fb' && element[0].quickReplies) {
                  var fbQuickRepliesArray = [];
                  fbQuickRepliesArray.push(element[0].quickReplies);
                  chatLocal.message = fbQuickRepliesArray;
                  chats.push(chatLocal);
                } else if (element[1].quickReplies) {
                  var quickRepliesArray = [];
                  quickRepliesArray.push(element[1].quickReplies);
                  chatLocal.message = quickRepliesArray;
                  chats.push(chatLocal);
                } else if (element[1].payload) {
                  if (element[1].payload.facebook.attachment.payload.template_type == 'generic') {
                    var carouselElements = element[1].payload.facebook.attachment.payload.elements;
                    chatLocal.message = carouselElements;
                    chats.push(chatLocal);
                  } else if (element[1].payload.facebook.attachment.payload.template_type == 'list') {
                    var templateElements = [element[1].payload.facebook.attachment.payload];
                    chatLocal.message = templateElements;
                    chats.push(chatLocal);
                  } else {
                    console.log('receiving payload but unknown format');
                  }
                } else if (element[1][0].address) {
                  var _carouselElements = element[1];
                  chatLocal.message = _carouselElements;
                  chats.push(chatLocal);
                }
              });
            } catch (e) {
              console.log('error mou', e, val.message);
            }
          } else {
            if (val.message.search('&nbsp;') !== -1) {
              chat.message = val.message.replace('&nbsp;', ' ');
            }
            if (val.formattedAddress) {
              chat.message = val.formattedAddress;
            }
            if (val.imageUrl) {
              chat.message = {
                imageUrl: val.imageUrl
              };
            }
            if (typeof chat.message == 'string') {
              chat.message = chat.message.split(icPattern).join('••••IC NO••••').split(cdsPattern).join('•••CDS••••');
            }

            chats.push(chat);
          }
        });
        _this3.chats = chats;

        _this3.loading = false;
        _this3.loadingMore = false;
        if (_this3.clickedOnLoadMore == false) {
          setTimeout(function () {
            window.scrollTo(0, document.body.scrollHeight);
          }, 300);
        } else {
          var firstChatID = _this3.firstChatID;
          setTimeout(function () {
            var headerHeight = 70;
            document.getElementById(firstChatID).scrollIntoView(true);
            var scrolledY = window.scrollY;

            if (scrolledY) {
              window.scroll(0, scrolledY - headerHeight);
            }
          }, 100);
        }
        _this3.clickedOnLoadMore = false;
        _this3.firstChatID = _this3.chats[0].chatID;
      });
      chatRef.child(this.pageID + '/chats').once('value').then(function (snapshot) {
        if (snapshot.numChildren() <= _this3.noOfChats * 10) {
          _this3.maxChatsNotReached = false;
        }
      });
    },

    replaceNewline: function replaceNewline(innerHTML) {
      if (typeof innerHTML !== 'string') {
        return '';
      }
      return innerHTML.replace(/\n/g, '<br>');
    },
    addNoOfChats: function addNoOfChats() {
      this.loadingMore = true;
      this.noOfChats += 1;
      this.clickedOnLoadMore = true;
      this.displayChat(this.noOfChats);
    },
    triggersend: function triggersend(evt) {
      evt.preventDefault();
      this.$refs.myModalRef.hide();
      this.Sendconfirmation = true;
    },
    hidemodal: function hidemodal() {
      this.$refs.myModalRef.hide();
      this.Sendconfirmation = false;
    },
    navigation: function navigation() {
      this.$router.push('/interactionsRT');
      this.$snotify.error('Your page session has expired!');
    },
    sendMessage: function sendMessage() {
      this.sending = true;

      var content = {
        platform: this.chats[0].platform.source,
        userID: this.pageID,
        message: this.msg.content,

        agentName: this.firstNameOfAgent,
        agentID: this.uniqueIDOfAgent
      };

      Object(__WEBPACK_IMPORTED_MODULE_7__api__["i" /* send */])(content).then(function (res) {
        res.error && this.$snotify.error(res.error);
        if (this.flagged && this.firstSendObj[this.pageID] && this.msg.content !== undefined && /^\s*$/.test(this.msg.content)) {
          this.firstSendObj[this.pageID] = false;
          window.localStorage.setItem('firstSendObj', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.firstSendObj));

          Object(__WEBPACK_IMPORTED_MODULE_7__api__["b" /* cancelCountdown */])(this.pageID).then(function (res) {
            console.log(res);
          });
        }

        this.sending = false;
      }.bind(this));

      this.$data.msg.content = '';
      document.getElementsByTagName('input')[0].value = '';
    },
    sendBlast: function sendBlast() {
      var content = {
        platform: 'webPopup',
        campaignGroup: 'demo',
        campaign: this.msg.content
      };

      Object(__WEBPACK_IMPORTED_MODULE_7__api__["a" /* blast */])(content).then(function (res) {
        res.error && this.$snotify.error(res.error);
      });
    },
    pause: function pause() {
      var _this4 = this;

      usersRef.child(this.pageID).update({
        takeover: !this.paused,
        flagged: false
      });
      msgsRef.child(this.newestKey).once('value').then(function (snapshot) {
        var t = snapshot.val().timestamp;
        msgsRef.child(_this4.newestKey).update({
          timestamp: t + 1,
          flagged: false
        });
      });

      if (this.flagged && !this.paused) {
        flagRef.orderByChild('userID').equalTo(this.pageID).once('value', function (snapshot) {
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(snapshot.val()).forEach(function (_ref3) {
            var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                key = _ref4[0],
                val = _ref4[1];

            flagRef.child(key).remove();
          });
        });
        this.flagged = false;
        delete this.firstSendObj[this.pageID];
        localStorage.setItem('firstSendObj', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.firstSendObj));
        clearInterval(this.dTimer);

        Object(__WEBPACK_IMPORTED_MODULE_7__api__["b" /* cancelCountdown */])(this.pageID).then(function (res) {
          console.log(res);
        });
      }
    },
    initializeVideocall: function initializeVideocall() {
      var that = this;
      this.$data.videoIsOn = !this.$data.videoIsOn;
      console.log('it run here initialize');
      if (this.$data.videoIsOn) {
        process.nextTick(function () {
          var friendsVideo = document.getElementById('friendsVideo');
          var yourId = that.pageID;
          that.$data.videoId = yourId;

          var servers = { 'iceServers': [{ 'urls': 'stun:stun.services.mozilla.com' }, { 'urls': 'stun:stun.l.google.com:19302' }, { 'urls': 'turn:numb.viagenie.ca', 'credential': 'beaver', 'username': 'boringdragonlee@gmail.com' }] };
          var pc = new RTCPeerConnection(servers);
          that.$data.pc = pc;
          pc.onicecandidate = function (event) {
            return event.candidate ? sendMessage(yourId, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({ 'ice': event.candidate })) : console.log('Sent All Ice');
          };
          pc.onaddstream = function (event) {
            friendsVideo.srcObject = event.stream;
          };
          videoRef.on('child_added', readMessage);
          that.showMyFace();
        });
      } else {
        if (that.screenFull) {
          that.screenFull = false;
        }
        that.$data.pc.close();
      }

      function sendMessage(senderId, data) {
        var msg = videoRef.push({ sender: senderId, message: data });
        msg.remove();
      }

      function readMessage(data) {
        var msg = JSON.parse(data.val().message);
        var sender = data.val().sender;
        if (sender != that.$data.videoId) {
          if (msg.ice != undefined) {
            that.$data.pc.addIceCandidate(new RTCIceCandidate(msg.ice));
          } else if (msg.sdp.type == 'offer') {
            that.$data.pc.setRemoteDescription(new RTCSessionDescription(msg.sdp)).then(function () {
              return that.$data.pc.createAnswer();
            }).then(function (answer) {
              return that.$data.pc.setLocalDescription(answer);
            }).then(function () {
              return sendMessage(that.$data.videoId, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({ 'sdp': that.$data.pc.localDescription }));
            });
          } else if (msg.sdp.type == 'answer') {
            that.$data.pc.setRemoteDescription(new RTCSessionDescription(msg.sdp));
          }
        }
      }
    },
    showMyFace: function showMyFace() {
      var _this5 = this;

      var yourVideo = document.getElementById('yourVideo');
      yourVideo.muted = 'muted';
      navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then(function (stream) {
        yourVideo.srcObject = stream;
        return stream;
      }).then(function (stream) {
        _this5.$data.pc.addStream(stream);
      });
    },
    showFriendsFace: function showFriendsFace() {
      var _this6 = this;

      this.$data.pc.createOffer().then(function (offer) {
        return _this6.$data.pc.setLocalDescription(offer);
      }).then(function () {
        return sendMessage(_this6.$data.videoId, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({ 'sdp': _this6.$data.pc.localDescription }));
      });

      function sendMessage(senderId, data) {
        var msg = videoRef.push({ sender: senderId, message: data });
        msg.remove();
      }
    },
    generateAutocompleteItems: function generateAutocompleteItems(input) {
      var results = input.length > 1 && input.length <= 64 ? fuse.search(input).slice(0, 5) : [];

      this.autocompleteItems = results;
    },
    autocompleteInput: function autocompleteInput(title) {
      this.msg.content = title;
      this.autocompleteItems = [];
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(101)))

/***/ }),

/***/ 899:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var FUSE_OPTIONS = {
  shouldSort: true,
  includeScore: true,

  threshold: 0.44,
  location: 16,
  distance: 80,
  maxPatternLength: 64,
  minMatchCharLength: 2,
  keys: ['title', 'synonyms']
};

/* harmony default export */ __webpack_exports__["a"] = (FUSE_OPTIONS);

/***/ }),

/***/ 900:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var FUZZY_SEARCH_ITEMS = [{
  title: '1. Provide your IC and supported documents\n    2. Go to Application Tab and fill in.\n    3. Fill in your loan amount and submit!',
  synonyms: ['How do i apply for loan']
}, {
  title: 'Benefits of Unit Trusts\n    1) Professional management\n    2) Diversification\n    3) Economies of scale'
}, {
  title: 'Eligibility of Unit Trusts\n    1) Make a one-time investment on a fund and take immediate advantage of the underlying market.\n    2) Make regular investments from as low as RM100* a month and even out market risks in the long run.\n    3) A systematic investment programme that spreads out your one-time unit trust investment amount over a 6-month or 12-month period.'
}, {
  title: 'Benefits of Premier Account\n    1) Easily manage funds with e-Statement.\n    2) Insures eligible deposits for up to RM250,000 per depositor.\n    3) Enable to create joint account with 2 or more individuals.'
}, {
  title: 'Eligibility of Premier Account \n    1a) Individuals aged 18 years old and above\n    1b) Malaysian, Permanent Residents and Non-residents\n\n    Documents Required\n    2a) IC\n    2b) Letter (existing account holder with at least 12 months with CI Bank / statements form another banks)\n    2c) Minimum Initial Deposit - RM3,000'
}, {
  title: 'I\'m glad to help you.'
}, {
  title: 'Thank you for reaching out, can I have your contact to follow up?',
  synonyms: ['can you give me your number', 'hi there', 'vip', 'vvip', 'vvvip']
}, {
  title: 'How may I help you?',
  synonyms: ['hello', 'hi there', 'hey', 'sorry']
}, {
  title: 'Pleasure to serve you.'
}];

/* harmony default export */ __webpack_exports__["a"] = (FUZZY_SEARCH_ITEMS);

/***/ }),

/***/ 901:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Interaction"), _c('small', [_vm._v(" with " + _vm._s(_vm.name) + "  ")]), (_vm.sentimentValue >= 0) ? _c('button', {
    staticClass: "btn btn-success"
  }, [_c('span', [_vm._v(_vm._s(_vm.sentiment) + "  ")]), _c('span', {
    staticClass: "fa fa-thumbs-o-up"
  })]) : (_vm.sentimentValue == '-') ? _c('button', {
    staticClass: "btn btn-secondary"
  }, [_c('span', [_vm._v(_vm._s(_vm.sentiment) + "  ")]), _c('span')]) : _c('button', {
    staticClass: "btn btn-danger"
  }, [_c('span', [_vm._v(_vm._s(_vm.sentiment) + "  ")]), _c('span', {
    staticClass: "fa fa-thumbs-o-down"
  })])]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Displaying past interactions with " + _vm._s(_vm.name))])])]), _c('br'), (_vm.loading) ? _c('div', [_vm._v("Loading Chat..."), _c('br'), _c('br')]) : _c('div', [(_vm.loadingMore) ? _c('div', {
    staticStyle: {
      "margin": "10px 0px",
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : (_vm.maxChatsNotReached) ? _c('div', {
    staticStyle: {
      "margin": "10px 0px",
      "text-align": "center",
      "text-decoration": "underline",
      "color": "#0084ff",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.addNoOfChats
    }
  }, [_vm._v("View older messages...")]) : _vm._e(), (!_vm.screenFull) ? _c('app-chat', {
    attrs: {
      "msgs": _vm.chats,
      "profPic": _vm.profPicUrl,
      "botPic": _vm.avatarURL,
      "takeover": _vm.paused,
      "duplicateAgent": _vm.duplicateAgent,
      "onlineStatus": _vm.onlineStatus
    }
  }) : _vm._e()], 1), (_vm.videoIsOn) ? _c('div', {
    staticClass: "video-window",
    class: {
      fullscreen: _vm.screenFull
    }
  }, [_c('video', {
    staticClass: "friendVideoCalling",
    class: {
      fullscreen: _vm.screenFull
    },
    attrs: {
      "id": "friendsVideo",
      "autoplay": "autoplay",
      "playsinline": "playsinline"
    }
  }), _c('video', {
    staticClass: "yourVideoCalling",
    class: {
      fullscreen: _vm.screenFull
    },
    attrs: {
      "id": "yourVideo",
      "autoplay": "autoplay",
      "playsinline": "playsinline"
    }
  }), _c('br'), _c('button', {
    staticClass: "full",
    class: {
      fullscreen: _vm.screenFull
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleFullscreen
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 28.361 28.361"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "id": "Capa_1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 28.361 28.361",
      "xml:space": "preserve",
      "width": "14px",
      "height": "14px"
    }
  }, [_c('g', [_c('g', {
    attrs: {
      "id": "c115_arrows"
    }
  }, [_c('path', {
    attrs: {
      "d": "M28.36,19.595c0-0.868-0.665-1.57-1.491-1.57c-0.819,0.002-1.492,0.702-1.492,1.57v3.25l-6.018-6.021    c-0.582-0.583-1.524-0.583-2.106,0c-0.582,0.582-0.582,1.527,0,2.109l5.989,5.987h-3.235c-0.881,0.002-1.591,0.669-1.591,1.491    c0,0.824,0.71,1.49,1.591,1.49h6.761c0.881,0,1.59-0.665,1.593-1.49c-0.003-0.022-0.006-0.039-0.009-0.061    c0.003-0.028,0.009-0.058,0.009-0.087v-6.668H28.36z",
      "fill": "#000000"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9,16.824l-6.015,6.021v-3.25c0-0.868-0.672-1.568-1.493-1.57c-0.824,0-1.49,0.702-1.49,1.57L0,26.264    c0,0.029,0.008,0.059,0.01,0.087c-0.002,0.021-0.006,0.038-0.008,0.061c0.002,0.825,0.712,1.49,1.592,1.49h6.762    c0.879,0,1.59-0.666,1.59-1.49c0-0.822-0.711-1.489-1.59-1.491H5.121l5.989-5.987c0.58-0.582,0.58-1.527,0-2.109    C10.527,16.241,9.584,16.241,9,16.824z",
      "fill": "#000000"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19.359,11.535l6.018-6.017v3.25c0,0.865,0.673,1.565,1.492,1.568c0.826,0,1.491-0.703,1.491-1.568V2.097    c0-0.029-0.006-0.059-0.009-0.085c0.003-0.021,0.006-0.041,0.009-0.062c-0.003-0.826-0.712-1.491-1.592-1.491h-6.761    c-0.881,0-1.591,0.665-1.591,1.491c0,0.821,0.71,1.49,1.591,1.492h3.235l-5.989,5.987c-0.582,0.581-0.582,1.524,0,2.105    C17.835,12.12,18.777,12.12,19.359,11.535z",
      "fill": "#000000"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.121,3.442h3.234c0.879-0.002,1.59-0.671,1.59-1.492c0-0.826-0.711-1.491-1.59-1.491H1.594    c-0.88,0-1.59,0.665-1.592,1.491C0.004,1.971,0.008,1.991,0.01,2.012C0.008,2.038,0,2.067,0,2.097l0.002,6.672    c0,0.865,0.666,1.568,1.49,1.568c0.821-0.003,1.493-0.703,1.493-1.568v-3.25L9,11.535c0.584,0.585,1.527,0.585,2.11,0    c0.58-0.581,0.58-1.524,0-2.105L5.121,3.442z",
      "fill": "#000000"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Capa_1_253_"
    }
  })])])]), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    class: {
      fullscreen: _vm.screenFull
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showFriendsFace
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-facetime-video",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("Call client")])])]) : _vm._e(), _c('form', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "disabled": _vm.duplicateAgent
    },
    model: {
      value: (_vm.msg.content),
      callback: function($$v) {
        _vm.msg.content = $$v
      },
      expression: "msg.content"
    }
  }), _c('div', {
    staticClass: "autocomplete",
    staticStyle: {
      "position": "absolute",
      "bottom": "36px",
      "width": "100%",
      "color": "#3e515b",
      "background": "white",
      "font-size": "0.875rem"
    }
  }, _vm._l((_vm.autocompleteItems), function(item) {
    return (_vm.msg.content !== item.item.title) ? _c('div', {
      staticClass: "autocomplete-item",
      staticStyle: {
        "padding": "0 13px",
        "line-height": "2",
        "height": "2.5em"
      },
      on: {
        "click": function($event) {
          _vm.autocompleteInput(item.item.title)
        }
      }
    }, [_vm._v(_vm._s(item.item.title))]) : _vm._e()
  })), (_vm.flagged) ? _c('b-input-group-button', {
    slot: "left"
  }, [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: ("Countdown"),
      expression: "\"Countdown\"",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn",
    attrs: {
      "type": "button",
      "variant": _vm.countdown < 10 ? "danger" : "success",
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.countdown))])], 1) : _vm._e(), _c('b-input-group-button', {
    slot: "right"
  }, [(!_vm.videoIsOn) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: ("Start Video Call"),
      expression: "\"Start Video Call\"",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn",
    attrs: {
      "type": "button",
      "variant": "secondary",
      "disabled": _vm.duplicateAgent
    },
    on: {
      "click": _vm.initializeVideocall
    }
  }, [_c('svg', {
    staticClass: "videoIcon",
    staticStyle: {
      "enable-background": "new 0 0 41.76 41.76"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 41.76 41.76",
      "xml:space": "preserve",
      "width": "14px",
      "height": "14px"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M26.365,33.46H2.897C1.3,33.46,0,32.161,0,30.564V11.195C0,9.599,1.3,8.3,2.897,8.3h23.468   c1.597,0,2.896,1.299,2.896,2.896v19.369C29.261,32.161,27.962,33.46,26.365,33.46z M2.897,9.3C1.852,9.3,1,10.15,1,11.195v19.369   c0,1.045,0.852,1.896,1.897,1.896h23.468c1.045,0,1.896-0.85,1.896-1.896V11.195c0-1.045-0.851-1.896-1.896-1.896H2.897z",
      "fill": "#ffffff",
      "stroke": "#ffffff",
      "stroke-width": "3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.26,30.73c-0.106,0-0.211-0.034-0.3-0.1l-12.499-9.354c-0.126-0.095-0.2-0.243-0.2-0.4s0.074-0.306,0.2-0.4   l12.496-9.348c0.153-0.113,0.355-0.132,0.523-0.047c0.17,0.085,0.276,0.258,0.276,0.447L41.76,30.23   c0,0.189-0.106,0.362-0.276,0.447C41.413,30.713,41.336,30.73,41.26,30.73z M29.596,20.877l11.164,8.354l-0.003-16.704   L29.596,20.877z",
      "fill": "#ffffff",
      "stroke": "#ffffff",
      "stroke-width": "3"
    }
  })])])]) : _vm._e(), (_vm.videoIsOn) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: ("Stop Video Call"),
      expression: "\"Stop Video Call\"",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn",
    attrs: {
      "type": "button",
      "variant": "success",
      "disabled": _vm.duplicateAgent
    },
    on: {
      "click": _vm.initializeVideocall
    }
  }, [_c('svg', {
    staticClass: "videoIcon",
    staticStyle: {
      "enable-background": "new 0 0 41.76 41.76"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 41.76 41.76",
      "xml:space": "preserve",
      "width": "14px",
      "height": "14px"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M26.365,33.46H2.897C1.3,33.46,0,32.161,0,30.564V11.195C0,9.599,1.3,8.3,2.897,8.3h23.468   c1.597,0,2.896,1.299,2.896,2.896v19.369C29.261,32.161,27.962,33.46,26.365,33.46z M2.897,9.3C1.852,9.3,1,10.15,1,11.195v19.369   c0,1.045,0.852,1.896,1.897,1.896h23.468c1.045,0,1.896-0.85,1.896-1.896V11.195c0-1.045-0.851-1.896-1.896-1.896H2.897z",
      "fill": "#ffffff",
      "stroke": "#ffffff",
      "stroke-width": "3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.26,30.73c-0.106,0-0.211-0.034-0.3-0.1l-12.499-9.354c-0.126-0.095-0.2-0.243-0.2-0.4s0.074-0.306,0.2-0.4   l12.496-9.348c0.153-0.113,0.355-0.132,0.523-0.047c0.17,0.085,0.276,0.258,0.276,0.447L41.76,30.23   c0,0.189-0.106,0.362-0.276,0.447C41.413,30.713,41.336,30.73,41.26,30.73z M29.596,20.877l11.164,8.354l-0.003-16.704   L29.596,20.877z",
      "fill": "#ffffff",
      "stroke": "#ffffff",
      "stroke-width": "3"
    }
  })])])]) : _vm._e(), (!_vm.paused) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: ("Pause Chatbot"),
      expression: "\"Pause Chatbot\"",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn",
    attrs: {
      "type": "button",
      "variant": "danger",
      "disabled": _vm.duplicateAgent
    },
    on: {
      "click": _vm.pause
    }
  }, [_c('i', {
    staticClass: "icon-control-pause"
  })]) : _vm._e(), (_vm.paused) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: ("Unpause Chatbot"),
      expression: "\"Unpause Chatbot\"",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn",
    attrs: {
      "type": "button",
      "variant": "success",
      "disabled": _vm.duplicateAgent
    },
    on: {
      "click": _vm.pause
    }
  }, [_c('i', {
    staticClass: "icon-control-play"
  })]) : _vm._e(), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: (_vm.sending ? "Sending Message" : "Send Message"),
      expression: "sending ? \"Sending Message\" : \"Send Message\"",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn text-white",
    attrs: {
      "type": "submit",
      "variant": "secondary",
      "disabled": !_vm.msg.content || (_vm.flagged && _vm.duplicateAgent)
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [(_vm.sending) ? _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }) : _c('i', {
    staticClass: "icon-paper-plane"
  })])], 1)], 1)], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 902:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InteractionsRT_vue__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d79130e_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_InteractionsRT_vue__ = __webpack_require__(904);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InteractionsRT_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d79130e_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_InteractionsRT_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 903:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__firebase__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filter__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(69);













var msgsRef = __WEBPACK_IMPORTED_MODULE_7__firebase__["b" /* db */].ref('newestChats');
var usersRef = __WEBPACK_IMPORTED_MODULE_7__firebase__["b" /* db */].ref('users');
var flagRef = __WEBPACK_IMPORTED_MODULE_7__firebase__["b" /* db */].ref('flags');
var dRef = __WEBPACK_IMPORTED_MODULE_7__firebase__["b" /* db */].ref('dashboard');

function fullNameElseID(key, val) {
  if (val.firstName && val.lastName) {
    return val.firstName + ' ' + val.lastName;
  } else if (val.name) {
    return val.name;
  } else if (val.shortID) {
    return 'Guest';
  } else {
      return 'Guest';
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  props: ['boss'],
  data: function data() {
    return {
      firstSendObj: {},
      timeout: [],
      refreshPage: false,
      finishedRefresh: true,
      userAccessLevel: this.$store.state.profile.accessLevel,
      loading: true,
      paused: null,
      interval: null,
      loadingPause: null,
      actions1: [{ name: 'View More' }],
      loadingText: 'Loading...',
      tableItems: [],
      tableFields: {
        avatar: {
          label: 'Status'
        },
        messageId: {
          label: 'Customer Name / ID'
        },
        userMessage: {
          label: 'User Message'
        },
        message: {
          label: 'Bot Message'
        },
        flagHandleBy: {
          label: 'Resolved By'
        },
        firstInteraction: {
          label: 'First Interaction'
        },
        numTimestamp: {
          label: 'Last Interaction'
        },
        sentiment: {
          label: 'Sentiment'
        }
      },
      tableItemsFlag: [],
      tableFieldsFlag: {
        avatar: {
          label: 'Status'
        },
        messageId: {
          label: 'Customer Name / ID'
        },
        userMessage: {
          label: 'User Message'
        },
        message: {
          label: 'Bot Message'
        },
        flagHandleBy: {
          label: 'Resolved By'
        },
        firstInteraction: {
          label: 'First Interaction'
        },
        numTimestamp: {
          label: 'Last Interaction'
        },
        quicksend: {
          label: '<i></i>',
          class: 'text-right',
          thStyle: {
            minWidth: '14em'
          }
        },
        agent: {
          label: 'Agent',
          class: 'text-center'
        }
      }
    };
  },

  methods: {
    paginate: function paginate(p) {
      var _this = this;

      var self = this;
      return new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(resolve) {
          var msgs, msgsFlag, users, flags, messageKey;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  msgsRef.limitToLast(p * 15).once('value', function () {
                    var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(snapshot) {
                      var keys, numOfFlag, currentNumFlag, iterator, promiseArray, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, k, icPattern, cdsPattern, val, senderID, d, cutOff, message, flagHandleByString, platform, msg, j;

                      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              msgs = [];
                              msgsFlag = [];
                              users = {};
                              keys = [];
                              numOfFlag = 0;
                              currentNumFlag = 0;
                              iterator = 0;
                              promiseArray = [];

                              promiseArray.push(flagRef.once('value').then(function (snapshot) {
                                numOfFlag = snapshot.numChildren();
                                flags = {};
                                messageKey = {};
                                var senderID;
                                if (window.localStorage.getItem('firstSendObj') !== null) {
                                  self.firstSendObj = JSON.parse(window.localStorage.getItem('firstSendObj'));
                                }
                                snapshot.val() && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(snapshot.val()).forEach(function (_ref3) {
                                  var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                                      key = _ref4[0],
                                      val = _ref4[1];

                                  try {
                                    senderID = val.senderID || val.userID;
                                    flags[senderID] = val.agent || ' ';
                                    messageKey[senderID] = key;
                                  } catch (error) {
                                    console.log('no uid: ' + error);
                                  }
                                });
                                __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(self.firstSendObj).forEach(function (_ref5) {
                                  var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
                                      key = _ref6[0],
                                      val = _ref6[1];

                                  if (messageKey.hasOwnProperty(key) === false) {
                                    delete self.firstSendObj[key];
                                    window.localStorage.setItem('firstSendObj', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.firstSendObj));
                                  }
                                });
                              }));

                              snapshot.forEach(function (child) {
                                keys.unshift(child.key);
                                try {
                                  promiseArray.push(usersRef.child(child.val().userID).once('value').then(function (ss) {
                                    users[child.val().userID] = ss.val();
                                  }));
                                } catch (error) {}
                              });
                              _context.next = 12;
                              return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a.all(promiseArray);

                            case 12:
                              _iteratorNormalCompletion = true;
                              _didIteratorError = false;
                              _iteratorError = undefined;
                              _context.prev = 15;
                              _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(keys);

                            case 17:
                              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                _context.next = 45;
                                break;
                              }

                              k = _step.value;

                              if (!(numOfFlag <= currentNumFlag && iterator >= p * 10)) {
                                _context.next = 21;
                                break;
                              }

                              return _context.abrupt('break', 45);

                            case 21:
                              _context.prev = 21;
                              icPattern = /\d{2}[0-1]\d{1}[0-3]\d{1}-?\d{2}-?\d{4}/;
                              cdsPattern = /\d{10}/;

                              if (!(iterator >= p * 10)) {
                                _context.next = 27;
                                break;
                              }

                              if (snapshot.val()[k].flagged) {
                                _context.next = 27;
                                break;
                              }

                              return _context.abrupt('continue', 42);

                            case 27:
                              val = snapshot.val()[k];
                              senderID = val.senderID || val.userID;

                              if (users[senderID]) {
                                val.username = fullNameElseID(senderID, users[senderID]);
                                val.url = users[senderID].profilePic || 'static/img/avatars/0.png';
                                val.status = users[senderID].status || 'danger';
                                val.takeover = users[senderID].takeover || false;
                                val.firstInteraction = users[senderID].firstInteraction || '-';
                                val.flagHandleBy = users[senderID].flagHandleBy || ['Not Applicable'];
                              } else {
                                val.username = senderID;
                                val.url = 'static/img/avatars/0.png';
                                val.status = 'danger';
                                val.takeover = false;
                                val.firstInteraction = '-';
                                val.flagHandleBy = ['Not Applicable'];
                              }
                              d = new Date();
                              cutOff = 50;
                              message = Object(__WEBPACK_IMPORTED_MODULE_8__filter__["parseMessage"])(val.message, cutOff);

                              if (val.flagHandleBy != ['Not Applicable']) {
                                flagHandleByString = val.flagHandleBy.join(', ');
                              } else {
                                flagHandleByString = 'Not Applicable';
                              }
                              platform = val.platform ? val.platform.source : '';
                              msg = {
                                avatar: { url: val.url, status: val.status, platform: platform, tooltip: k },
                                userId: senderID,
                                userMessage: val.userMessage ? val.userMessage.split(icPattern).join('••••IC NO••••').split(cdsPattern).join('•••CDS••••') : '',
                                rawMsg: val.message,
                                sentiment: {
                                  score: Math.round(val.sentiment * 100) + '%',
                                  number: val.sentiment
                                },
                                agent: { url: flags[senderID] && flags[senderID] !== ' ' && 'static/img/avatars/0.png', status: 'success', tooltip: flags[senderID] },
                                messageId: val.username,
                                flagHandleBy: { id: senderID, flagHandleBy: val.flagHandleBy, flagHandleByString: flagHandleByString },
                                numTimestamp: val.timestamp,
                                firstInteraction: val.firstInteraction,
                                message: message.split(icPattern).join('••••IC NO••••').split(cdsPattern).join('•••CDS••••'),
                                _rowVariant: d - val.timestamp < 300000 && 'success'
                              };

                              if (msg.userId && val.flagged == true) {
                                msg._rowVariant = 'danger';
                                for (j = 0; j < msgsFlag.length; j++) {
                                  if (msgsFlag[j].userId == msg.userId) {
                                    msgsFlag.splice(j, 1);
                                  }
                                }
                                msgsFlag.unshift(msg);
                                currentNumFlag += 1;
                              } else {
                                senderID && msgs.push(msg);
                                iterator += 1;
                              }
                              _context.next = 42;
                              break;

                            case 39:
                              _context.prev = 39;
                              _context.t0 = _context['catch'](21);

                              console.log(_context.t0);

                            case 42:
                              _iteratorNormalCompletion = true;
                              _context.next = 17;
                              break;

                            case 45:
                              _context.next = 51;
                              break;

                            case 47:
                              _context.prev = 47;
                              _context.t1 = _context['catch'](15);
                              _didIteratorError = true;
                              _iteratorError = _context.t1;

                            case 51:
                              _context.prev = 51;
                              _context.prev = 52;

                              if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                              }

                            case 54:
                              _context.prev = 54;

                              if (!_didIteratorError) {
                                _context.next = 57;
                                break;
                              }

                              throw _iteratorError;

                            case 57:
                              return _context.finish(54);

                            case 58:
                              return _context.finish(51);

                            case 59:
                              self.tableItemsFlag = msgsFlag;
                              self.tableItems = msgs;
                              resolve('completed');
                              msgs = [];
                              msgsFlag = [];
                              users = {};
                              flags = {};
                              messageKey = {};

                            case 67:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this, [[15, 47, 51, 59], [21, 39], [52,, 54, 58]]);
                    }));

                    return function (_x2) {
                      return _ref2.apply(this, arguments);
                    };
                  }());

                case 1:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    bossPause: function bossPause() {
      var p = this.paused;
      this.paused = !this.paused;
      this.loadingPause = true;
      var self = this;
      setTimeout(function () {
        self.loadingPause = false;
      }, 5000);
      dRef.update({
        pauseToggle: this.paused
      });
      if (!p) {
        Object(__WEBPACK_IMPORTED_MODULE_9__api__["f" /* pauseAll */])();
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_9__api__["h" /* resumeAll */])();
      }
    }
  },
  watch: {
    refreshPage: function refreshPage() {
      var _this2 = this;

      var p = 1;
      var that = this;
      if (this.finishedRefresh == true && this.refreshPage == true) {
        var _self = this;
        var int = setInterval(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
          var i;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  for (i = 0; i < that.timeout.length; i++) {
                    clearTimeout(that.timeout[i]);
                  }
                  that.timeout = [];
                  that.refreshPage = false;
                  that.finishedRefresh = false;
                  _self.paginate(p).then(function (res) {
                    for (var ite = 0; ite < 28; ite++) {
                      if (_self.tableItems[ite] && _self.tableItems[ite]._rowVariant == 'success') {
                        var i = ite;
                        that.timeout.push(setTimeout(function () {
                          _self.tableItems[i]._rowVariant = '';
                        }, 300000 - (new Date() - _self.tableItems[i].numTimestamp)));
                      }
                    }
                    if (that.refreshPage == false) {
                      clearInterval(int);
                      that.finishedRefresh = true;
                      _self.loading = false;
                    }
                  });

                case 5:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this2);
        })), 1000);
      }
      that.timeout = [];
      self.tableitems = [];
    }
  },
  mounted: function () {
    var _ref8 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var _this3 = this;

      var self;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              dRef.on('value', function (snapshot) {
                _this3.paused = snapshot.child('pauseToggle').val();
              });
              self = this;

              msgsRef.limitToLast(2).on('value', function (snapshot) {
                self.refreshPage = true;
              });

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function mounted() {
      return _ref8.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
    msgsRef.off('value');
  }
});

/***/ }),

/***/ 904:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Interactions (Live)")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Displaying Live Interactions")])]), _c('div', {
    staticClass: "col-sm-7 hidden-sm-down"
  }, [(_vm.userAccessLevel != "agent") ? _c('div', [(!_vm.paused) ? _c('b-btn', {
    staticClass: "pull-right ml-1",
    attrs: {
      "type": "button",
      "variant": "danger",
      "disabled": _vm.loadingPause
    },
    on: {
      "click": _vm.bossPause
    }
  }, [_c('i', {
    staticClass: "fa fa-pause"
  }), _vm._v("  Pause Autoreply")]) : _vm._e(), (_vm.paused) ? _c('b-btn', {
    staticClass: "pull-right ml-1",
    attrs: {
      "type": "button",
      "variant": "success",
      "disabled": _vm.loadingPause
    },
    on: {
      "click": _vm.bossPause
    }
  }, [_c('i', {
    staticClass: "fa fa-play"
  }), _vm._v("  Resume Autoreply")]) : _vm._e()], 1) : _vm._e()])]), _c('br'), (_vm.loading) ? _c('div', [_vm._v(_vm._s(_vm.loadingText))]) : _c('div', [(_vm.tableItemsFlag.length > 0) ? _c('div', [_c('app-interactionsTable', {
    attrs: {
      "data": _vm.tableItemsFlag,
      "label": _vm.tableFieldsFlag,
      "rowClick": "rowClick"
    }
  }), _c('br')], 1) : _vm._e(), (!_vm.boss) ? _c('app-interactionsTable', {
    attrs: {
      "data": _vm.tableItems,
      "label": _vm.tableFields,
      "rowClick": "rowClick"
    }
  }) : _vm._e()], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 905:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InteractionMenu_vue__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5378dbb6_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_InteractionMenu_vue__ = __webpack_require__(907);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InteractionMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5378dbb6_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_InteractionMenu_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 906:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      userAccessLevel: this.$store.state.profile.accessLevel,
      navs: {}
    };
  },

  methods: {
    chatLink: function chatLink(value) {
      return '/interactions/' + value.toLowerCase().replace(' ', '-');
    }
  }
});

/***/ }),

/***/ 907:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-row', {
    attrs: {
      "id": "home"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "interactions/live"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "fa fa-commenting"
  }), _c('br'), _vm._v("Live")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "interactions/historical"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "icon-book-open"
  }), _c('br'), _vm._v("Historical")])])], 1)], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 908:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoCall_vue__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9225f744_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_VideoCall_vue__ = __webpack_require__(910);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoCall_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9225f744_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_VideoCall_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 909:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_carousel__);







var videoRef = __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('videoCalling');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  components: {
    Carousel: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Slide"]
  },
  data: function data() {
    return {
      usersCount: 0,
      name: null,
      loading: true,
      profPicUrl: 'static/img/avatars/0.png',
      pageID: this.$route.params.userId,
      chats: [],
      msg: {
        content: ''
      },
      paused: false,
      onlineStatus: 'danger',
      sending: false,
      avatarURL: null,
      countdown: 999,
      dTimer: null,
      flagged: false,
      currentUser: this.$store.state.profile.firstName,
      duplicateAgent: false,
      newestKey: null,
      flagKey: null,
      firstSendObj: {},
      firstNameOfAgent: this.$store.state.profile.firstName,
      uniqueIDOfAgent: this.$store.state.profile.uniqueID,
      cdSync: false,
      noOfChats: 1,
      firstChatID: '',
      clickedOnLoadMore: false,
      maxChatsNotReached: true,
      loadingMore: false,
      pc: null,
      screenFull: true,
      videoIsOn: false,
      videoIsMute: false,
      videoStream: null,
      noteText: '',
      micIsMute: false
    };
  },

  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {
    var _this = this;

    if (this.flagged) {
      Object(__WEBPACK_IMPORTED_MODULE_2__api__["d" /* getCountdown */])(this.pageID, this.flagKey).then(function (jsonObj) {
        var timeLeft = jsonObj.body;
        if (jsonObj.statusCode !== 400 && timeLeft <= 0) {
          _this.flagged = false;
          delete _this.firstSendObj[_this.pageID];
          localStorage.setItem('firstSendObj', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.firstSendObj));
        }
      });
    }
    clearInterval(this.dTimer);
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll: function handleScroll() {},

    replaceNewline: function replaceNewline(innerHTML) {
      if (typeof innerHTML !== 'string') {
        return '';
      }
      return innerHTML.replace(/\n/g, '<br>');
    },
    addNoOfChats: function addNoOfChats() {
      this.loadingMore = true;
      this.noOfChats += 1;
      this.clickedOnLoadMore = true;
      this.displayChat(this.noOfChats);
    },
    triggersend: function triggersend(evt) {
      evt.preventDefault();
      this.$refs.myModalRef.hide();
      this.Sendconfirmation = true;
    },
    hidemodal: function hidemodal() {
      this.$refs.myModalRef.hide();
      this.Sendconfirmation = false;
    },
    navigation: function navigation() {
      this.$router.push('/interactionsRT');
      this.$snotify.error('Your page session has expired!');
    },
    sendMessage: function sendMessage() {
      this.sending = true;

      var content = {
        platform: 'webPopup',
        userID: this.pageID,
        message: this.msg.content,

        agentName: this.firstNameOfAgent,
        agentID: this.uniqueIDOfAgent
      };

      Object(__WEBPACK_IMPORTED_MODULE_2__api__["i" /* send */])(content).then(function (res) {
        res.error && this.$snotify.error(res.error);
        if (this.flagged && this.firstSendObj[this.pageID] && this.msg.content !== undefined && /^\s*$/.test(this.msg.content)) {
          this.firstSendObj[this.pageID] = false;
          window.localStorage.setItem('firstSendObj', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.firstSendObj));

          Object(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* cancelCountdown */])(this.pageID).then(function (res) {
            console.log(res);
          });
        }

        this.sending = false;
      }.bind(this));

      Object(__WEBPACK_IMPORTED_MODULE_2__api__["g" /* recordDataLog */])('sendMessage', this.pageID + '/' + this.$store.state.profile.uniqueID, {
        message: content.message
      });
      this.$data.msg.content = '';
      document.getElementsByTagName('input')[0].value = '';
    },
    sendBlast: function sendBlast() {
      var content = {
        platform: 'webPopup',
        campaignGroup: 'demo',
        campaign: this.msg.content
      };

      Object(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* blast */])(content).then(function (res) {
        res.error && this.$snotify.error(res.error);
      });
    },
    initializeVideocall: function initializeVideocall() {
      var that = this;
      process.nextTick(function () {
        var friendsVideo = document.getElementById('friendsVideo');
        var yourId = Math.floor(Math.random() * 1000000000);
        that.$data.videoId = yourId;

        var servers = { 'iceServers': [{ 'urls': 'stun:stun.services.mozilla.com' }, { 'urls': 'stun:stun.l.google.com:19302' }, { 'urls': 'turn:numb.viagenie.ca', 'credential': 'beaver', 'username': 'boringdragonlee@gmail.com' }] };
        var pc = new RTCPeerConnection(servers);
        that.$data.pc = pc;
        pc.onicecandidate = function (event) {
          return event.candidate ? sendMessage(yourId, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'ice': event.candidate })) : console.log('Sent All Ice');
        };
        pc.onaddstream = function (event) {
          friendsVideo.srcObject = event.stream;
        };
        pc.oniceconnectionstatechange = function () {
          if (pc.iceConnectionState == 'disconnected') {
            that.closeVideo();
          }
        };
        videoRef.on('child_added', readMessage);
        that.setStart();
        that.showMyFace();
      });

      function sendMessage(senderId, data) {
        var msg = videoRef.push({ sender: senderId, message: data });
        msg.remove();
      }

      function readMessage(data) {
        var msg = JSON.parse(data.val().message);
        var sender = data.val().sender;
        if (sender != that.$data.videoId) {
          if (msg.ice != undefined) {
            that.$data.pc.addIceCandidate(new RTCIceCandidate(msg.ice));
          } else if (msg.sdp.type == 'offer') {
            that.$data.pc.setRemoteDescription(new RTCSessionDescription(msg.sdp)).then(function () {
              return that.$data.pc.createAnswer();
            }).then(function (answer) {
              that.$data.answer = answer;
              document.getElementById('acceptCallButton').style.display = '';
              document.getElementById('rejectCallButton').style.display = '';
            });
          } else if (msg.sdp.type == 'answer') {
            that.$data.pc.setRemoteDescription(new RTCSessionDescription(msg.sdp));
          }
        }
      }
    },
    showMyFace: function showMyFace() {
      var _this2 = this;

      var yourVideo = document.getElementById('yourVideo');
      yourVideo.muted = 'muted';
      navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then(function (stream) {
        yourVideo.srcObject = stream;
        _this2.$data.videoStream = stream;
        return stream;
      }).then(function (stream) {
        _this2.$data.pc.addStream(stream);
      });
    },
    setStart: function setStart() {
      document.getElementById('alertClient').style.display = '';
      document.getElementById('alertStart').style.display = 'none';
      document.getElementById('closeVideoButton').style.display = 'none';
    },
    setOnCalling: function setOnCalling() {
      document.getElementById('alertClient').style.display = 'none';
      document.getElementById('muteMicButton').style.display = '';
      document.getElementById('muteVideoButton').style.display = '';
      document.getElementById('closeVideoButton').style.display = '';
    },
    closeOnCalling: function closeOnCalling() {
      document.getElementById('alertStart').style.display = '';
      document.getElementById('alertClient').style.display = 'none';
      document.getElementById('muteMicButton').style.display = 'none';
      document.getElementById('muteVideoButton').style.display = 'none';
      document.getElementById('closeVideoButton').style.display = 'none';
    },
    acceptOnCalling: function acceptOnCalling() {
      document.getElementById('alertClient').style.display = 'none';
      document.getElementById('muteMicButton').style.display = '';
      document.getElementById('muteVideoButton').style.display = '';
      document.getElementById('closeVideoButton').style.display = '';
    },
    acceptCall: function acceptCall() {
      var _this3 = this;

      document.getElementById('acceptCallButton').style.display = 'none';
      document.getElementById('rejectCallButton').style.display = 'none';
      this.acceptOnCalling();
      this.$data.pc.setLocalDescription(this.$data.answer).then(function () {
        return sendMessage(_this3.$data.videoId, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'sdp': _this3.$data.pc.localDescription }));
      });

      function sendMessage(senderId, data) {
        var msg = videoRef.push({ sender: senderId, message: data });
        msg.remove();
      }
    },
    rejectCall: function rejectCall() {
      document.getElementById('acceptCallButton').style.display = 'none';
      document.getElementById('rejectCallButton').style.display = 'none';
      alert('Call Rejected.');
    },
    muteMic: function muteMic() {
      var yourVideo = document.getElementById('yourVideo');
      this.$data.micIsMute = yourVideo.srcObject.getAudioTracks()[0].enabled;
      if (yourVideo.srcObject.getAudioTracks()[0].enabled == true) {
        document.getElementById('muteMicButton').classList.add('btn-danger');
        document.getElementById('muteMicButton').classList.remove('btn-primary');
        yourVideo.srcObject.getAudioTracks()[0].enabled = false;
      } else {
        document.getElementById('muteMicButton').classList.add('btn-primary');
        document.getElementById('muteMicButton').classList.remove('btn-danger');
        yourVideo.srcObject.getAudioTracks()[0].enabled = true;
      }
    },
    muteVideo: function muteVideo() {
      try {
        var yourVideo = document.getElementById('yourVideo');
        if (this.$data.videoIsMute == false) {
          document.getElementById('muteVideoButton').classList.add('btn-danger');
          document.getElementById('muteVideoButton').classList.remove('btn-primary');
          yourVideo.srcObject.getVideoTracks()[0].enabled = false;
          this.$data.videoIsMute = true;
        } else {
          document.getElementById('muteVideoButton').classList.add('btn-primary');
          document.getElementById('muteVideoButton').classList.remove('btn-danger');
          yourVideo.srcObject.getVideoTracks()[0].enabled = true;
          this.$data.videoIsMute = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    closeVideo: function closeVideo() {
      try {
        if (this.$data.videoIsMute == true) {
          this.muteVideo();
        }
        var yourVideo = document.getElementById('yourVideo');
        if (yourVideo.srcObject.getAudioTracks()[0].enabled == false) {
          this.muteMic();
        }
        yourVideo.srcObject = null;
        var friendsVideo = document.getElementById('friendsVideo');
        friendsVideo.srcObject = null;
        this.closeOnCalling();
        this.setclose();
        this.$data.pc.close();
        this.$data.pc = null;
      } catch (error) {
        console.log(error);
      }
    },
    showFriendsFace: function showFriendsFace() {
      var _this4 = this;

      this.setOnCalling();
      this.$data.pc.createOffer().then(function (offer) {
        return _this4.$data.pc.setLocalDescription(offer);
      }).then(function () {
        return sendMessage(_this4.$data.videoId, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'sdp': _this4.$data.pc.localDescription }));
      });

      function sendMessage(senderId, data) {
        var msg = videoRef.push({ sender: senderId, message: data });
        msg.remove();
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(101)))

/***/ }),

/***/ 910:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Video call")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v(" Connect video calling with client")])])]), _c('br'), _c('div', {
    staticClass: "video-window",
    class: {
      fullscreen: _vm.screenFull
    }
  }, [_c('video', {
    staticClass: "friendVideoCalling",
    class: {
      fullscreen: _vm.screenFull
    },
    attrs: {
      "id": "friendsVideo",
      "autoplay": "autoplay",
      "playsinline": "playsinline"
    }
  }), _c('video', {
    staticClass: "yourVideoCalling",
    class: {
      fullscreen: _vm.screenFull
    },
    attrs: {
      "id": "yourVideo",
      "autoplay": "autoplay",
      "playsinline": "playsinline"
    }
  }), _c('br'), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    class: {
      fullscreen: _vm.screenFull
    },
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "alertClient",
      "type": "button"
    },
    on: {
      "click": _vm.showFriendsFace
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-facetime-video",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    staticClass: "iconVideo",
    staticStyle: {
      "enable-background": "new 0 0 348.077 348.077"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "width": "14px",
      "height": "14px",
      "viewBox": "0 0 348.077 348.077",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M340.273,275.083l-53.755-53.761c-10.707-10.664-28.438-10.34-39.518,0.744l-27.082,27.076     c-1.711-0.943-3.482-1.928-5.344-2.973c-17.102-9.476-40.509-22.464-65.14-47.113c-24.704-24.701-37.704-48.144-47.209-65.257     c-1.003-1.813-1.964-3.561-2.913-5.221l18.176-18.149l8.936-8.947c11.097-11.1,11.403-28.826,0.721-39.521L73.39,8.194     C62.708-2.486,44.969-2.162,33.872,8.938l-15.15,15.237l0.414,0.411c-5.08,6.482-9.325,13.958-12.484,22.02     C3.74,54.28,1.927,61.603,1.098,68.941C-6,127.785,20.89,181.564,93.866,254.541c100.875,100.868,182.167,93.248,185.674,92.876     c7.638-0.913,14.958-2.738,22.397-5.627c7.992-3.122,15.463-7.361,21.941-12.43l0.331,0.294l15.348-15.029     C350.631,303.527,350.95,285.795,340.273,275.083z",
      "fill": "#FFFFFF"
    }
  })])])])]), _vm._v("Call client")])]), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    class: {
      fullscreen: _vm.screenFull
    },
    attrs: {
      "id": "alertStart",
      "type": "button"
    },
    on: {
      "click": _vm.initializeVideocall
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-facetime-video",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    staticClass: "iconVideo",
    staticStyle: {
      "enable-background": "new 0 0 41.76 41.76"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 41.76 41.76",
      "xml:space": "preserve",
      "width": "14px",
      "height": "14px"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M26.365,33.46H2.897C1.3,33.46,0,32.161,0,30.564V11.195C0,9.599,1.3,8.3,2.897,8.3h23.468   c1.597,0,2.896,1.299,2.896,2.896v19.369C29.261,32.161,27.962,33.46,26.365,33.46z M2.897,9.3C1.852,9.3,1,10.15,1,11.195v19.369   c0,1.045,0.852,1.896,1.897,1.896h23.468c1.045,0,1.896-0.85,1.896-1.896V11.195c0-1.045-0.851-1.896-1.896-1.896H2.897z",
      "fill": "#ffffff",
      "stroke": "#ffffff",
      "stroke-width": "3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.26,30.73c-0.106,0-0.211-0.034-0.3-0.1l-12.499-9.354c-0.126-0.095-0.2-0.243-0.2-0.4s0.074-0.306,0.2-0.4   l12.496-9.348c0.153-0.113,0.355-0.132,0.523-0.047c0.17,0.085,0.276,0.258,0.276,0.447L41.76,30.23   c0,0.189-0.106,0.362-0.276,0.447C41.413,30.713,41.336,30.73,41.26,30.73z M29.596,20.877l11.164,8.354l-0.003-16.704   L29.596,20.877z",
      "fill": "#ffffff",
      "stroke": "#ffffff",
      "stroke-width": "3"
    }
  })])]), _vm._v("Allow Camera")])]), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    class: {
      fullscreen: _vm.screenFull
    },
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "closeVideoButton",
      "type": "button"
    },
    on: {
      "click": _vm.closeVideo
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-facetime-video",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    staticClass: "iconVideo",
    staticStyle: {
      "enable-background": "new 0 0 32.192 32.192"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 32.192 32.192",
      "xml:space": "preserve",
      "width": "14px",
      "height": "14px"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M0,17.783l0.02,2.637l0.003,0.004c0.006,0.603,0.498,1.033,1.047,1.027l0.007,0.004l7.489-0.06   c0.578-0.005,1.028-0.476,1.022-1.043l-0.021-2.64l-0.366,0.005c0.114-1.096,1.444-1.354,4.096-1.647l6.383-0.055   c1.534,0.149,3.022,0.425,3.129,1.617l-0.205,0.001l0.021,2.637l0.001,0.004c0.005,0.605,0.499,1.033,1.049,1.028l0.006,0.005   l7.488-0.062c0.579-0.002,1.027-0.474,1.023-1.041l-0.022-2.64l-0.271,0.002c-0.264-1.604-2.91-6.78-15.413-6.828   c-12.975-0.047-16.012,5.323-16.17,7.043L0,17.783z",
      "fill": "#FFFFFF"
    }
  })])]), _vm._v("Hang Up")])]), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    class: {
      fullscreen: _vm.screenFull
    },
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "muteMicButton",
      "type": "button"
    },
    on: {
      "click": _vm.muteMic
    }
  }, [(!_vm.micIsMute) ? _c('span', {
    staticClass: "glyphicon glyphicon-facetime-video",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    staticClass: "iconVideo",
    staticStyle: {
      "enable-background": "new 0 0 461.55 461.55"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "width": "14px",
      "height": "14px",
      "viewBox": "0 0 461.55 461.55",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('g', {
    attrs: {
      "id": "volume-off"
    }
  }, [_c('path', {
    attrs: {
      "d": "M345.525,229.5c0-45.9-25.5-84.15-63.75-102v56.1l63.75,63.75C345.525,239.7,345.525,234.6,345.525,229.5z M409.275,229.5    c0,22.95-5.1,45.9-12.75,66.3l38.25,38.25c17.85-30.6,25.5-68.85,25.5-107.1c0-109.65-76.5-201.45-178.5-224.4V56.1    C355.725,81.6,409.275,147.9,409.275,229.5z M34.425,0L1.275,33.15L121.125,153H1.275v153h102l127.5,127.5V262.65L340.425,372.3    c-17.851,12.75-35.7,22.95-58.65,30.601v53.55c35.7-7.65,66.3-22.95,94.35-45.9l51,51l33.15-33.149l-229.5-229.5L34.425,0z     M230.775,25.5l-53.55,53.55l53.55,53.55V25.5z",
      "fill": "#FFFFFF"
    }
  })])])]), _vm._v("Mute Mic")]) : _vm._e(), (_vm.micIsMute) ? _c('span', {
    staticClass: "glyphicon glyphicon-facetime-video",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    staticClass: "iconVideo",
    staticStyle: {
      "enable-background": "new 0 0 461.55 461.55"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "width": "14px",
      "height": "14px",
      "viewBox": "0 0 461.55 461.55",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('g', {
    attrs: {
      "id": "volume-off"
    }
  }, [_c('path', {
    attrs: {
      "d": "M345.525,229.5c0-45.9-25.5-84.15-63.75-102v56.1l63.75,63.75C345.525,239.7,345.525,234.6,345.525,229.5z M409.275,229.5    c0,22.95-5.1,45.9-12.75,66.3l38.25,38.25c17.85-30.6,25.5-68.85,25.5-107.1c0-109.65-76.5-201.45-178.5-224.4V56.1    C355.725,81.6,409.275,147.9,409.275,229.5z M34.425,0L1.275,33.15L121.125,153H1.275v153h102l127.5,127.5V262.65L340.425,372.3    c-17.851,12.75-35.7,22.95-58.65,30.601v53.55c35.7-7.65,66.3-22.95,94.35-45.9l51,51l33.15-33.149l-229.5-229.5L34.425,0z     M230.775,25.5l-53.55,53.55l53.55,53.55V25.5z",
      "fill": "#FFFFFF"
    }
  })])])]), _vm._v("Unmute Mic")]) : _vm._e()]), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    class: {
      fullscreen: _vm.screenFull
    },
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "muteVideoButton",
      "type": "button"
    },
    on: {
      "click": _vm.muteVideo
    }
  }, [(!_vm.videoIsMute) ? _c('span', {
    staticClass: "glyphicon glyphicon-facetime-video",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    staticClass: "iconVideo",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 41.76 41.76",
      "xml:space": "preserve",
      "width": "14px",
      "height": "14px"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M26.365,33.46H2.897C1.3,33.46,0,32.161,0,30.564V11.195C0,9.599,1.3,8.3,2.897,8.3h23.468   c1.597,0,2.896,1.299,2.896,2.896v19.369C29.261,32.161,27.962,33.46,26.365,33.46z M2.897,9.3C1.852,9.3,1,10.15,1,11.195v19.369   c0,1.045,0.852,1.896,1.897,1.896h23.468c1.045,0,1.896-0.85,1.896-1.896V11.195c0-1.045-0.851-1.896-1.896-1.896H2.897z",
      "fill": "#ffffff",
      "stroke": "#ffffff",
      "stroke-width": "3"
    }
  }), _vm._v(" "), _c('line', {
    staticStyle: {
      "fill": "none",
      "stroke": "rgb(255, 255, 255)",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10"
    },
    attrs: {
      "x1": "32",
      "y1": "35",
      "x2": "1",
      "y2": "5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.26,30.73c-0.106,0-0.211-0.034-0.3-0.1l-12.499-9.354c-0.126-0.095-0.2-0.243-0.2-0.4s0.074-0.306,0.2-0.4   l12.496-9.348c0.153-0.113,0.355-0.132,0.523-0.047c0.17,0.085,0.276,0.258,0.276,0.447L41.76,30.23   c0,0.189-0.106,0.362-0.276,0.447C41.413,30.713,41.336,30.73,41.26,30.73z M29.596,20.877l11.164,8.354l-0.003-16.704   L29.596,20.877z",
      "fill": "#ffffff",
      "stroke": "#ffffff",
      "stroke-width": "3"
    }
  })])]), _vm._v("Mute Video ")]) : _vm._e(), (_vm.videoIsMute) ? _c('span', {
    staticClass: "glyphicon glyphicon-facetime-video",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    staticClass: "iconVideo",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 41.76 41.76",
      "xml:space": "preserve",
      "width": "14px",
      "height": "14px"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M26.365,33.46H2.897C1.3,33.46,0,32.161,0,30.564V11.195C0,9.599,1.3,8.3,2.897,8.3h23.468   c1.597,0,2.896,1.299,2.896,2.896v19.369C29.261,32.161,27.962,33.46,26.365,33.46z M2.897,9.3C1.852,9.3,1,10.15,1,11.195v19.369   c0,1.045,0.852,1.896,1.897,1.896h23.468c1.045,0,1.896-0.85,1.896-1.896V11.195c0-1.045-0.851-1.896-1.896-1.896H2.897z",
      "fill": "#ffffff",
      "stroke": "#ffffff",
      "stroke-width": "3"
    }
  }), _vm._v(" "), _c('line', {
    staticStyle: {
      "fill": "none",
      "stroke": "rgb(255, 255, 255)",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10"
    },
    attrs: {
      "x1": "32",
      "y1": "35",
      "x2": "1",
      "y2": "5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.26,30.73c-0.106,0-0.211-0.034-0.3-0.1l-12.499-9.354c-0.126-0.095-0.2-0.243-0.2-0.4s0.074-0.306,0.2-0.4   l12.496-9.348c0.153-0.113,0.355-0.132,0.523-0.047c0.17,0.085,0.276,0.258,0.276,0.447L41.76,30.23   c0,0.189-0.106,0.362-0.276,0.447C41.413,30.713,41.336,30.73,41.26,30.73z M29.596,20.877l11.164,8.354l-0.003-16.704   L29.596,20.877z",
      "fill": "#ffffff",
      "stroke": "#ffffff",
      "stroke-width": "3"
    }
  })])]), _vm._v("Unmute Video")]) : _vm._e()]), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    class: {
      fullscreen: _vm.screenFull
    },
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "rejectCallButton",
      "type": "button"
    },
    on: {
      "click": _vm.rejectCall
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-facetime-video",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    staticClass: "iconVideo",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "viewBox": "0 0 21.9 21.9",
      "enable-background": "new 0 0 21.9 21.9",
      "width": "14px",
      "height": "14px"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14.1,11.3c-0.2-0.2-0.2-0.5,0-0.7l7.5-7.5c0.2-0.2,0.3-0.5,0.3-0.7s-0.1-0.5-0.3-0.7l-1.4-1.4C20,0.1,19.7,0,19.5,0  c-0.3,0-0.5,0.1-0.7,0.3l-7.5,7.5c-0.2,0.2-0.5,0.2-0.7,0L3.1,0.3C2.9,0.1,2.6,0,2.4,0S1.9,0.1,1.7,0.3L0.3,1.7C0.1,1.9,0,2.2,0,2.4  s0.1,0.5,0.3,0.7l7.5,7.5c0.2,0.2,0.2,0.5,0,0.7l-7.5,7.5C0.1,19,0,19.3,0,19.5s0.1,0.5,0.3,0.7l1.4,1.4c0.2,0.2,0.5,0.3,0.7,0.3  s0.5-0.1,0.7-0.3l7.5-7.5c0.2-0.2,0.5-0.2,0.7,0l7.5,7.5c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l1.4-1.4c0.2-0.2,0.3-0.5,0.3-0.7  s-0.1-0.5-0.3-0.7L14.1,11.3z",
      "fill": "#FFFFFF"
    }
  })]), _vm._v("Reject Call")])]), _c('button', {
    staticClass: "btn btn-success btn-lg",
    class: {
      fullscreen: _vm.screenFull
    },
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "acceptCallButton",
      "type": "button"
    },
    on: {
      "click": _vm.acceptCall
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-facetime-video",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    staticClass: "iconVideo",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "viewBox": "0 0 26 26",
      "enable-background": "new 0 0 26 26",
      "width": "14px",
      "height": "14px"
    }
  }, [_c('path', {
    attrs: {
      "d": "m.3,14c-0.2-0.2-0.3-0.5-0.3-0.7s0.1-0.5 0.3-0.7l1.4-1.4c0.4-0.4 1-0.4 1.4,0l.1,.1 5.5,5.9c0.2,0.2 0.5,0.2 0.7,0l13.4-13.9h0.1v-8.88178e-16c0.4-0.4 1-0.4 1.4,0l1.4,1.4c0.4,0.4 0.4,1 0,1.4l0,0-16,16.6c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.5-0.1-0.7-0.3l-7.8-8.4-.2-.3z",
      "fill": "#FFFFFF"
    }
  })]), _vm._v("Accept Call")])])]), _c('form', [_c('b-form-textarea', {
    attrs: {
      "id": "textarea",
      "placeholder": "Take note..",
      "no-resize": true,
      "rows": 4,
      "max-rows": 16
    },
    model: {
      value: (_vm.noteText),
      callback: function($$v) {
        _vm.noteText = $$v
      },
      expression: "noteText"
    }
  })], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 911:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_176dd3ed_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__(913);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_176dd3ed_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 912:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsonToXlsx__ = __webpack_require__(137);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      userAccessLevel: this.$store.state.profile.accessLevel
    };
  },

  mounted: function mounted() {},
  methods: {
    xlsx: function xlsx() {
      Object(__WEBPACK_IMPORTED_MODULE_0__jsonToXlsx__["a" /* ec */])();
    },
    pdf: function pdf() {
      Object(__WEBPACK_IMPORTED_MODULE_0__jsonToXlsx__["b" /* ecp */])();
    }
  }
});

/***/ }),

/***/ 913:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Customers")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Displaying customers that have interacted with your bot")])]), _c('div', {
    staticClass: "col-sm-7 hidden-sm-down"
  }, [(_vm.userAccessLevel != "agent") ? _c('b-dropdown', {
    staticClass: "float-right",
    attrs: {
      "type": "button",
      "variant": "primary"
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('i', {
    staticClass: "icon-cloud-download"
  }), _vm._v("  Export")]), _c('b-dropdown-item', {
    attrs: {
      "type": "button",
      "variant": "info"
    },
    on: {
      "click": _vm.xlsx
    }
  }, [_vm._v("Download as xlsx")]), _c('b-dropdown-item', {
    attrs: {
      "type": "button",
      "variant": "info"
    },
    on: {
      "click": _vm.pdf
    }
  }, [_vm._v("Download as pdf")])], 2) : _c('b-button', {
    staticClass: "float-right",
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": _vm.pdf
    }
  }, [_c('i', {
    staticClass: "icon-cloud-download"
  }), _vm._v(" Export as pdf")])], 1)]), _c('br'), _c('user-table')], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 914:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Data_vue__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8a76f56_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Data_vue__ = __webpack_require__(916);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Data_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8a76f56_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Data_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 915:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {};
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ 916:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn",
    staticStyle: {
      "max-height": "calc( 100vh - 150px)"
    }
  }, [_c('b-img', {
    staticClass: "chatflow",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "src": "static/img/chatflow.png",
      "alt": "ChatFlow"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 917:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Graph_vue__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_879e179a_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Graph_vue__ = __webpack_require__(919);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Graph_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_879e179a_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Graph_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 918:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {};
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ 919:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row p-0"
  }, [_c('b-img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": "static/img/analytics.jpeg",
      "alt": "Users & Interactions Graph"
    }
  })], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 920:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Campaigns_vue__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11b8d348_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Campaigns_vue__ = __webpack_require__(922);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Campaigns_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11b8d348_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Campaigns_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 921:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {};
  },

  mounted: function mounted() {},
  methods: {}
});

/***/ }),

/***/ 922:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Broadcast")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Mange your ongoing campaigns")])]), _c('div', {
    staticClass: "col-sm-7 hidden-sm-down"
  }, [_c('b-btn', {
    staticClass: "pull-right",
    attrs: {
      "type": "button",
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "icon-cloud-download"
  }), _vm._v("  Export")]), _c('broadcast-modal')], 1)]), _c('br'), _c('broadcast-table')], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 923:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Campaign_vue__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93bd158a_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Campaign_vue__ = __webpack_require__(925);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Campaign_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93bd158a_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Campaign_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 924:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(69);





var campRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('campaign');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      broadcast: {},
      broadcastId: this.$route.params.Id,
      errorBlast: false,
      loading: true,
      bot: null
    };
  },

  mounted: function mounted() {
    var _this = this;

    campRef.child(this.$route.params.Id).on('value', function (snapshot) {
      _this.broadcast = snapshot.val();
      _this.loading = false;
    });
    this.bot = this.$store.state.bot;
  },
  computed: {
    lowerName: function lowerName() {
      return this.broadcast.name.toLowerCase().replace(/ /g, '-');
    },
    botName: function botName() {
      return this.bot.toLowerCase().replace(/ /g, '-');
    },
    uniqueId: function uniqueId() {
      return '#' + this.broadcastId;
    }
  },
  methods: {
    onApprove: function onApprove() {
      var _this2 = this;

      var contentFB = {
        platform: 'webPopup',
        campaignGroup: this.broadcast.audience,
        campaign: this.broadcast.message
      };
      var contentSMS = {
        platform: 'sms',
        campaignGroup: this.broadcast.audience,
        campaign: this.broadcast.message + ' Visit https://m.me/' + this.botName + '/?' + this.lowerName
      };
      this.broadcast.sms && this.broadcast.messenger && Object(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* blast */])(contentSMS).then(function (res) {
        res.error && this.onError(res.error);
      }.bind(this)) && Object(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* blast */])(contentFB).then(function (res) {
        res.error && this.onError(res.error);
      }.bind(this)).then(function () {
        return campRef.child(_this2.broadcastId).update({ approval: 'approved', sent: !_this2.errorBlast });
      });
      this.broadcast.messenger && !this.broadcast.sms && Object(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* blast */])(contentFB).then(function (res) {
        res.error && this.onError(res.error);
      }.bind(this)).then(function () {
        return campRef.child(_this2.broadcastId).update({ approval: 'approved', sent: !_this2.errorBlast });
      });
      this.broadcast.sms && !this.broadcast.messenger && Object(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* blast */])(contentSMS).then(function (res) {
        res.error && this.onError(res.error);
      }.bind(this)).then(function () {
        return campRef.child(_this2.broadcastId).update({ approval: 'approved', sent: !_this2.errorBlast });
      });
    },
    onDeny: function onDeny() {
      campRef.child(this.broadcastId).update({ approval: 'denied' });
    },
    onError: function onError(error) {
      this.errorBlast = true;
      this.$snotify.error(error);
    }
  }
});

/***/ }),

/***/ 925:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [(_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("Loading...")])]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v(_vm._s(_vm.broadcast.name))]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Broadcast " + _vm._s(_vm.uniqueId))])]), _c('div', {
    staticClass: "col-sm-7 hidden-sm-down"
  }, [_c('b-btn', {
    staticClass: "pull-right pill-right",
    attrs: {
      "type": "button",
      "variant": _vm.broadcast.approval == "denied" ? "outline-danger" : "danger",
      "disabled": _vm.broadcast.approval == "denied"
    },
    on: {
      "click": _vm.onDeny
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v("  Deny")]), _c('b-btn', {
    staticClass: "pull-right pill-left",
    attrs: {
      "type": "button",
      "variant": _vm.broadcast.approval == "approved" ? "outline-success" : "success",
      "disabled": _vm.broadcast.approval == "approved"
    },
    on: {
      "click": _vm.onApprove
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("  Approve")])], 1)]), _c('br'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("Audience:")]), _c('div', {
    staticClass: "col-md-10"
  }, [_vm._v(_vm._s(_vm.broadcast.audience))]), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("Message:")]), _c('div', {
    staticClass: "col-md-10"
  }, [_vm._v(_vm._s(_vm.broadcast.message))]), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("Campaign Link:")]), _c('div', {
    staticClass: "col-md-10"
  }, [_vm._v("https://m.me/" + _vm._s(_vm.botName) + "/?" + _vm._s(_vm.lowerName))]), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("Start Date:")]), _c('div', {
    staticClass: "col-md-10"
  }, [_vm._v(_vm._s(_vm.broadcast.start_date))]), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("End Date:")]), _c('div', {
    staticClass: "col-md-10"
  }, [_vm._v(_vm._s(_vm.broadcast.end_date))]), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("Platforms:")]), _c('div', {
    staticClass: "col-md-10"
  }, [_c('b-row', [_c('b-col', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: ("Email"),
      expression: "\"Email\"",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "cols": "1"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o",
    class: {
      "text-success": _vm.broadcast.email
    }
  })]), _c('b-col', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: ("SMS"),
      expression: "\"SMS\"",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "cols": "1"
    }
  }, [_c('i', {
    staticClass: "fa fa-mobile",
    class: {
      "text-success": _vm.broadcast.sms
    }
  })]), _c('b-col', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: ("Facebook Messenger"),
      expression: "\"Facebook Messenger\"",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "cols": "1"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook",
    class: {
      "text-success": _vm.broadcast.messenger
    }
  })])], 1)], 1)])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 926:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CRM_vue__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79f85803_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CRM_vue__ = __webpack_require__(928);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CRM_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79f85803_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CRM_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 927:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {};
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ 928:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("CRM")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Displaying upcoming appointments")])]), _c('div', {
    staticClass: "col-sm-7 hidden-sm-down"
  }, [_c('b-btn', {
    staticClass: "pull-right",
    attrs: {
      "type": "button",
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "icon-cloud-download"
  }), _vm._v("  Export")])], 1)]), _c('br'), _c('crm-table')], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 929:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Manual_vue__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d3f4c9e_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Manual_vue__ = __webpack_require__(931);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Manual_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d3f4c9e_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Manual_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 930:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      userAccessLevel: this.$store.state.profile.accessLevel,
      simulatedAccessLevel: null
    };
  },

  mounted: function mounted() {
    this.simulatedAccessLevel = this.userAccessLevel;
  },
  methods: {
    toggleAccessLevel: function toggleAccessLevel() {
      this.simulatedAccessLevel = this.simulatedAccessLevel == 'agent' ? this.userAccessLevel : 'agent';
    }
  }
});

/***/ }),

/***/ 931:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("User Manual for"), _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(" " + _vm._s(_vm.simulatedAccessLevel))])]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Documentation for Enchatment")])]), _c('div', {
    staticClass: "col-sm-4 hidden-sm-down text-right"
  }, [(_vm.userAccessLevel != "agent") ? _c('div', [(_vm.simulatedAccessLevel != "agent") ? _c('b-btn', {
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleAccessLevel()
      }
    }
  }, [_vm._v("Agent View")]) : _c('b-btn', {
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleAccessLevel()
      }
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.userAccessLevel))]), _vm._v(" View")])], 1) : _vm._e()])]), _c('br'), _c('p', [_c('b', [_vm._v("Enchatment")]), _vm._v(" is a platform for admins/agents to monitor the company's performance, manage the bot and it contains various features such as "), (_vm.simulatedAccessLevel != "agent") ? _c('span', [_vm._v("Dashboard, ")]) : _vm._e(), _vm._v("Interactions, Customers, Broadcast, Training, Chat Flow and CRM.")]), _c('br'), (_vm.simulatedAccessLevel != "agent") ? _c('div', [_c('h3', [_vm._v("Dashboard")]), _c('hr'), _c('p', [_vm._v("The Dashboard feature allows the agents to look at the overall performance of the bot.")]), _c('ol', [_c('li', [_vm._v("At the top section, the agent will be able to see two boxes which records the statistics of "), _c('b', [_vm._v("Total Customers")]), _vm._v(" and "), _c('b', [_vm._v("Total Interactions")]), _vm._v(". It will display the latest updates of the number of customers and the amount of interactions respectively.")]), _c('br'), _c('img', {
    attrs: {
      "src": "static/img/ui/topcustomers.png",
      "alt": "Total Customers"
    }
  }), _c('br'), _c('br'), _c('img', {
    attrs: {
      "src": "/static/img/ui/topinteractions.png",
      "alt": "Total Interactions"
    }
  }), _c('br'), _c('br'), _c('li', [_vm._v("At the middle section, the agent will be able to view "), _c('b', [_vm._v("Top Conversation Topics")]), _vm._v(" which will have the 5 Most Interacted Topics that the customers have used during interaction with the bot. It also displays the Users Count and Interactions Count for the each specific topic. "), _c('br'), _vm._v(" At the top right of the table, an "), _c('b', [_vm._v("Export")]), _vm._v(" button will be available. "), (_vm.simulatedAccessLevel != "agent") ? _c('span', [_vm._v("Supervisor will be able to download as Excel Spreadsheet while agent will be able to download as PDF.")]) : _c('span', [_vm._v("Agent will be able to download as PDF.")])]), _c('br'), _c('img', {
    attrs: {
      "src": "/static/img/ui/dashboard2.png",
      "alt": "Top Conversation Topics"
    }
  }), _c('br'), _c('br'), _c('li', [_vm._v("At the bottom section, the agent will be able to monitor "), _c('b', [_vm._v("Real Time Interactions")]), _vm._v(" with the 5 Most Recent Interactions. It displays the updated messages as they are being sent from every customer, including the timestamp that states the time of occurrence of the particular message. "), _c('br'), _vm._v(" At the top right of the table, an "), _c('b', [_vm._v("Export")]), _vm._v(" button will be available. "), (_vm.simulatedAccessLevel != "agent") ? _c('span', [_vm._v("Supervisor will be able to download as Excel Spreadsheet while agent will be able to download as PDF.")]) : _c('span', [_vm._v("Agent will be able to download as PDF.")])]), _c('br'), _c('img', {
    attrs: {
      "src": "/static/img/ui/dashboard3.png",
      "alt": "Real Time Interactions"
    }
  })]), _c('br')]) : _vm._e(), _c('h3', [_vm._v("Interactions")]), _c('hr'), _c('p', [_vm._v("The Interactions feature is mainly to display the past interactions between the customers and the bot. It has a list of interactions which will be running in real-time for agents to know what is happening so that they are able to control the bot. There are two types of interactions: "), _c('b', [_vm._v("Flagged")]), _vm._v(" and "), _c('b', [_vm._v("Unflagged")]), _vm._v(".")]), _c('p', [_vm._v("In every interaction, the replies that are being sent back to the customer will be from 2 different parties: "), _c('b', [_vm._v("Bot")]), _vm._v(" and "), _c('b', [_vm._v("Live Agent")]), _vm._v(". Each types of the replies will be differentiated in colour variations:")]), _c('ol', [_c('li', [_vm._v("Replies from "), _c('b', [_vm._v("Bot")]), _vm._v(" will be "), _c('i', [_vm._v("blue")]), _vm._v(" in colour.")]), _c('img', {
    attrs: {
      "src": "/static/img/ui/msg1.png",
      "alt": "Bot Message"
    }
  }), _c('br'), _c('br'), _c('li', [_vm._v("Replies from "), _c('b', [_vm._v("Live Agent")]), _vm._v(" will be "), _c('i', [_vm._v("green")]), _vm._v(" in colour.")]), _c('img', {
    attrs: {
      "src": "/static/img/ui/msg2.png",
      "alt": "Live Agent Message"
    }
  })]), _c('br'), _c('h5', [_vm._v("Unflagged")]), _c('p', [_vm._v("For the unflagged interactions, there are 3 different action buttons that the agents can perform towards every specific interaction: "), _c('b', [_vm._v("Quicksend")]), _vm._v(", "), _c('b', [_vm._v("History")]), _vm._v(" and "), _c('b', [_vm._v("Pause Autoreply")]), _vm._v(".")]), _c('img', {
    attrs: {
      "src": "/static/img/ui/actions.png",
      "alt": "Action Buttons"
    }
  }), _c('br'), _c('br'), _c('ol', [_c('li', [_vm._v("Click on "), _c('b', [_vm._v("Quicksend")]), _vm._v(". "), _c('br'), _vm._v(" The agent will be able to send messages instantly.")]), _c('img', {
    attrs: {
      "src": "/static/img/ui/quicksend.png",
      "alt": "Quicksend"
    }
  }), _c('br'), _c('br'), _c('li', [_vm._v("Click on "), _c('b', [_vm._v("History")]), _vm._v(". "), _c('br'), _vm._v(" The agent will be able to view the history of the interaction.")]), _c('img', {
    attrs: {
      "src": "/static/img/ui/history.png",
      "alt": "History"
    }
  }), _c('br'), _c('br'), _c('li', [_vm._v("Click on "), _c('b', [_vm._v("Pause Autoreply")]), _vm._v(". "), _c('br'), _vm._v(" The agent will be able to takeover the bot by pausing autoreply.")]), _c('img', {
    attrs: {
      "src": "/static/img/ui/pause.png",
      "alt": "Pause Autoreply"
    }
  })]), _c('br'), _c('p', [_vm._v("When a bot is paused, the whole chat box will be covered in a "), _c('b', [_vm._v("red")]), _vm._v(" border and it will be stated as "), _c('b', [_vm._v("Agent Takeover Active")]), _vm._v(". However, the agent will be "), _c('b', [_vm._v("disconnected")]), _vm._v(" from the chat after 30 seconds of idle, but the 30 seconds timer will reset whenever the live agent is still replying to the customer.")]), _c('br'), _c('img', {
    attrs: {
      "src": "/static/img/ui/takeover.png",
      "alt": "Takeover"
    }
  }), _c('br'), _c('br'), _c('p', [_vm._v("Whenever two agents are accessing the same interaction, the latter will receive a screen covered in red. This is because only one agent is able to access and takeover an interaction.")]), _c('br'), _c('h5', [_vm._v("Flagged")]), _c('p', [_vm._v("When the interactions in this section are highlighted in red colour, these are the interactions that are in need of attention for an agent to takeover. After 90 seconds, the flagged interactions will be changed back to unflagged if nothing happens to it (no takeover by agents). After pausing the bot, the input field is a "), _c('b', [_vm._v("quicksend")]), _vm._v(" function that can be used to instantly reply customers without pressing into the chat or button as it is faster to reply a flagged interaction.")]), _c('img', {
    attrs: {
      "src": "/static/img/ui/flagged.png",
      "alt": "Flagged"
    }
  }), _c('br'), _c('br'), _c('p', [_vm._v("At the top right of the table, an "), _c('b', [_vm._v("Export")]), _vm._v(" button will be available. "), (_vm.simulatedAccessLevel != "agent") ? _c('span', [_vm._v("Supervisor will be able to download as Excel Spreadsheet while agent will be able to download as PDF.")]) : _c('span', [_vm._v("Agent will be able to download as PDF.")])]), _c('img', {
    attrs: {
      "src": "/static/img/ui/export.png",
      "alt": "Export"
    }
  }), _c('br'), _c('br'), _c('p', [_vm._v("Click on "), _c('b', [_vm._v("Pause Autoreply")]), _vm._v(". "), _c('br'), _vm._v(" The agent will be able to pause and resume "), _c('b', [_vm._v("ALL")]), _vm._v(" autoreplies of the bot for every single interaction.")]), _c('img', {
    attrs: {
      "src": "/static/img/ui/pauseautoreply.png",
      "alt": "Pause All"
    }
  }), _c('br'), _c('br'), _c('img', {
    attrs: {
      "src": "/static/img/ui/resume.png",
      "alt": "Resume All"
    }
  }), _c('br'), _c('br'), _c('h3', [_vm._v("Complaints")]), _c('hr'), _c('p', [_vm._v("This is where all complaints are being sent that will notify the agent and it will display the names, messages of the complaint, ID, timestamps etc. The agent will be able to send an "), _c('b', [_vm._v("email")]), _vm._v(" to the user of the particular complaint to reply to their negative feedback.")]), _c('p', [_vm._v("Click on "), _c('b', [_vm._v("Email")]), _vm._v(". "), _c('br'), _vm._v(" The agent will be redirected to a link to send out the email.")]), _c('img', {
    attrs: {
      "src": "/static/img/ui/email.png",
      "alt": "Email"
    }
  }), _c('br'), _c('br'), _c('p', [_vm._v("At the top right of the table, an "), _c('b', [_vm._v("Export")]), _vm._v(" button will be available. "), (_vm.simulatedAccessLevel != "agent") ? _c('span', [_vm._v("Supervisor will be able to download as Excel Spreadsheet while agent will be able to download as PDF.")]) : _c('span', [_vm._v("Agent will be able to download as PDF.")])]), _c('img', {
    attrs: {
      "src": "/static/img/ui/export.png",
      "alt": "Export"
    }
  })])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 932:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntentsList_vue__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07eaae62_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_IntentsList_vue__ = __webpack_require__(934);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntentsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07eaae62_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_IntentsList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 933:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xlsx__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_xlsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(69);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IntentsList',
  data: function data() {
    return {
      EditorIsOpened: false,
      esIndex: 'dialogflow',
      esType: 'intents',
      esDataSize: 0,
      filter: null,
      loadingText: 'Loading...',
      loading: true,
      openUploadModal: false,
      openExportModal: false,
      xlsxFile: null,
      xlsxForDownload: [],
      bulkBody: [],
      listOfIntents: [],
      listOfAllQuickReply: [],
      intentsExist: false,
      tableItems: [],
      tableFields: {
        intentId: {
          label: 'No',
          sortable: true,
          thStyle: {
            width: '100px'
          }
        },
        intentTitle: {
          label: 'Intents',
          sortable: true,
          thStyle: {
            width: '400px'
          }
        },
        answerType: {
          label: 'Type of Answer'
        },

        noOfTrainings: {
          label: '# of Utterances'
        },
        quickReplies: {
          label: 'Quick Replies'
        },
        actions: {
          label: '<i></i>'
        }
      }
    };
  },

  watch: {
    '$store.state.newIntents': function $storeStateNewIntents() {
      this.EditorIsOpened = false;
      this.tableItems.unshift(this.$store.state.newIntents);
    },
    '$store.state.newEditedIntent': function $storeStateNewEditedIntent() {
      var that = this;
      console.log(this.$store.state.newEditedIntent);
      this.tableItems = [];
      Object(__WEBPACK_IMPORTED_MODULE_4__api__["e" /* getDFIntents */])().then(function (response) {
        if (response.status === 200) {
          that.displayIntents();
        }
      });
    },
    '$store.state.asideStatus': function $storeStateAsideStatus() {
      this.EditorIsOpened = this.$store.state.asideStatus;
    },
    '$store.state.removeIntent': function $storeStateRemoveIntent() {
      var that = this;
      this.tableItems = this.tableItems.filter(function (item) {
        return item !== that.$store.state.removeIntent;
      });

      var intent = { intentFullId: this.$store.state.removeIntent.intentFullId };
      Object(__WEBPACK_IMPORTED_MODULE_4__api__["c" /* deleteDFIntents */])(intent).then(function (response, error) {
        if (response) {
          console.log(response);
        } else {
          console.log(error);
        }
      });
    },
    filter: function filter() {}
  },
  methods: {
    clearTable: function clearTable() {
      this.tableItems = [];
    },
    toggleIntentEditor: function toggleIntentEditor() {
      if (this.EditorIsOpened) {
        this.$store.dispatch('setAsideStatus', false);
      } else {
        this.$store.dispatch('setAsideStatus', true);
        this.$store.dispatch('setActionInIntentPage', 'Create Intent');
      }
      document.body.classList.toggle('aside-menu-hidden');
    },
    filtersearch: function filtersearch() {
      this.filter = null;
    },
    uploadXLSX: function uploadXLSX() {
      if (window.FileReader) {
        var that = this;

        var reader = new FileReader();
        reader.onload = function (e) {
          var data = e.target.result;

          var workbook = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.read(data, { type: 'binary' });
          var worksheets = workbook.SheetNames;
          console.log(workbook);

          var rows = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.sheet_to_json(workbook.Sheets[worksheets[0]], { raw: false });

          that.listOfIntents = [];

          var listOfQuestions = [];
          var listOfQuickReply = [];

          var intentIndex;
          var intentTitle;
          var intentAnswers;

          var noOfUtterance = 0;
          var noOfBubble = 0;

          rows.forEach(function (rowObject, index) {
            if (rowObject['No'] && index !== 0 || index + 1 === rows.length) {
              that.listOfIntents.push({
                intentNo: intentIndex,
                intentTitle: intentTitle,
                intentQuestions: listOfQuestions,
                intentAnswers: intentAnswers,
                quickReplies: listOfQuickReply,
                utterance: noOfUtterance || 0,
                noOfBubble: noOfBubble || 0,
                answerCollapseIs: false });
              that.bulkBody.push({
                index: {
                  _index: 'intents',
                  _type: 'FAQ',
                  _id: intentIndex
                }
              }, {
                intentNo: intentIndex,
                intentTitle: intentTitle,
                intentQuestions: listOfQuestions,
                intentAnswers: intentAnswers,
                quickReplies: listOfQuickReply,
                utterance: noOfUtterance || 0,
                noOfBubble: noOfBubble || 0,
                answerCollapseIs: false });

              listOfQuestions = [];
              listOfQuickReply = [];
              noOfUtterance = 0;
              noOfBubble = 0;
            }

            if (rowObject['No']) {
              intentIndex = rowObject['No'];
            }

            if (rowObject['Intents']) {
              intentTitle = rowObject['Intents'];
            }

            if (rowObject['Answers']) {
              intentAnswers = rowObject['Answers'];
            }

            if (rowObject['Bubble Suggestion']) {
              listOfQuickReply.push({
                text: rowObject['Bubble Suggestion'],
                value: { index: rowObject['Bubble Suggestion'] }
              });
              noOfBubble = listOfQuickReply.length;
            }
            if (rowObject['Questions / Triggering Bubble']) {
              listOfQuestions.push({
                text: rowObject['Questions / Triggering Bubble'],
                value: { index: rowObject['Questions / Triggering Bubble'] }
              });
              noOfUtterance = listOfQuestions.length;
            }

            that.xlsxForDownload.push({
              intentNo: rowObject['No'] || '',
              intentTitle: rowObject['Intents'] || '',
              intentQuestions: rowObject['Questions / Triggering Bubble'] || '',
              intentAnswers: rowObject['Answers'] || '',
              quickReplies: rowObject['Bubble Suggestion'] || ''
            });
          });
          that.tableItems = that.listOfIntents;
          console.log('this is the list of intents');
          console.log(that.tableItems);
          console.log('bulkBody exist?', that.bulkBody);
        };
        reader.readAsBinaryString(this.xlsxFile);
      }
    },
    downloadXLSX: function downloadXLSX() {
      if (this.xlsxForDownload.length === 0) {
        this.$snotify.error('Sorry there is nothing to export.');
      } else {
        var worksheet = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.json_to_sheet([{ A: 'No', B: 'Intents', C: 'Questions / Triggering Bubble', D: 'Answers', E: 'Bubble Suggestion' }], { header: ['A', 'B', 'C', 'D', 'E', 'F'], skipHeader: true });
        this.xlsxForDownload.forEach(function (rowObject, index) {
          __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.sheet_add_json(worksheet, [{
            A: rowObject.intentNo,
            B: rowObject.intentTitle,
            C: rowObject.intentQuestions,
            D: rowObject.intentAnswers,
            E: rowObject.quickReplies
          }], {
            header: ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
            skipHeader: true,
            origin: -1
          });
        });
        var workbook = { SheetNames: ['Intent List'], Sheets: { 'Intent List': worksheet } };
        var date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()).format('YYYYMMDD');
        var fileName = 'imSME_FAQ_IntentList_' + date + '.xlsx';
        __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.writeFile(workbook, fileName);
      }
    },
    displayIntents: function displayIntents() {}
  },
  mounted: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var that;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              that = this;
              _context.next = 3;
              return Object(__WEBPACK_IMPORTED_MODULE_4__api__["e" /* getDFIntents */])().then(function (response) {
                if (response.status === 200) {
                  that.displayIntents();
                }
              });

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    if (document.getElementsByClassName('aside-menu-hidden').length === 0) {
      document.body.classList.toggle('aside-menu-hidden');
    }
  }
});

/***/ }),

/***/ 934:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h4', {
    staticClass: "col-title mb-0"
  }, [_vm._v("NLU Studio")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Displaying a List of Intents")])])]), _c('br'), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('b-form-group', {
    attrs: {
      "horizontal": "horizontal",
      "label": "Search"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "Type to Search..."
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _c('b-btn', {
    staticStyle: {
      "border-radius": "0 0.25rem 0.25rem 0"
    },
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.filtersearch
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1), _c('div', {
    staticClass: "col-sm-6"
  }, [(!_vm.EditorIsOpened) ? _c('b-button', {
    staticClass: "pull-right ml-3",
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": _vm.toggleIntentEditor
    }
  }, [_vm._v(" Open Editor")]) : _c('b-button', {
    staticClass: "pull-right ml-3",
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": _vm.toggleIntentEditor
    }
  }, [_vm._v(" Close Editor")]), _c('b-modal', {
    attrs: {
      "title": "Import Excel",
      "ok-title": "Upload",
      "lazy": "lazy"
    },
    on: {
      "ok": _vm.uploadXLSX
    },
    model: {
      value: (_vm.openUploadModal),
      callback: function($$v) {
        _vm.openUploadModal = $$v
      },
      expression: "openUploadModal"
    }
  }, [_c('b-form-file', {
    attrs: {
      "placeholder": "Place a xlsx file...",
      "no-drop": "no-drop"
    },
    model: {
      value: (_vm.xlsxFile),
      callback: function($$v) {
        _vm.xlsxFile = $$v
      },
      expression: "xlsxFile"
    }
  })], 1)], 1)])]), _c('intent-table', {
    attrs: {
      "data": _vm.tableItems,
      "label": _vm.tableFields
    }
  })], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 935:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_appointment_vue__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_423680da_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_appointment_vue__ = __webpack_require__(937);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_appointment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_423680da_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_appointment_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 936:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {};
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ 937:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Motor Accident")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Displaying motor accidents reported")])]), _c('div', {
    staticClass: "col-sm-7 hidden-sm-down"
  }, [_c('b-btn', {
    staticClass: "pull-right",
    attrs: {
      "type": "button",
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "icon-cloud-download"
  }), _vm._v("  Export")])], 1)]), _c('br'), _c('crm-table-appointment')], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 938:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_motor_insurance_vue__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afdb4014_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_motor_insurance_vue__ = __webpack_require__(940);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_motor_insurance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afdb4014_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_motor_insurance_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 939:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {};
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ 940:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Motor Insurance")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Displaying motor insurance renewals")])]), _c('div', {
    staticClass: "col-sm-7 hidden-sm-down"
  }, [_c('b-btn', {
    staticClass: "pull-right",
    attrs: {
      "type": "button",
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "icon-cloud-download"
  }), _vm._v("  Export")])], 1)]), _c('br'), _c('crm-table-motor')], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 941:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accountOpening_vue__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f7215b2_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_accountOpening_vue__ = __webpack_require__(943);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accountOpening_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f7215b2_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_accountOpening_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 942:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {};
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ 943:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Account Opening")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Displaying appointment for account opening")])]), _c('div', {
    staticClass: "col-sm-7 hidden-sm-down"
  }, [_c('b-btn', {
    staticClass: "pull-right",
    attrs: {
      "type": "button",
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "icon-cloud-download"
  }), _vm._v("  Export")])], 1)]), _c('br'), _c('crm-table-account-opening')], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 944:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tm_vue__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0802c796_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_tm_vue__ = __webpack_require__(946);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0802c796_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_tm_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 945:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsonToXlsx__ = __webpack_require__(137);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      userAccessLevel: this.$store.state.profile.accessLevel
    };
  },

  mounted: function mounted() {},
  methods: {
    xlsx: function xlsx() {
      Object(__WEBPACK_IMPORTED_MODULE_0__jsonToXlsx__["c" /* ecrm */])();
    },
    pdf: function pdf() {
      Object(__WEBPACK_IMPORTED_MODULE_0__jsonToXlsx__["d" /* ecrmp */])();
    }
  }
});

/***/ }),

/***/ 946:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Task Reporting")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Displaying tasks reported")])]), _c('div', {
    staticClass: "col-sm-7 hidden-sm-down"
  }, [(_vm.userAccessLevel != "agent") ? _c('b-dropdown', {
    staticClass: "float-right",
    attrs: {
      "type": "button",
      "variant": "primary"
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('i', {
    staticClass: "icon-cloud-download"
  }), _vm._v("  Export")]), _c('b-dropdown-item', {
    attrs: {
      "type": "button",
      "variant": "info"
    },
    on: {
      "click": _vm.xlsx
    }
  }, [_vm._v("Download as xlsx")]), _c('b-dropdown-item', {
    attrs: {
      "type": "button",
      "variant": "info"
    },
    on: {
      "click": _vm.pdf
    }
  }, [_vm._v("Download as pdf")])], 2) : _c('b-button', {
    staticClass: "float-right",
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": _vm.pdf
    }
  }, [_c('i', {
    staticClass: "icon-cloud-download"
  }), _vm._v(" Export as pdf")])], 1)]), _c('br'), _c('crm-table-tm')], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 947:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobAnalytics_vue__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_510d9e3d_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_JobAnalytics_vue__ = __webpack_require__(1001);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobAnalytics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_510d9e3d_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_JobAnalytics_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 948:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__methods_JobAnalyticsChart__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase__ = __webpack_require__(14);









var moment = __webpack_require__(998);
var cusRef = __WEBPACK_IMPORTED_MODULE_5__firebase__["b" /* db */].ref('custom');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  components: {
    JobChart: __WEBPACK_IMPORTED_MODULE_4__methods_JobAnalyticsChart__["a" /* default */]
  },
  data: function data() {
    return {
      jobTableItems: [],
      jobTableFields: {
        timestamp: {
          label: 'Date'
        },
        email: {
          label: 'Email'
        },
        job: {
          label: 'Position Applied'
        },
        linked: {
          label: 'Linked In'
        },
        reason: {
          label: 'Reason',
          thStyle: {
            minWidth: '20em'
          }
        },
        qualification: {
          label: 'Qualification'
        },
        rating: {
          label: 'Rating (/100)'
        },
        manualRate: {
          label: 'Manual Rating'
        }
      },
      initialise: true,
      graphStatus: 'sevenDays',
      graphOutdatedStatus: false,
      daysOfGraph: {
        days: 8,
        timestamp: new Date()
      },
      graphLabels: [],
      userData: [],
      interactionsData: [],
      userAccessLevel: this.$store.state.profile.accessLevel,
      usersCount: 0,
      interactionsCount: 0,
      todayUsersCount: 0,
      thisWeekUsersCount: 0,
      thisMonthUsersCount: 0,
      todayInteractionsCount: 0,
      thisWeekInteractionsCount: 0,
      thisMonthInteractionsCount: 0,
      textToChanges: [],
      topics: null,
      actions1: [{ name: 'View More' }],

      dataPoints: null,
      height: 20,
      stats: function stats() {
        return {};
      }
    };
  },

  watch: {
    startEndDateUpdate: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.getGraph();

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function startEndDateUpdate() {
        return _ref.apply(this, arguments);
      }

      return startEndDateUpdate;
    }()
  },
  computed: {
    startEndDateUpdate: function startEndDateUpdate() {
      return this.$store.state.startEndDate;
    },
    graphDataUpdate: function graphDataUpdate() {
      return this.$store.state.graphData;
    },
    dateRangeStart: function dateRangeStart() {
      return '' + this.$store.state.startEndDate.startingDate;
    },
    dateRangeEnd: function dateRangeEnd() {
      return '' + this.$store.state.startEndDate.endingDate;
    }
  },
  mounted: function mounted() {
    var _this = this;

    var endDate = new Date();
    var startDate = new Date(endDate - 7 * 24 * 60 * 60 * 1000);
    var sDate = this.formatDate(new Date(startDate));
    var eDate = this.formatDate(new Date(endDate));
    var startEndDate = {
      startingDate: sDate,
      endingDate: eDate
    };
    this.$store.dispatch('setStartEndDate', startEndDate);
    var graphStatus = 'sevenDays';
    this.$store.dispatch('setGraphStatus', graphStatus);

    cusRef.child('jobRequirement').on('value', function (snapshot) {
      _this.graphOutdatedStatus = true;
      if (_this.initialise == true) {
        _this.graphOutdatedStatus = false;
        _this.initialise = false;
      }
    });
  },
  methods: {
    getGraph: function getGraph() {
      var that = this;

      var jobArray = [];
      var jobNumberArray = [];
      this.$data.jobTableItems = [];
      cusRef.child('jobRequirement').once('value', function (snapshot) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(snapshot.val()).forEach(function (_ref2) {
          var _ref3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
              key = _ref3[0],
              val = _ref3[1];

          var objectToPush = {
            timestamp: Number(val.timestamp),
            email: val.email,
            job: val.job,
            linked: val.linked,
            reason: val.reason,
            qualification: val.qualification,
            rating: val.rating,
            manualRate: {
              value: val.manualRate,
              key: key
            }
          };
          that.$data.jobTableItems.push(objectToPush);
          if (jobArray.indexOf(val.job) != '-1') {
            jobNumberArray[jobArray.indexOf(val.job)] += 1;
          } else {
            jobArray.push(val.job);
            jobNumberArray.push(1);
          }
        });

        var graphData = {
          jobArray: jobArray,
          jobNumberArray: jobNumberArray,
          timestamp: new Date()
        };
        that.$store.dispatch('setGraphData', graphData);
      });
    },
    exportGraph: function exportGraph() {
      var dateStringToAdd = moment(this.$store.state.temporaryStartEndDate.startingDate).format('Do MMM \'YY') + ' - ' + moment(this.$store.state.temporaryStartEndDate.endingDate).format('Do MMM \'YY');
      var d = new Date();
      var month = '' + (d.getMonth() + 1);
      var day = '' + d.getDate();
      var year = d.getFullYear();
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      var canvas = document.getElementById('bar-chart');
      var ctx = canvas.getContext('2d');

      var imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      var data = imgData.data;
      for (var i = 0; i < data.length; i += 1) {
        if (data[i] < 1) {
          data[i] = 255;
        }
      }
      canvas.height = canvas.height + 40;
      ctx.putImageData(imgData, 0, 40);
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, canvas.width, 40);
      ctx.fillStyle = 'black';
      ctx.font = '25px sans-serif';
      ctx.fillText('Website Survey Received/Average Rating', 10, 20);
      ctx.font = '20px sans-serif';
      ctx.fillText(dateStringToAdd, 10, 40);
      var url = canvas.toDataURL('image/png', 1);
      var link = document.createElement('a');
      link.href = url;
      link.download = 'imSME_ChatBot_TotalInteractionsAndUsersChart_' + year + month + day + '.png';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      this.$store.dispatch('setExportGraphStatus', false);
      this.refreshGraph();
    },
    exportGraph2: function exportGraph2() {
      var dateStringToAdd = moment(this.$store.state.temporaryStartEndDate.startingDate).format('Do MMM \'YY') + ' - ' + moment(this.$store.state.temporaryStartEndDate.endingDate).format('Do MMM \'YY');
      var d = new Date();
      var month = '' + (d.getMonth() + 1);
      var day = '' + d.getDate();
      var year = d.getFullYear();
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      var canvas = document.getElementById('horizontalbar-chart');
      var ctx = canvas.getContext('2d');

      var imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      var data = imgData.data;
      for (var i = 0; i < data.length; i += 1) {
        if (data[i] < 1) {
          data[i] = 255;
        }
      }
      canvas.height = canvas.height + 40;
      ctx.putImageData(imgData, 0, 40);
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, canvas.width, 40);
      ctx.fillStyle = 'black';
      ctx.font = '25px sans-serif';
      ctx.fillText('Overall Website Survey Rating', 10, 20);
      ctx.font = '20px sans-serif';
      ctx.fillText(dateStringToAdd, 10, 40);
      var url = canvas.toDataURL('image/png', 1);
      var link = document.createElement('a');
      link.href = url;
      link.download = 'imSME_ChatBot_TotalInteractionsAndUsersChart_' + year + month + day + '.png';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      this.$store.dispatch('setExportGraphStatus', false);
      this.refreshGraph();
    },
    refreshGraph: function refreshGraph() {
      var startEndDate = {
        timestamp: new Date()
      };
      this.graphOutdatedStatus = false;
      this.$store.dispatch('setStartEndDate', startEndDate);
    },
    weeklyGraph: function weeklyGraph() {
      this.daysOfGraph = {
        days: 8,
        timestamp: new Date()
      };
      var endDate = new Date();
      var startDate = new Date(endDate - 7 * 24 * 60 * 60 * 1000);
      var sDate = this.formatDate(new Date(startDate));
      var eDate = this.formatDate(new Date(endDate));
      var startEndDate = {
        startingDate: sDate,
        endingDate: eDate
      };
      var graphStatus = 'sevenDays';
      this.$store.dispatch('setGraphStatus', graphStatus);
      this.$store.dispatch('setStartEndDate', startEndDate);
    },
    monthlyGraph: function monthlyGraph() {
      this.daysOfGraph = {
        days: 31,
        timestamp: new Date()
      };
      var endDate = new Date();
      var startDate = new Date(endDate - 30 * 24 * 60 * 60 * 1000);
      var sDate = this.formatDate(new Date(startDate));
      var eDate = this.formatDate(new Date(endDate));
      var startEndDate = {
        startingDate: sDate,
        endingDate: eDate
      };
      var graphStatus = 'thirtyDays';
      this.$store.dispatch('setGraphStatus', graphStatus);
      this.$store.dispatch('setStartEndDate', startEndDate);
    },
    yearlyGraph: function yearlyGraph() {
      this.daysOfGraph = 365;
    },
    increaseHeight: function increaseHeight() {
      this.height += 10;
    },
    getRandomInt: function getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
    variant: function variant(value) {
      var $variant = void 0;
      if (value <= 25) {
        $variant = 'info';
      } else if (value > 25 && value <= 50) {
        $variant = 'success';
      } else if (value > 50 && value <= 75) {
        $variant = 'warning';
      } else if (value > 75 && value <= 100) {
        $variant = 'danger';
      }
      return $variant;
    },
    chatLink: function chatLink(value) {
      return '/interactions/' + value.toLowerCase().replace(' ', '-');
    },

    formatDate: function formatDate(date) {
      var d = new Date(date);
      var month = '' + (d.getMonth() + 1);
      var day = '' + d.getDate();
      var year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      return [year, month, day].join('-');
    },
    formatDateSpace: function formatDateSpace(date) {
      var d = new Date(date);
      var month = '' + (d.getMonth() + 1);
      var day = '' + d.getDate();
      var year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      return [year, month, day].join('');
    }
  }
});

/***/ }),

/***/ 949:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseCharts__ = __webpack_require__(950);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      backgroundColor: ['#5cbae6', '#b6d957', '#fac364', '#8cd3ff', '#d998cb', '#f2d249', '#93b9c6', '#ccc5a8', '#52bacc', '#dbdb46', '#98aafb']
    };
  },

  props: {
    graphData: {
      jobArray: [],
      jobNumberArray: [],
      timestamp: new Date()
    }
  },
  extends: __WEBPACK_IMPORTED_MODULE_0__BaseCharts__["a" /* Bar */],
  watch: {
    graphData: function graphData() {
      this.renderChart({ labels: this.graphData.jobArray, datasets: this.setChartData(this.graphData.jobArray, this.graphData.jobNumberArray) }, this.setChartOptions());
    }
  },
  methods: {
    setChartData: function setChartData(jobArray, jobNumberArray) {
      var includedGraph = [];
      if (jobNumberArray !== undefined) {
        includedGraph.push({
          label: '',
          yAxisID: 'rating',
          backgroundColor: ['#5cbae6', '#b6d957', '#fac364', '#8cd3ff', '#d998cb', '#f2d249', '#93b9c6', '#ccc5a8', '#52bacc', '#dbdb46', '#98aafb'],
          borderColor: ['#5cbae6', '#b6d957', '#fac364', '#8cd3ff', '#d998cb', '#f2d249', '#93b9c6', '#ccc5a8', '#52bacc', '#dbdb46', '#98aafb'],
          fill: false,
          pointRadius: 6,
          borderWidth: 1,
          data: jobNumberArray,
          datalabels: {
            align: 'end',
            anchor: 'end'
          }
        });
      }
      return includedGraph;
    },
    setChartOptions: function setChartOptions() {
      return {
        layout: {
          padding: {
            left: 0,
            right: 50,
            top: 0,
            bottom: 0
          }
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        FontFamily: 'sans-serif',
        animation: false,
        scales: {
          yAxes: [{
            id: 'rating',
            scaleLabel: {
              display: true,
              labelString: 'Rating'
            },
            ticks: {
              beginAtZero: true,
              steps: 1,
              stepValue: 1,
              max: 5
            }
          }],
          xAxes: [{
            scaleLabel: {
              display: false,
              labelString: 'Date'
            }
          }]
        },
        plugins: {
          datalabels: {
            display: function display(context) {
              return context.chart.isDatasetVisible(context.datasetIndex);
            },
            backgroundColor: function backgroundColor(context) {
              return context.dataset.backgroundColor;
            },
            borderRadius: 6,
            color: 'white',
            font: {
              weight: 'bold'
            },
            formatter: Math.round
          }
        }
      };
    }
  }
});

/***/ }),

/***/ 950:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Line */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Bar; });
/* unused harmony export Doughnut */
/* unused harmony export Doughnut2 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);

__WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.defaults.global.legend.labels.usePointStyle = true;
__WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.NewLegend = __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.Legend.extend({
  afterFit: function afterFit() {
    var _this = this;

    if (this.lineWidths) {
      this.lineWidths = this.lineWidths.map(function () {
        return _this.width - 12;
      });
      this.height = this.height + 20;
    }
  }
});

function createNewLegendAndAttach(chartInstance, legendOpts) {
  var legend = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.NewLegend({
    ctx: chartInstance.chart.ctx,
    options: legendOpts,
    chart: chartInstance
  });
  if (chartInstance.legend) {
    __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.layoutService.removeBox(chartInstance, chartInstance.legend);
    delete chartInstance.newLegend;
  }
  chartInstance.newLegend = legend;
  __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.layoutService.addBox(chartInstance, legend);
}

__WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.plugins.register({
  beforeInit: function beforeInit(chartInstance) {
    var legendOpts = chartInstance.options.legend;

    if (legendOpts) {
      createNewLegendAndAttach(chartInstance, legendOpts);
    }
  },
  beforeUpdate: function beforeUpdate(chartInstance) {
    var legendOpts = chartInstance.options.legend;

    if (legendOpts) {
      legendOpts = __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.helpers.configMerge(__WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.defaults.global.legend, legendOpts);

      if (chartInstance.newLegend) {
        chartInstance.newLegend.options = legendOpts;
      } else {
        createNewLegendAndAttach(chartInstance, legendOpts);
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.layoutService.removeBox(chartInstance, chartInstance.newLegend);
      delete chartInstance.newLegend;
    }
  },
  afterEvent: function afterEvent(chartInstance, e) {
    var legend = chartInstance.newLegend;
    if (legend) {
      legend.handleEvent(e);
    }
  }
});

function generateChart(chartId, chartType) {
  return {
    render: function render(createElement) {
      return createElement('div', {
        style: this.styles,
        class: this.cssClasses
      }, [createElement('canvas', {
        attrs: {
          id: this.chartId,
          width: this.width,
          height: this.height
        },
        ref: 'canvas'
      })]);
    },

    props: {
      chartId: {
        default: chartId,
        type: String
      },
      width: {
        default: 400,
        type: Number
      },
      height: {
        default: 400,
        type: Number
      },
      cssClasses: {
        type: String,
        default: ''
      },
      styles: {
        type: Object
      },
      plugins: {
        type: Array,
        default: function _default() {
          return [];
        }
      }
    },

    data: function data() {
      return {
        _chart: null,
        _plugins: this.plugins
      };
    },


    methods: {
      addPlugin: function addPlugin(plugin) {
        this.$data._plugins.push(plugin);
      },
      renderChart: function renderChart(data, options) {
        if (this.$data._chart) {
          this.$data._chart.destroy();
        }
        this.$data._chart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(this.$refs.canvas.getContext('2d'), {
          type: chartType,
          data: data,
          options: options
        });
      }
    },
    beforeDestroy: function beforeDestroy() {
      if (this.$data._chart) {
        this.$data._chart.destroy();
      }
    }
  };
}

var Line = generateChart('line-chart', 'line');
var Bar = generateChart('bar-chart', 'bar');
var Doughnut = generateChart('doughnut-chart', 'doughnut');
var Doughnut2 = generateChart('doughnut-chart2', 'doughnut');

/* unused harmony default export */ var _unused_webpack_default_export = ({
  Line: Line,
  Bar: Bar,
  Doughnut: Doughnut,
  Doughnut2: Doughnut2
});

/***/ }),

/***/ 980:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 431,
	"./af.js": 431,
	"./ar": 432,
	"./ar-dz": 433,
	"./ar-dz.js": 433,
	"./ar-kw": 434,
	"./ar-kw.js": 434,
	"./ar-ly": 435,
	"./ar-ly.js": 435,
	"./ar-ma": 436,
	"./ar-ma.js": 436,
	"./ar-sa": 437,
	"./ar-sa.js": 437,
	"./ar-tn": 438,
	"./ar-tn.js": 438,
	"./ar.js": 432,
	"./az": 439,
	"./az.js": 439,
	"./be": 440,
	"./be.js": 440,
	"./bg": 441,
	"./bg.js": 441,
	"./bn": 442,
	"./bn.js": 442,
	"./bo": 443,
	"./bo.js": 443,
	"./br": 444,
	"./br.js": 444,
	"./bs": 445,
	"./bs.js": 445,
	"./ca": 446,
	"./ca.js": 446,
	"./cs": 447,
	"./cs.js": 447,
	"./cv": 448,
	"./cv.js": 448,
	"./cy": 449,
	"./cy.js": 449,
	"./da": 450,
	"./da.js": 450,
	"./de": 451,
	"./de-at": 452,
	"./de-at.js": 452,
	"./de-ch": 453,
	"./de-ch.js": 453,
	"./de.js": 451,
	"./dv": 454,
	"./dv.js": 454,
	"./el": 455,
	"./el.js": 455,
	"./en-au": 456,
	"./en-au.js": 456,
	"./en-ca": 457,
	"./en-ca.js": 457,
	"./en-gb": 458,
	"./en-gb.js": 458,
	"./en-ie": 459,
	"./en-ie.js": 459,
	"./en-nz": 460,
	"./en-nz.js": 460,
	"./eo": 461,
	"./eo.js": 461,
	"./es": 462,
	"./es-do": 463,
	"./es-do.js": 463,
	"./es.js": 462,
	"./et": 464,
	"./et.js": 464,
	"./eu": 465,
	"./eu.js": 465,
	"./fa": 466,
	"./fa.js": 466,
	"./fi": 467,
	"./fi.js": 467,
	"./fo": 468,
	"./fo.js": 468,
	"./fr": 469,
	"./fr-ca": 470,
	"./fr-ca.js": 470,
	"./fr-ch": 471,
	"./fr-ch.js": 471,
	"./fr.js": 469,
	"./fy": 472,
	"./fy.js": 472,
	"./gd": 473,
	"./gd.js": 473,
	"./gl": 474,
	"./gl.js": 474,
	"./gom-latn": 475,
	"./gom-latn.js": 475,
	"./he": 476,
	"./he.js": 476,
	"./hi": 477,
	"./hi.js": 477,
	"./hr": 478,
	"./hr.js": 478,
	"./hu": 479,
	"./hu.js": 479,
	"./hy-am": 480,
	"./hy-am.js": 480,
	"./id": 481,
	"./id.js": 481,
	"./is": 482,
	"./is.js": 482,
	"./it": 483,
	"./it.js": 483,
	"./ja": 484,
	"./ja.js": 484,
	"./jv": 485,
	"./jv.js": 485,
	"./ka": 486,
	"./ka.js": 486,
	"./kk": 487,
	"./kk.js": 487,
	"./km": 488,
	"./km.js": 488,
	"./kn": 489,
	"./kn.js": 489,
	"./ko": 490,
	"./ko.js": 490,
	"./ky": 491,
	"./ky.js": 491,
	"./lb": 492,
	"./lb.js": 492,
	"./lo": 493,
	"./lo.js": 493,
	"./lt": 494,
	"./lt.js": 494,
	"./lv": 495,
	"./lv.js": 495,
	"./me": 496,
	"./me.js": 496,
	"./mi": 497,
	"./mi.js": 497,
	"./mk": 498,
	"./mk.js": 498,
	"./ml": 499,
	"./ml.js": 499,
	"./mr": 500,
	"./mr.js": 500,
	"./ms": 501,
	"./ms-my": 502,
	"./ms-my.js": 502,
	"./ms.js": 501,
	"./my": 503,
	"./my.js": 503,
	"./nb": 504,
	"./nb.js": 504,
	"./ne": 505,
	"./ne.js": 505,
	"./nl": 506,
	"./nl-be": 507,
	"./nl-be.js": 507,
	"./nl.js": 506,
	"./nn": 508,
	"./nn.js": 508,
	"./pa-in": 509,
	"./pa-in.js": 509,
	"./pl": 510,
	"./pl.js": 510,
	"./pt": 511,
	"./pt-br": 512,
	"./pt-br.js": 512,
	"./pt.js": 511,
	"./ro": 513,
	"./ro.js": 513,
	"./ru": 514,
	"./ru.js": 514,
	"./sd": 515,
	"./sd.js": 515,
	"./se": 516,
	"./se.js": 516,
	"./si": 517,
	"./si.js": 517,
	"./sk": 518,
	"./sk.js": 518,
	"./sl": 519,
	"./sl.js": 519,
	"./sq": 520,
	"./sq.js": 520,
	"./sr": 521,
	"./sr-cyrl": 522,
	"./sr-cyrl.js": 522,
	"./sr.js": 521,
	"./ss": 523,
	"./ss.js": 523,
	"./sv": 524,
	"./sv.js": 524,
	"./sw": 525,
	"./sw.js": 525,
	"./ta": 526,
	"./ta.js": 526,
	"./te": 527,
	"./te.js": 527,
	"./tet": 528,
	"./tet.js": 528,
	"./th": 529,
	"./th.js": 529,
	"./tl-ph": 530,
	"./tl-ph.js": 530,
	"./tlh": 531,
	"./tlh.js": 531,
	"./tr": 532,
	"./tr.js": 532,
	"./tzl": 533,
	"./tzl.js": 533,
	"./tzm": 534,
	"./tzm-latn": 535,
	"./tzm-latn.js": 535,
	"./tzm.js": 534,
	"./uk": 536,
	"./uk.js": 536,
	"./ur": 537,
	"./ur.js": 537,
	"./uz": 538,
	"./uz-latn": 539,
	"./uz-latn.js": 539,
	"./uz.js": 538,
	"./vi": 540,
	"./vi.js": 540,
	"./x-pseudo": 541,
	"./x-pseudo.js": 541,
	"./yo": 542,
	"./yo.js": 542,
	"./zh-cn": 543,
	"./zh-cn.js": 543,
	"./zh-hk": 544,
	"./zh-hk.js": 544,
	"./zh-tw": 545,
	"./zh-tw.js": 545
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 980;

/***/ })

},[673]);


// WEBPACK FOOTER //
// static/js/app.8856e56f64251675a5af.js